export const GAMEDATA = [
    {
        "_id": {
            "$oid": "6281b13eb5799fba8d6a8bc1"
        },
        "name": "Fermion",
        "category": "summonerswar",
        "slug": "fermion",
        "subCategory": "monsters",
        "images": [
            "/assets/images/heroes/summonerswar/Archangel/dark.png",
            "/assets/images/heroes/summonerswar/Archangel/dark_awake.png",
            "/assets/images/heroes/summonerswar/Archangel/bg/dark.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/heroes/summonerswar/Archangel/dark.png",
            "/assets/images/heroes/summonerswar/Archangel/dark_awake.png"
        ],
        "element": "Dark",
        "type": "Defense",
        "species": "Archangel",
        "leaderSkill": "Increases the HP of ally monsters with Dark attribute by 50%",
        "skill1": "Heavenly Sword",
        "skill2": "Punishment",
        "skill3": "Dominator",
        "skill4": "",
        "description": "More Details 1",
        "grade": "5",
        "price": 100,
        "quantity": 1,
        "rate": 5,
        "image1": "/assets/images/heroes/summonerswar/Archangel/dark.png",
        "image2": "/assets/images/heroes/summonerswar/Archangel/dark_awake.png",
        "image3": "/assets/images/heroes/summonerswar/Archangel/bg/dark.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/heroes/summonerswar/Archangel/dark.png",
        "thumbImage2": "/assets/images/heroes/summonerswar/Archangel/dark_awake.png",
        "backgroundImages": [
            "pIcrxW6dThaI98y0MFQy",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "details": "More Information",
        "title": "Fermion",
        "carouselImages": [
            "1ugxWj04RzKTUex57AIS",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "yRHWDzpUQWWnLkTFy7ig",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "0b06de58SM2ul9FiPMLA",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "modified": {
            "$date": "2022-11-02T13:23:05.162Z"
        },
        "modifiedBy": "Hung Nguyen"
    },
    {
        "_id": {
            "$oid": "6281c6bc0aff3e9fdd74adc0"
        },
        "name": "Artamiel",
        "category": "summonerswar",
        "__v": 0,
        "slug": "artamiel",
        "subCategory": "monsters",
        "thumbImage": [
            "/assets/images/heroes/summonerswar/Archangel/light.png",
            "/assets/images/heroes/summonerswar/Archangel/light_awake.png"
        ],
        "images": [
            "/assets/images/heroes/summonerswar/Archangel/light.png",
            "/assets/images/heroes/summonerswar/Archangel/light_awake.png",
            "/assets/images/heroes/summonerswar/Archangel/bg/light.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Light",
        "type": "Support",
        "species": "Archangel",
        "leaderSkill": "Increases the HP of ally monsters with Light attribute by 50%",
        "skill1": "Heavenly Sword",
        "skill2": "Archangel's Blessing",
        "skill3": "Judge",
        "skill4": "",
        "description": "More Information",
        "grade": "5",
        "image1": "/assets/images/heroes/summonerswar/Archangel/light.png",
        "image2": "/assets/images/heroes/summonerswar/Archangel/light_awake.png",
        "image3": "/assets/images/heroes/summonerswar/Archangel/bg/light.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-02T13:24:54.187Z"
        },
        "modifiedBy": "Hung Nguyen",
        "price": 1,
        "quantity": 1,
        "rate": 5,
        "thumbImage1": "/assets/images/heroes/summonerswar/Archangel/light.png",
        "thumbImage2": "/assets/images/heroes/summonerswar/Archangel/light_awake.png"
    },
    {
        "_id": {
            "$oid": "62835747d145e7a48f72ec81"
        },
        "name": "Velajuel",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "velajuel",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/heroes/summonerswar/Archangel/fire.png",
            "/assets/images/heroes/summonerswar/Archangel/fire_awake.png",
            "/assets/images/heroes/summonerswar/Archangel/bg/fire.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/heroes/summonerswar/Archangel/fire.png",
            "/assets/images/heroes/summonerswar/Archangel/fire_awake.png"
        ],
        "__v": 0,
        "element": "Fire",
        "type": "Support",
        "species": "Archangel",
        "leaderSkill": "Increases the HP of ally monsters with Fire attribute by 50%",
        "skill1": "Heavenly Sword",
        "skill2": "Punishment",
        "skill3": "Sanctuary",
        "skill4": "",
        "grade": "5",
        "image1": "/assets/images/heroes/summonerswar/Archangel/fire.png",
        "image2": "/assets/images/heroes/summonerswar/Archangel/fire_awake.png",
        "image3": "/assets/images/heroes/summonerswar/Archangel/bg/fire.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-02T13:27:53.062Z"
        },
        "modifiedBy": "Hung Nguyen",
        "quantity": 1,
        "thumbImage1": "/assets/images/heroes/summonerswar/Archangel/fire.png",
        "thumbImage2": "/assets/images/heroes/summonerswar/Archangel/fire_awake.png"
    },
    {
        "_id": {
            "$oid": "6283574cd145e7a48f72ec83"
        },
        "name": "Ariel",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "ariel",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/heroes/summonerswar/Archangel/water.png",
            "/assets/images/heroes/summonerswar/Archangel/water_awake.png",
            "/assets/images/heroes/summonerswar/Archangel/bg/water.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/heroes/summonerswar/Archangel/water.png",
            "/assets/images/heroes/summonerswar/Archangel/water_awake.png"
        ],
        "__v": 0,
        "element": "Water",
        "type": "Support",
        "species": "Archangel",
        "leaderSkill": "Increases the HP of ally monsters with Water attribute by 50%",
        "skill1": "Heavenly Sword",
        "skill2": "Archangel's Blessing",
        "skill3": "Holy Water",
        "skill4": "",
        "grade": "5",
        "image1": "/assets/images/heroes/summonerswar/Archangel/water.png",
        "image2": "/assets/images/heroes/summonerswar/Archangel/water_awake.png",
        "image3": "/assets/images/heroes/summonerswar/Archangel/bg/water.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-02T13:27:22.535Z"
        },
        "modifiedBy": "Hung Nguyen",
        "quantity": 1,
        "thumbImage1": "/assets/images/heroes/summonerswar/Archangel/water.png",
        "thumbImage2": "/assets/images/heroes/summonerswar/Archangel/water_awake.png"
    },
    {
        "_id": {
            "$oid": "62835751d145e7a48f72ec85"
        },
        "name": "Eladriel",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "eladriel",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/heroes/summonerswar/Archangel/wind.png",
            "/assets/images/heroes/summonerswar/Archangel/light_awake.png",
            "/assets/images/heroes/summonerswar/Archangel/bg/light.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/heroes/summonerswar/Archangel/light.png",
            "/assets/images/heroes/summonerswar/Archangel/light_awake.png"
        ],
        "__v": 0,
        "element": "Wind",
        "type": "Support",
        "species": "Archangel",
        "leaderSkill": "Increases the HP of ally monsters with Wind attribute by 50%",
        "skill1": "Heavenly Sword",
        "skill2": "Archangel's Blessing",
        "skill3": "Archangel's Mercy",
        "skill4": "",
        "grade": "5",
        "image1": "/assets/images/heroes/summonerswar/Archangel/wind.png",
        "image2": "/assets/images/heroes/summonerswar/Archangel/light_awake.png",
        "image3": "/assets/images/heroes/summonerswar/Archangel/bg/light.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-02T13:26:51.486Z"
        },
        "modifiedBy": "Hung Nguyen",
        "quantity": 1,
        "thumbImage1": "/assets/images/heroes/summonerswar/Archangel/light.png",
        "thumbImage2": "/assets/images/heroes/summonerswar/Archangel/light_awake.png"
    },
    {
        "_id": {
            "$oid": "62835756d145e7a48f72ec87"
        },
        "name": "Mookwol",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Mookwol",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/artmaster/artmaster_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/artmaster/artmaster_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "type": "Support",
        "species": "Art Master",
        "leaderSkill": "Increases the Attack Power of ally monsters with Dark attribute by 50%",
        "skill1": "Mark of Brush Tip",
        "skill2": "Moon Drawn by Clouds",
        "skill3": "Mask of Devil",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283575bd145e7a48f72ec89"
        },
        "name": "Hanwul",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Hanwul",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/artmaster/artmaster_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/artmaster/artmaster_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "type": "Attack",
        "species": "Art Master",
        "leaderSkill": "Increase the Attack Power of ally monsters with Light attribute by 50%",
        "skill1": "Mark of Brush Tip",
        "skill2": "Scroll Trap",
        "skill3": "Final Touch",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835760d145e7a48f72ec8b"
        },
        "name": "Jeogun",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Jeogun",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/artmaster/artmaster_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/artmaster/artmaster_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "type": "Support",
        "species": "Art Master",
        "leaderSkill": "Increase the Attack Power of ally monsters with Water attribute by 50%",
        "skill1": "Mark of Brush Tip",
        "skill2": "Scroll Trap",
        "skill3": "Blossom Painting",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835764d145e7a48f72ec8d"
        },
        "name": "Haegang",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Haegang",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/artmaster/artmaster_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/artmaster/artmaster_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "species": "Art Master",
        "element": "Fire",
        "type": "Support",
        "leaderSkill": "Increase the Attack Power of ally monsters with Fire attribute by 50%",
        "skill1": "Mark of Brush Tip",
        "skill2": "Moon Drawn by Clouds",
        "skill3": "Art of Blank Space",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835769d145e7a48f72ec8f"
        },
        "name": "Cheongpung",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Cheongpung",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/artmaster/artmaster_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/artmaster/artmaster_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Art Master",
        "type": "Attack",
        "leaderSkill": "Increase the Attack Power of ally monsters with Water attribute by 50%",
        "skill1": "Mark of Brush Tip",
        "skill2": "Moon Drawn by Clouds",
        "skill3": "Serious Matter",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283576ed145e7a48f72ec91"
        },
        "name": "Rahul",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "rahul",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/heroes/summonerswar/BeastMonk/dark.png",
            "/assets/images/heroes/summonerswar/BeastMonk/dark_awake.png",
            "/assets/images/heroes/summonerswar/BeastMonk/bg/beastmonk_dark.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/heroes/summonerswar/BeastMonk/dark.png",
            "/assets/images/heroes/summonerswar/BeastMonk/dark_awake.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Beast Monk",
        "type": "HP",
        "leaderSkill": "Increases the Attack Power of ally monsters in the Dungeons by 44%.",
        "skill1": "Crushing Blow",
        "skill2": "Dark Strengthened",
        "skill3": "Defend",
        "skill4": "Trick of Darkness",
        "grade": "5",
        "image1": "/assets/images/heroes/summonerswar/BeastMonk/dark.png",
        "image2": "/assets/images/heroes/summonerswar/BeastMonk/dark_awake.png",
        "image3": "/assets/images/heroes/summonerswar/BeastMonk/bg/beastmonk_dark.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-06T08:30:44.592Z"
        },
        "modifiedBy": "Hung Nguyen",
        "quantity": 1,
        "thumbImage1": "/assets/images/heroes/summonerswar/BeastMonk/dark.png",
        "thumbImage2": "/assets/images/heroes/summonerswar/BeastMonk/dark_awake.png"
    },
    {
        "_id": {
            "$oid": "62835772d145e7a48f72ec93"
        },
        "name": "Shazam",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "shazam",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/heroes/summonerswar/BeastMonk/light.png",
            "/assets/images/heroes/summonerswar/BeastMonk/light_awake.png",
            "/assets/images/heroes/summonerswar/BeastMonk/bg/beastmonk_light.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/heroes/summonerswar/BeastMonk/light.png",
            "/assets/images/heroes/summonerswar/BeastMonk/light_awake.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Beast Monk",
        "type": "HP",
        "leaderSkill": "Increases the Accuracy of ally monsters in the Dungeons by 55%.",
        "skill1": "Crushing Blow",
        "skill2": "Light Strengthened",
        "skill3": "Meditate",
        "skill4": "Trick of Light",
        "grade": "5",
        "image1": "/assets/images/heroes/summonerswar/BeastMonk/light.png",
        "image2": "/assets/images/heroes/summonerswar/BeastMonk/light_awake.png",
        "image3": "/assets/images/heroes/summonerswar/BeastMonk/bg/beastmonk_light.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-06T08:31:23.65Z"
        },
        "modifiedBy": "Hung Nguyen",
        "quantity": 1,
        "thumbImage1": "/assets/images/heroes/summonerswar/BeastMonk/light.png",
        "thumbImage2": "/assets/images/heroes/summonerswar/BeastMonk/light_awake.png"
    },
    {
        "_id": {
            "$oid": "62835775d145e7a48f72ec95"
        },
        "name": "Kumar",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "kumar",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/heroes/summonerswar/BeastMonk/fire.png",
            "/assets/images/heroes/summonerswar/BeastMonk/fire_awake.png",
            "/assets/images/heroes/summonerswar/BeastMonk/bg/beastmonk_fire.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/heroes/summonerswar/BeastMonk/fire.png",
            "/assets/images/heroes/summonerswar/BeastMonk/fire_awake.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Beast Monk",
        "type": "HP",
        "leaderSkill": "Increases the Critical Rate of ally monsters in the Dungeons by 33%.",
        "skill1": "Crushing Blow",
        "skill2": "Fire Strengthened",
        "skill3": "Meditate",
        "skill4": "Trick of Fire",
        "grade": "5",
        "image1": "/assets/images/heroes/summonerswar/BeastMonk/fire.png",
        "image2": "/assets/images/heroes/summonerswar/BeastMonk/fire_awake.png",
        "image3": "/assets/images/heroes/summonerswar/BeastMonk/bg/beastmonk_fire.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-06T08:32:54.147Z"
        },
        "modifiedBy": "Hung Nguyen",
        "quantity": 1,
        "thumbImage1": "/assets/images/heroes/summonerswar/BeastMonk/fire.png",
        "thumbImage2": "/assets/images/heroes/summonerswar/BeastMonk/fire_awake.png"
    },
    {
        "_id": {
            "$oid": "62835779d145e7a48f72ec97"
        },
        "name": "Chandra",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "chandra",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/heroes/summonerswar/BeastMonk/water.png",
            "/assets/images/heroes/summonerswar/BeastMonk/water_awake.png",
            "/assets/images/heroes/summonerswar/BeastMonk/bg/beastmonk_water.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/heroes/summonerswar/BeastMonk/water.png",
            "/assets/images/heroes/summonerswar/BeastMonk/water_awake.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Beast Monk",
        "type": "HP",
        "leaderSkill": "Increases the Defense of ally monsters in the Dungeons by 44%.",
        "skill1": "Crushing Blow",
        "skill2": "Water Strengthened",
        "skill3": "Defend",
        "skill4": "Trick of Water",
        "grade": "5",
        "image1": "/assets/images/heroes/summonerswar/BeastMonk/water.png",
        "image2": "/assets/images/heroes/summonerswar/BeastMonk/water_awake.png",
        "image3": "/assets/images/heroes/summonerswar/BeastMonk/bg/beastmonk_water.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-06T08:33:19.835Z"
        },
        "modifiedBy": "Hung Nguyen",
        "quantity": 1,
        "thumbImage1": "/assets/images/heroes/summonerswar/BeastMonk/water.png",
        "thumbImage2": "/assets/images/heroes/summonerswar/BeastMonk/water_awake.png"
    },
    {
        "_id": {
            "$oid": "6283577ed145e7a48f72ec99"
        },
        "name": "Ritesh",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "ritesh",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/heroes/summonerswar/BeastMonk/wind.png",
            "/assets/images/heroes/summonerswar/BeastMonk/wind_awake.png",
            "/assets/images/heroes/summonerswar/BeastMonk/bg/beastmonk_wind.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/heroes/summonerswar/BeastMonk/wind.png",
            "/assets/images/heroes/summonerswar/BeastMonk/wind_awake.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Beast Monk",
        "type": "HP",
        "leaderSkill": "Increases the Accuracy of ally monsters in the Dungeons by 55%.",
        "skill1": "Crushing Blow",
        "skill2": "Wind Strengthened",
        "skill3": "Meditate",
        "skill4": "Trick of Wind",
        "grade": "5",
        "image1": "/assets/images/heroes/summonerswar/BeastMonk/wind.png",
        "image2": "/assets/images/heroes/summonerswar/BeastMonk/wind_awake.png",
        "image3": "/assets/images/heroes/summonerswar/BeastMonk/bg/beastmonk_wind.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-06T08:33:46.453Z"
        },
        "modifiedBy": "Hung Nguyen",
        "quantity": 1,
        "thumbImage1": "/assets/images/heroes/summonerswar/BeastMonk/wind.png",
        "thumbImage2": "/assets/images/heroes/summonerswar/BeastMonk/wind_awake.png"
    },
    {
        "_id": {
            "$oid": "62835782d145e7a48f72ec9b"
        },
        "name": "Xiana",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Xiana",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/beastrider/beastrider_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/beastrider/beastrider_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Beast Rider",
        "type": "Attack",
        "leaderSkill": "",
        "skill1": "Spear of Protector",
        "skill2": "Fast Link",
        "skill3": "Late Night Ambush",
        "skill4": "Rider"
    },
    {
        "_id": {
            "$oid": "62835786d145e7a48f72ec9d"
        },
        "name": "Narsha",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Narsha",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/beastrider/beastrider_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/beastrider/beastrider_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Beast Rider",
        "type": "Attack",
        "leaderSkill": "",
        "skill1": "Spear of Protector",
        "skill2": "Critical Link",
        "skill3": "Wild Chase",
        "skill4": "Rider"
    },
    {
        "_id": {
            "$oid": "6283578ad145e7a48f72ec9f"
        },
        "name": "Masha",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Masha",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/beastrider/beastrider_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/beastrider/beastrider_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Beast Rider",
        "type": "Attack",
        "leaderSkill": "",
        "skill1": "Spear of Protector",
        "skill2": "Fast Link",
        "skill3": "Wild Steps",
        "skill4": "Rider"
    },
    {
        "_id": {
            "$oid": "6283578ed145e7a48f72eca1"
        },
        "name": "Barbara",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Barbara",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/beastrider/beastrider_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/beastrider/beastrider_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Beast Rider",
        "type": "Attack",
        "leaderSkill": "",
        "skill1": "Spear of Protector",
        "skill2": "Fast Link",
        "skill3": "Start of Attacking",
        "skill4": "Rider"
    },
    {
        "_id": {
            "$oid": "62835792d145e7a48f72eca3"
        },
        "name": "Savannah",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Savannah",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/beastrider/beastrider_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/beastrider/beastrider_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Beast Rider",
        "type": "Attack",
        "leaderSkill": "",
        "skill1": "Spear of Protector",
        "skill2": "Critical Link",
        "skill3": "Gigantic Roar",
        "skill4": "Rider"
    },
    {
        "_id": {
            "$oid": "62835796d145e7a48f72eca5"
        },
        "name": "Bella",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Bella",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/cannongirl/cannongirl_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/cannongirl/cannongirl_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Cannon Girl",
        "type": "Attack",
        "leaderSkill": "",
        "skill1": "Fire",
        "skill2": "Focused 5 Shots",
        "skill3": "Wild Shot!",
        "skill4": "Burst Cannon"
    },
    {
        "_id": {
            "$oid": "6283579bd145e7a48f72eca7"
        },
        "name": "Emily",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Emily",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/cannongirl/cannongirl_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/cannongirl/cannongirl_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Cannon Girl",
        "type": "Attack",
        "leaderSkill": "Increases the Attack Power of ally monsters by 28%",
        "skill1": "Fire",
        "skill2": "Wild Shot!",
        "skill3": "Fatal Armor Bullet",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283579fd145e7a48f72eca9"
        },
        "name": "Scarlett",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Scarlett",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/cannongirl/cannongirl_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/cannongirl/cannongirl_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Cannon Girl",
        "type": "Attack",
        "leaderSkill": "Increases the Attack Power of ally monsters in the Guild Content by 38%",
        "skill1": "Fire",
        "skill2": "Wild Shot!",
        "skill3": "Fatal Armor Bullet",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357a3d145e7a48f72ecab"
        },
        "name": "Abigail",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Abigail",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/cannongirl/cannongirl_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/cannongirl/cannongirl_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Cannon Girl",
        "type": "Attack",
        "leaderSkill": "Increases the Attack Power of ally monsters in the Dungeons by 38%",
        "skill1": "Fire",
        "skill2": "Wild Shot!",
        "skill3": "Fatal Extinctive Bullet",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357a8d145e7a48f72ecad"
        },
        "name": "Christina",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Christina",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/cannongirl/cannongirl_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/cannongirl/cannongirl_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Cannon Girl",
        "type": "Attack",
        "leaderSkill": "",
        "skill1": "Fire",
        "skill2": "Focused 5 Shots",
        "skill3": "Coy Revenge ",
        "skill4": "Rolling Cannon"
    },
    {
        "_id": {
            "$oid": "628357acd145e7a48f72ecaf"
        },
        "name": "Zeratu",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Zeratu",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/chimera/chimera_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/chimera/chimera_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Chimera",
        "type": "Attack",
        "leaderSkill": "Increases the HP of ally monsters with Dark attribute by 50%",
        "skill1": "Trample",
        "skill2": "Unleashed Fury",
        "skill3": "Forbidden Power",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357b0d145e7a48f72ecb1"
        },
        "name": "Shan",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Shan",
        "rate": 5,
        "price": 1,
        "description": "More Information 1",
        "images": [
            "/assets/images/monsters/chimera/chimera_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/chimera/chimera_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Chimera",
        "type": "Attack",
        "leaderSkill": "Increases the HP of ally monsters with Light attribute by 50%",
        "skill1": "Trample",
        "skill2": "Squall",
        "skill3": "Holy Calling",
        "skill4": "",
        "grade": "5",
        "quantity": 1
    },
    {
        "_id": {
            "$oid": "628357b6d145e7a48f72ecb3"
        },
        "name": "Rakan",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Rakan",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/chimera/chimera_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/chimera/chimera_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Chimera",
        "type": "HP",
        "leaderSkill": "Increases the HP of ally monsters with Fire attribute by 50%",
        "skill1": "Trample",
        "skill2": "Unleashed Fury",
        "skill3": "Collapse",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357b9d145e7a48f72ecb5"
        },
        "name": "Taor",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Taor",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/chimera/chimera_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/chimera/chimera_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Chimera",
        "type": "Attack",
        "leaderSkill": "Increases the HP of ally monsters with Water attribute by 50%",
        "skill1": "Trample",
        "skill2": "Squall",
        "skill3": "Crush",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357bcd145e7a48f72ecb7"
        },
        "name": "Lagmaron",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Lagmaron",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/chimera/chimera_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/chimera/chimera_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Chimera",
        "type": "Attack",
        "leaderSkill": "Increases the HP of ally monsters with Wind attribute by 50%",
        "skill1": "Trample",
        "skill2": "Squall",
        "skill3": "Lightning Strike",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357c1d145e7a48f72ecb9"
        },
        "name": "Beelzebub",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Beelzebub",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/demon/demon_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/demon/demon_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Demon",
        "type": "Attack",
        "leaderSkill": "Increases the Attack Power of ally monsters in the Arena by 44%",
        "skill1": "Sword of Destruction",
        "skill2": "Madness Judgement",
        "skill3": "Purgatory",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357c5d145e7a48f72ecbb"
        },
        "name": "Lucifer",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Lucifer",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/demon/demon_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/demon/demon_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Demon",
        "type": "HP",
        "leaderSkill": "Increases the Defense of ally monsters in the Arena by 44%",
        "skill1": "Sword of Destruction",
        "skill2": "Devil's Bargain",
        "skill3": "Red Battlefield",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357c9d145e7a48f72ecbd"
        },
        "name": "Bael",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Bael",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/demon/demon_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/demon/demon_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Demon",
        "type": "Attack",
        "leaderSkill": "Increase the Accuracy of ally monsters in the Arena by 55%",
        "skill1": "Sword of Destruction",
        "skill2": "Devil's Bargain",
        "skill3": "Flames of Hell",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357dad145e7a48f72ecc0"
        },
        "name": "Belial",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Belial",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/demon/demon_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/demon/demon_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Demon",
        "type": "Attack",
        "leaderSkill": "Increase the Resistance of ally monsters in the Arena by 55%",
        "skill1": "Sword of Destruction",
        "skill2": "Madness Judgement",
        "skill3": "Repeated Nightmare",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357ded145e7a48f72ecc2"
        },
        "name": "Mephisto",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Mephisto",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/demon/demon_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/demon/demon_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Demon",
        "type": "HP",
        "leaderSkill": "Increases the HP of ally monsters in the Arena by 44%",
        "skill1": "Sword of Destruction",
        "skill2": "Devil's Bargain",
        "skill3": "Soul Stealer",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357e1d145e7a48f72ecc4"
        },
        "name": "Nephthys",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Nephthys",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/desertqueen/desertqueen_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/desertqueen/desertqueen_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Desert Queen",
        "type": "Support",
        "leaderSkill": "Increases the Attack Speed of ally monsters by 24%",
        "skill1": "Touch of Seduction",
        "skill2": "Curse of the Beautiful",
        "skill3": "Deadly Charm",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357e4d145e7a48f72ecc6"
        },
        "name": "Isis",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Isis",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/desertqueen/desertqueen_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/desertqueen/desertqueen_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Desert Queen",
        "type": "Support",
        "leaderSkill": "Increases the Attack Power of ally monsters by 33%",
        "skill1": "Touch of Seduction",
        "skill2": "Sweet Dreams",
        "skill3": "Gaze of Oblivion",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357e8d145e7a48f72ecc8"
        },
        "name": "Sekhmet",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Sekhmet",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/desertqueen/desertqueen_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/desertqueen/desertqueen_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Desert Queen",
        "type": "Support",
        "leaderSkill": "Increases the HP of ally monsters by 33%",
        "skill1": "Touch of Seduction",
        "skill2": "Curse of the Beautiful",
        "skill3": "Charming Voice",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357ebd145e7a48f72ecca"
        },
        "name": "Bastet",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Bastet",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/desertqueen/desertqueen_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/desertqueen/desertqueen_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Desert Queen",
        "type": "Support",
        "leaderSkill": "Increases the Defense of ally monsters by 33%",
        "skill1": "Touch of Seduction",
        "skill2": "Curse of the Beautiful",
        "skill3": "Oasis's Blessing",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357efd145e7a48f72eccc"
        },
        "name": "Hathor",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Hathor",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/desertqueen/desertqueen_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/desertqueen/desertqueen_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Desert Queen",
        "type": "Support",
        "leaderSkill": "Increases the Resistance of ally monsters by 41%",
        "skill1": "Touch of Seduction",
        "skill2": "Sweet Dreams",
        "skill3": "Delayed Promise",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357f2d145e7a48f72ecce"
        },
        "name": "Grogen",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Grogen",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/dragon/dragon_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/dragon/dragon_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "species": "Dragon",
        "element": "Dark",
        "type": "Attack",
        "leaderSkill": "Increases the Resistance of ally monsters by 41%",
        "skill1": "Dark Bolt",
        "skill2": "Dark Storm",
        "skill3": "Decimate",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357f6d145e7a48f72ecd0"
        },
        "name": "Zerath",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Zerath",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/dragon/dragon_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/dragon/dragon_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "species": "Dragon",
        "element": "Light",
        "type": "HP",
        "leaderSkill": "Increases the Critical Rate of ally monsters by 24%",
        "skill1": "Holy Bolt",
        "skill2": "Holy Light",
        "skill3": "Armageddon",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357f9d145e7a48f72ecd2"
        },
        "name": "Zaiross",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Zaiross",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/dragon/dragon_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/dragon/dragon_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "species": "Dragon",
        "element": "Fire",
        "type": "Attack",
        "leaderSkill": "Increases the Attack Power of ally monsters by 33%",
        "skill1": "Fire Bolt",
        "skill2": "Rain of Fire",
        "skill3": "Illusion of Time",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628357fdd145e7a48f72ecd4"
        },
        "name": "Verad",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Verad",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/dragon/dragon_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/dragon/dragon_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "species": "Dragon",
        "element": "Water",
        "type": "Defense",
        "leaderSkill": "Increases the HP of ally monsters by 33%",
        "skill1": "Ice Bolt",
        "skill2": "Snowstorm",
        "skill3": "Absolute Zero",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835801d145e7a48f72ecd6"
        },
        "name": "Jamire",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Jamire",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/dragon/dragon_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/dragon/dragon_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "species": "Dragon",
        "element": "Wind",
        "type": "Support",
        "leaderSkill": "Increases the Attack Speed of ally monsters by 24%",
        "skill1": "Thunder Bolt",
        "skill2": "Thunder Break",
        "skill3": "Fiery Breath",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835805d145e7a48f72ecd8"
        },
        "name": "Ragdoll",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Ragdoll",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/dragonknight/dragonknight_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/dragonknight/dragonknight_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Dragon Knight",
        "type": "Support",
        "leaderSkill": "Increases the Defense of ally monsters with Dark attribute by 50%",
        "skill1": "Dragon's Might",
        "skill2": "Torrent",
        "skill3": "Tooth For a Tooth",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835809d145e7a48f72ecda"
        },
        "name": "Jager",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Jager",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/dragonknight/dragonknight_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/dragonknight/dragonknight_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Dragon Knight",
        "type": "HP",
        "leaderSkill": "Increases the Defense of ally monsters with Light attribute by 50%",
        "skill1": "Dragon's Might",
        "skill2": "Justice",
        "skill3": "King's Rage",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283580cd145e7a48f72ecdc"
        },
        "name": "Laika",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Laika",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/dragonknight/dragonknight_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/dragonknight/dragonknight_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Dragon Knight",
        "type": "Attack",
        "leaderSkill": "Increases the Defense of ally monsters with Fire attribute by 50%",
        "skill1": "Dragon's Might",
        "skill2": "Justice",
        "skill3": "Noble Blood",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835810d145e7a48f72ecde"
        },
        "name": "Chow",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Chow",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/dragonknight/dragonknight_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/dragonknight/dragonknight_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Dragon Knight",
        "type": "HP",
        "leaderSkill": "Increases the Defense of ally monsters with Water attribute by 50%",
        "skill1": "Dragon's Might",
        "skill2": "Justice",
        "skill3": "Flow",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835815d145e7a48f72ece0"
        },
        "name": "Leo",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Leo",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/dragonknight/dragonknight_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/dragonknight/dragonknight_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Dragon Knight",
        "type": "Support",
        "leaderSkill": "Increases the Defense of ally monsters with Wind attribute by 50%",
        "skill1": "Dragon's Might",
        "skill2": "Eye of the Storm",
        "skill3": "",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835818d145e7a48f72ece2"
        },
        "name": "Pater",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Pater",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/druid/druid_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/druid/druid_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Druid",
        "type": "HP",
        "leaderSkill": "",
        "skill1": "Touch of Punishment",
        "skill2": "Wild Blow",
        "skill3": "Moonlight Grace",
        "skill4": "Druid's Wisdom"
    },
    {
        "_id": {
            "$oid": "6283584dd145e7a48f72ece4"
        },
        "name": "Valantis",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Valantis",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/druid/druid_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/druid/druid_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Druid",
        "type": "HP",
        "leaderSkill": "",
        "skill1": "Touch of Punishment",
        "skill2": "Moonlight Flood",
        "skill3": "Rage of Mother Nature",
        "skill4": "Druid's Agility"
    },
    {
        "_id": {
            "$oid": "62835850d145e7a48f72ece6"
        },
        "name": "Bellenus",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Bellenus",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/druid/druid_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/druid/druid_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Druid",
        "type": "Defense",
        "leaderSkill": "",
        "skill1": "Touch of Punishment",
        "skill2": "Moonlight Flood",
        "skill3": "Wild Roar",
        "skill4": "Druid's Secret Plan"
    },
    {
        "_id": {
            "$oid": "62835853d145e7a48f72ece8"
        },
        "name": "Abellio",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Abellio",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/druid/druid_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/druid/druid_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Druid",
        "type": "Defense",
        "leaderSkill": "",
        "skill1": "Touch of Punishment",
        "skill2": "Wild Blow",
        "skill3": "Wild Cure",
        "skill4": "Druid's Wit"
    },
    {
        "_id": {
            "$oid": "62835857d145e7a48f72ecea"
        },
        "name": "Taranys",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Taranys",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/druid/druid_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/druid/druid_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Druid",
        "type": "Defense",
        "leaderSkill": "",
        "skill1": "Touch of Punishment",
        "skill2": "Wild Blow",
        "skill3": "Forest of Living",
        "skill4": "Druid's Proficiency"
    },
    {
        "_id": {
            "$oid": "6283585ad145e7a48f72ecec"
        },
        "name": "Nyx",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Nyx",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/fairyking/fairyking_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/fairyking/fairyking_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Fairy King",
        "type": "Attack",
        "leaderSkill": "Increases the Resistance of ally monsters in the Arena by 55%",
        "skill1": "Serenity",
        "skill2": "Overwhelm",
        "skill3": "Discernment",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283585fd145e7a48f72ecee"
        },
        "name": "Oberon",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Oberon",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/fairyking/fairyking_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/fairyking/fairyking_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Fairy King",
        "type": "Attack",
        "leaderSkill": "Increases the Attack Power of ally monsters in the Arena by 44%",
        "skill1": "Serenity",
        "skill2": "Ventilate",
        "skill3": "Light of Judgement",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835862d145e7a48f72ecf0"
        },
        "name": "Daphnis",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Daphnis",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/fairyking/fairyking_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/fairyking/fairyking_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Fairy King",
        "type": "Attack",
        "leaderSkill": "Increases the Critical Rate of ally monsters in the Arena by 33%",
        "skill1": "Serenity",
        "skill2": "Overwhelm of Fire",
        "skill3": "Hellfire",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835865d145e7a48f72ecf2"
        },
        "name": "Psamathe",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Psamathe",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/fairyking/fairyking_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/fairyking/fairyking_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Fairy King",
        "type": "Attack",
        "leaderSkill": "Increases the Attack Speed of ally monsters in the Arena by 33%",
        "skill1": "Serenity",
        "skill2": "Overwhelm of Water",
        "skill3": "Rageful Return",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835868d145e7a48f72ecf4"
        },
        "name": "Ganymede",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Ganymede",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/fairyking/fairyking_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/fairyking/fairyking_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Fairy King",
        "type": "Support",
        "leaderSkill": "Increases the Accuracy of ally monsters in the Arena by 55%",
        "skill1": "Serenity",
        "skill2": "Ventilate",
        "skill3": "Seal Magic",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283586bd145e7a48f72ecf6"
        },
        "name": "Craka",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Craka",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/helllady/helllady_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/helllady/helllady_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Hell Lady",
        "type": "Support",
        "leaderSkill": "Increases the Defense of ally monsters in the Arena by 44%",
        "skill1": "Wound",
        "skill2": "Shatter",
        "skill3": "Summon Perpetrator",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283586fd145e7a48f72ecf8"
        },
        "name": "Asima",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Asima",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/helllady/helllady_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/helllady/helllady_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Hell Lady",
        "type": "Attack",
        "leaderSkill": "Increases the Accuracy of ally monsters in the Arena by 55%",
        "skill1": "Wound",
        "skill2": "Gouge",
        "skill3": "Crumble",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835875d145e7a48f72ecfa"
        },
        "name": "Raki",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Raki",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/helllady/helllady_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/helllady/helllady_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Hell Lady",
        "type": "Attack",
        "leaderSkill": "Increases the Attack Power of ally monsters in the Arena by 44%",
        "skill1": "Wound",
        "skill2": "Shatter",
        "skill3": "Soul Crusher",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835878d145e7a48f72ecfc"
        },
        "name": "Beth",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Beth",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/helllady/helllady_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/helllady/helllady_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Hell Lady",
        "type": "Attack",
        "leaderSkill": "Increases the HP of ally monsters in the Arena by 44%",
        "skill1": "Wound",
        "skill2": "Gouge",
        "skill3": "Eternal Scar",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283587cd145e7a48f72ecfe"
        },
        "name": "Ethna",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Ethna",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/helllady/helllady_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/helllady/helllady_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Hell Lady",
        "type": "Attack",
        "leaderSkill": "Increases the Critical Rate of ally monsters in the Arena by 33%",
        "skill1": "Wound",
        "skill2": "Shatter",
        "skill3": "Capture",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283587fd145e7a48f72ed00"
        },
        "name": "Homunculus Dark",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Homunculus-Dark",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/homunculus/homunculus_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/homunculus/homunculus_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Homunculus",
        "type": "Attack",
        "leaderSkill": "",
        "skill1": "Mana Shock",
        "skill2": "Operation Support",
        "skill3": "Protection Field",
        "skill4": "Magic Power Explosion II"
    },
    {
        "_id": {
            "$oid": "62835883d145e7a48f72ed02"
        },
        "name": "Homunculus Light",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Homunculus-Light",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/homunculus/homunculus_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/homunculus/homunculus_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Homunculus",
        "type": "Support",
        "leaderSkill": "",
        "skill1": "Mana Shock",
        "skill2": "Operation Support",
        "skill3": "Protection Field",
        "skill4": "Magic Power Explosion II"
    },
    {
        "_id": {
            "$oid": "62835888d145e7a48f72ed04"
        },
        "name": "Homunculus Fire",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Homunculus-Fire",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/homunculus/homunculus_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/homunculus/homunculus_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Homunculus",
        "type": "Attack",
        "leaderSkill": "",
        "skill1": "Magic Ray",
        "skill2": "Magic Bullet",
        "skill3": "Magic Power Burst",
        "skill4": "Magic Power Explosion"
    },
    {
        "_id": {
            "$oid": "6283588dd145e7a48f72ed06"
        },
        "name": "Homunculus Water",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Homunculus-Water",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/homunculus/homunculus_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/homunculus/homunculus_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Homunculus",
        "type": "Attack",
        "leaderSkill": "",
        "skill1": "Magic Ray",
        "skill2": "Magic Bullet",
        "skill3": "Magic Power Burst",
        "skill4": "Magic Power Explosion"
    },
    {
        "_id": {
            "$oid": "62835891d145e7a48f72ed08"
        },
        "name": "Homunculus Wind",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Homunculus-Wind",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/homunculus/homunculus_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/homunculus/homunculus_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Homunculus",
        "type": "Attack",
        "leaderSkill": "",
        "skill1": "Magic Ray",
        "skill2": "Magic Bullet",
        "skill3": "Magic Power Burst",
        "skill4": "Magic Power Explosion"
    },
    {
        "_id": {
            "$oid": "62835895d145e7a48f72ed0a"
        },
        "name": "Veromos",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Veromos",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/ifrit/ifrit_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/ifrit/ifrit_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Ifrit",
        "type": "Attack",
        "leaderSkill": "Increases the HP of ally monsters by 33%",
        "skill1": "Mega Smash",
        "skill2": "Super Crush",
        "skill3": "Conversion of Magic",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835899d145e7a48f72ed0c"
        },
        "name": "Elsharion",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Elsharion",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/ifrit/ifrit_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/ifrit/ifrit_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Ifrit",
        "type": "Attack",
        "leaderSkill": "Increases the Attack Power of ally monsters by 33%",
        "skill1": "Mega Smash",
        "skill2": "Triple Crush 2",
        "skill3": "Master of Magic Power",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283589ed145e7a48f72ed0e"
        },
        "name": "Tesarion",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Tesarion",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/ifrit/ifrit_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/ifrit/ifrit_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Ifrit",
        "type": "Attack",
        "leaderSkill": "Increases the Resistance of ally monsters by 41%",
        "skill1": "Mega Smash",
        "skill2": "Triple Crush",
        "skill3": "Ancient Power",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628358a2d145e7a48f72ed10"
        },
        "name": "Theomars",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Theomars",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/ifrit/ifrit_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/ifrit/ifrit_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Ifrit",
        "type": "Attack",
        "leaderSkill": "Increases the Critical Rate of ally monsters by 24%",
        "skill1": "Mega Smash",
        "skill2": "Triple Crush",
        "skill3": "Elemental King",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628358a6d145e7a48f72ed12"
        },
        "name": "Akhamamir",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Akhamamir",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/ifrit/ifrit_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/ifrit/ifrit_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Ifrit",
        "type": "Attack",
        "leaderSkill": "Increases the Attack Speed of ally monsters by 24%",
        "skill1": "Mega Smash",
        "skill2": "Super Crush",
        "skill3": "Mach Crush",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628358b1d145e7a48f72ed14"
        },
        "name": "KEN",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "KEN",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/ken/ken_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/ken/ken_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "KEN",
        "type": "Attack",
        "leaderSkill": "Increase the Critical Rate of ally monsters in the Dungeons by 33%",
        "skill1": "Hadoken",
        "skill2": "Tatsumaki Senpukyaku",
        "skill3": "Shinryuken",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628358b5d145e7a48f72ed16"
        },
        "name": "Herteit",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Herteit",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/lightningemperor/lightningemperor_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/lightningemperor/lightningemperor_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Lightning Emperor",
        "type": "Attack",
        "leaderSkill": "The Resistance of ally Monsters is increased by 55% in Guild content",
        "skill1": "Lightning Strike",
        "skill2": "Gain Knowledge",
        "skill3": "Endless Desire",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628358b8d145e7a48f72ed18"
        },
        "name": "Geldnir",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Geldnir",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/lightningemperor/lightningemperor_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/lightningemperor/lightningemperor_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Lightning Emperor",
        "type": "HP",
        "leaderSkill": "The Attack Speed of ally Monsters is increased by 33% in Guild content",
        "skill1": "Lightning Strike",
        "skill2": "Learn Knowledge",
        "skill3": "Eye of Pioneer",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628358c1d145e7a48f72ed1a"
        },
        "name": "Baleygr",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Baleygr",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/lightningemperor/lightningemperor_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/lightningemperor/lightningemperor_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Lightning Emperor",
        "type": "Attack",
        "leaderSkill": "The Attack Power of ally Monsters is increased by 44% in Guild Content",
        "skill1": "Lightning Strike",
        "skill2": "Gain Knowledge",
        "skill3": "Start of Apocalypse",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628358c4d145e7a48f72ed1c"
        },
        "name": "Bolverk",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Bolverk",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/lightningemperor/lightningemperor_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/lightningemperor/lightningemperor_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Lightning Emperor",
        "type": "HP",
        "leaderSkill": "The HP of ally Monsters is increased by 44% in Guild Content",
        "skill1": "Lightning Strike",
        "skill2": "Learn Knowledge",
        "skill3": "Forbidden Galdr",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628358c8d145e7a48f72ed1e"
        },
        "name": "Odin",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Odin",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/lightningemperor/lightningemperor_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/lightningemperor/lightningemperor_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Lightning Emperor",
        "type": "Attack",
        "leaderSkill": "The Critical Rate of ally Monsters is increased by 33% in Guild Content",
        "skill1": "Lightning Strike",
        "skill2": "Gain Knowledge",
        "skill3": "Legacy of Knowledge",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283590ad145e7a48f72ed20"
        },
        "name": "M.BISON Dark",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "M.BISON-Dark",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/mbison/mbison_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/mbison/mbison_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "M.BISON",
        "type": "HP",
        "leaderSkill": "Increase the Critical Rate of ally monsters in the Arena by 33%",
        "skill1": "Psycho Inferno",
        "skill2": "Psycho Crusher",
        "skill3": "Black Moons",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283590fd145e7a48f72ed22"
        },
        "name": "M.BISON Light",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "M.BISON-Light",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/mbison/mbison_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/mbison/mbison_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "M.BISON",
        "type": "HP",
        "leaderSkill": "Increase the Resistance of ally monsters in the Arena by 55%",
        "skill1": "Psycho Inferno",
        "skill2": "Double Knee Press",
        "skill3": "Psycho Power",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835914d145e7a48f72ed24"
        },
        "name": "M.BISON Fire",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "M.BISON-Fire",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/mbison/mbison_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/mbison/mbison_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "M.BISON",
        "type": "HP",
        "leaderSkill": "Increase the HP of ally monsters in the Arena by 44%",
        "skill1": "Psycho Inferno",
        "skill2": "Double Knee Press",
        "skill3": "Ultimate Psycho Crusher",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835919d145e7a48f72ed26"
        },
        "name": "M.BISON Water",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "M.BISON-Water",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/mbison/mbison_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/mbison/mbison_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "M.BISON",
        "type": "HP",
        "leaderSkill": "Increase the Accuracy of ally monsters in the Arena by 55%",
        "skill1": "Psycho Inferno",
        "skill2": "Psycho Crusher",
        "skill3": "Demonic Being",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283591dd145e7a48f72ed28"
        },
        "name": "M.BISON Wind",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "M.BISON-Wind",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/mbison/mbison_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/mbison/mbison_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "M.BISON",
        "type": "HP",
        "leaderSkill": "Increase the Defense of ally monsters in the Arena by 44%",
        "skill1": "Psycho Inferno",
        "skill2": "Psycho Crusher",
        "skill3": "Head Press",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835921d145e7a48f72ed2a"
        },
        "name": "Kiki",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Kiki",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/mage/mage_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/mage/mage_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Mage",
        "type": "Support",
        "leaderSkill": "Increase the Defense of ally monsters in Guild Content by 44%",
        "skill1": "Magical Eye",
        "skill2": "Mana Storm",
        "skill3": "Start of Pain",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835925d145e7a48f72ed2c"
        },
        "name": "Dorothy",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Dorothy",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/mage/mage_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/mage/mage_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Mage",
        "type": "Attack",
        "leaderSkill": "Increase the Resistance of ally monsters in Guild Content by 55%",
        "skill1": "Magical Eye",
        "skill2": "Night Crow",
        "skill3": "Time of Destruction",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835928d145e7a48f72ed2e"
        },
        "name": "Coco",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Coco",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/mage/mage_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/mage/mage_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Mage",
        "type": "Attack",
        "leaderSkill": "Increase the Critical Rate of ally monsters in Guild Content by 33%",
        "skill1": "Magical Eye",
        "skill2": "Night Crow",
        "skill3": "Chaos Magic Circle",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283592cd145e7a48f72ed30"
        },
        "name": "Nana",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Nana",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/mage/mage_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/mage/mage_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Mage",
        "type": "Support",
        "leaderSkill": "Increase the Accuracy of ally monsters in Guild Content by 55%",
        "skill1": "Magical Eye",
        "skill2": "Mana Storm",
        "skill3": "Soul Harvest",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283592fd145e7a48f72ed32"
        },
        "name": "Momo",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Momo",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/mage/mage_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/mage/mage_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Mage",
        "type": "Attack",
        "leaderSkill": "Increase the Attack Power of ally monsters in Guild Content by 44%",
        "skill1": "Magical Eye",
        "skill2": "Mana Storm",
        "skill3": "Secret Book",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835933d145e7a48f72ed34"
        },
        "name": "Son Zhang Lao",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Son-Zhang-Lao",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/monkeyking/monkeyking_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/monkeyking/monkeyking_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Monkey King",
        "type": "Attack",
        "leaderSkill": "Increases the Accuracy of ally monsters by 41%",
        "skill1": "Monkey Wand",
        "skill2": "Dark Monkey Wand",
        "skill3": "Summon Clouds",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283593bd145e7a48f72ed36"
        },
        "name": "Qitian Dasheng",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Qitian-Dasheng",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/monkeyking/monkeyking_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/monkeyking/monkeyking_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Monkey King",
        "type": "Support",
        "leaderSkill": "Increases the Resistance of ally monsters by 41%",
        "skill1": "Monkey Wand",
        "skill2": "All or Nothing",
        "skill3": "Giant Net",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283593fd145e7a48f72ed38"
        },
        "name": "Mei Hou Wang",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Mei-Hou-Wang",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/monkeyking/monkeyking_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/monkeyking/monkeyking_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Monkey King",
        "type": "Defense",
        "leaderSkill": "Increases the HP of ally monsters by 33%",
        "skill1": "Monkey Wand",
        "skill2": "Lighting Monkey Wand",
        "skill3": "Stone Monkey",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835944d145e7a48f72ed3a"
        },
        "name": "Shi Hou",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Shi-Hou",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/monkeyking/monkeyking_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/monkeyking/monkeyking_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Monkey King",
        "type": "Attack",
        "leaderSkill": "Increases the Attack Power of ally monsters by 33%",
        "skill1": "Monkey Wand",
        "skill2": "All or Nothing",
        "skill3": "Alter Ego Attack",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835948d145e7a48f72ed3c"
        },
        "name": "Xing Zhe",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Xing-Zhe",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/monkeyking/monkeyking_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/monkeyking/monkeyking_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Monkey King",
        "type": "HP",
        "leaderSkill": "Increases the Defense of ally monsters by 33%",
        "skill1": "Monkey Wand",
        "skill2": "Fire Monkey Wand",
        "skill3": "Gold Headband",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283594dd145e7a48f72ed3e"
        },
        "name": "Nicki",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Nicki",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/occultgirl/occultgirl_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/occultgirl/occultgirl_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Occult Girl",
        "type": "Attack",
        "leaderSkill": "Increases the Critical Rate of ally monsters with Dark attribute by 38%",
        "skill1": "Help Me, Teddy",
        "skill2": "Girl's Prayer",
        "skill3": "Dark Guardian Angel",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835950d145e7a48f72ed40"
        },
        "name": "Lora",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Lora",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/occultgirl/occultgirl_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/occultgirl/occultgirl_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Occult Girl",
        "type": "HP",
        "leaderSkill": "Increases the Critical Rate of ally monsters with Light attribute by 38%",
        "skill1": "Help Me, Teddy",
        "skill2": "Toy Knight",
        "skill3": "Light Guardian Angel",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835954d145e7a48f72ed42"
        },
        "name": "Rica",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Rica",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/occultgirl/occultgirl_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/occultgirl/occultgirl_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Occult Girl",
        "type": "Attack",
        "leaderSkill": "Increases the Critical Rate of ally monsters with Fire attribute by 38%",
        "skill1": "Help Me, Teddy",
        "skill2": "Toy Knight",
        "skill3": "Fire Guardian Angel",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835957d145e7a48f72ed44"
        },
        "name": "Anavel",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Anavel",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/occultgirl/occultgirl_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/occultgirl/occultgirl_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Occult Girl",
        "type": "Support",
        "leaderSkill": "Increases the Critical Rate of ally monsters with Water attribute by 38%",
        "skill1": "Help Me, Teddy",
        "skill2": "Girl's Prayer",
        "skill3": "Water Guardian Angel",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283595bd145e7a48f72ed46"
        },
        "name": "Charlotte",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Charlotte",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/occultgirl/occultgirl_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/occultgirl/occultgirl_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Occult Girl",
        "type": "Attack",
        "leaderSkill": "Increases the Critical Rate of ally monsters with Wind attribute by 38%",
        "skill1": "Help Me, Teddy",
        "skill2": "Toy Knight",
        "skill3": "Wind Guardian Angel",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283595ed145e7a48f72ed48"
        },
        "name": "Ongyouki",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Ongyouki",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/onimusha/dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/onimusha/dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Onimusha",
        "type": "Attack",
        "leaderSkill": "Increase the HP of ally monsters in the Arena by 33%",
        "skill1": "Ghost Slash",
        "skill2": "Ghost Wild Dance",
        "skill3": "Indomitable",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835962d145e7a48f72ed4a"
        },
        "name": "Kinki",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Kinki",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/onimusha/light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/onimusha/light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Onimusha",
        "type": "HP",
        "leaderSkill": "",
        "skill1": "Ghost Slash",
        "skill2": "Blade Slaughter",
        "skill3": "Banging Head Against A Brick Wall",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835966d145e7a48f72ed4c"
        },
        "name": "Kaki",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Kaki",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/onimusha/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/onimusha/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Onimusha",
        "type": "Attack",
        "leaderSkill": "",
        "skill1": "Ghost Slash",
        "skill2": "Blade Slaughter",
        "skill3": "Forestall",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283596ad145e7a48f72ed4e"
        },
        "name": "Suiki",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Suiki",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/onimusha/water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/onimusha/water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Onimusha",
        "type": "Attack",
        "leaderSkill": "",
        "skill1": "Ghost Slash",
        "skill2": "Ghost Wild Dance",
        "skill3": "Undergo Hardship",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283596dd145e7a48f72ed50"
        },
        "name": "Fuuki",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Fuuki",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/onimusha/wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/onimusha/wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Onimusha",
        "type": "HP",
        "leaderSkill": "",
        "skill1": "Ghost Slash",
        "skill2": "Blade Slaughter",
        "skill3": "Calculated Sacrifice",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835972d145e7a48f72ed52"
        },
        "name": "Douman",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Douman",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/onmyouji/dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/onmyouji/dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Onmyouji",
        "type": "Support",
        "leaderSkill": "Increase the Accuracy of ally monsters by 41%",
        "skill1": "Burning Soul",
        "skill2": "Karma",
        "skill3": "Curse of Death",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835976d145e7a48f72ed54"
        },
        "name": "Seimei",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Seimei",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/onmyouji/light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/onmyouji/light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Onmyouji",
        "type": "Support",
        "leaderSkill": "Increase the Defense of ally monsters by 33%",
        "skill1": "Burning Soul",
        "skill2": "Past Life Spell",
        "skill3": "Yin-Yang Five Elements",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835979d145e7a48f72ed56"
        },
        "name": "Tomoe",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Tomoe",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/onmyouji/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/onmyouji/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Onmyouji",
        "type": "Support",
        "leaderSkill": "Increase the Attack Speed of ally monsters by 24%",
        "skill1": "Burning Soul",
        "skill2": "Karma",
        "skill3": "Yin-Yang Bounded Circle",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "6283597cd145e7a48f72ed58"
        },
        "name": "Shizuka",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Shizuka",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/onmyouji/water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/onmyouji/water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Onmyouji",
        "type": "Support",
        "leaderSkill": "Increase the HP of ally monsters by 33% ",
        "skill1": "Burning Soul",
        "skill2": "Past Life Spell",
        "skill3": "All Things in Nature",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835980d145e7a48f72ed5a"
        },
        "name": "Giou",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Giou",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/onmyouji/wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/onmyouji/wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Onmyouji",
        "type": "Support",
        "leaderSkill": "Increase the Resistance of ally monsters by 41%",
        "skill1": "Burning Soul",
        "skill2": "Karma",
        "skill3": "Comeuppance",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628359bfd145e7a48f72ed5d"
        },
        "name": "Giana",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Giana",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/oracle/dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/oracle/dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Oracle",
        "type": "Attack",
        "leaderSkill": "Increases the Attack Power of ally monsters by 33%",
        "skill1": "Passing Time",
        "skill2": "Fate of Destruction 1",
        "skill3": "Critical Error",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628359c2d145e7a48f72ed5f"
        },
        "name": "Laima",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Laima",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/oracle/light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/oracle/light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Oracle",
        "type": "Support",
        "leaderSkill": "Increases the Accuracy of ally monsters by 41%",
        "skill1": "Passing Time",
        "skill2": "Predicted Future",
        "skill3": "Start and End",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628359c6d145e7a48f72ed61"
        },
        "name": "Juno",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Juno",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/oracle/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/oracle/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Oracle",
        "type": "Support",
        "leaderSkill": "Increases the Critical Rate of ally monsters by 24%",
        "skill1": "Passing Time",
        "skill2": "Predicted Future",
        "skill3": "Loss of Cause and Effect",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628359c9d145e7a48f72ed63"
        },
        "name": "Praha",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Praha",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/oracle/water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/oracle/water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Oracle",
        "type": "Support",
        "leaderSkill": "Increases the Resistance of ally monsters by 41%",
        "skill1": "Passing Time",
        "skill2": "Predicted Future",
        "skill3": "Daydream",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628359ced145e7a48f72ed65"
        },
        "name": "Seara",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Seara",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/oracle/wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/oracle/wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Oracle",
        "type": "Attack",
        "leaderSkill": "Increases the Attack Speed of ally monsters by 24%",
        "skill1": "Passing Time",
        "skill2": "Fate of Destruction 2",
        "skill3": "Promised Time",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628359d1d145e7a48f72ed67"
        },
        "name": "Leona",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Leona",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/paladin/dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/paladin/dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Paladin",
        "type": "Defense",
        "leaderSkill": "Increases the Critical Rate of ally monsters Guild Battles by 33%",
        "skill1": "Justice Strike",
        "skill2": "Fury of Punishment",
        "skill3": "Internal Force",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628359d5d145e7a48f72ed69"
        },
        "name": "Jeanne",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Jeanne",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/paladin/light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/paladin/light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Paladin",
        "type": "HP",
        "leaderSkill": "Increases the Resistance of ally monsters by 41%",
        "skill1": "Justice Strike",
        "skill2": "Prayer of Protection",
        "skill3": "Cry of Provocation",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628359d8d145e7a48f72ed6b"
        },
        "name": "Ophilia",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Ophilia",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/paladin/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/paladin/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Paladin",
        "type": "HP",
        "leaderSkill": "Increases the Defense of ally monsters Guild Battles by 44%",
        "skill1": "Justice Strike",
        "skill2": "Prayer of Protection",
        "skill3": "Cry of Threat",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628359dcd145e7a48f72ed6d"
        },
        "name": "Josephine",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Josephine",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/paladin/water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/paladin/water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Paladin",
        "type": "HP",
        "leaderSkill": "Increases the Accuracy of ally monsters by 41%",
        "skill1": "Justice Strike",
        "skill2": "Fury of Punishment",
        "skill3": "Heavenly Blessing",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628359e0d145e7a48f72ed6f"
        },
        "name": "Louise",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Louise",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/paladin/wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/paladin/wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Paladin",
        "type": "Support",
        "leaderSkill": "Increases the HP of ally monsters Guild Battles by 44%",
        "skill1": "Justice Strike",
        "skill2": "Prayer of Protection",
        "skill3": "Divine Wind",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628359e3d145e7a48f72ed71"
        },
        "name": "Mi Ying",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Mi-Ying",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/pandawarrior/dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/pandawarrior/dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Panda Warrior",
        "type": "Attack",
        "leaderSkill": "Increases the Attack Power of ally monsters Guild Battles by 44%",
        "skill1": "Sequential Attack",
        "skill2": "Calm Mind",
        "skill3": "Almighty Strength",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628359e9d145e7a48f72ed73"
        },
        "name": "Tian Lang",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Tian-Lang",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/pandawarrior/light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/pandawarrior/light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Panda Warrior",
        "type": "Attack",
        "leaderSkill": "Increases the HP of ally monsters Guild Battles by 44%",
        "skill1": "Sequential Attack",
        "skill2": "Dragon's Dance",
        "skill3": "Strong Energy",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628359edd145e7a48f72ed75"
        },
        "name": "Xiong Fei",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Xiong-Fei",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/pandawarrior/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/pandawarrior/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Panda Warrior",
        "type": "Defense",
        "leaderSkill": "Increases the Defense of ally monsters by 33%",
        "skill1": "Sequential Attack",
        "skill2": "Calm Mind",
        "skill3": "Panda Supremacy",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628359f2d145e7a48f72ed77"
        },
        "name": "Mo Long",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Mo-Long",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/pandawarrior/water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/pandawarrior/water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Panda Warrior",
        "type": "HP",
        "leaderSkill": "Increases the HP of ally monsters by 33%",
        "skill1": "Sequential Attack",
        "skill2": "Dragon's Dance",
        "skill3": "Reckless Assault",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628359f7d145e7a48f72ed79"
        },
        "name": "Feng Yan",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Feng-Yan",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/pandawarrior/wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/pandawarrior/wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Panda Warrior",
        "type": "Defense",
        "leaderSkill": "Increases the Defense of ally monsters Guild Battles by 44%",
        "skill1": "Sequential Attack",
        "skill2": "Calm Mind",
        "skill3": "Winds and Clouds",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628359fcd145e7a48f72ed7b"
        },
        "name": "Jaara",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Jaara",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/phoenix/dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/phoenix/dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Phoenix",
        "type": "Attack",
        "leaderSkill": "Increases the Resistance of ally monsters in the Dungeons by 55%",
        "skill1": "Arcane Blast",
        "skill2": "Dark Nova",
        "skill3": "Fiery Path",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "628359ffd145e7a48f72ed7d"
        },
        "name": "Eludia",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Eludia",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/phoenix/light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/phoenix/light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Phoenix",
        "type": "Attack",
        "leaderSkill": "Increases the Defense of ally monsters in the Dungeons by 44%",
        "skill1": "Arcane Blast",
        "skill2": "Holy Orb",
        "skill3": "Purifying Blaze",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a03d145e7a48f72ed7f"
        },
        "name": "Perna",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Perna",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/phoenix/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/phoenix/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Phoenix",
        "type": "HP",
        "leaderSkill": "Increases the Attack Power of ally monsters in the Dungeons by 44%",
        "skill1": "Arcane Blast",
        "skill2": "Flame Nova",
        "skill3": "Eternity",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a07d145e7a48f72ed81"
        },
        "name": "Sigmarus",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Sigmarus",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/phoenix/water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/phoenix/water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Phoenix",
        "type": "Attack",
        "leaderSkill": "Increases the HP of ally monsters in the Dungeons by 44%",
        "skill1": "Arcane Blast",
        "skill2": "Frozen Orb",
        "skill3": "Ice Volcano",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a0cd145e7a48f72ed83"
        },
        "name": "Teshar",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Teshar",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/phoenix/wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/phoenix/wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Phoenix",
        "type": "Attack",
        "leaderSkill": "Increases the Critical Rate of ally monsters in the Dungeons by 33%",
        "skill1": "Arcane Blast",
        "skill2": "Lightning Nova",
        "skill3": "Tempest",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a0fd145e7a48f72ed85"
        },
        "name": "Woonsa",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Woonsa",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/pioneer/dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/pioneer/dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Pioneer",
        "type": "HP",
        "leaderSkill": "Increases the Defense of ally monsters by 33%",
        "skill1": "Yin Yang Attack",
        "skill2": "North Star's Wisdom",
        "skill3": "Inhale Magic",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a13d145e7a48f72ed87"
        },
        "name": "Nigong",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Nigong",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/pioneer/light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/pioneer/light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Pioneer",
        "type": "HP",
        "leaderSkill": "Increases the HP of ally monsters by 33%",
        "skill1": "Yin Yang Attack",
        "skill2": "Mountain's Power",
        "skill3": "Heavenly Protection",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a18d145e7a48f72ed89"
        },
        "name": "Chiwu",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Chiwu",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/pioneer/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/pioneer/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Pioneer",
        "type": "HP",
        "leaderSkill": "Increases the Attack Speed of ally monsters by 24%",
        "skill1": "Yin Yang Attack",
        "skill2": "North Star's Wisdom",
        "skill3": "Sleeve Attack",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a1fd145e7a48f72ed8b"
        },
        "name": "Woosa",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Woosa",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/pioneer/water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/pioneer/water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Pioneer",
        "type": "HP",
        "leaderSkill": "Increases the Accuracy of ally monsters by 41%",
        "skill1": "Yin Yang Attack",
        "skill2": "Mountain's Power",
        "skill3": "Wish of Immortality",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a22d145e7a48f72ed8d"
        },
        "name": "Pungbaek",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Pungbaek",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/pioneer/wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/pioneer/wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Pioneer",
        "type": "HP",
        "leaderSkill": "Increases the Critical Rate of ally monsters by 24%",
        "skill1": "Yin Yang Attack",
        "skill2": "North Star's Wisdom",
        "skill3": "Lightning of Cycle",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a26d145e7a48f72ed8f"
        },
        "name": "Lydia",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Lydia",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/polarqueen/dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/polarqueen/dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Polar Queen",
        "type": "Attack"
    },
    {
        "_id": {
            "$oid": "62835a29d145e7a48f72ed91"
        },
        "name": "Elenoa",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Elenoa",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/polarqueen/light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/polarqueen/light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Polar Queen",
        "type": "Attack"
    },
    {
        "_id": {
            "$oid": "62835a2cd145e7a48f72ed93"
        },
        "name": "Brandia",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Brandia",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/polarqueen/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/polarqueen/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Polar Queen",
        "type": "Attack"
    },
    {
        "_id": {
            "$oid": "62835a30d145e7a48f72ed95"
        },
        "name": "Alicia",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Alicia",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/polarqueen/water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/polarqueen/water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Polar Queen",
        "type": "Attack"
    },
    {
        "_id": {
            "$oid": "62835a33d145e7a48f72ed97"
        },
        "name": "Tiana",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Tiana",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/polarqueen/wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/polarqueen/wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Polar Queen",
        "type": "Support"
    },
    {
        "_id": {
            "$oid": "62835a36d145e7a48f72ed99"
        },
        "name": "RYU Dark",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "RYU-Dark",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/ryu/dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/ryu/dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "RYU",
        "type": "Attack",
        "leaderSkill": "Increase the Critical Rate of ally monsters by 24%",
        "skill1": "Hadoken",
        "skill2": "Shoryuken",
        "skill3": "PPK Combo",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a3bd145e7a48f72ed9b"
        },
        "name": "RYU Light",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "RYU-Light",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/ryu/light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/ryu/light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "RYU",
        "type": "Attack",
        "leaderSkill": "Increase the Resistance of ally monsters by 41%",
        "skill1": "Hadoken",
        "skill2": "Tatsumaki Senpukyaku",
        "skill3": "Denjin Hadoken",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a3fd145e7a48f72ed9d"
        },
        "name": "RYU Fire",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "RYU-Fire",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/ryu/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/ryu/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "RYU",
        "type": "Attack",
        "leaderSkill": "Increase the Attack Power of ally monsters by 33%",
        "skill1": "Hadoken",
        "skill2": "Shoryuken",
        "skill3": "Martial Art's Instinct",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a44d145e7a48f72ed9f"
        },
        "name": "RYU Wind",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "RYU-Wind",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/ryu/wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/ryu/wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "RYU",
        "type": "Attack",
        "leaderSkill": "Increase the Attack Speed of ally monsters by 24%",
        "skill1": "Hadoken",
        "skill2": "Tatsumaki Senpukyaku",
        "skill3": "Mind's Eye",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a49d145e7a48f72eda1"
        },
        "name": "RYU Water",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "RYU-Water",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/ryu/water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/ryu/water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "RYU",
        "type": "Attack",
        "leaderSkill": "Increase the Accuracy of ally monsters by 41%",
        "skill1": "Hadoken",
        "skill2": "Shoryuken",
        "skill3": "Triple Combo",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a4dd145e7a48f72eda3"
        },
        "name": "Manannan",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Manannan",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/seaemperor/dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/seaemperor/dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Sea Emperor",
        "type": "Attack",
        "leaderSkill": "Increases the Critical Rate of ally monsters by 24%",
        "skill1": "Power Surge",
        "skill2": "Spear of Devastation",
        "skill3": "King of the Ruins",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a51d145e7a48f72eda5"
        },
        "name": "Pontos",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Pontos",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/seaemperor/light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/seaemperor/light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Sea Emperor",
        "type": "Support",
        "leaderSkill": "Increases the Attack Speed of ally monsters by 24%",
        "skill1": "Power Surge",
        "skill2": "Sweeping Waves",
        "skill3": "Holy Ground",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a5dd145e7a48f72eda7"
        },
        "name": "Okeanos",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Okeanos",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/seaemperor/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/seaemperor/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Sea Emperor",
        "type": "Attack",
        "leaderSkill": "Increases the Accuracy of ally monsters by 41%",
        "skill1": "Power Surge",
        "skill2": "Spear of Devastation",
        "skill3": "Rain of Stones",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a60d145e7a48f72eda9"
        },
        "name": "Poseidon",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Poseidon",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/seaemperor/water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/seaemperor/water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Sea Emperor",
        "type": "Attack",
        "leaderSkill": "Increases the Attack Power of ally monsters by 33%",
        "skill1": "Power Surge",
        "skill2": "Sweeping Waves",
        "skill3": "Maelstrom",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a64d145e7a48f72edab"
        },
        "name": "Triton",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Triton",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/seaemperor/wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/seaemperor/wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Sea Emperor",
        "type": "Defense",
        "leaderSkill": "Increases the Defense of ally monsters by 33%",
        "skill1": "Power Surge",
        "skill2": "Sweeping Waves",
        "skill3": "Mega Tsunami",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a68d145e7a48f72edad"
        },
        "name": "Bernadotte",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Bernadotte",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/shadowclaw/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/shadowclaw/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Shadow Claw",
        "type": "Attack",
        "leaderSkill": "Increase the Critical Rate of ally monsters in the Dungeons by 33%",
        "skill1": "Mach Slash",
        "skill2": "Hurricane Rush",
        "skill3": "Shadow Blade",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a6bd145e7a48f72edaf"
        },
        "name": "Ritsu",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Ritsu",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/shadowcaster/dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/shadowcaster/dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Shadowcaster",
        "type": "Attack",
        "leaderSkill": "Increase the Critical Rate of ally monsters with Dark attribute by 38%",
        "skill1": "Dizzying Gesture",
        "skill2": "Shadow of Right Arm",
        "skill3": "Shadow Trap",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a6fd145e7a48f72edb1"
        },
        "name": "Shun",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Shun",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/shadowcaster/light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/shadowcaster/light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Shadowcaster",
        "type": "Attack",
        "leaderSkill": "Increase the Critical Rate of ally monsters with Light attribute by 38%",
        "skill1": "Dizzying Gesture",
        "skill2": "Shadow Tie",
        "skill3": "Infinity Shadow",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a74d145e7a48f72edb3"
        },
        "name": "Ren",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Ren",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/shadowcaster/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/shadowcaster/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Shadowcaster",
        "type": "Attack",
        "leaderSkill": "Increase the Critical Rate of ally monsters with Fire attribute by 38%",
        "skill1": "Dizzying Gesture",
        "skill2": "Shadow of Right Arm",
        "skill3": "Destructive Shadow",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a79d145e7a48f72edb5"
        },
        "name": "Minato",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Minato",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/shadowcaster/water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/shadowcaster/water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Shadowcaster",
        "type": "Attack",
        "leaderSkill": "Increase the Critical Rate of ally monsters with Water attribute by 38%",
        "skill1": "Dizzying Gesture",
        "skill2": "Shadow of Right Arm",
        "skill3": "Shadow Within Me",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835a7cd145e7a48f72edb7"
        },
        "name": "Zen",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Zen",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/shadowcaster/wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/shadowcaster/wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Shadowcaster",
        "type": "Attack",
        "leaderSkill": "Increase the Critical Rate of ally monsters with Wind attribute by 38%",
        "skill1": "Dizzying Gesture",
        "skill2": "Shadow Tie",
        "skill3": "Frantic Chaos",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835aacd145e7a48f72edbb"
        },
        "name": "Jackson",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Jackson",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/skysurfer/dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/skysurfer/dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Sky Surfer",
        "type": "Attack",
        "leaderSkill": "Increase the Accuracy of ally monsters in the Arena by 55%",
        "skill1": "Cutback Blow",
        "skill2": "Spin Grab Shot",
        "skill3": "Synergistic Effect",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835aafd145e7a48f72edbd"
        },
        "name": "Daniel",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Daniel",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/skysurfer/light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/skysurfer/light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Sky Surfer",
        "type": "Attack",
        "leaderSkill": "Increase the Critical Rate of ally monsters in the Arena by 33%",
        "skill1": "Cutback Blow",
        "skill2": "Impulse Gun",
        "skill3": "Quantum Explosion",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835ab2d145e7a48f72edbf"
        },
        "name": "John",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "John",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/skysurfer/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/skysurfer/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Sky Surfer",
        "type": "Attack",
        "leaderSkill": "Increase the Resistance of ally monsters in the Arena by 55%",
        "skill1": "Cutback Blow",
        "skill2": "Impulse Gun",
        "skill3": "Plasma Bomb",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835abad145e7a48f72edc1"
        },
        "name": "Miles",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Miles",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/skysurfer/water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/skysurfer/water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Sky Surfer",
        "type": "Support",
        "leaderSkill": "Increase the Defense of ally monsters in the Arena by 44%",
        "skill1": "Cutback Blow",
        "skill2": "Spin Grab Shot",
        "skill3": "Jet Engine",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835abed145e7a48f72edc3"
        },
        "name": "Oliver",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Oliver",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/skysurfer/wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/skysurfer/wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Sky Surfer",
        "type": "Attack",
        "leaderSkill": "Increase the Attack Speed of ally monsters in the Arena by 33%",
        "skill1": "Cutback Blow",
        "skill2": "Impulse Gun",
        "skill3": "Mega Impulse Gun",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835ac1d145e7a48f72edc5"
        },
        "name": "Gurkha",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Gurkha",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/slayer/dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/slayer/dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Slayer",
        "type": "HP",
        "leaderSkill": "Increase the Critical Rate of ally monsters in the Arena by 33%",
        "skill1": "Rage Explosion",
        "skill2": "Sword of Burst",
        "skill3": "Ruler of Pain",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835ac4d145e7a48f72edc7"
        },
        "name": "Craig",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Craig",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/slayer/light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/slayer/light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Slayer",
        "type": "HP",
        "leaderSkill": "Increase the Resistance of ally monsters in the Arena by 55%",
        "skill1": "Rage Explosion",
        "skill2": "Sword of Gluttony",
        "skill3": "Devil's Grace",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835ac8d145e7a48f72edc9"
        },
        "name": "Karnal",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Karnal",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/slayer/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/slayer/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Slayer",
        "type": "HP",
        "leaderSkill": "Increase the HP of ally monsters in the Arena by 44%",
        "skill1": "Rage Explosion",
        "skill2": "Sword of Gluttony",
        "skill3": "Sword Rain",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835accd145e7a48f72edcb"
        },
        "name": "Borgnine",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Borgnine",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/slayer/water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/slayer/water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Slayer",
        "type": "Support",
        "leaderSkill": "Increase the Accuracy of ally monsters in the Arena by 55%",
        "skill1": "Rage Explosion",
        "skill2": "Sword of Burst",
        "skill3": "Destroyer of Battlefield",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835acfd145e7a48f72edcd"
        },
        "name": "Sagar",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Sagar",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/slayer/wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/slayer/wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Slayer",
        "type": "HP",
        "leaderSkill": "Increase the Defense of ally monsters in the Arena by 44%",
        "skill1": "Rage Explosion",
        "skill2": "Sword of Burst",
        "skill3": "Great Sword of the End",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835ad2d145e7a48f72edcf"
        },
        "name": "Vancliffe",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Vancliffe",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/striker/dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/striker/dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Striker",
        "type": "Attack",
        "leaderSkill": "Increase the Critical Rate of ally monsters by 24%",
        "skill1": "Mach Punch",
        "skill2": "Iron Uppercut",
        "skill3": "Chain Combo Attack",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835ad5d145e7a48f72edd1"
        },
        "name": "Talisman",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Talisman",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/striker/light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/striker/light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Striker",
        "type": "Attack",
        "leaderSkill": "Increase the Resistance of ally monsters by 41%",
        "skill1": "Mach Punch",
        "skill2": "Rolling Spike",
        "skill3": "Final Drive",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835adbd145e7a48f72edd3"
        },
        "name": "Douglas",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Douglas",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/striker/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/striker/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Striker",
        "type": "Attack",
        "leaderSkill": "Increase the Attack Power of ally monsters by 33%",
        "skill1": "Mach Punch",
        "skill2": "Iron Uppercut",
        "skill3": "Attack is the Best Form of Defense",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835aded145e7a48f72edd5"
        },
        "name": "Moore",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Moore",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/striker/water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/striker/water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Striker",
        "type": "Support",
        "leaderSkill": "Increase the Attack Speed of ally monsters by 24% ",
        "skill1": "Mach Punch",
        "skill2": "Rolling Spike",
        "skill3": "Overdrive",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835ae1d145e7a48f72edd7"
        },
        "name": "Kashmir",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Kashmir",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/striker/wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/striker/wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Striker",
        "type": "Attack",
        "leaderSkill": "Increase the Accuracy of ally monsters by 41%",
        "skill1": "Mach Punch",
        "skill2": "Iron Uppercut",
        "skill3": "Triple Crush",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835ae7d145e7a48f72edd9"
        },
        "name": "Maya",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Maya",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/totemist/dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/totemist/dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Totemist",
        "type": "Support",
        "leaderSkill": "",
        "skill1": "Totem Magic",
        "skill2": "Totem Friends",
        "skill3": "Ancestor's Blessing",
        "skill4": "Half Moon Tribe Totem"
    },
    {
        "_id": {
            "$oid": "62835aedd145e7a48f72eddb"
        },
        "name": "Ella",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Ella",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/totemist/light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/totemist/light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Totemist",
        "type": "Support",
        "leaderSkill": "",
        "skill1": "Totem Magic",
        "skill2": "Dance with the Elemental",
        "skill3": "Wise Owl Soul",
        "skill4": "Sun Tribe Totem"
    },
    {
        "_id": {
            "$oid": "62835af0d145e7a48f72eddd"
        },
        "name": "Nora",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Nora",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/totemist/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/totemist/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Totemist",
        "type": "Support",
        "leaderSkill": "",
        "skill1": "Totem Magic",
        "skill2": "Totem Friends",
        "skill3": "Ancestor's Wisdom",
        "skill4": "Volcanic Tribe Totem"
    },
    {
        "_id": {
            "$oid": "62835af9d145e7a48f72eddf"
        },
        "name": "Aaliyah",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Aaliyah",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/totemist/water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/totemist/water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Totemist",
        "type": "Support",
        "leaderSkill": "",
        "skill1": "Totem Magic",
        "skill2": "Dance with the Elemental",
        "skill3": "Strong Bull Soul",
        "skill4": "Sea Tribe Totem"
    },
    {
        "_id": {
            "$oid": "62835afed145e7a48f72ede1"
        },
        "name": "Riley",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Riley",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/totemist/wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/totemist/wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Totemist",
        "type": "Support",
        "leaderSkill": "",
        "skill1": "Totem Magic",
        "skill2": "Dance with the Elemental",
        "skill3": "Valiant Boar Soul",
        "skill4": "Grassland Tribe Totem"
    },
    {
        "_id": {
            "$oid": "62835b02d145e7a48f72ede3"
        },
        "name": "Alexandra",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Alexandra",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/unicorn/dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/unicorn/dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Unicorn",
        "type": "HP",
        "leaderSkill": "",
        "skill1": "Dark Horn",
        "skill2": "Nature's Protection",
        "skill3": "Other Side of the Moon",
        "skill4": "Transformation: Human Form 2"
    },
    {
        "_id": {
            "$oid": "62835b06d145e7a48f72ede5"
        },
        "name": "Eleanor",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Eleanor",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/unicorn/light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/unicorn/light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Unicorn",
        "type": "Attack",
        "leaderSkill": "",
        "skill1": "Holy Horn",
        "skill2": "Fierce Charge",
        "skill3": "Dazzling Flash",
        "skill4": "Transformation: Human Form 2"
    },
    {
        "_id": {
            "$oid": "62835b09d145e7a48f72ede7"
        },
        "name": "Helena",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Helena",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/unicorn/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/unicorn/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Unicorn",
        "type": "HP",
        "leaderSkill": "",
        "skill1": "Fire Horn",
        "skill2": "Nature's Protection",
        "skill3": "Eternal Flame",
        "skill4": "Transformation: Human Form 1"
    },
    {
        "_id": {
            "$oid": "62835b0cd145e7a48f72ede9"
        },
        "name": "Amelia",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Amelia",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/unicorn/water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/unicorn/water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Unicorn",
        "type": "HP",
        "leaderSkill": "",
        "skill1": "Ice Horn",
        "skill2": "Fierce Charge",
        "skill3": "Protection Wings",
        "skill4": "Transformation: Human Form 2"
    },
    {
        "_id": {
            "$oid": "62835b11d145e7a48f72edeb"
        },
        "name": "Diana",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Diana",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/unicorn/wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/unicorn/wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Unicorn",
        "type": "HP",
        "leaderSkill": "",
        "skill1": "Lightning Horn",
        "skill2": "Nature's Protection",
        "skill3": "Messenger of the Wind",
        "skill4": "Transformation: Human Form 1"
    },
    {
        "_id": {
            "$oid": "62835b15d145e7a48f72eded"
        },
        "name": "Trinity",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Trinity",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/valkyrja/dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/valkyrja/dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Valkyrja",
        "type": "HP",
        "leaderSkill": "Increases the Attack Speed of ally monsters in the Arena by 33%",
        "skill1": "Sword of Promise",
        "skill2": "Soul Reaper",
        "skill3": "Ragnarok",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835b19d145e7a48f72edef"
        },
        "name": "Akroma",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Akroma",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/valkyrja/light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/valkyrja/light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Valkyrja",
        "type": "Defense",
        "leaderSkill": "Increases the HP of ally monsters in the Arena by 44%",
        "skill1": "Sword of Promise",
        "skill2": "Seal of Light",
        "skill3": "God's Shield",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835b1dd145e7a48f72edf1"
        },
        "name": "Vanessa",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Vanessa",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/valkyrja/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/valkyrja/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Valkyrja",
        "type": "Support",
        "leaderSkill": "Increases the Attack Speed of ally monsters in the Arena by 33%",
        "skill1": "Sword of Promise",
        "skill2": "Soul Reaper",
        "skill3": "Warrior's Return",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835b20d145e7a48f72edf3"
        },
        "name": "Camilla",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Camilla",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/valkyrja/water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/valkyrja/water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Valkyrja",
        "type": "Attack",
        "leaderSkill": "Increases the Critical Rate of ally monsters in the Arena by 33%",
        "skill1": "Sword of Promise",
        "skill2": "Seal of Water",
        "skill3": "First Aid",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835b24d145e7a48f72edf5"
        },
        "name": "Katarina",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Katarina",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/valkyrja/wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/valkyrja/wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Valkyrja",
        "type": "Attack",
        "leaderSkill": "Increases the Resistance of ally monsters in the Arena by 55%",
        "skill1": "Sword of Promise",
        "skill2": "Soul Reaper",
        "skill3": "Sword of Discharge",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835b27d145e7a48f72edf7"
        },
        "name": "Eirgar",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "eirgar",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/vampirelord/vampirelord_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/vampirelord/vampirelord_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Vampire Lord",
        "type": "Attack",
        "leaderSkill": "Increases the Attack Power of ally monsters in the Dungeons by 38%",
        "skill1": "Vampire Lord - Vampire Bat",
        "skill2": "Vampire Lord - Weaken",
        "skill3": "Blood Contract",
        "skill4": "",
        "grade": "5",
        "image1": "/assets/images/monsters/vampirelord/vampirelord_dark.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T06:47:38.718Z"
        },
        "modifiedBy": "Hung Nguyen",
        "quantity": 1,
        "thumbImage1": "/assets/images/monsters/vampirelord/vampirelord_dark.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62835b2ad145e7a48f72edf9"
        },
        "name": "Maximilian",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Maximilian",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/weaponmaster/dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/weaponmaster/dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Dark",
        "species": "Weapon Master",
        "type": "Attack",
        "leaderSkill": "Increase the Attack Speed of ally monsters by 24%",
        "skill1": "Glaive Slash",
        "skill2": "Storm Scythe",
        "skill3": "Shadowless Movement",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835b2ed145e7a48f72edfb"
        },
        "name": "Benedict",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Benedict",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/weaponmaster/light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/weaponmaster/light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Light",
        "species": "Weapon Master",
        "type": "Attack",
        "leaderSkill": "Increase the Accuracy of ally monsters by 41%",
        "skill1": "Glaive Slash",
        "skill2": "Weakness Shot",
        "skill3": "Final Strike",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835b31d145e7a48f72edfd"
        },
        "name": "Carlos",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Carlos",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/weaponmaster/fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/weaponmaster/fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Fire",
        "species": "Weapon Master",
        "type": "Attack",
        "leaderSkill": "Increase the Critical Rate of ally monsters by 24%",
        "skill1": "Glaive Slash",
        "skill2": "Weakness Shot",
        "skill3": "Collect Weapons",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835b35d145e7a48f72edff"
        },
        "name": "Liam",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Liam",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/weaponmaster/water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/weaponmaster/water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Water",
        "species": "Weapon Master",
        "type": "Attack",
        "leaderSkill": "",
        "skill1": "Glaive Slash",
        "skill2": "Storm Scythe",
        "skill3": "",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835b38d145e7a48f72ee01"
        },
        "name": "Dominic",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "Dominic",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/weaponmaster/wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/weaponmaster/wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "__v": 0,
        "element": "Wind",
        "species": "Weapon Master",
        "type": "Attack",
        "leaderSkill": "Increase the HP of ally monsters by 33%",
        "skill1": "Glaive Slash",
        "skill2": "Weakness Shot",
        "skill3": "Improvisation",
        "skill4": ""
    },
    {
        "_id": {
            "$oid": "62835e041ab2e31db81c167c"
        },
        "name": "CRI Dmg+%",
        "category": "summonerswar",
        "subCategory": "runetypes",
        "slug": "cri-dmgpluspercent",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/runetypes/CRI_Dmg_percent.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runetypes/CRI_Dmg_percent.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "RuneType",
        "type": "Attack",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/runetypes/CRI_Dmg_percent.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "quantity": 1,
        "modified": {
            "$date": "2022-08-05T02:05:04.291Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "SW",
        "thumbImage1": "/assets/images/runetypes/CRI_Dmg_percent.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62835e0b1ab2e31db81c167e"
        },
        "name": "CRI Rate+%",
        "category": "summonerswar",
        "subCategory": "runetypes",
        "slug": "cri-ratepluspercent",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/runetypes/CRI_Rate_percent.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runetypes/CRI_Rate_percent.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "RuneType",
        "type": "Attack",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/runetypes/CRI_Rate_percent.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "quantity": 1,
        "modified": {
            "$date": "2022-08-05T03:26:05.276Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "SW",
        "thumbImage1": "/assets/images/runetypes/CRI_Rate_percent.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62835e111ab2e31db81c1680"
        },
        "name": "DEF+",
        "category": "summonerswar",
        "subCategory": "runetypes",
        "slug": "defplus",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/runetypes/def_plus.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runetypes/def_plus.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "RuneType",
        "type": "Attack",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/runetypes/def_plus.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "quantity": 4,
        "modified": {
            "$date": "2022-08-05T03:29:23.412Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "SW",
        "thumbImage1": "/assets/images/runetypes/def_plus.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62835e171ab2e31db81c1682"
        },
        "name": "DEF+%",
        "category": "summonerswar",
        "subCategory": "runetypes",
        "slug": "defpluspercent",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/runetypes/def_percent.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runetypes/def_percent.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "RuneType",
        "type": "Attack",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/runetypes/def_percent.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "quantity": 3,
        "modified": {
            "$date": "2022-08-05T03:29:59.545Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "SW",
        "thumbImage1": "/assets/images/runetypes/def_percent.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62835e1c1ab2e31db81c1684"
        },
        "name": "HP+",
        "category": "summonerswar",
        "subCategory": "runetypes",
        "slug": "hpplus",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/runetypes/hp_plus.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runetypes/hp_plus.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "RuneType",
        "type": "Attack",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/runetypes/hp_plus.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "quantity": 4,
        "modified": {
            "$date": "2022-08-05T03:32:39.856Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "SW",
        "thumbImage1": "/assets/images/runetypes/hp_plus.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62835e211ab2e31db81c1686"
        },
        "name": "HP+%",
        "category": "summonerswar",
        "subCategory": "runetypes",
        "slug": "hppluspercent",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/runetypes/hp_percent.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runetypes/hp_percent.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "RuneType",
        "type": "Attack",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/runetypes/hp_percent.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "quantity": 3,
        "modified": {
            "$date": "2022-08-05T03:33:25.518Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "SW",
        "thumbImage1": "/assets/images/runetypes/hp_percent.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62835e261ab2e31db81c1688"
        },
        "name": "Resistance+%",
        "category": "summonerswar",
        "subCategory": "runetypes",
        "slug": "resistancepluspercent",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/runetypes/Resistance_percent.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runetypes/Resistance_percent.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "RuneType",
        "type": "Attack",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/runetypes/Resistance_percent.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "quantity": 1,
        "modified": {
            "$date": "2022-08-05T03:35:12.032Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "SW",
        "thumbImage1": "/assets/images/runetypes/Resistance_percent.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62835e2b1ab2e31db81c168a"
        },
        "name": "SPD+",
        "category": "summonerswar",
        "subCategory": "runetypes",
        "slug": "spdplus",
        "rate": 5,
        "price": 1,
        "description": "More Information",
        "images": [
            "/assets/images/runetypes/spd_plus.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runetypes/spd_plus.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "RuneType",
        "type": "Attack",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/runetypes/spd_plus.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "quantity": 1,
        "modified": {
            "$date": "2022-08-05T03:36:10.685Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "SW",
        "thumbImage1": "/assets/images/runetypes/spd_plus.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628363f41fafc021f92d8471"
        },
        "name": "Energy",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "energy",
        "rate": 5,
        "price": 1,
        "quantity": 2,
        "description": "HP +15%",
        "images": [
            "/assets/images/runes/energy.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/energy.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "HP",
        "type": "HP",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628364031fafc021f92d8473"
        },
        "name": "Fatal",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Fatal",
        "rate": 5,
        "price": 1,
        "quantity": 4,
        "description": "Attack Power +35%",
        "images": [
            "/assets/images/runes/fatal.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/fatal.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Attack",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628364121fafc021f92d8475"
        },
        "name": "Blade",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Blade",
        "rate": 5,
        "price": 1,
        "quantity": 2,
        "description": "Critical Rate +15%",
        "images": [
            "/assets/images/runes/blade.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/blade.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Attack",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "6283641e1fafc021f92d8477"
        },
        "name": "Swift",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Swift",
        "rate": 5,
        "price": 1,
        "quantity": 4,
        "description": "Attack Speed +25%",
        "images": [
            "/assets/images/runes/swift.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/swift.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Attack",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "6283642c1fafc021f92d8479"
        },
        "name": "Focus",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Focus",
        "rate": 5,
        "price": 1,
        "quantity": 2,
        "description": "Accuracy +20%",
        "images": [
            "/assets/images/runes/focus.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/focus.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "effect",
        "type": "effect",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628364381fafc021f92d847b"
        },
        "name": "Guard",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Guard",
        "rate": 5,
        "price": 1,
        "quantity": 2,
        "description": "Defense +15%",
        "images": [
            "/assets/images/runes/guard.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/guard.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Defense",
        "type": "Defense",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628364461fafc021f92d847d"
        },
        "name": "Endure",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Endure",
        "rate": 5,
        "price": 1,
        "quantity": 2,
        "description": "Resistance +20%",
        "images": [
            "/assets/images/runes/endure.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/endure.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Effect",
        "type": "Effect",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628364591fafc021f92d847f"
        },
        "name": "Shield",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Shield",
        "rate": 5,
        "price": 1,
        "quantity": 2,
        "description": "Ally Shield 3 turns (15% of HP)",
        "images": [
            "/assets/images/runes/shield.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/shield.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Effect",
        "type": "Effect",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628364661fafc021f92d8481"
        },
        "name": "Revenge",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Revenge",
        "rate": 5,
        "price": 1,
        "quantity": 2,
        "description": "Counterattack +15%",
        "images": [
            "/assets/images/runes/revenge.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/revenge.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Attack",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628364731fafc021f92d8483"
        },
        "name": "Will",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Will",
        "rate": 5,
        "price": 1,
        "quantity": 2,
        "description": "Immunity +1 turn",
        "images": [
            "/assets/images/runes/will.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/will.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Effect",
        "type": "Effect",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628364811fafc021f92d8485"
        },
        "name": "Nemesis",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Nemesis",
        "rate": 5,
        "price": 1,
        "quantity": 2,
        "description": "ATK Gauge +4% (for every 7% HP lost)",
        "images": [
            "/assets/images/runes/nemesis.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/nemesis.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Attack",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "6283648e1fafc021f92d8487"
        },
        "name": "Vampire",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Vampire",
        "rate": 5,
        "price": 1,
        "quantity": 4,
        "description": "Life Drain +35%",
        "images": [
            "/assets/images/runes/vampire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/vampire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Attack",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "6283649b1fafc021f92d8489"
        },
        "name": "Destroy",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Destroy",
        "rate": 5,
        "price": 1,
        "quantity": 2,
        "description": "30% of the damage dealt will reduce up to 4% of the enemy's Max HP",
        "images": [
            "/assets/images/runes/destroy.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/destroy.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Attack",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628364ac1fafc021f92d848b"
        },
        "name": "Despair",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Despair",
        "rate": 5,
        "price": 1,
        "quantity": 4,
        "description": "Stun Rate +25%",
        "images": [
            "/assets/images/runes/despair.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/despair.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Effect",
        "type": "Effect",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628364b71fafc021f92d848d"
        },
        "name": "Violent",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Violent",
        "rate": 5,
        "price": 1,
        "quantity": 4,
        "description": "Get Extra Turn +22%",
        "images": [
            "/assets/images/runes/violent.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/violent.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Attack",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628364c21fafc021f92d848f"
        },
        "name": "Rage",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Rage",
        "rate": 5,
        "price": 1,
        "quantity": 4,
        "description": "Critical Damage +40%",
        "images": [
            "/assets/images/runes/rage.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/rage.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Attack",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628364cd1fafc021f92d8491"
        },
        "name": "Fight",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Fight",
        "rate": 5,
        "price": 1,
        "quantity": 2,
        "description": "Allies' ATK +8%",
        "images": [
            "/assets/images/runes/fight.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/fight.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Support",
        "type": "Support",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628364d91fafc021f92d8493"
        },
        "name": "Determination",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Determination",
        "rate": 5,
        "price": 1,
        "quantity": 2,
        "description": "Allies' DEF +8%",
        "images": [
            "/assets/images/runes/determination.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/determination.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Support",
        "type": "Support",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628364e21fafc021f92d8495"
        },
        "name": "Enhance",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Enhance",
        "rate": 5,
        "price": 1,
        "quantity": 2,
        "description": "Allies' HP +8%",
        "images": [
            "/assets/images/runes/enhance.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/enhance.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Support",
        "type": "Support",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628364ed1fafc021f92d8497"
        },
        "name": "Accuracy",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Accuracy",
        "rate": 5,
        "price": 1,
        "quantity": 2,
        "description": "Allies' ACC +10%",
        "images": [
            "/assets/images/runes/accuracy.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/accuracy.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Support",
        "type": "Support",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628364f31fafc021f92d8499"
        },
        "name": "Tolerance",
        "category": "summonerswar",
        "subCategory": "runes",
        "slug": "Tolerance",
        "rate": 5,
        "price": 1,
        "quantity": 2,
        "description": "Allies' RES +10%",
        "images": [
            "/assets/images/runes/tolerance.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/runes/tolerance.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Support",
        "type": "Support",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "6285a8b900a1699da6987b40"
        },
        "name": "Archangel's Blessing",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Archangel's-Blessing",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Recovers the ally target's HP by 50% and increases the Defense for 2 turns. (Reusable in 5 turns). Multiplier: 50%",
        "images": [
            "/assets/images/skills/skill2/Archangels_Blessing_Water.png",
            "/assets/images/skills/Increase-DEF.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Archangels_Blessing_Water.png",
            "/assets/images/skills/Increase-DEF.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "6285a8f800a1699da6987b47"
        },
        "name": "Dominator",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Dominator",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "The damage you receive decreases as more allies survive and the damage you inflict increases as more allies die. Additionally, the enemy you attack will be provoked for 1 turn. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Dominator_Passive_Dark.png",
            "/assets/images/skills/Provoke.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Dominator_Passive_Dark.png",
            "/assets/images/skills/Provoke.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "6285a91200a1699da6987b4a"
        },
        "name": "Judge",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Judge",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Counterattacks instantly when you or an ally is hit with a critical hit and increases your attack bar by 10%. Increases your Defense by 10% each whenever [Judge (Passive)] is activated. (Accumulates up to 10 times) [Automatic Effect] Multiplier: 75%",
        "images": [
            "/assets/images/skills/skill3/Judge_Passive_Light.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Judge_Passive_Light.png",
            "/assets/images/skills/attack-bar-up.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "6285a93a00a1699da6987b4d"
        },
        "name": "Sanctuary",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Sanctuary",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Removes all harmful effects on all allies, granting them immunity for 3 turns, and increasing the Attack Bar by 30%. (Reusable in 6 turns)",
        "images": [
            "/assets/images/skills/skill3/Sanctuary_Fire.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/skills/Immunity.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Sanctuary_Fire.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/skills/Immunity.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "6285a94f00a1699da6987b50"
        },
        "name": "Holy Water",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Holy-Water",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Removes all harmful effects granted on all allies and recovers their HP by 50% each. In addition, increases the Attack Bar of all allies by 20% each and recovers 15% HP each turn for 3 turns by the no. of harmful effects removed on the allies who had their harmful effects removed. (Reusable in 5 turns). Multiplier: 30%",
        "images": [
            "/assets/images/skills/skill3/Holy_Water_Water.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/skills/Blessed.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Holy_Water_Water.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/skills/Blessed.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "6285a95d00a1699da6987b53"
        },
        "name": "Archangel's Mercy",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Archangel's-Mercy",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Revives the target dead ally and fills up its HP to the maximum amount and also revives other dead allies with 30% of their HP. Consumes your HP by half and grants Soul Protection on yourself for 2 turns. In addition, consumes your HP additionally by 15% per revived ally. (Reusable in 8 turns).",
        "images": [
            "/assets/images/skills/skill3/Archangels_Mercy.png",
            "/assets/images/skills/Protect-Soul.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Archangels_Mercy.png",
            "/assets/images/skills/Protect-Soul.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "6285b84300a1699da6987b93"
        },
        "name": "Increases the HP of ally monsters with Dark attribute by 50%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-hp-of-ally-monsters-with-dark-attribute-by-50percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the HP of ally monsters with Dark attribute by 50%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Mid_Dark_Icon-1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Mid_Dark_Icon-1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62870a9c2a9ce072c7693ce2"
        },
        "name": "Increases the HP of ally monsters with Light attribute by 50%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-hp-of-ally-monsters-with-light-attribute-by-50percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the HP of ally monsters with Light attribute by 50%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Mid_Light_Icon-1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Mid_Light_Icon-1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62870ae52a9ce072c7693cf2"
        },
        "name": "Increases the HP of ally monsters with Fire attribute by 50%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-hp-of-ally-monsters-with-fire-attribute-by-50percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the HP of ally monsters with Fire attribute by 50%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Mid_Fire_Icon-1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Mid_Fire_Icon-1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62870af02a9ce072c7693cf5"
        },
        "name": "Increases the HP of ally monsters with Water attribute by 50%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-hp-of-ally-monsters-with-water-attribute-by-50percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the HP of ally monsters with Water attribute by 50%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Mid_Water_Icon-1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Mid_Water_Icon-1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62870afb2a9ce072c7693cf8"
        },
        "name": "Increases the HP of ally monsters with Wind attribute by 50%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-hp-of-ally-monsters-with-wind-attribute-by-50percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the HP of ally monsters with Wind attribute by 50%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Mid_Wind_Icon-1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Mid_Wind_Icon-1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62870b082a9ce072c7693cfb"
        },
        "name": "Increases the Attack Power of ally monsters with Dark attribute by 50%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-attack-power-of-ally-monsters-with-dark-attribute-by-50percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Attack Power of ally monsters with Dark attribute by 50%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Dark_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Dark_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62870b122a9ce072c7693cfe"
        },
        "name": "Increase the Attack Power of ally monsters with Light attribute by 50%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-attack-power-of-ally-monsters-with-light-attribute-by-50percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Attack Power of ally monsters with Light attribute by 50%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Light_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Light_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62870b1f2a9ce072c7693d01"
        },
        "name": "Increase the Attack Power of ally monsters with Fire attribute by 50%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-attack-power-of-ally-monsters-with-fire-attribute-by-50percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Attack Power of ally monsters with Fire attribute by 50%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Fire_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Fire_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62870b372a9ce072c7693d07"
        },
        "name": "Increase the Attack Power of ally monsters with Wind attribute by 50%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-attack-power-of-ally-monsters-with-wind-attribute-by-50percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Attack Power of ally monsters with Wind attribute by 50%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Wind_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Wind_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62870b422a9ce072c7693d0a"
        },
        "name": "Increases the Attack Power of ally monsters in the Dungeons by 44%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-attack-power-of-ally-monsters-in-the-dungeons-by-44percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Attack Power of ally monsters in the Dungeons by 44%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Dungeon_Icon-1.png",
            "/assets/images/skills/Increase-ATK.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Dungeon_Icon-1.png",
            "/assets/images/skills/Increase-ATK.png"
        ],
        "element": "Fire",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Dungeon_Icon-1.png",
        "image2": "/assets/images/skills/Increase-ATK.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-08T04:29:32.291Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Vampire",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Dungeon_Icon-1.png",
        "thumbImage2": "/assets/images/skills/Increase-ATK.png"
    },
    {
        "_id": {
            "$oid": "62870b4b2a9ce072c7693d0d"
        },
        "name": "Increases the Accuracy of ally monsters in the Dungeons by 55%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-accuracy-of-ally-monsters-in-the-dungeons-by-55percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Accuracy of ally monsters in the Dungeons by 55%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Accuracy_Mid_Dungeon_Icon-2.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Accuracy_Mid_Dungeon_Icon-2.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62870b522a9ce072c7693d10"
        },
        "name": "Increases the HP of ally monsters in the Dungeons by 38%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-hp-of-ally-monsters-in-the-dungeons-by-38percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the HP of ally monsters in the Dungeons by 38%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Low_Dungeon_Icon-4.png",
            "/assets/images/skills/Increase-CRI-Rate.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Low_Dungeon_Icon-4.png",
            "/assets/images/skills/Increase-CRI-Rate.png"
        ],
        "element": "Water",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Low_Dungeon_Icon-4.png",
        "image2": "/assets/images/skills/Increase-CRI-Rate.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T06:41:05.753Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Vampire",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Low_Dungeon_Icon-4.png",
        "thumbImage2": "/assets/images/skills/Increase-CRI-Rate.png"
    },
    {
        "_id": {
            "$oid": "62870b592a9ce072c7693d13"
        },
        "name": "Increases the Defense of ally monsters in the Dungeons by 44%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-defense-of-ally-monsters-in-the-dungeons-by-44percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Defense of ally monsters in the Dungeons by 44%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Dungeon_Icon.png",
            "/assets/images/skills/Increase-DEF.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Dungeon_Icon.png",
            "/assets/images/skills/Increase-DEF.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62870b6b2a9ce072c7693d17"
        },
        "name": "Increases the Attack Power of ally monsters by 28%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-attack-power-of-ally-monsters-by-28percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Attack Power of ally monsters by 28%",
        "images": [
            "/assets/images/skills/leaderskill/leader_skill_Attack_Power.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/leader_skill_Attack_Power.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62870b7b2a9ce072c7693d1b"
        },
        "name": "Increases the Attack Power of ally monsters in the Guild Content by 38%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-attack-power-of-ally-monsters-in-the-guild-content-by-38percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Attack Power of ally monsters in the Guild Content by 38%",
        "images": [
            "/assets/images/skills/leaderskill/leader_skill_Attack_Power.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/leader_skill_Attack_Power.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62870b832a9ce072c7693d1e"
        },
        "name": "Increases the Attack Power of ally monsters in the Dungeons by 38%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-attack-power-of-ally-monsters-in-the-dungeons-by-38percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Attack Power of ally monsters in the Dungeons by 38%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Low_Dungeon_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Low_Dungeon_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Light",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Low_Dungeon_Icon.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-08T04:28:08.824Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Vampire",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Low_Dungeon_Icon.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870bc22a9ce072c7693d26"
        },
        "name": "Increases the Attack Power of ally monsters in the Arena by 44%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-attack-power-of-ally-monsters-in-the-arena-by-44percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Attack Power of ally monsters in the Arena by 44%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Arena_Icon-2.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Arena_Icon-2.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Arena_Icon-2.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-08T04:29:05.836Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Demon",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Arena_Icon-2.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870bcb2a9ce072c7693d29"
        },
        "name": "Increases the Defense of ally monsters in the Arena by 44%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-defense-of-ally-monsters-in-the-arena-by-44percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Defense of ally monsters in the Arena by 44%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Arena_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Arena_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Arena_Icon.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:34:39.366Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Demon",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Arena_Icon.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870bd12a9ce072c7693d2c"
        },
        "name": "Increase the Accuracy of ally monsters in the Arena by 55%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-accuracy-of-ally-monsters-in-the-arena-by-55percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Accuracy of ally monsters in the Arena by 55%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Accuracy_Mid_Arena_Icon-4.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Accuracy_Mid_Arena_Icon-4.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Accuracy_Mid_Arena_Icon-4.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:32:33.601Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Demon",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Accuracy_Mid_Arena_Icon-4.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870bd62a9ce072c7693d2f"
        },
        "name": "Increase the Resistance of ally monsters in the Arena by 55%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-resistance-of-ally-monsters-in-the-arena-by-55percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Resistance of ally monsters in the Arena by 55%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Resistance_Mid_Arena_Icon-3.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Resistance_Mid_Arena_Icon-3.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Resistance_Mid_Arena_Icon-3.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:32:08.182Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Demon",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Resistance_Mid_Arena_Icon-3.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870bdf2a9ce072c7693d32"
        },
        "name": "Increases the HP of ally monsters in the Arena by 44%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-hp-of-ally-monsters-in-the-arena-by-44percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the HP of ally monsters in the Arena by 44%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Mid_Arena_Icon-2.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Mid_Arena_Icon-2.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Mid_Arena_Icon-2.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:34:07.914Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Demon",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Mid_Arena_Icon-2.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870c062a9ce072c7693d36"
        },
        "name": "Increases the Attack Speed of ally monsters by 24%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-attack-speed-of-ally-monsters-by-24percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Attack Speed of ally monsters by 24%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Speed_Low_Icon-4.png",
            "/assets/images/skills/Increase-Speed.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Speed_Low_Icon-4.png",
            "/assets/images/skills/Increase-Speed.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Attack_Speed_Low_Icon-4.png",
        "image2": "/assets/images/skills/Increase-Speed.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:50:00.382Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Desert Queen",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Attack_Speed_Low_Icon-4.png",
        "thumbImage2": "/assets/images/skills/Increase-Speed.png"
    },
    {
        "_id": {
            "$oid": "62870c122a9ce072c7693d39"
        },
        "name": "Increases the Attack Power of ally monsters by 33%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-attack-power-of-ally-monsters-by-33percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Attack Power of ally monsters by 33%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Low_Icon-3.png",
            "/assets/images/skills/Increase-ATK.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Low_Icon-3.png",
            "/assets/images/skills/Increase-ATK.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Low_Icon-3.png",
        "image2": "/assets/images/skills/Increase-ATK.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:49:11.318Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Desert Queen",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Low_Icon-3.png",
        "thumbImage2": "/assets/images/skills/Increase-ATK.png"
    },
    {
        "_id": {
            "$oid": "62870c192a9ce072c7693d3c"
        },
        "name": "Increases the HP of ally monsters by 33%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-hp-of-ally-monsters-by-33percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the HP of ally monsters by 33%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Low_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Low_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62870c242a9ce072c7693d3f"
        },
        "name": "Increases the Defense of ally monsters by 33%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-defense-of-ally-monsters-by-33percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Defense of ally monsters by 33%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Defense_Low_Icon-2.png",
            "/assets/images/skills/Increase-DEF.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Defense_Low_Icon-2.png",
            "/assets/images/skills/Increase-DEF.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Defense_Low_Icon-2.png",
        "image2": "/assets/images/skills/Increase-DEF.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:46:32.05Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Desert Queen",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Defense_Low_Icon-2.png",
        "thumbImage2": "/assets/images/skills/Increase-DEF.png"
    },
    {
        "_id": {
            "$oid": "62870c302a9ce072c7693d42"
        },
        "name": "Increases the Resistance of ally monsters by 41%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-resistance-of-ally-monsters-by-41percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Resistance of ally monsters by 41%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Resistance_Mid_Icon-2.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Resistance_Mid_Icon-2.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Resistance_Mid_Icon-2.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-08T04:30:41.848Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Desert Queen",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Resistance_Mid_Icon-2.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870c602a9ce072c7693d47"
        },
        "name": "Increases the Critical Rate of ally monsters by 24%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-critical-rate-of-ally-monsters-by-24percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Critical Rate of ally monsters by 24%",
        "images": [
            "/assets/images/skills/leaderskill/leader_skill_Critical_Rate.png",
            "/assets/images/skills/Increase-CRI-Rate.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/leader_skill_Critical_Rate.png",
            "/assets/images/skills/Increase-CRI-Rate.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/leader_skill_Critical_Rate.png",
        "image2": "/assets/images/skills/Increase-CRI-Rate.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T05:57:10.123Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Ifrit",
        "thumbImage1": "/assets/images/skills/leaderskill/leader_skill_Critical_Rate.png",
        "thumbImage2": "/assets/images/skills/Increase-CRI-Rate.png"
    },
    {
        "_id": {
            "$oid": "62870cb72a9ce072c7693d55"
        },
        "name": "Increases the Defense of ally monsters with Dark attribute by 50%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-defense-of-ally-monsters-with-dark-attribute-by-50percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Defense of ally monsters with Dark attribute by 50%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Dark_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Dark_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Dark_Icon.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "species": "Dragon Knight",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Dark_Icon.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870cc12a9ce072c7693d58"
        },
        "name": "Increases the Defense of ally monsters with Light attribute by 50%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-defense-of-ally-monsters-with-light-attribute-by-50percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Defense of ally monsters with Light attribute by 50%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Light_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Light_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Light_Icon.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "species": "Dragon Knight",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Light_Icon.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870cc82a9ce072c7693d5b"
        },
        "name": "Increases the Defense of ally monsters with Fire attribute by 50%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-defense-of-ally-monsters-with-fire-attribute-by-50percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Defense of ally monsters with Fire attribute by 50%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Fire_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Fire_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Fire_Icon.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "species": "Dragon Knight",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Fire_Icon.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870cd12a9ce072c7693d5e"
        },
        "name": "Increases the Defense of ally monsters with Water attribute by 50%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-defense-of-ally-monsters-with-water-attribute-by-50percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Defense of ally monsters with Water attribute by 50%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Water_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Water_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Water_Icon.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "species": "Dragon Knight",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Water_Icon.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870cd92a9ce072c7693d61"
        },
        "name": "Increases the Defense of ally monsters with Wind attribute by 50%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-defense-of-ally-monsters-with-wind-attribute-by-50percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Defense of ally monsters with Wind attribute by 50%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Wind_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Wind_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Wind_Icon.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "species": "Dragon Knight",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Defense_Mid_Wind_Icon.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870dd72a9ce072c7693d67"
        },
        "name": "Mark of Brush Tip",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Mark-of-Brush-Tip",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy to decrease the Attack Bar by 30% with a 50% chance. Multiplier: 380%",
        "images": [
            "/assets/images/skills/skill1/mark-of-brush-teeth-1.png",
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/mark-of-brush-teeth-1.png",
            "/assets/images/skills/attack-bar-down.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62870de32a9ce072c7693d6a"
        },
        "name": "Crushing Blow",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "crushing-blow",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Strikes the enemy and increases your attack speed for 2 turns with a critical hit. Multiplier: 370%",
        "images": [
            "/assets/images/skills/skill1/Crushing_Blow_Strenghtened_Fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Crushing_Blow_Strenghtened_Fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Crushing_Blow_Strenghtened_Fire.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-05T04:18:57.215Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Beast Monk",
        "thumbImage1": "/assets/images/skills/skill1/Crushing_Blow_Strenghtened_Fire.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870deb2a9ce072c7693d6d"
        },
        "name": "Spear of Protector",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "spear-of-protector",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy to decrease the Attack Speed for 2 turns with a 30% chance. The faster your Attack Speed compared to the enemy's, the greater damage you can inflict. Multiplier: 200% * (Speed + 1)",
        "images": [
            "/assets/images/skills/skill1/Spear_of_Protector_Fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Spear_of_Protector_Fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Spear_of_Protector_Fire.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T01:47:03.602Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Beast Rider",
        "thumbImage1": "/assets/images/skills/skill1/Spear_of_Protector_Fire.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870df82a9ce072c7693d70"
        },
        "name": "Fire",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Fire",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy 3 times. Each attack has a 30% chance to decrease the Attack Bar by 30%. Multiplier: 120% x3",
        "images": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62870e022a9ce072c7693d73"
        },
        "name": "Trample",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "trample",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Pins down the enemy and inflicts Continuous Damage for 1 turn. The damage increases as the enemy's HP status decreases. Multiplier: {ATK}*(4.1 - 0.3*{Target Current HP %})",
        "images": [
            "/assets/images/skills/skill1/Trample_Fire.png",
            "/assets/images/skills/Continuous-Damage.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Trample_Fire.png",
            "/assets/images/skills/Continuous-Damage.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Trample_Fire.png",
        "image2": "/assets/images/skills/Continuous-Damage.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:04:21.213Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Chimera",
        "thumbImage1": "/assets/images/skills/skill1/Trample_Fire.png",
        "thumbImage2": "/assets/images/skills/Continuous-Damage.png"
    },
    {
        "_id": {
            "$oid": "62870e072a9ce072c7693d76"
        },
        "name": "Sword of Destruction",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "sword-of-destruction",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Decreases the current HP of the enemy with the best HP status (Boss excluded) by 10%, and attacks the enemy target to inflict damage that's proportionate to the reduced HP. Multiplier: 370%",
        "images": [
            "/assets/images/skills/skill1/sword-of-destruction_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/sword-of-destruction_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/sword-of-destruction_fire.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:19:27.188Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Demon",
        "thumbImage1": "/assets/images/skills/skill1/sword-of-destruction_fire.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870e102a9ce072c7693d79"
        },
        "name": "Touch of Seduction",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "touch-of-seduction",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy and decreases its Attack Power for 2 turns with a 50% chance. Multiplier: 400%",
        "images": [
            "/assets/images/skills/skill1/Touch_of_Seduction_Fire.png",
            "/assets/images/skills/Reduce-ATK.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Touch_of_Seduction_Fire.png",
            "/assets/images/skills/Reduce-ATK.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Touch_of_Seduction_Fire.png",
        "image2": "/assets/images/skills/Reduce-ATK.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:37:41.774Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Desert Queen",
        "thumbImage1": "/assets/images/skills/skill1/Touch_of_Seduction_Fire.png",
        "thumbImage2": "/assets/images/skills/Reduce-ATK.png"
    },
    {
        "_id": {
            "$oid": "62870e342a9ce072c7693d7d"
        },
        "name": "Dark Bolt",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "dark-bolt",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Dark Bolt",
        "images": [
            "/assets/images/skills/skill1/Dark_Bolt.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Dark_Bolt.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Dark_Bolt.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T06:59:46.037Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Dragon",
        "thumbImage1": "/assets/images/skills/skill1/Dark_Bolt.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870e742a9ce072c7693d80"
        },
        "name": "Holy Bolt",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "holy-bolt",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Shoots a light arrow at the enemy. This attack will deal more damage according to your MAX HP. Multiplier: 1.7*{ATK} + 0.19*{MAX HP}",
        "images": [
            "/assets/images/skills/skill1/Holy_Bolt.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Holy_Bolt.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Holy_Bolt.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T07:00:36.935Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Dragon",
        "thumbImage1": "/assets/images/skills/skill1/Holy_Bolt.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870e8a2a9ce072c7693d83"
        },
        "name": "Fire Bolt",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "fire-bolt",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Shoots a fire arrow at the enemy. The damage increases by 10% for each harmful effect. Multiplier: 460%",
        "images": [
            "/assets/images/skills/skill1/Fire_Bolt.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Fire_Bolt.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Fire_Bolt.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T07:02:27.907Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Dragon",
        "thumbImage1": "/assets/images/skills/skill1/Fire_Bolt.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870e9e2a9ce072c7693d86"
        },
        "name": "Ice Bolt",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "ice-bolt",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Shoots an ice arrow at the enemy. This attack will deal more damage according to your Defense. Multiplier: 460% + 290%",
        "images": [
            "/assets/images/skills/skill1/Ice_Bolt.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Ice_Bolt.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Ice_Bolt.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T07:01:57.246Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Dragon",
        "thumbImage1": "/assets/images/skills/skill1/Ice_Bolt.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870eb12a9ce072c7693d89"
        },
        "name": "Thunder Bolt",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "thunder-bolt",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Shoots a lightning arrow at the enemy. This attack will deal more damage according to your Attack Speed. Multiplier: {ATK}*({SPD} + 180)/65",
        "images": [
            "/assets/images/skills/skill1/Thunder_Bolt.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Thunder_Bolt.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Thunder_Bolt.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T07:01:18.434Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Dragon",
        "thumbImage1": "/assets/images/skills/skill1/Thunder_Bolt.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870ede2a9ce072c7693d8c"
        },
        "name": "Dark Storm",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "dark-storm",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Summons a storm of darkness to attack all enemies 4 times and stuns them with a 25% chance with each attack. The damage increases by 50% if the target is under inability effects. (Reusable in 4 turns Multiplier: 90% x4",
        "images": [
            "/assets/images/skills/skill2/Dark_Storm_Dragon.png",
            "/assets/images/skills/Stun.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Dark_Storm_Dragon.png",
            "/assets/images/skills/Stun.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Dark_Storm_Dragon.png",
        "image2": "/assets/images/skills/Stun.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T07:24:53.69Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Dragon",
        "thumbImage1": "/assets/images/skills/skill2/Dark_Storm_Dragon.png",
        "thumbImage2": "/assets/images/skills/Stun.png"
    },
    {
        "_id": {
            "$oid": "62870ef22a9ce072c7693d8f"
        },
        "name": "Decimate",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "decimate",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with the power of darkness to inflict damage which ignores all effects that resist death. This skill deals 100% increased Critical Damage on Critical Hits and the defeated enemy can't be revived. (Reusable in 6 turns). Multiplier: 480%",
        "images": [
            "/assets/images/skills/skill3/Decimate.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Decimate.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Decimate.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T07:06:51.171Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Dragon",
        "thumbImage1": "/assets/images/skills/skill3/Decimate.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870f082a9ce072c7693d92"
        },
        "name": "Holy Light",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "holy-light",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Calls upon the holy power of light to remove 2 harmful effects from all allies and heals their HP by 15% of your MAX HP. Light attribute allies will receive a doubled amount of healing. (Reusable in 4 turns).",
        "images": [
            "/assets/images/skills/skill2/Holy_Light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Holy_Light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Holy_Light.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T07:24:08.303Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Dragon",
        "thumbImage1": "/assets/images/skills/skill2/Holy_Light.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870f182a9ce072c7693d95"
        },
        "name": "Armageddon",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "armageddon",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Redistributes the HP of all enemies, excluding the Boss, and sacrifices half of your current HP to deal damage proportionate to the sacrificed HP to all enemies. (Reusable in 6 turns) Multiplier: 65%",
        "images": [
            "/assets/images/skills/skill3/Armageddon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Armageddon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Armageddon.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T07:07:34.151Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Dragon",
        "thumbImage1": "/assets/images/skills/skill3/Armageddon.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62870f392a9ce072c7693d98"
        },
        "name": "Thunder Break",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "thunder-break",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy to inflict damage proportionate to the target's MAX HP and attacks all enemies once again with 20% of the damage. Additionally, this attack has a 40% chance to decrease the enemy's Attack Power for 2 turns and Attack Speed for 2 turns. (Reusable in 3 turns). Multiplier: 375%+15% (75%+3%)",
        "images": [
            "/assets/images/skills/skill3/Thunder_Break.png",
            "/assets/images/skills/skill1/Reduce-ATK.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Thunder_Break.png",
            "/assets/images/skills/skill1/Reduce-ATK.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Thunder_Break.png",
        "image2": "/assets/images/skills/skill1/Reduce-ATK.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T07:23:09.465Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Dragon",
        "thumbImage1": "/assets/images/skills/skill3/Thunder_Break.png",
        "thumbImage2": "/assets/images/skills/skill1/Reduce-ATK.png"
    },
    {
        "_id": {
            "$oid": "62870f4a2a9ce072c7693d9b"
        },
        "name": "Illusion of Time",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "illusion-of-time",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Removes all harmful effects of all allies and all ally skills will become instantly available. [Illusion of Time] will not be affected by cooldown reducing or increasing skills. (Reusable in 7 turns).",
        "images": [
            "/assets/images/skills/skill3/Illusion_of_Time.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Illusion_of_Time.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Illusion_of_Time.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T07:08:06.651Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Dragon",
        "thumbImage1": "/assets/images/skills/skill3/Illusion_of_Time.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628ae42ceb67f276e3cac28f"
        },
        "name": "Increases the Critical Rate of ally monsters in the Arena by 33%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-critical-rate-of-ally-monsters-in-the-arena-by-33percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Critical Rate of ally monsters in the Arena by 33%",
        "images": [
            "/assets/images/skills/leaderskill/leader_skill_Attack_Power_Area.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/leader_skill_Attack_Power_Area.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/leader_skill_Attack_Power_Area.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "species": "Horus",
        "thumbImage1": "/assets/images/skills/leaderskill/leader_skill_Attack_Power_Area.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628ae43ceb67f276e3cac292"
        },
        "name": "Increases the Attack Speed of ally monsters in the Arena by 33%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-attack-speed-of-ally-monsters-in-the-arena-by-33percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Attack Speed of ally monsters in the Arena by 33%",
        "images": [
            "/assets/images/skills/leaderskill/leader_skill_Attack_Power_Area.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/leader_skill_Attack_Power_Area.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/leader_skill_Attack_Power_Area.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T03:03:31.109Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Fairy King",
        "thumbImage1": "/assets/images/skills/leaderskill/leader_skill_Attack_Power_Area.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628ae4d9eb67f276e3cac299"
        },
        "name": "Serenity",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "serenity",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy 2 times and increases the chances of the enemy to land a Glancing Hit for 2 turns with a 30% chance on each strike.Multiplier: 180% x2",
        "images": [
            "/assets/images/skills/skill1/Serenity_Water.png",
            "/assets/images/skills/Reduce-ACC.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Serenity_Water.png",
            "/assets/images/skills/Reduce-ACC.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Serenity_Water.png",
        "image2": "/assets/images/skills/Reduce-ACC.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T03:05:19.095Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Fairy King",
        "thumbImage1": "/assets/images/skills/skill1/Serenity_Water.png",
        "thumbImage2": "/assets/images/skills/Reduce-ACC.png"
    },
    {
        "_id": {
            "$oid": "628ae51eeb67f276e3cac29c"
        },
        "name": "Overwhelm",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "overwhelm",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies to remove 1 beneficial effect granted on them and to increase the skill cooldown time by 1 turn each with a 70% chance each. (Reusable in 4 turns) Multiplier: 320%",
        "images": [
            "/assets/images/skills/skill2/Overwhelm_Dark.png",
            "/assets/images/skills/skill2/Overwhelm_Water.png",
            "/assets/images/skills/skill2/Overwhelm_Fire.png",
            "/assets/images/skills/Unrecoverable.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Overwhelm_Dark.png",
            "/assets/images/skills/Reduce-Speed.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Overwhelm_Dark.png",
        "image2": "/assets/images/skills/skill2/Overwhelm_Water.png",
        "image3": "/assets/images/skills/skill2/Overwhelm_Fire.png",
        "image4": "/assets/images/skills/Unrecoverable.png",
        "modified": {
            "$date": "2022-09-07T03:11:35.938Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Fairy King",
        "thumbImage1": "/assets/images/skills/skill2/Overwhelm_Dark.png",
        "thumbImage2": "/assets/images/skills/Reduce-Speed.png"
    },
    {
        "_id": {
            "$oid": "628ae535eb67f276e3cac29f"
        },
        "name": "Ventilate",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "ventilate",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Instantly readies all skills of an ally except yourself. [Ventilate] will not be affected by other cooldown reduction or increasing skills.(Reusable in 4 turns)",
        "images": [
            "/assets/images/skills/skill2/Ventilate_Wind.png",
            "/assets/images/skills/skill2/Ventilate_Light.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Ventilate_Wind.png",
            "/assets/images/skills/skill2/Ventilate_Light.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Ventilate_Wind.png",
        "image2": "/assets/images/skills/skill2/Ventilate_Light.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T03:10:16.796Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Fairy King",
        "thumbImage1": "/assets/images/skills/skill2/Ventilate_Wind.png",
        "thumbImage2": "/assets/images/skills/skill2/Ventilate_Light.png"
    },
    {
        "_id": {
            "$oid": "628ae591eb67f276e3cac2a2"
        },
        "name": "Overwhelm of Fire",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "overwhelm-of-fire",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies to disturb their HP recovery for 1 turn and to increase the skill cooldown time by 1 turn each with a 70% chance each. (Reusable in 4 turns). Multiplier: 320%",
        "images": [
            "/assets/images/skills/skill2/Overwhelm_Fire.png",
            "/assets/images/skills/Unrecoverable.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Overwhelm_Fire.png",
            "/assets/images/skills/Unrecoverable.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Overwhelm_Fire.png",
        "image2": "/assets/images/skills/Unrecoverable.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T03:12:33.578Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Fairy King",
        "thumbImage1": "/assets/images/skills/skill2/Overwhelm_Fire.png",
        "thumbImage2": "/assets/images/skills/Unrecoverable.png"
    },
    {
        "_id": {
            "$oid": "628ae59feb67f276e3cac2a5"
        },
        "name": "Overwhelm of Water",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "overwhelm-of-water",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies to decrease their Attack Speed for 1 turn and to increase the skill cooldown time by 1 turn each with a 70% chance each. (Reusable in 4 turns). Multiplier: 320%",
        "images": [
            "/assets/images/skills/skill2/Overwhelm_Water.png",
            "/assets/images/skills/Reduce-Speed.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Overwhelm_Water.png",
            "/assets/images/skills/Reduce-Speed.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Overwhelm_Water.png",
        "image2": "/assets/images/skills/Reduce-Speed.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T03:14:02.625Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Fairy King",
        "thumbImage1": "/assets/images/skills/skill2/Overwhelm_Water.png",
        "thumbImage2": "/assets/images/skills/Reduce-Speed.png"
    },
    {
        "_id": {
            "$oid": "628ae5daeb67f276e3cac2a8"
        },
        "name": "Hellfire",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "hellfire",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": " Removes all beneficial effects granted on the enemy and weakens the enemy's Defense for 1 turn if you successfully remove all beneficial effects. Decreases the HP of yourself and the enemy target by 30% each with a flame and decreases the HP by 15% each if it's a Boss. Inflicts great damage to the target and creates a shield that's 50% of the inflicted damage for 3 turns afterwards.(Reusable in 4 turns)Multiplier: 30%+860%",
        "images": [
            "/assets/images/skills/skill3/Hellfire.png",
            "/assets/images/skills/Shield.png",
            "/assets/images/skills/Reduce-DEF.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Hellfire.png",
            "/assets/images/skills/Shield.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Hellfire.png",
        "image2": "/assets/images/skills/Shield.png",
        "image3": "/assets/images/skills/Reduce-DEF.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T03:15:31.933Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Fairy King",
        "thumbImage1": "/assets/images/skills/skill3/Hellfire.png",
        "thumbImage2": "/assets/images/skills/Shield.png"
    },
    {
        "_id": {
            "$oid": "628ae5fbeb67f276e3cac2ab"
        },
        "name": "Rageful Return",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "rageful-return",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Goes back to the elemental realm at the moment of death and returns with 30% HP. The activation of Rageful Return deals significant damage to all enemies. [Automatic Effect] (Reusable in 9 turns) Multiplier: 450%",
        "images": [
            "/assets/images/skills/skill3/Rageful_Return_Passive.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Rageful_Return_Passive.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Rageful_Return_Passive.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T03:22:38.915Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Fairy King",
        "thumbImage1": "/assets/images/skills/skill3/Rageful_Return_Passive.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628ae615eb67f276e3cac2ae"
        },
        "name": "Seal Magic",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "seal-magic",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy with an irresistible attack to put the target's skill on MAX cooldown and sets the Attack Bar of all enemies to 0. (Reusable in 6 turns) Multiplier: 740% (N/A)",
        "images": [
            "/assets/images/skills/skill3/Seal_Magic.png",
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Seal_Magic.png",
            "/assets/images/skills/attack-bar-down.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Seal_Magic.png",
        "image2": "/assets/images/skills/attack-bar-down.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T03:17:00.521Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Fairy King",
        "thumbImage1": "/assets/images/skills/skill3/Seal_Magic.png",
        "thumbImage2": "/assets/images/skills/attack-bar-down.png"
    },
    {
        "_id": {
            "$oid": "628ae64beb67f276e3cac2b1"
        },
        "name": "Light of Judgement",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "light-of-judgement",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Calls upon the power of light to inflict damage ignoring enemy's defense. Gains 1 turn of invincibility if the enemy dies. Multiplier: 380%",
        "images": [
            "/assets/images/skills/skill3/Light_of_Judgement.png",
            "/assets/images/skills/Invincibility.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Light_of_Judgement.png",
            "/assets/images/skills/Invincibility.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Light_of_Judgement.png",
        "image2": "/assets/images/skills/Invincibility.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T03:19:55.626Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Fairy King",
        "thumbImage1": "/assets/images/skills/skill3/Light_of_Judgement.png",
        "thumbImage2": "/assets/images/skills/Invincibility.png"
    },
    {
        "_id": {
            "$oid": "628ae668eb67f276e3cac2b4"
        },
        "name": "Discernment",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "discernment",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Decreases the changes of the allies being granted with harmful effects by 30% and increases the duration of the harmful effects that the allies, excluding those that are under inability effects, grant on the enemies by 1 turn each with the power of a piercing gaze.[Automatic Effect",
        "images": [
            "/assets/images/skills/skill3/Discernment_Passive.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Discernment_Passive.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Discernment_Passive.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T03:21:11.346Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Fairy King",
        "thumbImage1": "/assets/images/skills/skill3/Discernment_Passive.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628b4efedf0e1e3ae0cfbff4"
        },
        "name": "Increase the Critical Rate of ally monsters by 24%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-critical-rate-of-ally-monsters-by-24percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Critical Rate of ally monsters by 24%",
        "images": [
            "/assets/images/skills/leaderskill/leader_skill_Critical_Rate.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/leader_skill_Critical_Rate.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Fire",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/leader_skill_Critical_Rate.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-08T04:31:34.323Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Weapon Master",
        "thumbImage1": "/assets/images/skills/leaderskill/leader_skill_Critical_Rate.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628b4f0ddf0e1e3ae0cfbff7"
        },
        "name": "Increase the HP of ally monsters by 33%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-hp-of-ally-monsters-by-33percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the HP of ally monsters by 33%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Low_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Low_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Wind",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Low_Icon.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T03:31:15.665Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Weapon Master",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Low_Icon.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628b4f16df0e1e3ae0cfbffa"
        },
        "name": "Increase the Accuracy of ally monsters by 41%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-accuracy-of-ally-monsters-by-41percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Accuracy of ally monsters by 41%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Accuracy_Mid_Icon-4.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Accuracy_Mid_Icon-4.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Light",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Accuracy_Mid_Icon-4.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T03:32:13.549Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Weapon Master",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Accuracy_Mid_Icon-4.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628b4f1ddf0e1e3ae0cfbffd"
        },
        "name": "Increase the Attack Speed of ally monsters by 24%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-attack-speed-of-ally-monsters-by-24percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Attack Speed of ally monsters by 24%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Speed_Low_Icon-4.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Speed_Low_Icon-4.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Attack_Speed_Low_Icon-4.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T03:32:45.604Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Weapon Master",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Attack_Speed_Low_Icon-4.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628b4f43df0e1e3ae0cfc000"
        },
        "name": "Glaive Slash",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "glaive-slash",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy 2 times to disturb the target's HP recovery for 2 turns with a 30% chance each. Multiplier: 1.9*{ATK} x2",
        "images": [
            "/assets/images/skills/skill1/Glaive_Slash_Dark.png",
            "/assets/images/skills/skill1/Glaive_Slash_Water.png",
            "/assets/images/skills/skill1/Glaive_Slash_Wind.png",
            "/assets/images/skills/skill1/Glaive_Slash_Light.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Glaive_Slash_Fire.png",
            "/assets/images/skills/Unrecoverable.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Glaive_Slash_Dark.png",
        "image2": "/assets/images/skills/skill1/Glaive_Slash_Water.png",
        "image3": "/assets/images/skills/skill1/Glaive_Slash_Wind.png",
        "image4": "/assets/images/skills/skill1/Glaive_Slash_Light.png",
        "modified": {
            "$date": "2022-09-07T03:38:38.523Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Weapon Master",
        "thumbImage1": "/assets/images/skills/skill1/Glaive_Slash_Fire.png",
        "thumbImage2": "/assets/images/skills/Unrecoverable.png"
    },
    {
        "_id": {
            "$oid": "628b4f68df0e1e3ae0cfc003"
        },
        "name": "Weakness Shot",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "weakness-shot",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy to leave a Branding effect for 2 turns and attacks 3 more times. The damage increases as the enemy's HP condition is bad. (Reusable in 4 turns). Multiplier: {ATK}*(3.1 - 1.2*{Target Current HP %}) x4",
        "images": [
            "/assets/images/skills/skill2/Weakness_Shot_Fire.png",
            "/assets/images/skills/skill2/Weakness_Shot_Wind.png",
            "/assets/images/skills/skill2/Weakness_Shot_Light.png",
            "/assets/images/skills/Brand1.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Weakness_Shot_Fire.png",
            "/assets/images/skills/Brand1.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Weakness_Shot_Fire.png",
        "image2": "/assets/images/skills/skill2/Weakness_Shot_Wind.png",
        "image3": "/assets/images/skills/skill2/Weakness_Shot_Light.png",
        "image4": "/assets/images/skills/Brand1.png",
        "modified": {
            "$date": "2022-09-07T03:36:17.844Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Weapon Master",
        "thumbImage1": "/assets/images/skills/skill2/Weakness_Shot_Fire.png",
        "thumbImage2": "/assets/images/skills/Brand1.png"
    },
    {
        "_id": {
            "$oid": "628b4f81df0e1e3ae0cfc006"
        },
        "name": "Storm Scythe",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "storm-scythe",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies 2 times to block them from receiving beneficial effects and to increase the chance of landing glancing hits for 2 turns with a 70% chance each. The damage increases according to the enemy's MAX HP. (Reusable in 4 turns). Multiplier: 1.3*{ATK} + 0.05*{Target MAX HP} x2",
        "images": [
            "/assets/images/skills/skill2/Storm_Scythe_Water.png",
            "/assets/images/skills/skill2/Storm_Scythe_Dark.png",
            "/assets/images/skills/Reduce-ACC.png",
            "/assets/images/skills/Block-Beneficial-Effects.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Storm_Scythe_Water.png",
            "/assets/images/skills/skill2/Storm_Scythe_Dark.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Storm_Scythe_Water.png",
        "image2": "/assets/images/skills/skill2/Storm_Scythe_Dark.png",
        "image3": "/assets/images/skills/Reduce-ACC.png",
        "image4": "/assets/images/skills/Block-Beneficial-Effects.png",
        "modified": {
            "$date": "2022-09-07T03:40:43.374Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Weapon Master",
        "thumbImage1": "/assets/images/skills/skill2/Storm_Scythe_Water.png",
        "thumbImage2": "/assets/images/skills/skill2/Storm_Scythe_Dark.png"
    },
    {
        "_id": {
            "$oid": "628b4f9ddf0e1e3ae0cfc009"
        },
        "name": "Collect Weapons",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "collect-weapons",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Your Attack Bar increases by 75% when an enemy dies, and your Attack Power increases by up to 300% equal to the dead target's base Attack Power. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Collect_Weapons.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Collect_Weapons.png",
            "/assets/images/skills/attack-bar-up.png"
        ],
        "element": "Fire",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Collect_Weapons.png",
        "image2": "/assets/images/skills/attack-bar-up.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T03:42:04.078Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Weapon Master",
        "thumbImage1": "/assets/images/skills/skill3/Collect_Weapons.png",
        "thumbImage2": "/assets/images/skills/attack-bar-up.png"
    },
    {
        "_id": {
            "$oid": "628b4fb1df0e1e3ae0cfc00c"
        },
        "name": "Improvisation",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "improvisation",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Your Attack Power increases as your HP decreases, and attacks additionally when attacking an enemy on your turn. This attack deals damage proportional to your MAX HP if your HP exceeds 50% and recovers HP equal to the damage dealt if it's 50% or below. [Automatic Effect] Multiplier: 0.14*{MAX HP}",
        "images": [
            "/assets/images/skills/skill3/Improvisation.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Improvisation.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Wind",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Improvisation.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T03:45:07.924Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Weapon Master",
        "thumbImage1": "/assets/images/skills/skill3/Improvisation.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628b4fc2df0e1e3ae0cfc00f"
        },
        "name": "Final Strike",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "final-strike",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks additionally when you attack an enemy on your turn. This attack absorbs 30% of the enemy target's Attack Bar if the enemy's HP exceeds 30% and deals damage that ignores the target's Defense if it's 30% or below. [Automatic Effect] Multiplier: 2.3*{ATK}",
        "images": [
            "/assets/images/skills/skill3/Final_Strike.png",
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Final_Strike.png",
            "/assets/images/skills/attack-bar-down.png"
        ],
        "element": "Light",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Final_Strike.png",
        "image2": "/assets/images/skills/attack-bar-down.png",
        "image3": "/assets/images/skills/attack-bar-up.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T03:46:20.597Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Weapon Master",
        "thumbImage1": "/assets/images/skills/skill3/Final_Strike.png",
        "thumbImage2": "/assets/images/skills/attack-bar-down.png"
    },
    {
        "_id": {
            "$oid": "628b4fd4df0e1e3ae0cfc012"
        },
        "name": "Shadowless Movement",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "shadowless-movement",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies 4 times. Each attack will decrease the Defense for 2 turns, decrease Attack Power for 2 turns, grant Continuous Damage for 2 turns and absorb 25% of Attack Bar respectively. (Reusable in 5 turns). Multiplier: 1.2*{ATK}",
        "images": [
            "/assets/images/skills/skill3/Shadowless_Movement.png",
            "/assets/images/skills/Reduce-DEF.png",
            "/assets/images/skills/Reduce-ATK.png",
            "/assets/images/skills/Continuous-Damage.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Shadowless_Movement.png",
            "/assets/images/skills/attack-bar-down.png"
        ],
        "element": "Dark",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Shadowless_Movement.png",
        "image2": "/assets/images/skills/Reduce-DEF.png",
        "image3": "/assets/images/skills/Reduce-ATK.png",
        "image4": "/assets/images/skills/Continuous-Damage.png",
        "modified": {
            "$date": "2022-09-07T03:47:59.056Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Weapon Master",
        "thumbImage1": "/assets/images/skills/skill3/Shadowless_Movement.png",
        "thumbImage2": "/assets/images/skills/attack-bar-down.png"
    },
    {
        "_id": {
            "$oid": "628b5054df0e1e3ae0cfc01c"
        },
        "name": "Vampire Bat",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "vampire-bat",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks 2 times with a vampire bat and recovers HP by 30% of the inflicted damage. Multiplier: 200% x2",
        "images": [
            "/assets/images/skills/skill1/Vampire_Bat_Fire.png",
            "/assets/images/skills/skill1/Vampire_Bat_Water.png",
            "/assets/images/skills/skill1/Vampire_Bat_Light.png",
            "/assets/images/skills/skill1/Vampire_Bat_Dark.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Vampire_Bat_Dark_2.png",
            "/assets/images/skills/skill1/Vampire_Bat_Wind.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Vampire_Bat_Fire.png",
        "image2": "/assets/images/skills/skill1/Vampire_Bat_Water.png",
        "image3": "/assets/images/skills/skill1/Vampire_Bat_Light.png",
        "image4": "/assets/images/skills/skill1/Vampire_Bat_Dark.png",
        "modified": {
            "$date": "2022-09-07T06:24:09.895Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Vampire",
        "thumbImage1": "/assets/images/skills/skill1/Vampire_Bat_Dark_2.png",
        "thumbImage2": "/assets/images/skills/skill1/Vampire_Bat_Wind.png"
    },
    {
        "_id": {
            "$oid": "628b5064df0e1e3ae0cfc01f"
        },
        "name": "Weaken",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "weaken",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks and weakens the enemy's Attack Power and decreases the enemy's Attack Speed for 2 turns with a 75% chance. The target won't be granted with beneficial effects for 2 turns with a 75% chance. (Reusable in 4 turns) Multiplier: 620%",
        "images": [
            "/assets/images/skills/skill1/Weaken_Water.png",
            "/assets/images/skills/Reduce-Speed.png",
            "/assets/images/skills/Reduce-ATK.png",
            "/assets/images/skills/Block-Beneficial-Effects.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Weaken_Water.png",
            "/assets/images/skills/Reduce-Speed.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Weaken_Water.png",
        "image2": "/assets/images/skills/Reduce-Speed.png",
        "image3": "/assets/images/skills/Reduce-ATK.png",
        "image4": "/assets/images/skills/Block-Beneficial-Effects.png",
        "modified": {
            "$date": "2022-09-07T06:26:39.225Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Vampire",
        "thumbImage1": "/assets/images/skills/skill1/Weaken_Water.png",
        "thumbImage2": "/assets/images/skills/Reduce-Speed.png"
    },
    {
        "_id": {
            "$oid": "628b507adf0e1e3ae0cfc022"
        },
        "name": "Blood Contract",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "blood-contract",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Makes the Blood Contract with all allies to grant the Vampire effect that heals their HP by 20% of the inflicted damage for 3 turns and increases their Attack Power for 3 turns. (Reusable in 6 turns)",
        "images": [
            "/assets/images/skills/skill3/Blood_Contract.png",
            "/assets/images/skills/Increase-ATK.png",
            "/assets/images/skills/icon_duration_vampire.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Blood_Contract.png",
            "/assets/images/skills/Increase-ATK.png"
        ],
        "element": "Dark",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Blood_Contract.png",
        "image2": "/assets/images/skills/Increase-ATK.png",
        "image3": "/assets/images/skills/icon_duration_vampire.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T06:43:51.93Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Vampire Lord",
        "thumbImage1": "/assets/images/skills/skill3/Blood_Contract.png",
        "thumbImage2": "/assets/images/skills/Increase-ATK.png"
    },
    {
        "_id": {
            "$oid": "628b50dcdf0e1e3ae0cfc02c"
        },
        "name": "Sword of Promise",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "sword-of-promise",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy with a sword and increases the enemy's skill cooldown time by 1 turn each with a 20% chance. [Soul Reaper] is automatically activated if the enemy dies. Multiplier: 410%",
        "images": [
            "/assets/images/skills/skill1/Sword_of_Promise_Fire.png",
            "/assets/images/skills/skill1/Sword_of_Promise_Water.png",
            "/assets/images/skills/skill1/Sword_of_Promise_Wind.png",
            "/assets/images/skills/skill1/Sword_of_Promise_Light.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Sword_of_Promise_Fire.png",
            "/assets/images/skills/skill1/Sword_of_Promise_Dark.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Sword_of_Promise_Fire.png",
        "image2": "/assets/images/skills/skill1/Sword_of_Promise_Water.png",
        "image3": "/assets/images/skills/skill1/Sword_of_Promise_Wind.png",
        "image4": "/assets/images/skills/skill1/Sword_of_Promise_Light.png",
        "modified": {
            "$date": "2022-09-07T06:55:29.802Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Valkyrja",
        "thumbImage1": "/assets/images/skills/skill1/Sword_of_Promise_Fire.png",
        "thumbImage2": "/assets/images/skills/skill1/Sword_of_Promise_Dark.png"
    },
    {
        "_id": {
            "$oid": "628b50f5df0e1e3ae0cfc02f"
        },
        "name": "Seal of Fire",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "seal-of-fire",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks an enemy, dealing damage proportionate to the enemy's MAX HP, and decreases its Defense for 2 turns. (Reusable in 3 turns). Multiplier: 440%+11%",
        "images": [
            "/assets/images/skills/skill2/Seal_of_Fire_Fire.png",
            "/assets/images/skills/Reduce-DEF.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Seal_of_Fire_Fire.png",
            "/assets/images/skills/Reduce-DEF.png"
        ],
        "element": "Fire",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Seal_of_Fire_Fire.png",
        "image2": "/assets/images/skills/Reduce-DEF.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T06:59:53.651Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Valkyrja",
        "thumbImage1": "/assets/images/skills/skill2/Seal_of_Fire_Fire.png",
        "thumbImage2": "/assets/images/skills/Reduce-DEF.png"
    },
    {
        "_id": {
            "$oid": "628b5109df0e1e3ae0cfc032"
        },
        "name": "Seal of Water",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "seal-of-water",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks an enemy, dealing damage proportionate to the enemy's MAX HP, and decreases its Attack Speed for 2 turns. (Reusable in 3 turns). Multiplier: 440%+11%",
        "images": [
            "/assets/images/skills/skill2/Seal_of_Water_Water.png",
            "/assets/images/skills/Reduce-Speed.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Seal_of_Water_Water.png",
            "/assets/images/skills/Reduce-Speed.png"
        ],
        "element": "Water",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Seal_of_Water_Water.png",
        "image2": "/assets/images/skills/Reduce-Speed.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T07:01:01.165Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Valkyrja",
        "thumbImage1": "/assets/images/skills/skill2/Seal_of_Water_Water.png",
        "thumbImage2": "/assets/images/skills/Reduce-Speed.png"
    },
    {
        "_id": {
            "$oid": "628b511bdf0e1e3ae0cfc035"
        },
        "name": "Soul Reaper",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "soul-reaper",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy target to inflict damage. Becomes Invincible for 1 turn and resets the cooldown time of [Sword of Discharge] if the enemy is killed. (Reusable in 5 turns). Multiplier: 650%",
        "images": [
            "/assets/images/skills/skill2/Soul_Reaper_Wind.png",
            "/assets/images/skills/skill2/Soul_Reaper_Dark.png",
            "/assets/images/skills/Invincibility.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Soul_Reaper_Wind.png",
            "/assets/images/skills/Invincibility.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Soul_Reaper_Wind.png",
        "image2": "/assets/images/skills/skill2/Soul_Reaper_Dark.png",
        "image3": "/assets/images/skills/Invincibility.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T06:58:27.449Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Valkyrja",
        "thumbImage1": "/assets/images/skills/skill2/Soul_Reaper_Wind.png",
        "thumbImage2": "/assets/images/skills/Invincibility.png"
    },
    {
        "_id": {
            "$oid": "628b512fdf0e1e3ae0cfc038"
        },
        "name": "Seal of Light",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "seal-of-light",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy to deal damage proportionate to the MAX HP and Silences the enemy for 2 turns. The enemy under the Silence Effect won't be able to use skills with cooldown time excluding the passive skills. (Reusable in 3 turns). Multiplier: 440%+11%",
        "images": [
            "/assets/images/skills/skill2/Seal_of_Light_Light.png",
            "/assets/images/skills/Status_Silence.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Seal_of_Light_Light.png",
            "/assets/images/skills/Status_Silence.png"
        ],
        "element": "Light",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Seal_of_Light_Light.png",
        "image2": "/assets/images/skills/Status_Silence.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T07:02:11.287Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Valkyrja",
        "thumbImage1": "/assets/images/skills/skill2/Seal_of_Light_Light.png",
        "thumbImage2": "/assets/images/skills/Status_Silence.png"
    },
    {
        "_id": {
            "$oid": "628b515bdf0e1e3ae0cfc03c"
        },
        "name": "Ragnarok",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "ragnarok",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "The final battle begins. Both allies and enemies lose 15% of their HP, and the enemies receive massive additional damage. (Reusable in 6 turns) Multiplier: 450%+15%",
        "images": [
            "/assets/images/skills/skill3/Ragnarok_Dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Ragnarok_Dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Ragnarok_Dark.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T07:03:47.247Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Valkyrja",
        "thumbImage1": "/assets/images/skills/skill3/Ragnarok_Dark.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628b5172df0e1e3ae0cfc03f"
        },
        "name": "God's Shield",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "god's-shield",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Calls upon the power of the divine shield, gaining immunity against all harmful effects. Additionally, the chance of allies receiving a Critical Hit is reduced by 15%. The effect is not accumulated with other critical hit reduction effects. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Gods_Sield_Light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Gods_Sield_Light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Light",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Gods_Sield_Light.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T07:03:08.785Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Valkyrja",
        "thumbImage1": "/assets/images/skills/skill3/Gods_Sield_Light.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628b5185df0e1e3ae0cfc042"
        },
        "name": "Sword of Discharge",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "sword-of-discharge",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy target to inflict damage and randomly attacks the enemies 2 times. The enemy's Defense is ignored when used in invincible state. (Reusable in 5 turns) Multiplier: 280% x3",
        "images": [
            "/assets/images/skills/skill3/Sword_Of_Discharge_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Sword_Of_Discharge_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Wind",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Sword_Of_Discharge_wind.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T07:04:31.638Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Valkyrja",
        "thumbImage1": "/assets/images/skills/skill3/Sword_Of_Discharge_wind.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628b5199df0e1e3ae0cfc045"
        },
        "name": "Warrior's Return",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "warrior's-return",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Revives the dead ally with 30% HP and increases the revived ally's Attack Power for 1 turn. In addition, if [Warrior's Return] skill is available to be used, the skill will be activated instantly when another ally takes damage that causes death. (Reusable in 8 turns)",
        "images": [
            "/assets/images/skills/skill3/Warriors_Return_Fire.png",
            "/assets/images/skills/Increase-ATK.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Warriors_Return_Fire.png",
            "/assets/images/skills/Increase-ATK.png"
        ],
        "element": "Fire",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Warriors_Return_Fire.png",
        "image2": "/assets/images/skills/Increase-ATK.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T07:06:19.457Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Valkyrja",
        "thumbImage1": "/assets/images/skills/skill3/Warriors_Return_Fire.png",
        "thumbImage2": "/assets/images/skills/Increase-ATK.png"
    },
    {
        "_id": {
            "$oid": "628b51aadf0e1e3ae0cfc048"
        },
        "name": "First Aid",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "first-aid",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "When struck with a critical hit, reduces critical damage by half and removes all harmful effects. Additionally, recovers your HP by 10% and other allies' HP by 10% at the start of each turn. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/First_Aid_Water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/First_Aid_Water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Water",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/First_Aid_Water.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T07:05:20.053Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Valkyrja",
        "thumbImage1": "/assets/images/skills/skill3/First_Aid_Water.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628b51c8df0e1e3ae0cfc04b"
        },
        "name": "Fire Horn",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "fire-horn",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks and Stuns the enemy for 1 turn with a 25% chance. The damage increases accordingly to your MAX HP. Multiplier: 180%+12%",
        "images": [
            "/assets/images/skills/skill1/Fire_Horn_Fire.png",
            "/assets/images/skills/Stun.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Fire_Horn_Fire.png",
            "/assets/images/skills/Stun.png"
        ],
        "element": "Fire",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Fire_Horn_Fire.png",
        "image2": "/assets/images/skills/Stun.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T07:13:34.072Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Unicorn",
        "thumbImage1": "/assets/images/skills/skill1/Fire_Horn_Fire.png",
        "thumbImage2": "/assets/images/skills/Stun.png"
    },
    {
        "_id": {
            "$oid": "628b51d9df0e1e3ae0cfc04e"
        },
        "name": "Ice Horn",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "ice-horn",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy and Freezes the target for 1 turn with a 25% chance. This attack will deal more damage increases according to your MAX HP. Multiplier: 180%+12%",
        "images": [
            "/assets/images/skills/skill1/Ice_Horn_Water.png",
            "/assets/images/skills/Status_Freeze.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Ice_Horn_Water.png",
            "/assets/images/skills/Status_Freeze.png"
        ],
        "element": "Water",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Ice_Horn_Water.png",
        "image2": "/assets/images/skills/Status_Freeze.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T07:14:38.484Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Unicorn",
        "thumbImage1": "/assets/images/skills/skill1/Ice_Horn_Water.png",
        "thumbImage2": "/assets/images/skills/Status_Freeze.png"
    },
    {
        "_id": {
            "$oid": "628b51e9df0e1e3ae0cfc051"
        },
        "name": "Lightning Horn",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "lightning-horn",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks and Stuns the enemy for 1 turn with a 25% chance. The damage increases accordingly to your MAX HP. Multiplier: 180%+12",
        "images": [
            "/assets/images/skills/skill1/Lightning_Horn_Wind.png",
            "/assets/images/skills/Stun.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Lightning_Horn_Wind.png",
            "/assets/images/skills/Stun.png"
        ],
        "element": "Wind",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Lightning_Horn_Wind.png",
        "image2": "/assets/images/skills/Stun.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T07:15:22.236Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Unicorn",
        "thumbImage1": "/assets/images/skills/skill1/Lightning_Horn_Wind.png",
        "thumbImage2": "/assets/images/skills/Stun.png"
    },
    {
        "_id": {
            "$oid": "628b51f8df0e1e3ae0cfc054"
        },
        "name": "Holy Horn",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "holy-horn",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks and Stuns the enemy for 1 turn with a 25% chance. The damage increases accordingly to your MAX HP. Multiplier: 180%+12%",
        "images": [
            "/assets/images/skills/skill1/Holy_Horn_Light.png",
            "/assets/images/skills/Stun.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Holy_Horn_Light.png",
            "/assets/images/skills/Stun.png"
        ],
        "element": "Light",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Holy_Horn_Light.png",
        "image2": "/assets/images/skills/Stun.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-08T04:32:30.437Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Unicorn",
        "thumbImage1": "/assets/images/skills/skill1/Holy_Horn_Light.png",
        "thumbImage2": "/assets/images/skills/Stun.png"
    },
    {
        "_id": {
            "$oid": "628b5209df0e1e3ae0cfc057"
        },
        "name": "Dark Horn",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "dark-horn",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks and Stuns the enemy for 1 turn with a 25% chance. The damage increases accordingly to your MAX HP. Multiplier: 180%+12%",
        "images": [
            "/assets/images/skills/skill1/Dark_Horn_Dark.png",
            "/assets/images/skills/Stun.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Dark_Horn_Dark.png",
            "/assets/images/skills/Stun.png"
        ],
        "element": "Dark",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Dark_Horn_Dark.png",
        "image2": "/assets/images/skills/Stun.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:04:56.745Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Unicorn",
        "thumbImage1": "/assets/images/skills/skill1/Dark_Horn_Dark.png",
        "thumbImage2": "/assets/images/skills/Stun.png"
    },
    {
        "_id": {
            "$oid": "628b5239df0e1e3ae0cfc05d"
        },
        "name": "Nature's Protection",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "nature's-protection",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Creates a shield that's 30% of your MAX HP for 3 turns and creates a shield that's 20% of your MAX HP on all other allies for 2 turns. (Reusable in 5 turns)",
        "images": [
            "/assets/images/skills/skill2/Natures_Protection_Fire.png",
            "/assets/images/skills/skill2/Natures_Protection_Wind.png",
            "/assets/images/skills/skill2/Natures_Protection_Dark.png",
            "/assets/images/skills/Shield.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Natures_Protection_Fire.png",
            "/assets/images/skills/Shield.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Natures_Protection_Fire.png",
        "image2": "/assets/images/skills/skill2/Natures_Protection_Wind.png",
        "image3": "/assets/images/skills/skill2/Natures_Protection_Dark.png",
        "image4": "/assets/images/skills/Shield.png",
        "modified": {
            "$date": "2022-09-07T09:07:00.398Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Unicorn",
        "thumbImage1": "/assets/images/skills/skill2/Natures_Protection_Fire.png",
        "thumbImage2": "/assets/images/skills/Shield.png"
    },
    {
        "_id": {
            "$oid": "628b5253df0e1e3ae0cfc060"
        },
        "name": "Fierce Charge",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "fierce-charge",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy to Provoke for 2 turns with a 75% chance and counterattacks the enemy for 2 turns whenever you're attacked. The damage increases accordingly to your MAX HP. (Reusable in 5 turns). Multiplier: 300%+20%",
        "images": [
            "/assets/images/skills/skill2/Fierce_Charge_Water.png",
            "/assets/images/skills/skill2/Fierce_Charge_Light.png",
            "/assets/images/skills/Provoke.png",
            "/assets/images/skills/Counterattack.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Fierce_Charge_Water.png",
            "/assets/images/skills/Provoke.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Fierce_Charge_Water.png",
        "image2": "/assets/images/skills/skill2/Fierce_Charge_Light.png",
        "image3": "/assets/images/skills/Provoke.png",
        "image4": "/assets/images/skills/Counterattack.png",
        "modified": {
            "$date": "2022-09-07T09:08:44.05Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Unicorn",
        "thumbImage1": "/assets/images/skills/skill2/Fierce_Charge_Water.png",
        "thumbImage2": "/assets/images/skills/Provoke.png"
    },
    {
        "_id": {
            "$oid": "628b52a4df0e1e3ae0cfc066"
        },
        "name": "Eternal Flame",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "eternal-flame",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Recovers your HP and Attack Bar by 20% each when you attack on your turn. Reduces the damage dealt by Water attribute by 50%. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Eternal_Flames_Passive_Fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Eternal_Flames_Passive_Fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Fire",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Eternal_Flames_Passive_Fire.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:16:17.045Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Unicorn",
        "thumbImage1": "/assets/images/skills/skill3/Eternal_Flames_Passive_Fire.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628b52bfdf0e1e3ae0cfc06c"
        },
        "name": "Protection Wings",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "protection-wings",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the defense for 2 turns when you're attacked by an enemy. This effect only activates once a turn. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Protection_Wings_Passive_Water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Protection_Wings_Passive_Water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Water",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Protection_Wings_Passive_Water.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:15:42.151Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Unicorn",
        "thumbImage1": "/assets/images/skills/skill3/Protection_Wings_Passive_Water.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628b52cedf0e1e3ae0cfc06f"
        },
        "name": "Messenger of the Wind",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "messenger-of-the-wind",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases your Attack Bar by 15% each when other allies are attacked by the enemies. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Messenger_of_the_Wind_Passive_Wind.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Messenger_of_the_Wind_Passive_Wind.png",
            "/assets/images/skills/attack-bar-up.png"
        ],
        "element": "Wind",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Messenger_of_the_Wind_Passive_Wind.png",
        "image2": "/assets/images/skills/attack-bar-up.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:15:01.611Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Unicorn",
        "thumbImage1": "/assets/images/skills/skill3/Messenger_of_the_Wind_Passive_Wind.png",
        "thumbImage2": "/assets/images/skills/attack-bar-up.png"
    },
    {
        "_id": {
            "$oid": "628b52e4df0e1e3ae0cfc072"
        },
        "name": "Dazzling Flash",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "dazzling-flash",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the enemy's chance to land a Glancing Hit by 15% and decreases the chance to receive a Critical Hit by 15% each for all allies when they are attacked. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Dazzling_Flash_Passive_Light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Dazzling_Flash_Passive_Light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Light",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Dazzling_Flash_Passive_Light.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:14:14.03Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Unicorn",
        "thumbImage1": "/assets/images/skills/skill3/Dazzling_Flash_Passive_Light.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628b52f6df0e1e3ae0cfc075"
        },
        "name": "Other Side of the Moon",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "other-side-of-the-moon",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Reflects 20% of the received damage back to the enemy. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Other_Side_of_the_Moon_Passive_Dark.png",
            "/assets/images/skills/Status_Reflect_Damage.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Other_Side_of_the_Moon_Passive_Dark.png",
            "/assets/images/skills/Status_Reflect_Damage.png"
        ],
        "element": "Dark",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Other_Side_of_the_Moon_Passive_Dark.png",
        "image2": "/assets/images/skills/Status_Reflect_Damage.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:13:27.825Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Unicorn",
        "thumbImage1": "/assets/images/skills/skill3/Other_Side_of_the_Moon_Passive_Dark.png",
        "thumbImage2": "/assets/images/skills/Status_Reflect_Damage.png"
    },
    {
        "_id": {
            "$oid": "628b5326df0e1e3ae0cfc078"
        },
        "name": "Transformation: Human Form 1",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "transformation:-human-form-1",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Transforms into a Human Form and you'll be able to use new skill. The Attack Power will be increased proportionate to your MAX HP in Human Form, but your MAX HP will be decreased by 50%. Instantly gains another turn after transformation. (Reusable in 2 turns)",
        "images": [
            "/assets/images/skills/skill4/Transformation-_Human_Form_Fire.png",
            "/assets/images/skills/skill4/Transformation-_Human_Form_Wind.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill4/Transformation-_Human_Form_Fire.png",
            "/assets/images/skills/skill4/Transformation-_Human_Form_Wind.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill4/Transformation-_Human_Form_Fire.png",
        "image2": "/assets/images/skills/skill4/Transformation-_Human_Form_Wind.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:11:11.585Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Unicorn",
        "thumbImage1": "/assets/images/skills/skill4/Transformation-_Human_Form_Fire.png",
        "thumbImage2": "/assets/images/skills/skill4/Transformation-_Human_Form_Wind.png"
    },
    {
        "_id": {
            "$oid": "628b5336df0e1e3ae0cfc07b"
        },
        "name": "Transformation: Human Form 2",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "transformation:-human-form-2",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Transforms into a Human Form and you'll be able to use new skill. The Attack Speed will be increased proportionate to your MAX HP in Human Form, but your MAX HP will be decreased by 30%. Instantly gains another turn after transformation. (Reusable in 2 turns)",
        "images": [
            "/assets/images/skills/skill4/Transformation-_Human_Form_Water.png",
            "/assets/images/skills/skill4/Transformation-_Human_Form_Light.png",
            "/assets/images/skills/skill4/Transformation-_Human_Form_Dark.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill4/Transformation-_Human_Form_Water.png",
            "/assets/images/skills/skill4/Transformation-_Human_Form_Light.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill4/Transformation-_Human_Form_Water.png",
        "image2": "/assets/images/skills/skill4/Transformation-_Human_Form_Light.png",
        "image3": "/assets/images/skills/skill4/Transformation-_Human_Form_Dark.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:12:14.348Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Unicorn",
        "thumbImage1": "/assets/images/skills/skill4/Transformation-_Human_Form_Water.png",
        "thumbImage2": "/assets/images/skills/skill4/Transformation-_Human_Form_Light.png"
    },
    {
        "_id": {
            "$oid": "628b53d9df0e1e3ae0cfc087"
        },
        "name": "Totem Magic",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "totem-magic",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy target and recovers the HP of an ally with the lowest HP ratio by 15%. Multiplier: 3.9*{ATK}",
        "images": [
            "/assets/images/skills/skill1/Totem_Magic_Fire.png",
            "/assets/images/skills/skill1/Totem_Magic_Water.png",
            "/assets/images/skills/skill1/Totem_Magic_Wind.png",
            "/assets/images/skills/skill1/Totem_Magic_Light.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Totem_Magic_Fire.png",
            "/assets/images/skills/skill1/Totem_Magic_Dark.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Totem_Magic_Fire.png",
        "image2": "/assets/images/skills/skill1/Totem_Magic_Water.png",
        "image3": "/assets/images/skills/skill1/Totem_Magic_Wind.png",
        "image4": "/assets/images/skills/skill1/Totem_Magic_Light.png",
        "modified": {
            "$date": "2022-09-07T09:20:13.421Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Totemist",
        "thumbImage1": "/assets/images/skills/skill1/Totem_Magic_Fire.png",
        "thumbImage2": "/assets/images/skills/skill1/Totem_Magic_Dark.png"
    },
    {
        "_id": {
            "$oid": "628b53f2df0e1e3ae0cfc08a"
        },
        "name": "Totem Friends",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "totem-friends",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies to remove all beneficial effects granted on them and provokes for 1 turn with a 50% chance each. (Reusable in 4 turns). Multiplier: 3.2*{ATK}",
        "images": [
            "/assets/images/skills/skill2/Totem_Friends_Fire.png",
            "/assets/images/skills/skill2/Totem_Friends_Dark.png",
            "/assets/images/skills/Provoke.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Totem_Friends_Fire.png",
            "/assets/images/skills/Provoke.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Totem_Friends_Fire.png",
        "image2": "/assets/images/skills/skill2/Totem_Friends_Dark.png",
        "image3": "/assets/images/skills/Provoke.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-08T04:33:55.798Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Totemist",
        "thumbImage1": "/assets/images/skills/skill2/Totem_Friends_Fire.png",
        "thumbImage2": "/assets/images/skills/Provoke.png"
    },
    {
        "_id": {
            "$oid": "628b5402df0e1e3ae0cfc08d"
        },
        "name": "Dance with the Elemental",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "dance-with-the-elemental",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Grants Immunity on all allies for 1 turn. (Reusable in 4 turns).",
        "images": [
            "/assets/images/skills/skill2/Dance_with_the_Elemental_Water.png",
            "/assets/images/skills/skill2/Dance_with_the_Elemental_Wind.png",
            "/assets/images/skills/skill2/Dance_with_the_Elemental_Light.png",
            "/assets/images/skills/Immunity.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Dance_with_the_Elemental_Water.png",
            "/assets/images/skills/Immunity.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Dance_with_the_Elemental_Water.png",
        "image2": "/assets/images/skills/skill2/Dance_with_the_Elemental_Wind.png",
        "image3": "/assets/images/skills/skill2/Dance_with_the_Elemental_Light.png",
        "image4": "/assets/images/skills/Immunity.png",
        "modified": {
            "$date": "2022-09-08T04:34:35.909Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Totemist",
        "thumbImage1": "/assets/images/skills/skill2/Dance_with_the_Elemental_Water.png",
        "thumbImage2": "/assets/images/skills/Immunity.png"
    },
    {
        "_id": {
            "$oid": "628b542ddf0e1e3ae0cfc090"
        },
        "name": "Ancestor's Blessing",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "ancestor's-blessing",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Takes damage only from the first hit of the enemy's attack. This doesn't apply to boss attacks. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Ancestor_s_Blessing.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Ancestor_s_Blessing.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Ancestor_s_Blessing.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:30:16.79Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Totemist",
        "thumbImage1": "/assets/images/skills/skill3/Ancestor_s_Blessing.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628b544adf0e1e3ae0cfc093"
        },
        "name": "Half Moon Tribe Totem",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "half-moon-tribe-totem",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Stacks 1 totem whenever you're attacked by a target during the enemy's turn or use a skill during your turn. Becomes able to use the [Half Moon Tribe Totem] skill when you stack 3 totems. Attacks all enemies to remove all beneficial effects and decreases the HP of the enemy granted with harmful effect by 15% and decreases 10% HP if it's the boss. Multiplier: 4.1*{ATK}",
        "images": [
            "/assets/images/skills/skill4/Half_Moon_Tribe_Totem.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill4/Half_Moon_Tribe_Totem.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill4/Half_Moon_Tribe_Totem.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:31:04.446Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Totemist",
        "thumbImage1": "/assets/images/skills/skill4/Half_Moon_Tribe_Totem.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628b5469df0e1e3ae0cfc096"
        },
        "name": "Sun Tribe Totem",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "sun-tribe-totem",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Stacks 1 totem whenever you're attacked by a target during the enemy's turn or use a skill during your turn. Becomes able to use the [Sun Tribe Totem] skill when you stack 3 totems. Recovers the HP of all allies by 20%, decreases the cooldown time by 1 turn and grants Immunity for 1 turn when you use the skill",
        "images": [
            "/assets/images/skills/skill4/Sun_Tribe_Totem.png",
            "/assets/images/skills/Immunity.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill4/Sun_Tribe_Totem.png",
            "/assets/images/skills/Immunity.png"
        ],
        "element": "Light",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill4/Sun_Tribe_Totem.png",
        "image2": "/assets/images/skills/Immunity.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:31:57.978Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Totemist",
        "thumbImage1": "/assets/images/skills/skill4/Sun_Tribe_Totem.png",
        "thumbImage2": "/assets/images/skills/Immunity.png"
    },
    {
        "_id": {
            "$oid": "628b5478df0e1e3ae0cfc099"
        },
        "name": "Wise Owl Soul",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "wise-owl-soul",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Resets the cooldown time of an ally except yourself and increases the Attack Bar by 50%. However, [Wise Owl Soul] will not be affected by cooldown reducing or increasing skills. (Reusable in 6 turns)",
        "images": [
            "/assets/images/skills/skill3/Wise_Owl_Soul.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Wise_Owl_Soul.png",
            "/assets/images/skills/attack-bar-up.png"
        ],
        "element": "Light",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Wise_Owl_Soul.png",
        "image2": "/assets/images/skills/attack-bar-up.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:29:26.352Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Totemist",
        "thumbImage1": "/assets/images/skills/skill3/Wise_Owl_Soul.png",
        "thumbImage2": "/assets/images/skills/attack-bar-up.png"
    },
    {
        "_id": {
            "$oid": "628b5488df0e1e3ae0cfc09c"
        },
        "name": "Valiant Boar Soul",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "valiant-boar-soul",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Removes 1 harmful effect of all allies, recovers the HP by 30% and increases the Attack Power for 2 turns. (Reusable in 5 turns)",
        "images": [
            "/assets/images/skills/skill3/Valiant_Boar_Soul.png",
            "/assets/images/skills/Increase-ATK.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Valiant_Boar_Soul.png",
            "/assets/images/skills/Increase-ATK.png"
        ],
        "element": "Wind",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Valiant_Boar_Soul.png",
        "image2": "/assets/images/skills/Increase-ATK.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:28:33.827Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Totemist",
        "thumbImage1": "/assets/images/skills/skill3/Valiant_Boar_Soul.png",
        "thumbImage2": "/assets/images/skills/Increase-ATK.png"
    },
    {
        "_id": {
            "$oid": "628b5499df0e1e3ae0cfc09f"
        },
        "name": "Grassland Tribe Totem",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "grassland-tribe-totem",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Stacks 1 totem whenever you're attacked by a target during the enemy's turn or use a skill during your turn. Becomes able to use the [Grassland Tribe Totem] skill when you stack 3 totems. Recovers the HP of all allies by 20%, increases the Attack Power for 2 turns and grants Immunity for 1 turn when you use the skill",
        "images": [
            "/assets/images/skills/skill4/Grassland_Tribe_Totem.png",
            "/assets/images/skills/Immunity.png",
            "/assets/images/skills/Increase-ATK.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill4/Grassland_Tribe_Totem.png",
            "/assets/images/skills/Immunity.png"
        ],
        "element": "Wind",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill4/Grassland_Tribe_Totem.png",
        "image2": "/assets/images/skills/Immunity.png",
        "image3": "/assets/images/skills/Increase-ATK.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:32:59.392Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Totemist",
        "thumbImage1": "/assets/images/skills/skill4/Grassland_Tribe_Totem.png",
        "thumbImage2": "/assets/images/skills/Immunity.png"
    },
    {
        "_id": {
            "$oid": "628b54b2df0e1e3ae0cfc0a2"
        },
        "name": "Sea Tribe Totem",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "sea-tribe-totem",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Stacks 1 totem whenever you're attacked by a target during the enemy's turn or use a skill during your turn. Becomes able to use the [Sea Tribe Totem] skill when you stack 3 totems. Recovers the HP of all allies by 20%, increases the Defense for 2 turns and grants Immunity for 1 turn when you use the skill",
        "images": [
            "/assets/images/skills/skill4/Sea_Tribe_Totem.png",
            "/assets/images/skills/Immunity.png",
            "/assets/images/skills/Increase-DEF.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill4/Sea_Tribe_Totem.png",
            "/assets/images/skills/Immunity.png"
        ],
        "element": "Water",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill4/Sea_Tribe_Totem.png",
        "image2": "/assets/images/skills/Immunity.png",
        "image3": "/assets/images/skills/Increase-DEF.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:34:02.561Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Totemist",
        "thumbImage1": "/assets/images/skills/skill4/Sea_Tribe_Totem.png",
        "thumbImage2": "/assets/images/skills/Immunity.png"
    },
    {
        "_id": {
            "$oid": "628b54bedf0e1e3ae0cfc0a5"
        },
        "name": "Strong Bull Soul",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "strong-bull-soul",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Recovers the HP of all allies by 15% each for 2 turns and increases their Defense. (Reusable in 5 turns)",
        "images": [
            "/assets/images/skills/skill3/Strong_Bull_Soul.png",
            "/assets/images/skills/Increase-DEF.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Strong_Bull_Soul.png",
            "/assets/images/skills/Increase-DEF.png"
        ],
        "element": "Water",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Strong_Bull_Soul.png",
        "image2": "/assets/images/skills/Increase-DEF.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:27:23.85Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Totemist",
        "thumbImage1": "/assets/images/skills/skill3/Strong_Bull_Soul.png",
        "thumbImage2": "/assets/images/skills/Increase-DEF.png"
    },
    {
        "_id": {
            "$oid": "628b54d3df0e1e3ae0cfc0a8"
        },
        "name": "Volcanic Tribe Totem",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "volcanic-tribe-totem",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Stacks 1 totem whenever you're attacked by a target during the enemy's turn or use a skill during your turn. Becomes able to use the [Volcanic Tribe Totem] skill when you stack 3 totems. Attacks all enemies to remove all beneficial effects and decreases the HP by 5% per harmful effect granted when you use the skill. Up to 10% is applied to the boss. Multiplier: 4.1*{ATK}",
        "images": [
            "/assets/images/skills/skill4/Volcanic_Tribe_Totem.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill4/Volcanic_Tribe_Totem.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Fire",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill4/Volcanic_Tribe_Totem.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:34:47.775Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Totemist",
        "thumbImage1": "/assets/images/skills/skill4/Volcanic_Tribe_Totem.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628b54e6df0e1e3ae0cfc0ab"
        },
        "name": "Ancestor's Wisdom",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "ancestor's-wisdom",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Inflicts Continuous Damage for 2 turns when you attack the enemy on your turn and inflicts Continuous Damage to the enemy target for 2 turns when you're attacked by a target during the enemy's turn. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Ancestor_s_Wisdom.png",
            "/assets/images/skills/Continuous-Damage.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Ancestor_s_Wisdom.png",
            "/assets/images/skills/Continuous-Damage.png"
        ],
        "element": "Fire",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Ancestor_s_Wisdom.png",
        "image2": "/assets/images/skills/Continuous-Damage.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-08T04:36:18.18Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Totemist",
        "thumbImage1": "/assets/images/skills/skill3/Ancestor_s_Wisdom.png",
        "thumbImage2": "/assets/images/skills/Continuous-Damage.png"
    },
    {
        "_id": {
            "$oid": "628b5509df0e1e3ae0cfc0ae"
        },
        "name": "Increase the Attack Power of ally monsters by 33%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-attack-power-of-ally-monsters-by-33percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Attack Power of ally monsters by 33%",
        "images": [
            "/assets/images/skills/leaderskill/leader_skill_Attack_Power.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/leader_skill_Attack_Power.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Water",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/leader_skill_Attack_Power.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T03:33:44.382Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Weapon Master",
        "thumbImage1": "/assets/images/skills/leaderskill/leader_skill_Attack_Power.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628b5514df0e1e3ae0cfc0b1"
        },
        "name": "Increase the Attack Speed of ally monsters by 24%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-attack-speed-of-ally-monsters-by-24percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Attack Speed of ally monsters by 24% ",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b553fdf0e1e3ae0cfc0b5"
        },
        "name": "Mach Punch",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Mach-Punch",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy and decreases the Attack Power for 2 turns with a 50% chance. Multiplier: 3.7*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b556bdf0e1e3ae0cfc0b8"
        },
        "name": "Iron Uppercut",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Iron-Uppercut",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Uses an uppercut to attack the enemy and leaves a Branding effect for 2 turns. [Mach Punch] will be activated in succession with a 30% chance. (Reusable in 3 turns). Multiplier: 5.5*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b557cdf0e1e3ae0cfc0bb"
        },
        "name": "Rolling Spike",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Rolling-Spike",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies 3 times. Each attack has a 20% chance to remove one beneficial effect and to absorb the Attack Bar by 10%. (Reusable in 4 turns). Multiplier: 1.3*{ATK} x3",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b5594df0e1e3ae0cfc0be"
        },
        "name": "Chain Combo Attack",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Chain-Combo-Attack",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks 6 times with endless attacks. The first 3 hits decrease one enemy's Attack Bar by 30% each, and the 4th hit Stuns that enemy. Afterwards, attacks all enemies 2 more times, increasing the duration of harmful effects granted on them by 1 turn each. (Reusable in 6 turns). Multiplier: 1.1*{ATK} x6",
        "images": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b55a3df0e1e3ae0cfc0c1"
        },
        "name": "Final Drive",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Final-Drive",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases your Attack Power for 2 turns, and inflicts damage that ignores all damage reduction effects. Gains a turn instantly if the enemy gets defeated from this attack. (Reusable in 5 turns). Multiplier: 4.6*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b55b9df0e1e3ae0cfc0c4"
        },
        "name": "Triple Crush",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Triple-Crush",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy with an attack that won't land as a Glancing Hit to remove all beneficial effects. If the enemy has no beneficial effects after the attack, attacks the enemy once again to weaken the Defense for 2 turns. If you successfully weakened the Defense, attacks the enemy with a powerful finishing strike. In addition, the cooldown time of [Triple Crush] will reset if the attack is not made until the finishing strike. (Reusable in 5 turns). Multiplier: 2.2*{ATK} x3",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b55d1df0e1e3ae0cfc0c7"
        },
        "name": "Overdrive",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Overdrive",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "The damage will be offset and your Attack Bar will be filled up if you receive damage during the turn of the enemy. [Automatic Effect] (Reusable in 4 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b55e7df0e1e3ae0cfc0ca"
        },
        "name": "Attack is the Best Form of Defense",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Attack-is-the-Best-Form-of-Defense",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "When being attacked by an enemy, the chance of receiving a Glancing Hit increases up to 50% as the enemy's Attack Power is lower than your Attack Power. If the enemy's attack lands as a Glancing Hit, removes 1 harmful effect counterattacks with [Iron Uppercut]. [Automatic Effect",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b5630df0e1e3ae0cfc0d5"
        },
        "name": "Increase the Critical Rate of ally monsters in the Arena by 33%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-critical-rate-of-ally-monsters-in-the-arena-by-33percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Critical Rate of ally monsters in the Arena by 33%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b564ddf0e1e3ae0cfc0d8"
        },
        "name": "Rage Explosion",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Rage-Explosion",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy and provokes the enemy for 1 turn with a 50% chance. This attack will deal more damage according to your MAX HP. Multiplier: 4.0*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b566adf0e1e3ae0cfc0db"
        },
        "name": "Sword of Gluttony",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Sword-of-Gluttony",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy 3 times, absorbing the Attack Bar by 20% each, and recovers your HP by 30% of the damage dealt. The damage of this attack is proportionate to your MAX HP. (Reusable in 4 turns). Multiplier: 0.9*{ATK} + 0.09*{MAX HP} x3",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b5679df0e1e3ae0cfc0de"
        },
        "name": "Sword of Burst",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Sword-of-Burst",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy to provoke and to decrease Defense for 1 turn. This attack will deal more damage according to your MAX HP. (Reusable in 3 turns). Multiplier: 3.0*{ATK} + 0.2*{MAX HP}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b569adf0e1e3ae0cfc0e1"
        },
        "name": "Ruler of Pain",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Ruler-of-Pain",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Your Attack Bar will be filled up and HP will be recovered by 20% if you get attacked during the turn of the provoked enemy. [Automatic Effect]}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b56acdf0e1e3ae0cfc0e4"
        },
        "name": "Destroyer of Battlefield",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Destroyer-of-Battlefield",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Destroys the enemy's MAX HP by 50% of the enemy's current lost HP after attacking the enemy. Also, if all allies are attacked by the target with destroyed HP, the incoming damage will be decreased in proportion to the destroyed HP. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b56bedf0e1e3ae0cfc0e7"
        },
        "name": "Sword Rain",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Sword-Rain",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies 3 times to inflict damage proportional to your MAX HP. Also, each attack decreases the Attack Bar by 15%, decreases the Attack Speed for 2 turns, and Stuns them for 1 turn with a 50% chance respectively. (Reusable in 5 turns). Multiplier: 0.1*{MAX HP} x3",
        "images": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b56d0df0e1e3ae0cfc0ea"
        },
        "name": "Great Sword of the End",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Great-Sword-of-the-End",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy to remove all beneficial effects and sets the enemy's skills on max cooldown time. Afterwards, attacks all enemies to decrease their Attack Bar to 0 and provokes them for 1 turn. (Reusable in 5 turns). Multiplier: 4.0*{ATK} x2",
        "images": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b56dedf0e1e3ae0cfc0ed"
        },
        "name": "Devil's Grace",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Devil's-Grace",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Absorbs the HP of all allies by 30% each and HP of all enemies by 15% each. Afterwards, increases the Attack Bar of all allies by 40% each, increases the Attack Power for 2 turns and Attack Speed for 2 turns. (Reusable in 6 turns). Multiplier: 0.15*{Target MAX HP} (Fixed)",
        "images": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b5711df0e1e3ae0cfc0f2"
        },
        "name": "Increase the Attack Speed of ally monsters in the Arena by 33%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-attack-speed-of-ally-monsters-in-the-arena-by-33percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Attack Speed of ally monsters in the Arena by 33%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b573cdf0e1e3ae0cfc0f7"
        },
        "name": "Cutback Blow",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Cutback-Blow",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy to absorb the Attack Bar by 15% with a 50% chance. Multiplier: 3.8*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b5759df0e1e3ae0cfc0fa"
        },
        "name": "Spin Grab Shot",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Spin-Grab-Shot",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy to remove all beneficial effects with an 80% chance and stuns the enemy with a 30% chance. (Reusable in 4 turns). Multiplier: 6.2*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b576adf0e1e3ae0cfc0fd"
        },
        "name": "Impulse Gun",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Impulse-Gun",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy to remove all beneficial effects with an 80% chance and stuns the enemy with a 30% chance. (Reusable in 4 turns). Multiplier: 6.2*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b5780df0e1e3ae0cfc100"
        },
        "name": "Synergistic Effect",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Synergistic-Effect",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases Attack Bar of all allies by 10% each if the enemy target decreases an ally's Attack Bar during the enemy's turn. In addition, increases the effect of Attack Bar increasing skills of all allies by 50%. This effect does not accumulate and does not apply in battle against bosses. [Automatic Effect]",
        "images": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b5797df0e1e3ae0cfc103"
        },
        "name": "Jet Engine",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Jet-Engine",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases your Attack Speed by 5%, up to 100%, for each beneficial effect granted on the enemies and allies. In addition, inflicts additional damage that ignores Defense in proportion to your Attack Speed when you attack the enemy on your turn. [Automatic Effect] Multiplier: 20*{SPD}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b57acdf0e1e3ae0cfc106"
        },
        "name": "Plasma Bomb",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Plasma-Bomb",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Installs a bomb that goes off after 1 turn on the enemy target and a bomb that goes off after 2 turns on all remaining enemies. (Reusable in 5 turns). Multiplier: 4.5*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b57b9df0e1e3ae0cfc109"
        },
        "name": "Mega Impulse Gun",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Mega-Impulse-Gun",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy, increases the target's skill cooldown time by 2 turns and absorbs the Attack Bar by 100%. In addition, decreases your skill cooldown time by 2 turns if you successfully increased the skill cooldown time. Increases the damage dealt to the enemy by 20% each, up to 100%, whenever you use [Mega Impulse Gun] skill on your turn. (Reusable in 5 turns). Multiplier: 7.6*{ATK}",
        "images": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b57c9df0e1e3ae0cfc10c"
        },
        "name": "Quantum Explosion",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Quantum-Explosion",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies to decrease their Attack Bar by 70% each. If the Attack Bar of an enemy (bosses excluded) becomes 0 and there is no more Attack Bar to be decreased, decreases the enemy's HP by the remaining amount of Attack Bar to be decreased. (Reusable in 5 turns). Multiplier: 4.1*{ATK}",
        "images": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b57eedf0e1e3ae0cfc10f"
        },
        "name": "Increase the Critical Rate of ally monsters with Fire attribute by 38%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-critical-rate-of-ally-monsters-with-fire-attribute-by-38percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Critical Rate of ally monsters with Fire attribute by 38%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b5809df0e1e3ae0cfc112"
        },
        "name": "Increase the Critical Rate of ally monsters with Water attribute by 38%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-critical-rate-of-ally-monsters-with-water-attribute-by-38percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Critical Rate of ally monsters with Water attribute by 38%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b5812df0e1e3ae0cfc115"
        },
        "name": "Increase the Critical Rate of ally monsters with Wind attribute by 38%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-critical-rate-of-ally-monsters-with-wind-attribute-by-38percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Critical Rate of ally monsters with Wind attribute by 38%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b581bdf0e1e3ae0cfc118"
        },
        "name": "Increase the Critical Rate of ally monsters with Light attribute by 38%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-critical-rate-of-ally-monsters-with-light-attribute-by-38percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Critical Rate of ally monsters with Light attribute by 38%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b5825df0e1e3ae0cfc11b"
        },
        "name": "Increase the Critical Rate of ally monsters with Dark attribute by 38%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-critical-rate-of-ally-monsters-with-dark-attribute-by-38percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Critical Rate of ally monsters with Dark attribute by 38%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b583cdf0e1e3ae0cfc11e"
        },
        "name": "Dizzying Gesture",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Dizzying-Gesture",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy to stun for 1 turn with a 30% chance. Multiplier: 3.8*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b5856df0e1e3ae0cfc121"
        },
        "name": "Shadow of Right Arm",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Shadow-of-Right-Arm",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy to decrease Defense for 2 turns with an 80% chance, and the shadow, which is dismissed when attacked by an enemy, protects you for 1 turn. While under protection, nullifies an enemy's attack 1 time, cannot attack together, and attacks additionally before attacking if you use a skill on the next turn. (Reusable in 4 turns). Multiplier: 5.8*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b586adf0e1e3ae0cfc124"
        },
        "name": "Shadow Tie",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Shadow-Tie",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Ties the enemy's shadow, and grants an effect that gives 30% of the first hit damage to all enemies if you deal a single target skill damage to the target. This effect can tie one target at a time, and gets untied if the tied target gets hit by a single target attack or if you get defeated. It does not apply to boss battles. (Reusable in 5 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b587ddf0e1e3ae0cfc127"
        },
        "name": "Destructive Shadow",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Destructive-Shadow",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies to silence them for 2 turns and absorbs their Attack Bar by 50% each. (Reusable in 5 turns). Multiplier: 4.4*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b588fdf0e1e3ae0cfc12a"
        },
        "name": "Frantic Chaos",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Frantic-Chaos",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Guaranteed to exchange the Attack Bar status of all enemies (boss excluded) with each other at random. Afterwards, recovers your Attack Bar by 100%. (Reusable in 6 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b58a4df0e1e3ae0cfc12d"
        },
        "name": "Shadow Within Me",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Shadow-Within-Me",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Counterattacks with [Shadow of Right Arm] if you get attacked by enemies without the shadow's protection. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b58b8df0e1e3ae0cfc130"
        },
        "name": "Infinity Shadow",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Infinity-Shadow",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Ignores Defense when attacking a target tied by the shadow, and the shadow you tied won't get untied even if the enemy takes damage. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b58c3df0e1e3ae0cfc133"
        },
        "name": "Shadow Trap",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Shadow-Trap",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Casts a shadow trap on the target (boss excluded) after you attack the enemy on your turn. If the target with the shadow trap gets a turn, you will get the turn instead of the target. [Automatic Effect] (Reusable in 3 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b592cdf0e1e3ae0cfc13a"
        },
        "name": "Increase the Critical Rate of ally monsters in the Dungeons by 33%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-critical-rate-of-ally-monsters-in-the-dungeons-by-33percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Critical Rate of ally monsters in the Dungeons by 33%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Critical_Rate_Low_Dungeon_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Critical_Rate_Low_Dungeon_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Critical_Rate_Low_Dungeon_Icon.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T06:38:57.689Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Vampire",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Critical_Rate_Low_Dungeon_Icon.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628b593bdf0e1e3ae0cfc13d"
        },
        "name": "Mach Slash",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Mach-Slash",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy and decreases the Attack Power for 2 turns with a 50% chance. Multiplier: 370%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b594ddf0e1e3ae0cfc140"
        },
        "name": "Hurricane Rush",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Hurricane-Rush",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies 3 times. Each attack has a 20% chance to remove one beneficial effect and to absorb the Attack Bar by 10%. (Reusable in 4 turns). Multiplier: 110% x3",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628b5959df0e1e3ae0cfc143"
        },
        "name": "Shadow Blade",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Shadow-Blade",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy target 3 times to remove 1 beneficial effect with a 30% chance and to leave a Branding effect for 2 turns with a 100% chance per hit. The damage increases by 15% per harmful effect granted on the enemy, and instantly gains another turn if all attacks land as a Critical Hit. (Reusable in 5 turns). Multiplier: 285% x3",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c30800280ff77cb829d94"
        },
        "name": "Increases the Accuracy of ally monsters by 41%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-accuracy-of-ally-monsters-by-41percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Accuracy of ally monsters by 41%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c31190280ff77cb829da1"
        },
        "name": "Power Surge",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Power-Surge",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy, dealing damage and transferring 2 harmful effects on you to the enemy. Multiplier: 400%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c312f0280ff77cb829da4"
        },
        "name": "Spear of Devastation",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Spear-of-Devastation",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy 2 times with each attack, removing 1 beneficial effect and sets back the target's skills to MAX cooldown. (Reusable in 4 turns) Multiplier: 310% x2",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c31400280ff77cb829da7"
        },
        "name": "Sweeping Waves",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Sweeping-Waves",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": " Attacks all enemies with mighty waves, silencing them for 2 turns. The enemies under Silence Effect won't be able to use skills with cooldown time excluding passive skills. (Reusable in 5 turns) Multiplier: 300%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c315b0280ff77cb829daa"
        },
        "name": "King of the Ruins",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "King-of-the-Ruins",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks deal 50% increased damage on enemies that are under harmful effects. Also, attacks will deal 50% increased damage on enemies that do not have any beneficial effects. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c31740280ff77cb829dad"
        },
        "name": "Rain of Stones",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Rain-of-Stones",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemies 3 to 5 times with flaming meteoroids with each attack having a 30% chance to stun them for 1 turn. Your Attack Bar will be recovered by 25% for each enemy stunned by this attack. (Reusable in 5 turns). Multiplier: 1.1*{ATK} x3",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c31870280ff77cb829db0"
        },
        "name": "Maelstrom",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Maelstrom",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with the attack that won't land as a Glancing Hit to inflict damage proportionate to your Attack Speed and decreases their Attack Bar to 0. Also decreases their attack speed for 2 turns. (Reusable in 5 turns) Multiplier: 530%",
        "images": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c31930280ff77cb829db3"
        },
        "name": "Mega Tsunami",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Mega-Tsunami",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with a massive tidal wave, removing all beneficial effects on the enemies and decreases the Attack Bar of each enemy by 35%. (Reusable in 6 turns). Multiplier: 440%",
        "images": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c31a00280ff77cb829db6"
        },
        "name": "Holy Ground",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Holy-Ground",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Removes all harmful effects on all allies and grants them Immunity and Invincibility for 2 turns. If the ally's harmful effects are removed, the duration of Immunity effect will be increased by 1 turn of that ally. (Reusable in 6 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c325e0280ff77cb829dc1"
        },
        "name": "Hadoken",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Hadoken",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Uses Hadoken on the enemy to inflict damage and decreases the Attack Power for 2 turns with a 50% chance. Multiplier: 370%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c32730280ff77cb829dc4"
        },
        "name": "Shoryuken",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Shoryuken",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Uses an uppercut to inflict damage and leaves a Branding effect for 2 turns. [Hadoken] will be activated in succession with a 30% chance. (Reusable in 3 turns). Multiplier: 550%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c32810280ff77cb829dc7"
        },
        "name": "Tatsumaki Senpukyaku",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Tatsumaki-Senpukyaku",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies 3 times. Each attack has a 20% chance to remove one beneficial effect and to absorb the Attack Bar by 10%. (Reusable in 4 turns). Multiplier: 130%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c32960280ff77cb829dca"
        },
        "name": "PPK Combo",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "PPK-Combo",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks 6 times with endless attacks. The first 3 hits decrease one enemy's Attack Bar by 30% each, and the 4th hit Stuns that enemy. Afterwards, attacks all enemies 2 more times, increasing the duration of harmful effects granted on them by 1 turn each. (Reusable in 6 turns). Multiplier: 110%",
        "images": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c32a60280ff77cb829dcd"
        },
        "name": "Denjin Hadoken",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Denjin-Hadoken",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Collects energy to increase your Attack Power for 2 turns, and shoots the extreme Hadoken on all enemies to inflict damage that ignores all damage reduction effects. Gains a turn instantly if the enemy gets defeated from this attack. (Reusable in 5 turns). Multiplier: 460%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c32b50280ff77cb829dd0"
        },
        "name": "Triple Combo",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Triple-Combo",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy with an attack that won't land as a Glancing Hit to remove all beneficial effects. If the enemy has no beneficial effects after the attack, attacks the enemy once again to weaken the Defense for 2 turns. If you successfully weakened the Defense, attacks the enemy with a powerful finishing strike. In addition, the cooldown time of [Triple Combo] will reset if the attack is not made until the finishing strike. (Reusable in 5 turns). Multiplier: 220%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c32d10280ff77cb829dd3"
        },
        "name": "Martial Art's Instinct",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Martial-Art's-Instinct",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "When being attacked by an enemy, the chance of receiving a Glancing Hit increases up to 50% as the enemy's Attack Power is lower than your Attack Power. If the enemy's attack lands as a Glancing Hit, removes 1 harmful effect and counterattacks with [Shoryuken]. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c32e00280ff77cb829dd6"
        },
        "name": "Mind's Eye",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Mind's-Eye",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "The damage will be offset and your Attack Bar will be filled up if you receive damage during the turn of the enemy. [Automatic Effect] (Reusable in 4 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c33d70280ff77cb829de5"
        },
        "name": "Essence Explosion",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Essence-Explosion",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy to inflict damage and weakens the Defense for 2 turns with a 50% chance.Multiplier: 410%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c33f70280ff77cb829de8"
        },
        "name": "Storm of Midnight",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Storm-of-Midnight",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks to deal damage that increases proportionate to the enemy's Attack Speed. The attack will always land as a Critical Hit if the enemy has no beneficial effects. (Reusable in 3 turns). Multiplier: (Spd+20)/0.4)%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c34060280ff77cb829deb"
        },
        "name": "Aura of Dawn",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Aura-of-Dawn",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies to decrease their Attack Power and increases the enemy's chance to land a Glancing Hit for 2 turns with an 80% chance each. In addition, your Attack Bar increases by 10% per harmful effect granted on the enemy. (Reusable in 3 turns). Multiplier: 3.8*{ATK}",
        "images": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c341e0280ff77cb829dee"
        },
        "name": "Deep Grudge",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Deep-Grudge",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Reflects 30% of damage back to the enemy whenever attacked. Inflicts additional damage that is proportional to the damage that another ally received from the enemy during the previous turn when you attack during your turn. The damage will reset whenever you attack an enemy. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c342f0280ff77cb829df1"
        },
        "name": "Brutal Order",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Brutal-Order",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Sacrifices 10% of an ally target's HP to grant a turn instantly to the target. Decreases the skill cooldowns of all allies by 2 turns. (Reusable in 7 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c34a70280ff77cb829df4"
        },
        "name": "Touch of Mercy",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Touch-of-Mercy",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy with an attack where the inflicted damage is increased by 40% for each harmful effect or beneficial effect of the enemy. Puts the enemy to sleep for 2 turns after the attack. Targets that have immunity against sleep will be inflicted with 50% more damage. (Reusable in 4 turns) Multiplier: 840%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c34b70280ff77cb829df7"
        },
        "name": "Frost Rush",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Frost-Rush",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with ice pillars 3 times and freezes them for 1 turn with a 15% chance on each strike. Gains another turn instantly if the enemy dies or the enemy is frozen after the attack. (Reusable in 5 turns). Multiplier: 160% x3",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c34c50280ff77cb829dfa"
        },
        "name": "Wind of Changes",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Wind-of-Changes",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Removes all harmful and beneficial effects of all allies and enemies and increases the attack gauge of all allies by 30%. This effect can't be resisted. (Reusable in 6 turns) Multiplier: N/A",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c37c10280ff77cb829e06"
        },
        "name": "Yin Yang Attack",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Yin-Yang-Attack",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy with the power of Yin and Yang and puts the enemy to sleep for 2 turns with a 20% chance. The damage increases according to your MAX HP. Multiplier: 360%+9%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c37d90280ff77cb829e09"
        },
        "name": "North Star's Wisdom",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "North-Star's-Wisdom",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy 2 times with each attack having a 75% chance to remove a beneficial effect at the enemy and a 75% chance to block the beneficial effects granted on the target for 2 turns. This attack won't land as Glancing Hits. (Reusable in 4 turns) Multiplier: 300% x2",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c37e80280ff77cb829e0c"
        },
        "name": "Mountain's Power",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Mountain's-Power",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy with the might of the mountains to inflict damage by 15% of your MAX HP and recovers the HP of all allies by 15% of your MAX HP. (Reusable in 4 turns). Multiplier: 15%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c37fd0280ff77cb829e0f"
        },
        "name": "Inhale Magic",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Inhale-Magic",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Steals the HP of all enemies by 15% of your MAX HP and steals all beneficial effects on all enemies. Increases the Attack Bar of all allies by 20% if you successfully steal beneficial effects. (Reusable in 6 turns). Multiplier: 15%",
        "images": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c38c00280ff77cb829e12"
        },
        "name": "Heavenly Protection",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Heavenly-Protection",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Revives all dead allies with 30% HP and casts Soul Protection upon all allies that are alive for 3 turns. The damage that all allies except yourself receive will be decreased by 15% when this skill is on cooldown. (Reusable in 8 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c38d60280ff77cb829e15"
        },
        "name": "Lightning of Cycle",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Lightning-of-Cycle",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy target with a powerful lightning and inflicts damage that's half of the damage dealt to all the other enemies. If the enemy dies from the first attack, the damage inflicted to the other enemies will be increased by 50%. (Reusable in 4 turns). Multiplier: 800% (+half of first attack)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c38e20280ff77cb829e18"
        },
        "name": "Wish of Immortality",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Wish-of-Immortality",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Grants immunity to all allies that lasts for 3 turns and creates a shield equal to 15% of my HP. (Reusable in 5 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c38f60280ff77cb829e1b"
        },
        "name": "Sleeve Attack",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Sleeve-Attack",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with world devouring powers to remove the beneficial effects on all enemies and to decrease their Attack Bar by 15% each. Additionally decreases each enemy's Attack Bar by 15% per beneficial effect removed from each enemy. (Reusable in 5 turns). Multiplier: 440%",
        "images": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c39820280ff77cb829e1f"
        },
        "name": "Arcane Blast",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Arcane-Blast",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy with a mysterious energy and stuns them for 1 turn with an 18% chance. Multiplier: 420%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c39bc0280ff77cb829e22"
        },
        "name": "Dark Nova",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Dark-Nova",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Explodes compressed energy of darkness to inflict damage to the enemy and removes 1 beneficial effect. The more HP the targeted enemy currently has, the larger the damage becomes. (Reusable in 4 turns). Multiplier: {ATK}*(4.0*{Target Current HP %} + 5.0)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c39f60280ff77cb829e25"
        },
        "name": "Holy Orb",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Holy-Orb",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy with a holy energy to inflict damage that's proportionate to the enemy's MAX HP and stuns the enemy for 1 turn. (Reusable in 3 turns). Multiplier: 450%+8%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3a020280ff77cb829e28"
        },
        "name": "Lightning Nova",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Lightning-Nova",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Explodes compressed energy of darkness to inflict damage to the enemy and removes 1 beneficial effect. The more HP the targeted enemy currently has, the larger the damage becomes. (Reusable in 4 turns). Multiplier: {ATK}*(4.0*{Target Current HP %} + 5.0)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3a0b0280ff77cb829e2b"
        },
        "name": "Flame Nova",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Flame-Nova",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Explodes compressed energy of darkness to inflict damage to the enemy and removes 1 beneficial effect. The more HP the targeted enemy currently has, the larger the damage becomes. (Reusable in 4 turns). Multiplier: {ATK}*(4.0*{Target Current HP %} + 5.0)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3a210280ff77cb829e2e"
        },
        "name": "Frozen Orb",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Frozen-Orb",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks with an extreme chill to inflict damage that's proportionate to the enemy's MAX HP and freezes the enemy for 1 turn. (Reusable in 3 turns). Multiplier: 450%+8%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3b890280ff77cb829e31"
        },
        "name": "Fiery Path",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Fiery-Path",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Leaves a Branding Effect for 3 turns with a 50% chance when you attack an enemy. When you defeat an enemy during your turn, the enemy can't be revived during the battle, and the cooldown time of [Dark Nova] will be decreased by 1 turn. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3b9b0280ff77cb829e34"
        },
        "name": "Purifying Blaze",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Purifying-Blaze",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Removes the beneficial effects of all enemies with holy fire, weakens the Defense for 2 turns and inflicts damage. (Reusable in 5 turns). Multiplier: 450%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3ba80280ff77cb829e37"
        },
        "name": "Tempest",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Tempest",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with a violent storm once more after you attack the enemy on your turn. The cooldown time of [Tempest] will reset if an enemy dies from your attack. [Automatic Effect] (Reusable in 5 turns). Multiplier: 450%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3bba0280ff77cb829e3a"
        },
        "name": "Ice Volcano",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Ice-Volcano",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with an exploding ice volcano, inflicting damage based on their MAX HP and decreasing their Attack Power for 2 turns and freezes them for 1 turn. (Reusable in 5 turns). Multiplier: 300%+12%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3bf00280ff77cb829e3d"
        },
        "name": "Eternity",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Eternity",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Recovers the HP of all allies by 10% every turn, and rises from the ashes at the moment of death with 100% HP. [Automatic Effect] (Reusable in 12 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3c460280ff77cb829e41"
        },
        "name": "Sequential Attack",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Sequential-Attack",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy 3 times with each strike having a 30% chance to decrease the target's Defense for 2 turns. Multiplier: 130% x3",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3c5c0280ff77cb829e44"
        },
        "name": "Calm Mind",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Calm-Mind",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Removes the harmful effects casted on yourself and counterattacks for 2 turns when attacked. Recovers 15% of the HP of all allies in each turn for the next 2 turns. (Reusable in 5 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3c710280ff77cb829e47"
        },
        "name": "Dragon's Dance",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Dragon's-Dance",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": " Attacks all enemies 3 times to inflict damage that increases accordingly to your MAX HP. The third attack removes a beneficial effect and stuns them for 1 turn with a 25% chance each. (Reusable in 4 turns) Multiplier: (100%+7%) x3",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3c810280ff77cb829e4a"
        },
        "name": "Almighty Strength",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Almighty-Strength",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Decreases the incoming damage by 35% and increases the damage dealt by 50% if the enemy has lower Attack Power than yours. Recovers the HP by 30% of the damage dealt whenever you attack the enemy. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3c9e0280ff77cb829e4d"
        },
        "name": "Strong Energy",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Strong-Energy",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "The effect of all Attack Bar increasing skills of both allies and enemies will be decreased by 50%. Your Attack Bar will increase by 15% whenever an enemy uses an Attack Bar increasing skill. This skill will not apply to an opponent that has the same skill or Boss skills",
        "images": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3d000280ff77cb829e50"
        },
        "name": "Winds and Clouds",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Winds-and-Clouds",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Your Attack Bar increases by 20% whenever you are attacked. Your attacks will inflict additional damage that is proportionate to your Defense whenever you attack. Multiplier: 160%",
        "images": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3d170280ff77cb829e53"
        },
        "name": "Panda Supremacy",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Panda-Supremacy",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": " Attacks the enemy 4 times to grant 1 random harmful effect among Glancing Hit Rate Increase, Attack Power Decrease, and Attack Speed Decrease with a 70% chance each. The inflicted damage is proportionate to your Defense and the MAX HP of the target. (Reusable in 5 turns) Multiplier: (80%+4%) x4",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3d280280ff77cb829e56"
        },
        "name": "Reckless Assault",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Reckless-Assault",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Launches a reckless attack that damages the enemy by 70% of its HP at the cost of receiving the same amount of damage. The damage can't exceed your current HP, and is reduced to 15% (instead of 70%) against Boss enemies. (Reusable in 8 turns) Multiplier: 70%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3d420280ff77cb829e59"
        },
        "name": "Increases the Defense of ally monsters Guild Battles by 44%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-defense-of-ally-monsters-guild-battles-by-44percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Defense of ally monsters Guild Battles by 44%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3d5e0280ff77cb829e5d"
        },
        "name": "Increases the HP of ally monsters Guild Battles by 44%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-hp-of-ally-monsters-guild-battles-by-44percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the HP of ally monsters Guild Battles by 44%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3d680280ff77cb829e60"
        },
        "name": "Increases the Critical Rate of ally monsters Guild Battles by 33%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-critical-rate-of-ally-monsters-guild-battles-by-33percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Critical Rate of ally monsters Guild Battles by 33%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3d880280ff77cb829e64"
        },
        "name": "Justice Strike",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Justice-Strike",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks and stuns the enemy for 1 turn with a 15% chance. Multiplier: 400%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3da30280ff77cb829e67"
        },
        "name": "Prayer of Protection",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Prayer-of-Protection",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Removes all harmful effects on the ally and makes the ally invincible for 1 turn. (Reusable in 5 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3db00280ff77cb829e6a"
        },
        "name": "Fury of Punishment",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Fury-of-Punishment",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": " Attacks the enemy 2 times to remove the beneficial effect with a 75% chance each and provokes the enemy for 1 turn. Afterwards, counterattacks whenever you're attacked for 2 turns. (Reusable in 4 turns) Multiplier: 300% x2",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3dc70280ff77cb829e6d"
        },
        "name": "Internal Force",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Internal-Force",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "When the battle begins, balances the Defense and Attack Power so that the stat with the lower value will have the same value as the stat with the higher value. Creates a shield that's equivalent to your Defense for 2 turns when you get attacked, and the damage you inflict on an enemy will be increased by 30% when you have a shield. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3de10280ff77cb829e70"
        },
        "name": "Heavenly Blessing",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Heavenly-Blessing",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Creates a shield that's proportionate to 20% of your HP on all allies for 2 turns when an ally gets granted with inability effects. Afterwards, removes all harmful effects granted on yourself, counterattacks the enemy target that attacked and gains a turn instantly. [Automatic Effect] (Reusable in 6 turns). Multiplier: 20%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3df40280ff77cb829e73"
        },
        "name": "Cry of Threat",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Cry-of-Threat",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Creates a shield that's proportionate to 20% your HP on all allies for 2 turns and activates Threat state while the enemy attacks 3 times. The enemy can only attack the target under the Threat state when using the attack skill. (Reusable in 6 turns) Multiplier: 20%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3e020280ff77cb829e76"
        },
        "name": "Divine Wind",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Divine-Wind",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Recovers the HP of all allies by 20% each and creates a shield that's proportionate to 20% of your HP for 3 turns. Afterwards, grants immunity on the allies who have full HP for 2 turns. (Reusable in 5 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c3e0f0280ff77cb829e79"
        },
        "name": "Cry of Provocation",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Cry-of-Provocation",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Provokes all enemies for 2 turns and instantly recovers a turn. (Reusable in 6 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c40e40280ff77cb829e87"
        },
        "name": "Passing Time",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Passing-Time",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks 3 times and recovers 15% of the Attack Bar each time the attack lands as a Critical Hit. Multiplier: 130% x3",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c413e0280ff77cb829e8a"
        },
        "name": "Fate of Destruction 1",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Fate-of-Destruction-1",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Inflicts Continuous Damage for 2 turns to the target enemy and sets up a bomb to blow up after 2 turns. Instantly gains another turn after using this skill. (Reusable in 4 turns) Multiplier: 500%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c41c40280ff77cb829e8f"
        },
        "name": "Fate of Destruction 2",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Fate-of-Destruction-2",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Inflicts Continuous Damage for 2 turns to the target enemy and sets up a bomb to blow up after 2 turns. Instantly gains another turn after using this skill. (Reusable in 4 turns) Multiplier: 500%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c41d70280ff77cb829e92"
        },
        "name": "Predicted Future",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Predicted-Future",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with an 80% chance to remove beneficial effects, inflicting Continuous Damage equal to the number of removed beneficial effects for 2 turns. (Reusable in 4 turns) Multiplier: 300%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c42550280ff77cb829e9a"
        },
        "name": "Loss of Cause and Effect",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Loss-of-Cause-and-Effect",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Removes all harmful effects if you start the turn with harmful effects. Recovers HP of all allies by 10% of your MAX HP for each removed harmful effect. [Automatic Effect] Multiplier: 300%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c42630280ff77cb829e9d"
        },
        "name": "Daydream",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Daydream",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Recovers the HP of all allies by 50% by putting yourself to sleep for 1 turn. In addition, puts all enemies to sleep for 1 turn with a 100% chance. (Reusable in 6 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c42730280ff77cb829ea0"
        },
        "name": "Promised Time",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Promised-Time",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies and immediately sets off the bombs on the target. (Reusable in 7 turns) Multiplier: 400%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c42820280ff77cb829ea3"
        },
        "name": "Start and End",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Start-and-End",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Removes the harmful effects on all allies and grants Invincibility for 1 turn and Immunity for 2 turns. Recovers their HP by 15% each for 3 turns afterwards. (Reusable in 6 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c428f0280ff77cb829ea6"
        },
        "name": "Critical Error",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Critical-Error",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies, removing all beneficial effects and stunning the enemies whose beneficial effect has been removed for 1 turn. (Reusable in 7 turns) Multiplier: 380%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c46b70280ff77cb829eaa"
        },
        "name": "Increase the HP of ally monsters by 33% ",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-hp-of-ally-monsters-by-33percent-",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the HP of ally monsters by 33% ",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c46dc0280ff77cb829eaf"
        },
        "name": "Increase the Defense of ally monsters by 33%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-defense-of-ally-monsters-by-33percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Defense of ally monsters by 33%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c46fa0280ff77cb829eb3"
        },
        "name": "Burning Soul",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Burning-Soul",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy and removes one beneficial effect with a 50% chance. Multiplier: 3.8*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c47140280ff77cb829eb6"
        },
        "name": "Karma",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Karma",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy target to remove 1 beneficial effect, and suppresses the target (boss excluded) for 2 turns. The suppressed target will have the HP reduced by 50% if the target uses a skill with cooldown time, and the used skill's cooldown time will be increased by 3 turns more than the maximum cooldown time. (Reusable in 4 turns). Multiplier: 5.4*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c47390280ff77cb829eb9"
        },
        "name": "Past Life Spell",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Past-Life-Spell",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Summons the soul of the dead ally and uses the target's skill once. At this time, the target's passive skill won't be applied. When used on a living ally, grants Soul Protection on the target for 2 turns and decreases the skill cooldown time by 1 turn. (Reusable in 5 turns",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c47730280ff77cb829ebc"
        },
        "name": "Curse of Death",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Curse-of-Death",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Grants the Curse of Death on the enemy target, excluding the boss, that cannot be removed to inflict damage by 25% of the target's MAX HP each and disturbs the HP recovery for 4 turns. The enemy defeated by this attack cannot be revived during battle, and this effect cannot be applied to two or more at the same time. The effect disappears when the caster dies. (Reusable in 5 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c47840280ff77cb829ebf"
        },
        "name": "Yin-Yang Five Elements",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Yin-Yang-Five-Elements",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Limits the no. of turns for harmful effects on allies and beneficial effects on enemies to 1 turn (bombs and boss skills excluded). The ally recovers HP by 10% per harmful effect granted on the target at the start of that ally's turn. However, this effect is not accumulated with other similar effects. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c47930280ff77cb829ec2"
        },
        "name": "Comeuppance",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Comeuppance",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Recovers the Attack Bar by 25% and decreases the cooldown time of [Karma] by 1 turn each if an enemy uses a skill with cooldown time. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c47a30280ff77cb829ec5"
        },
        "name": "All Things in Nature",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "All-Things-in-Nature",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Applies all harmful effects granted on this battle to each enemy for 1 turn each and applies all beneficial effects to each ally for 1 turn each. (Reusable in 6 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c47b30280ff77cb829ec8"
        },
        "name": "Yin-Yang Bounded Circle",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Yin-Yang-Bounded-Circle",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies to increase the duration of harmful effects granted on them by 1 turn each. Absorbs the Attack Bar by 15% for each turn of the harmful effects on the target. (Reusable in 6 turns). Multiplier: 4.2*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c47f50280ff77cb829ecb"
        },
        "name": "Ghost Slash",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Ghost-Slash",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy 2 times, recovering HP by 30% of the inflicted damage and decreasing the target's Defense for 2 turns with a 20% chance each. Multiplier: 4.3*{ATK} x2",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c480d0280ff77cb829ece"
        },
        "name": "Increase the HP of ally monsters in the Arena by 33%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-hp-of-ally-monsters-in-the-arena-by-33percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the HP of ally monsters in the Arena by 33%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c483a0280ff77cb829ed1"
        },
        "name": "Blade Slaughter",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Blade-Slaughter",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies and grants Endure effect on yourself for 1 turn if an enemy gets defeated. (Reusable in 4 turns). Multiplier: 12.5*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c484a0280ff77cb829ed4"
        },
        "name": "Ghost Wild Dance",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Ghost-Wild-Dance",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies 2 times and recovers HP by 30% of the inflicted damage. (Reusable in 4 turns). Multiplier: 6.2*{ATK} x2",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c485b0280ff77cb829ed7"
        },
        "name": "Indomitable",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Indomitable",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Critical Hits won’t occur when attacking the enemy, but the damage is increased by 30%. You won't die under inability effects, and removes all inability effects granted on yourself when the turn starts and the damage is increased by 50% additionally on that turn. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c486c0280ff77cb829eda"
        },
        "name": "Banging Head Against A Brick Wall",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Banging-Head-Against-A-Brick-Wall",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Counterattacks the target if the damage you received from the enemy is less than 15% of your MAX HP. Critical Hits won’t occur when being attacked or attacking the enemy. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c487e0280ff77cb829edd"
        },
        "name": "Calculated Sacrifice",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Calculated-Sacrifice",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Decreases your current HP by 20% at the start of each turn and inflicts additional damage by 15% of the lost HP when you attack on your turn. Critical Hits won’t occur when attacking the enemy. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c488c0280ff77cb829ee0"
        },
        "name": "Undergo Hardship",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Undergo-Hardship",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Attack Power by 10% each, up to 250%, whenever Monsters except yourself get a turn. Critical Hits won’t occur when attacking the enemy. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c48990280ff77cb829ee3"
        },
        "name": "Forestall",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Forestall",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases your Defense by 50% of your Attack Power when the battle begins, and inflicts additional damage proportional to your Defense when you attack on your turn. Critical Hits won’t occur when attacking the enemy. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c48b50280ff77cb829ee6"
        },
        "name": "Increases the Critical Rate of ally monsters with Fire attribute by 38%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-critical-rate-of-ally-monsters-with-fire-attribute-by-38percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Critical Rate of ally monsters with Fire attribute by 38%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c48c30280ff77cb829ee9"
        },
        "name": "Increases the Critical Rate of ally monsters with Water attribute by 38%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-critical-rate-of-ally-monsters-with-water-attribute-by-38percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Critical Rate of ally monsters with Water attribute by 38%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c48cc0280ff77cb829eec"
        },
        "name": "Increases the Critical Rate of ally monsters with Wind attribute by 38%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-critical-rate-of-ally-monsters-with-wind-attribute-by-38percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Critical Rate of ally monsters with Wind attribute by 38%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c48d70280ff77cb829eef"
        },
        "name": "Increases the Critical Rate of ally monsters with Light attribute by 38%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-critical-rate-of-ally-monsters-with-light-attribute-by-38percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Critical Rate of ally monsters with Light attribute by 38%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c48df0280ff77cb829ef2"
        },
        "name": "Increases the Critical Rate of ally monsters with Dark attribute by 38%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-the-critical-rate-of-ally-monsters-with-dark-attribute-by-38percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Critical Rate of ally monsters with Dark attribute by 38%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c48f40280ff77cb829ef5"
        },
        "name": "Help Me, Teddy",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Help-Me,-Teddy",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Summons a teddy bear to attack the enemy. This attack has a 25% chance to forcibly put the enemy to sleep for 1 turn. Acquires another turn if the enemy falls asleep. Multiplier: 380%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c49050280ff77cb829ef8"
        },
        "name": "Girl's Prayer",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Girl's-Prayer",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Removes the harmful effects on all allies and recovers their HP. Recovery amount is proportionate to your MAX HP and Attack Power. (Reusable in 4 turns). Multiplier: 2.9*{ATK} + 0.11*{MAX HP}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c49180280ff77cb829efb"
        },
        "name": "Toy Knight",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Toy-Knight",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Summons a doll knight and attacks all enemies. Stuns them for 1 turn and decreases their Attack Speed for 2 turns with 50% chance each. (Reusable in 3 turns) Multiplier: 340%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c49270280ff77cb829efe"
        },
        "name": "Light Guardian Angel",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Light-Guardian-Angel",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies three times to inflict damage that increases accordingly to your MAX HP. Each attack has a 50% chance to remove 1 beneficial effect. Afterwards, increases the Defense of all allies for 3 turns additionally. (Reusable in 3 turns) Multiplier: (75%+5%) x3",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c49450280ff77cb829f01"
        },
        "name": "Dark Guardian Angel",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Dark-Guardian-Angel",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Attack Power of all allies for 3 turns to attack all enemies 5 times and disturbs the HP recovery for 3 turns with a 30% chance each. (Reusable in 5 turns) Multiplier: 100% x5",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c49620280ff77cb829f04"
        },
        "name": "Wind Guardian Angel",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Wind-Guardian-Angel",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attack all enemies 3 times. Each attack decreases their Attack Bar by 30%, and has a 40% chance to increase the enemy's chances of landing a Glancing Hit for 2 turns. Afterwards, increases the Attack Bar of all allies by 30% additionally. (Reusable in 5 turns) Multiplier: 170% x3",
        "images": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/skills/attack-bar-down.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c496f0280ff77cb829f07"
        },
        "name": "Water Guardian Angel",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Water-Guardian-Angel",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies 3 times. Each attack has a 40% chance to decrease the target's Defense for 3 turns and attack speed for 2 turns. This attack will deal more damage according to your MAX HP. (Reusable in 5 turns) Multiplier: (75%+5%) x3",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c497c0280ff77cb829f0a"
        },
        "name": "Fire Guardian Angel",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Fire-Guardian-Angel",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies 3 times. Each attack will decrease their Attack Speed and inflict Continuous Damage for 3 turns. (Reusable in 5 turns) Multiplier: 170% x3",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c81a149ba4c6799a615f2"
        },
        "name": "Monkey Wand",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Monkey-Wand",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy with the Monkey Wand and stuns the enemy for 1 turn with a 35% chance. Multiplier: 400%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c81c649ba4c6799a615f5"
        },
        "name": "All or Nothing",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "All-or-Nothing",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies and stuns them for 1 turn with a 75% chance. Increases your Attack Bar by 25% per stunned enemy after the attack. (Reusable in 4 turns) Multiplier: 330%",
        "images": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c820549ba4c6799a615f8"
        },
        "name": "Lighting Monkey Wand",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Lighting-Monkey-Wand",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks and decreases the Defense for 2 turns with a 75% chance and recovers your attack gauge by 50%. (Reusable in 3 turns) Multiplier: 720%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c821549ba4c6799a615fb"
        },
        "name": "Dark Monkey Wand",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Dark-Monkey-Wand",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy to decrease the Defense for 2 turns and to steal 1 beneficial effect with a 75% chance each. (Reusable in 3 turns). Multiplier: 720%~1120%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c826a49ba4c6799a615fe"
        },
        "name": "Fire Monkey Wand",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Fire-Monkey-Wand",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy and decreases the Defense for 2 turns with a 75% chance and recovers your HP by 20%. (Reusable in 3 turns). Multiplier: 720%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c828749ba4c6799a61602"
        },
        "name": "Gold Headband",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Gold-Headband",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Gains immunity against inability effects and increases your Attack Power by 20% and Attack Speed by 5% whenever you're attacked. Accumulated up to 10 times. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c829749ba4c6799a61605"
        },
        "name": "Alter Ego Attack",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Alter-Ego-Attack",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Summons an alter ego that attacks the enemy 6 times, granting you invincibility for 2 turns and immunity for 2 turns. Removes 1 beneficial effect granted on the enemy each when an attack lands as a Critical Hit. (Reusable in 4 turns). Multiplier: 220% x4",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c82a749ba4c6799a61608"
        },
        "name": "Stone Monkey",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Stone-Monkey",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Decreases the inflicted damage by 35% and counterattacks with a 35% chance when an ally is attacked. [Automatic Effect] Multiplier: 75%*",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c82b449ba4c6799a6160b"
        },
        "name": "Giant Net",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Giant-Net",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with a giant net and puts them to sleep for 1 turn and decreases the Attack Speed for 2 turns with an 80% chance each. The damage of this skill will increase according to your MAX HP. In addition, decreases the target's Attack Bar by 35% per harmful effect granted on the enemy. (Reusable in 5 turns) Multiplier: 270%+18%",
        "images": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c82c449ba4c6799a6160e"
        },
        "name": "Summon Clouds",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Summon-Clouds",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with a giant storm cloud to decrease their Defense for 2 turns and stuns them for 1 turn with a 65% chance. The damage of this skill will increase according to your MAX HP. (Reusable in 5 turns). Multiplier: 270%+18%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c82d449ba4c6799a61611"
        },
        "name": "Increase the Critical Rate of ally monsters in Guild Content by 33%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-critical-rate-of-ally-monsters-in-guild-content-by-33percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Critical Rate of ally monsters in Guild Content by 33%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Critical_Rate_Low_Guild_Battles_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Critical_Rate_Low_Guild_Battles_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Critical_Rate_Low_Guild_Battles_Icon.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "species": "Battle Angel",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Critical_Rate_Low_Guild_Battles_Icon.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628c82df49ba4c6799a61614"
        },
        "name": "Increase the Accuracy of ally monsters in Guild Content by 55%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-accuracy-of-ally-monsters-in-guild-content-by-55percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Accuracy of ally monsters in Guild Content by 55%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Accuracy_Mid_Guild_Battles_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Accuracy_Mid_Guild_Battles_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Accuracy_Mid_Guild_Battles_Icon.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "species": "Battle Angel",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Accuracy_Mid_Guild_Battles_Icon.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628c82e649ba4c6799a61617"
        },
        "name": "Increase the Attack Power of ally monsters in Guild Content by 44%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-attack-power-of-ally-monsters-in-guild-content-by-44percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Attack Power of ally monsters in Guild Content by 44%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Guild_Battles_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Guild_Battles_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Guild_Battles_Icon.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "species": "Battle Angel",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Mid_Guild_Battles_Icon.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628c82ed49ba4c6799a6161a"
        },
        "name": "Increase the Resistance of ally monsters in Guild Content by 55%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-resistance-of-ally-monsters-in-guild-content-by-55percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Resistance of ally monsters in Guild Content by 55%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Resistance_Mid_Guild_Battles_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Resistance_Mid_Guild_Battles_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Resistance_Mid_Guild_Battles_Icon.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "species": "Battle Angel",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Resistance_Mid_Guild_Battles_Icon.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628c82f449ba4c6799a6161d"
        },
        "name": "Increase the Defense of ally monsters in Guild Content by 44%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-defense-of-ally-monsters-in-guild-content-by-44percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Defense of ally monsters in Guild Content by 44%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c830849ba4c6799a61620"
        },
        "name": "Magical Eye",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Magical-Eye",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy 2 times and decreases the Attack Power for 2 turns with a 35% chance with each attack. Multiplier: 1.9*{ATK} x2",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c832649ba4c6799a61623"
        },
        "name": "Night Crow",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Night-Crow",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy 3 times and leaves a Branding effect for 2 turns with a 75% chance each. The cooldown time of [Chaos Magic Circle] will be decreased by 1 turn each whenever you attack the target under harmful effects. (Reusable in 4 turns). Multiplier: 2.3*{ATK} x3",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c833a49ba4c6799a61626"
        },
        "name": "Mana Storm",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Mana-Storm",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with the magic energy to decrease their Defense for 2 turns with a 75% chance. (Reusable in 4 turns). Multiplier: 4.3*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c834c49ba4c6799a61629"
        },
        "name": "Start of Pain",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Start-of-Pain",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "When you get your turn, grants one of the following harmful effects that the enemies do not have for 2 turns each on all enemies: Decrease Attack Speed, Unrecoverable, Increase Chance of Landing a Glancing Hit, Beneficial Effects Blocked. In addition, absorbs the target's HP by 5% of your MAX HP, up to 10%, for each harmful effect granted on the target when you attack the enemy on your turn. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c836049ba4c6799a6162c"
        },
        "name": "Time of Destruction",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Time-of-Destruction",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Creates a giant energy by destroying the HP of all Monsters on the battlefield, excluding yourself, by 15% each. Afterwards, attacks all enemies to inflict great damage in proportion to the destroyed HP. (Reusable in 6 turns). Multiplier: 3.0*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c836f49ba4c6799a6162f"
        },
        "name": "Secret Book",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Secret-Book",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the damage by 5% each, up to 200%, whenever an ally attacks an enemy. The damage cannot be increased above 50% at once. In addition, decreases the damage taken from the enemy by 20%. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c837b49ba4c6799a61632"
        },
        "name": "Soul Harvest",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Soul-Harvest",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Creates a soul stone when the battle begins. In addition, harvests a soul and creates a soul stone when an enemy dies on an ally's turn. Up to 3 soul stones can be stored up, and consumes 1 saved soul stone to revive the ally with 40% HP when an ally dies. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c838d49ba4c6799a61635"
        },
        "name": "Chaos Magic Circle",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Chaos-Magic-Circle",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Summons 5 magic spheres, which each can inflict damage equal to 150% of your Attack Power. If you get attacked from an enemy while you still have magic spheres, uses 1 magic sphere to counterattack and increases your Attack Bar by 50%. When you attack on your turn, all remaining spheres will attack the enemy target together. (Reusable in 7 turns). Multiplier: 1.5*{ATK} (Fixed) x5",
        "images": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c83ed49ba4c6799a6163d"
        },
        "name": "Psycho Inferno",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Psycho-Inferno",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Raises the Psycho Power to attack the enemy and provokes the enemy for 1 turn with a 50% chance. This attack will deal more damage according to your MAX HP. Multiplier: 1.7*{ATK} + 0.19*{MAX HP}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c840349ba4c6799a61640"
        },
        "name": "Double Knee Press",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Double-Knee-Press",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy 3 times, absorbing the Attack Bar by 20% each, and recovers your HP by 30% of the damage dealt. The damage of this attack is proportionate to your MAX HP. (Reusable in 4 turns). Multiplier: 0.9*{ATK} + 0.09*{MAX HP} x3",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c841649ba4c6799a61643"
        },
        "name": "Psycho Crusher",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Psycho-Crusher",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Wraps the Psycho Power around your body and dashes towards the enemy target to provoke and to decrease Defense for 1 turn. This attack will deal more damage according to your MAX HP. (Reusable in 3 turns). Multiplier: 3.0*{ATK} + 0.2*{MAX HP}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c842749ba4c6799a61646"
        },
        "name": "Black Moons",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Black-Moons",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Your Attack Bar will be filled up and HP will be recovered by 20% if you get attacked during the turn of the provoked enemy. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c843449ba4c6799a61649"
        },
        "name": "Psycho Power",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Psycho-Power",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Absorbs the HP of all allies by 30% each and HP of all enemies by 15% each. Afterwards, increases the Attack Bar of all allies by 40% each, increases the Attack Power for 2 turns and Attack Speed for 2 turns. (Reusable in 6 turns)",
        "images": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c844049ba4c6799a6164c"
        },
        "name": "Head Press",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Head-Press",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy with a downward attack to remove all beneficial effects and sets the enemy's skills on max cooldown time. Afterwards, attacks all enemies with a powerful downward attack to decrease their Attack Bar to 0 and provokes them for 1 turn. (Reusable in 5 turns). Multiplier: 4.0*{ATK} x2",
        "images": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c845149ba4c6799a6164f"
        },
        "name": "Demonic Being",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Demonic-Being",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Destroys the enemy's MAX HP by 50% of the enemy's current lost HP after attacking the enemy. Also, if all allies are attacked by the target with destroyed HP, the incoming damage will be decreased in proportion to the destroyed HP. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c846149ba4c6799a61652"
        },
        "name": "Ultimate Psycho Crusher",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Ultimate-Psycho-Crusher",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Wraps the Ultimate Psycho Power around your body and dashes towards all enemies to attack 3 times with damage proportional to your MAX HP. Also, each attack decreases the Attack Bar by 15%, decreases the Attack Speed for 2 turns, and Stuns them for 1 turn with a 50% chance respectively. (Reusable in 5 turns). Multiplier: 0.1*{MAX HP} x3",
        "images": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8a0a49ba4c6799a6165b"
        },
        "name": "Shinryuken",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Shinryuken",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy target 3 times to remove 1 beneficial effect with a 30% chance and to leave a Branding effect for 2 turns with a 100% chance per hit. The damage increases by 15% per harmful effect granted on the enemy, and instantly gains another turn if all attacks land as a Critical Hit. (Reusable in 5 turns). Multiplier: 285% x3",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8a3649ba4c6799a6165f"
        },
        "name": "Mega Smash",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "mega-smash",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks with magical powers and inflicts continuous damage for 2 turns with a 50% chance. The damage increases according to Attack Speed. Multiplier: (Spd+210) / 0.7)%",
        "images": [
            "/assets/images/skills/skill1/Mega_Smash_Fire.png",
            "/assets/images/skills/Continuous-Damage.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Mega_Smash_Fire.png",
            "/assets/images/skills/Continuous-Damage.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Mega_Smash_Fire.png",
        "image2": "/assets/images/skills/Continuous-Damage.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T06:29:06.391Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Ifrit",
        "thumbImage1": "/assets/images/skills/skill1/Mega_Smash_Fire.png",
        "thumbImage2": "/assets/images/skills/Continuous-Damage.png"
    },
    {
        "_id": {
            "$oid": "628c8aa049ba4c6799a61667"
        },
        "name": "Super Crush",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "super-crush",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies to inflict damage that's proportionate to the enemy's MAX HP and stuns them with a 30% chance. The target immune to stun will have the Attack Bar decreased by 50% each with a 100% chance. (Reusable in 4 turns). Multiplier: 2.0*{ATK} + 0.15*{Target MAX HP}",
        "images": [
            "/assets/images/skills/skill2/Super_Crush_Wind.png",
            "/assets/images/skills/Stun.png",
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Super_Crush_Wind.png",
            "/assets/images/skills/Stun.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Super_Crush_Wind.png",
        "image2": "/assets/images/skills/Stun.png",
        "image3": "/assets/images/skills/attack-bar-down.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T06:45:03.593Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Ifrit",
        "thumbImage1": "/assets/images/skills/skill2/Super_Crush_Wind.png",
        "thumbImage2": "/assets/images/skills/Stun.png"
    },
    {
        "_id": {
            "$oid": "628c8b0f49ba4c6799a6166c"
        },
        "name": "Ifrit Triple Crush",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "ifrit-triple-crush",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy 3 times with magic and weakens the Defense for 2 turns with a 50% chance for each attack. The damage increases according to the Attack Speed. (Reusable in 3 turns). Multiplier: {ATK}*({SPD} + 150)/140 x3",
        "images": [
            "/assets/images/skills/skill2/Triple_Crush_Fire.png",
            "/assets/images/skills/Reduce-DEF.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Triple_Crush_Fire.png",
            "/assets/images/skills/Reduce-DEF.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Triple_Crush_Fire.png",
        "image2": "/assets/images/skills/Reduce-DEF.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T06:43:22.058Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Ifrit",
        "thumbImage1": "/assets/images/skills/skill2/Triple_Crush_Fire.png",
        "thumbImage2": "/assets/images/skills/Reduce-DEF.png"
    },
    {
        "_id": {
            "$oid": "628c8b5749ba4c6799a61671"
        },
        "name": "Conversion of Magic",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "conversion-of-magic",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Removes a harmful effect, except inability effects, on all allies each turn and recovers 3% HP for each harmful effect removed. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Conversion_of_Magic_Passive_Dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Conversion_of_Magic_Passive_Dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Conversion_of_Magic_Passive_Dark.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T06:47:59.984Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Ifrit",
        "thumbImage1": "/assets/images/skills/skill3/Conversion_of_Magic_Passive_Dark.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628c8b6649ba4c6799a61674"
        },
        "name": "Master of Magic Power",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "master-of-magic-power",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Steals one beneficial effect from the target and applies to all allies after the attack. Also increases your Attack Power by 30% for each beneficial effect you are granted with, and increases your Attack Speed by 5 for each beneficial effect granted on the allies, up to 100. [Automatic Effect] ",
        "images": [
            "/assets/images/skills/skill3/Master_of_Magic_Power_Passive.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Master_of_Magic_Power_Passive.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Master_of_Magic_Power_Passive.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T06:48:37.58Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Ifrit",
        "thumbImage1": "/assets/images/skills/skill3/Master_of_Magic_Power_Passive.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628c8b7549ba4c6799a61677"
        },
        "name": "Mach Crush",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "mach-crush",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with powerful magical energy. The damage increases by 30% for each harmful effect on the enemies. The damage increases by 50% if there's only one harmful effect on the enemies. (Reusable in 4 turns) Multiplier: 220% x2",
        "images": [
            "/assets/images/skills/skill3/Mach_Crush_Wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Mach_Crush_Wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Mach_Crush_Wind.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T06:46:10.986Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Ifrit",
        "thumbImage1": "/assets/images/skills/skill3/Mach_Crush_Wind.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628c8b8549ba4c6799a6167a"
        },
        "name": "Elemental King",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "elemental-king",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Always gains attribute advantage when attacking an enemy. When you receive fatal attacks, you will be immune to death for 1 turn. [Automatic effect] (Reusable in 4 turns)",
        "images": [
            "/assets/images/skills/skill3/Elemental_King_Passive_Water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Elemental_King_Passive_Water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Elemental_King_Passive_Water.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T06:49:35.051Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Ifrit",
        "thumbImage1": "/assets/images/skills/skill3/Elemental_King_Passive_Water.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628c8b9249ba4c6799a6167d"
        },
        "name": "Ancient Power",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "ancient-power",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Decreases the damages dealt from enemies with no harmful effects by 30% and increases the damage inflicted on enemies with harmful effects by 30% and makes the enemy oblivious for 2 turns with each attack. Passive skills aren't activated in oblivion state. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Ancient_Power_Passive_Fire.png",
            "/assets/images/skills/Status_Oblivious.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Ancient_Power_Passive_Fire.png",
            "/assets/images/skills/Status_Oblivious.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Ancient_Power_Passive_Fire.png",
        "image2": "/assets/images/skills/Status_Oblivious.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-08T06:50:35.41Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Ifrit",
        "thumbImage1": "/assets/images/skills/skill3/Ancient_Power_Passive_Fire.png",
        "thumbImage2": "/assets/images/skills/Status_Oblivious.png"
    },
    {
        "_id": {
            "$oid": "628c8bc349ba4c6799a61681"
        },
        "name": "Magic Ray",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Magic-Ray",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy with the power of condensed magic. Multiplier: 380%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8cb949ba4c6799a61684"
        },
        "name": "Mana Shock",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Mana-Shock",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Uses Mana to attack the enemy and inflict damage",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8d1849ba4c6799a61688"
        },
        "name": "Operation Support",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Operation-Support",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Recovers an ally's HP by 20%. (Reusable in 4 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8d2c49ba4c6799a6168b"
        },
        "name": "Magic Bullet",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Magic-Bullet",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Throws a magic ball to attack the enemy target and weakens the Defense for 2 turns with a 50% chance. (Reusable in 4 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8d3949ba4c6799a6168e"
        },
        "name": "Magic Power Burst",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Magic-Power-Burst",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy target to inflict damage. The damage increases by 20% for each harmful effect on the enemy. (Reusable in 5 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8d5149ba4c6799a61691"
        },
        "name": "Magic Power Explosion",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Magic-Power-Explosion",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Revives with 50% HP when you’re inflicted with fatal damage and falls under the Magic Power Explosion state for 2 turns. The Magic Power Explosion state will increase the damage inflicted to the enemies by 30%, but you’ll be uncontrollable and die when the effect ends. (Reusable in 10 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8d5c49ba4c6799a61694"
        },
        "name": "Protection Field",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Protection-Field",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Creates a shield that absorbs damage proportionate to your level on all allies and increases their Defense for 2 turns. (Reusable in 6 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8d7049ba4c6799a61697"
        },
        "name": "Magic Power Explosion II",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Magic-Power-Explosion-II",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Revives with 50% HP when you're inflicted with fatal damage, and resets the skill cooldown time of all skills and fall under the Magic Power Explosion state for 2 turns. You'll be uncontrollable under the Magic Power Explosion state and be defeated when the effect ends. [Automatic Effect] (Reusable in 10 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8ddb49ba4c6799a6169f"
        },
        "name": "Wound",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Wound",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attack the enemy with a sharp blade and inflicts continuous damage for 2 turns with a 50% chance. Multiplier: 400%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8ded49ba4c6799a616a2"
        },
        "name": "Shatter",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Shatter",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies 2 times with a sharp wind and weakens the Defense for 2 turns with a 50% chance for each attack. Your Attack Bar will increase by 10% each when the attack lands as a Critical Hit.(Reusable in 4 turns) Multiplier: 150% x2",
        "images": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8df849ba4c6799a616a5"
        },
        "name": "Gouge",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Gouge",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Performs a ruthless charge, attacking all enemies 3 times. Each attack has a 35% chance to inflict Continuous Damage for 1 turn and the skill will deal 50% increased damage to enemies under Continuous Damage effects. (Reusable in 3 turns) Multiplier: 130% x3",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8e2249ba4c6799a616a8"
        },
        "name": "Summon Perpetrator",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Summon-Perpetrator",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Revives all dead allies with 30% HP and all skills are available to use. In addition, makes the revived allies invincible for 1 turn. The cooldown time of this skill is increased by 1 turn per revived ally. (Reusable in 6 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8e3149ba4c6799a616ab"
        },
        "name": "Crumble",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Crumble",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies 3 times to weaken the Defense and inflict continuous damage for 2 turns. Increases your Attack Bar by 10% per Continuous Damage granted on the enemies after the attack. (Reusable in 5 turns) Multiplier: 140% x3",
        "images": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8e3d49ba4c6799a616ae"
        },
        "name": "Capture",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Capture",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy 5 times to remove the beneficial effect with a 100% chance with each attack and stuns the enemy for 1 turn with a 30% chance. The chances of the enemy being stunned increases as the enemy's HP decreases after the attack. The stun is guaranteed if the enemy has 30% or less HP. (Reusable in 5 turns) Multiplier: 190% x5",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8e4e49ba4c6799a616b1"
        },
        "name": "Eternal Scar",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Eternal-Scar",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies 2 times, the first attack decreasing the Defense for 2 turns and the second attack blocking enemies from removing harmful effects for 1 turn. Additionally, destroys the enemy's MAX HP by the amount of damage inflicted by the second attack. (Reusable in 5 turns). Multiplier: 240% x2",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8e5a49ba4c6799a616b4"
        },
        "name": "Soul Crusher",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Soul-Crusher",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy 2 times that won't land as Glancing Hits to inflict damage which ignores all effects that resist death and gains Endure effect for 1 turn. The enemy defeated by this attack cannot be revived during the battle. (Reusable in 4 turns). Multiplier: 420% x2",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8eac49ba4c6799a616bb"
        },
        "name": "Touch of Punishment",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Touch-of-Punishment",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks an enemy and stuns the target for 1 turn with a 35% chance. Multiplier: 380%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8ec249ba4c6799a616be"
        },
        "name": "Moonlight Flood",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Moonlight-Flood",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": " Attacks all enemies and inflicts Continuous Damage for 2 turns. In addition, when used in Beast Form, attacks 2 times and transforms into Druid Form after the attack. (Reusable in 4 turns) Multiplier: 300%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8ecf49ba4c6799a616c1"
        },
        "name": "Wild Blow",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Wild-Blow",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks an enemy to inflict damage that increases according to your Max HP and recovers 30% of the inflicted damage as HP. In addition, when used in Beast Form, the damage you inflict will be increased by 20% and then transforms into Druid Form. Multiplier: 600%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8ede49ba4c6799a616c4"
        },
        "name": "Moonlight Grace",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Moonlight-Grace",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Removes harmful effects granted on all allies. In addition, when used in Druid Form, grants immunity on all allies for 2 turns and then transforms into Beast Form to Provoke all enemies for 1 turn with a 50% chance. (Reusable in 6 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8eea49ba4c6799a616c7"
        },
        "name": "Druid's Wisdom",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Druid's-Wisdom",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Removes all of your harmful effects if you're under inability effect at the start of each turn. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8ef949ba4c6799a616ca"
        },
        "name": "Druid's Agility",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Druid's-Agility",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Counterattacks the target that attacked you with a 50% chance when you get attacked from the enemy. In addition, increases your Attack Bar by 20% after attacking. [Automatic Effect]",
        "images": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8f0749ba4c6799a616cd"
        },
        "name": "Rage of Mother Nature",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Rage-of-Mother-Nature",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies and removes all beneficial effects granted on them. In addition, when used in Druid Form, increases their chances of landing a glancing hit for 2 turns and then transforms into Beast Form to Provoke all enemies for 1 turn with a 50% chance. (Reusable in 6 turns) Multiplier: 450%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8f1649ba4c6799a616d0"
        },
        "name": "Druid's Secret Plan",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Druid's-Secret-Plan",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Revives into Beast Form with 30% HP at the moment of death and decreases the cooldown time of the [Fores of Living] by 2 turns. [Automatic Effect] (Reusable in 9 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8f2449ba4c6799a616d3"
        },
        "name": "Forest of Living",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Forest-of-Living",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Revives a dead ally target with 30% HP. If the ally is alive, casts Soul Protection for 3 turns. In addition, when used in Druid Form, increases the Defense of all allies for 3 turns and then transforms into Beast Form to Provoke all enemies for 1 turn with a 50% chance. (Reusable in 8 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8f3149ba4c6799a616d6"
        },
        "name": "Wild Cure",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Wild-Cure",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Recovers the HP of all allies by 30%. In addition, when used in Druid Form, increases the Attack Bar of all allies by 15% and then transforms into Beast Form to Provoke all enemies for 1 turn with a 30% chance. (Reusable in 5 turns)",
        "images": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8f3c49ba4c6799a616d9"
        },
        "name": "Druid's Wit",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Druid's-Wit",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Removes all harmful effects granted on yourself and increases your Attack Bar by 100% if an ally's HP falls to 40% or below from an attack. [Automatic Effect]",
        "images": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8f4849ba4c6799a616dc"
        },
        "name": "Wild Roar",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Wild-Roar",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies and weakens their Attack Power for 2 turns. In addition, when used in Druid Form, weakens the Defense of all enemies for 2 turns and then transforms into Beast Form to Provoke all enemies for 1 turn with a 50% chance. (Reusable in 6 turns) Multiplier: 450%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8f5549ba4c6799a616df"
        },
        "name": "Druid's Proficiency",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Druid's-Proficiency",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Absorbs the enemy's Attack Bar by 15% when you attack on your turn",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8f8749ba4c6799a616e4"
        },
        "name": "Dragon's Might",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Dragon's-Might",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Inflicts continuous damage for 2 turns if you land a Critical Hit. Multiplier: 430%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8f9949ba4c6799a616e7"
        },
        "name": "Justice",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Justice",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Channels burning rage to inflict damage that ignores all damage reduction effects to an enemy. The damage increases according to the number of dead allies. (Reusable in 4 turns) Multiplier: 800%~1240%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8fa449ba4c6799a616ea"
        },
        "name": "Torrent",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Torrent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "The damage of this attack increases as your HP drops. If your HP is below 30%, the enemy's Defense is ignored. (Reusable in 4 turns) Multiplier: 550%~730%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8fb149ba4c6799a616ed"
        },
        "name": "Tooth For a Tooth",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Tooth-For-a-Tooth",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Attack Bar of all allies by 15% if an ally receives a Critical Hit. [Automatic Effect]",
        "images": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8fbc49ba4c6799a616f0"
        },
        "name": "King's Rage",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "King's-Rage",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Gains immunity against inability effects and increases the Attack Power by 50% each time your allies are attacked, up to 5 times. In addition, counterattacks with a 30% chance when you get attacked. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8fc749ba4c6799a616f3"
        },
        "name": "Eye of the Storm",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Eye-of-the-Storm",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "The attack speed of all enemies and allies is limited to your attack speed. This effect does not affect enemies with the same skill or Boss Monsters. Decreases the enemy's Attack Bar by 15% with an attack. [Automatic Effect]",
        "images": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8fd649ba4c6799a616f6"
        },
        "name": "Flow",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Flow",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Gains immunity against HP recovery disturbance effects, and removes 1 harmful effect and recovers 15% HP at the start of your turn. Also, the damage you deal will be increased according to your current HP. [Automatic Effect] Multiplier: 13%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c8fe249ba4c6799a616f9"
        },
        "name": "Noble Blood",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Noble-Blood",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Your attacks won't land as Glancing Hits and the inflicted damage of one attack won't exceed 30% of the MAX HP. Additionally, counterattacks the attacker with a 50% chance when you're attacked. [Automatic Effect] Multiplier: 400%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c90f849ba4c6799a61706"
        },
        "name": "Curse of the Beautiful",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "curse-of-the-beautiful",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies 3 times to decrease the Defense, increase their chances of landing a glancing hit and disturb their HP recovery for 2 turns with a 50% chance. (Reusable in 5 turns) Multiplier: 100% x3",
        "images": [
            "/assets/images/skills/skill2/Curse_of_the_Beautiful_Fire.png",
            "/assets/images/skills/Reduce-DEF.png",
            "/assets/images/skills/Reduce-ACC.png",
            "/assets/images/skills/Unrecoverable.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Curse_of_the_Beautiful_Fire.png",
            "/assets/images/skills/Reduce-DEF.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Curse_of_the_Beautiful_Fire.png",
        "image2": "/assets/images/skills/Reduce-DEF.png",
        "image3": "/assets/images/skills/Reduce-ACC.png",
        "image4": "/assets/images/skills/Unrecoverable.png",
        "modified": {
            "$date": "2022-08-07T06:39:39.838Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Desert Queen",
        "thumbImage1": "/assets/images/skills/skill2/Curse_of_the_Beautiful_Fire.png",
        "thumbImage2": "/assets/images/skills/Reduce-DEF.png"
    },
    {
        "_id": {
            "$oid": "628c910949ba4c6799a61709"
        },
        "name": "Sweet Dreams",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "sweet-dreams",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks an enemy. This attack has a 75% chance to remove all beneficial effect and put the target to sleep for 1 turn. (Reusable in 4 turns) Multiplier: 520%",
        "images": [
            "/assets/images/skills/skill2/Sweet_Dreams_Wind.png",
            "/assets/images/skills/Sleep.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Sweet_Dreams_Wind.png",
            "/assets/images/skills/Sleep.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Sweet_Dreams_Wind.png",
        "image2": "/assets/images/skills/Sleep.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:40:39.737Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Desert Queen",
        "thumbImage1": "/assets/images/skills/skill2/Sweet_Dreams_Wind.png",
        "thumbImage2": "/assets/images/skills/Sleep.png"
    },
    {
        "_id": {
            "$oid": "628c911c49ba4c6799a6170c"
        },
        "name": "Charming Voice",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "charming-voice",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks an enemy, stealing all beneficial effects and sets all of the enemy's skills on max cooldown time. Decreases the cooldown time of the [Charming Voice] skill by the number of beneficial effects stolen from the enemy. If the skill didn't reset the enemy's skills on max cooldown time, the cooldown time of [Charming Voice] will reset. (Reusable in 5 turns) Multiplier: 720",
        "images": [
            "/assets/images/skills/skill3/Charming_Voice_Fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Charming_Voice_Fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Charming_Voice_Fire.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:41:20.992Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Desert Queen",
        "thumbImage1": "/assets/images/skills/skill3/Charming_Voice_Fire.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628c914549ba4c6799a6170f"
        },
        "name": "Oasis's Blessing",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "oasis's-blessing",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the Attack Bar of all allies by 25% each. This skill will also create a shield that absorbs damage and increases your Attack Power for 3 turns. The Shield amount is proportionate to your level. (Reusable in 5 turns) Multiplier: 120x Lv",
        "images": [
            "/assets/images/skills/skill3/Private_Invitation_Water.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/skills/Shield.png",
            "/assets/images/skills/Increase-ATK.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Private_Invitation_Water.png",
            "/assets/images/skills/attack-bar-up.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Private_Invitation_Water.png",
        "image2": "/assets/images/skills/attack-bar-up.png",
        "image3": "/assets/images/skills/Shield.png",
        "image4": "/assets/images/skills/Increase-ATK.png",
        "modified": {
            "$date": "2022-08-07T06:42:35.312Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Desert Queen",
        "thumbImage1": "/assets/images/skills/skill3/Private_Invitation_Water.png",
        "thumbImage2": "/assets/images/skills/attack-bar-up.png"
    },
    {
        "_id": {
            "$oid": "628c915049ba4c6799a61712"
        },
        "name": "Delayed Promise",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "delayed-promise",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Resets the Attack Bar of the enemy target and decreases the Attack Bar of the other enemies by 30% each. Also puts all enemies to sleep for 2 turns. (Reusable in 7 turns)",
        "images": [
            "/assets/images/skills/skill3/Delayed_Promise_Wind.png",
            "/assets/images/skills/Sleep.png",
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Delayed_Promise_Wind.png",
            "/assets/images/skills/Sleep.png"
        ],
        "element": "Skill",
        "type": "Attack",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Delayed_Promise_Wind.png",
        "image2": "/assets/images/skills/Sleep.png",
        "image3": "/assets/images/skills/attack-bar-down.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:43:39.113Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Desert Queen",
        "thumbImage1": "/assets/images/skills/skill3/Delayed_Promise_Wind.png",
        "thumbImage2": "/assets/images/skills/Sleep.png"
    },
    {
        "_id": {
            "$oid": "628c915b49ba4c6799a61715"
        },
        "name": "Gaze of Oblivion",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "gaze-of-oblivion",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Puts all enemies into Oblivion and prevents them from using skills with cool times for 2 turns. Passive skills aren't activated in Oblivion state. (Reusable in 7 turns)",
        "images": [
            "/assets/images/skills/skill3/Gaze_of_Oblivion_Light.png",
            "/assets/images/skills/Status_Oblivious.png",
            "/assets/images/skills/Status_Silence.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Gaze_of_Oblivion_Light.png",
            "/assets/images/skills/Status_Oblivious.png"
        ],
        "element": "Skill",
        "type": "Attack",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Gaze_of_Oblivion_Light.png",
        "image2": "/assets/images/skills/Status_Oblivious.png",
        "image3": "/assets/images/skills/Status_Silence.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:44:33.054Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Desert Queen",
        "thumbImage1": "/assets/images/skills/skill3/Gaze_of_Oblivion_Light.png",
        "thumbImage2": "/assets/images/skills/Status_Oblivious.png"
    },
    {
        "_id": {
            "$oid": "628c916f49ba4c6799a61718"
        },
        "name": "Deadly Charm",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "deadly-charm",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases your skill activation chance by 20% and the enemies can't resist the skill effects you apply on them. Silences the enemy for 1 turn if you attack the enemy with harmful effects. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Deadly_Charm_Passive_Dark.png",
            "/assets/images/skills/Status_Silence.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Deadly_Charm_Passive_Dark.png",
            "/assets/images/skills/Status_Silence.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Deadly_Charm_Passive_Dark.png",
        "image2": "/assets/images/skills/Status_Silence.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:45:17.681Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Desert Queen",
        "thumbImage1": "/assets/images/skills/skill3/Deadly_Charm_Passive_Dark.png",
        "thumbImage2": "/assets/images/skills/Status_Silence.png"
    },
    {
        "_id": {
            "$oid": "628c91b649ba4c6799a6171f"
        },
        "name": "Devil's Bargain",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "devil's-bargain",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Absorbs all other allies' HP by 10% to attack all enemies dealing damage that's proportionate to the absorbed HP. Recovers the Attack Bar of all allies by 20% afterwards. (Reusable in 5 turns). Multiplier: 340%",
        "images": [
            "/assets/images/skills/skill2/devils-bargain_fire.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/devils-bargain_fire.png",
            "/assets/images/skills/attack-bar-up.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/devils-bargain_fire.png",
        "image2": "/assets/images/skills/attack-bar-up.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:24:08.293Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Demon",
        "thumbImage1": "/assets/images/skills/skill2/devils-bargain_fire.png",
        "thumbImage2": "/assets/images/skills/attack-bar-up.png"
    },
    {
        "_id": {
            "$oid": "628c91c949ba4c6799a61722"
        },
        "name": "Madness Judgement",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "madness-judgement",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Consumes half of your current HP to attack the enemy target. This attack will ignore a portion of the enemy's Defense as your HP status worsens. (Reusable in 5 turns). Multiplier: 540%",
        "images": [
            "/assets/images/skills/skill2/madness-judgement_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/madness-judgement_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/madness-judgement_dark.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:22:04.847Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Demon",
        "thumbImage1": "/assets/images/skills/skill2/madness-judgement_dark.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628c91db49ba4c6799a61725"
        },
        "name": "Flames of Hell",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "flames-of-hell",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Always perform an attack that has an attribute advantage on all enemies. Blocks all enemies (boss excluded) from removing harmful effects for 1 turn. Inflicts Continuous Damage that can't be resisted by the number proportional to the damage dealt for 2 turns. (Reusable in 5 turns). Multiplier: 460%",
        "images": [
            "/assets/images/skills/skill3/Flames_of_Hell.png",
            "/assets/images/skills/Continuous-Damage.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Flames_of_Hell.png",
            "/assets/images/skills/Continuous-Damage.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Flames_of_Hell.png",
        "image2": "/assets/images/skills/Continuous-Damage.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:28:26.517Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Demon",
        "thumbImage1": "/assets/images/skills/skill3/Flames_of_Hell.png",
        "thumbImage2": "/assets/images/skills/Continuous-Damage.png"
    },
    {
        "_id": {
            "$oid": "628c91e849ba4c6799a61728"
        },
        "name": "Repeated Nightmare",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "repeated-nightmare",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Revives with little HP and fills up your Attack Bar by 100% if allies and enemies act for 12 turns when you are dead. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Repeated_Nightmare.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/skills/Shield.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Repeated_Nightmare.png",
            "/assets/images/skills/attack-bar-up.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Repeated_Nightmare.png",
        "image2": "/assets/images/skills/attack-bar-up.png",
        "image3": "/assets/images/skills/Shield.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:29:38.182Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Demon",
        "thumbImage1": "/assets/images/skills/skill3/Repeated_Nightmare.png",
        "thumbImage2": "/assets/images/skills/attack-bar-up.png"
    },
    {
        "_id": {
            "$oid": "628c91f649ba4c6799a6172b"
        },
        "name": "Soul Stealer",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "soul-stealer",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "No one can be revived while you are on the battlefield. In addition, the damage you inflict on enemies will be increased by 20% each when an enemy or ally dies (accumulates up to 5 times). In addition, creates a shield that's equivalent to 15% of your MAX HP for 2 turns if you attack an enemy on your turn. [Automatic Effect] Multiplier: 0.15*{MAX HP} (Fixed)",
        "images": [
            "/assets/images/skills/skill3/Soul_Stealer.png",
            "/assets/images/skills/Shield.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Soul_Stealer.png",
            "/assets/images/skills/Shield.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Soul_Stealer.png",
        "image2": "/assets/images/skills/Shield.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:27:10.861Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Demon",
        "thumbImage1": "/assets/images/skills/skill3/Soul_Stealer.png",
        "thumbImage2": "/assets/images/skills/Shield.png"
    },
    {
        "_id": {
            "$oid": "628c920249ba4c6799a6172e"
        },
        "name": "Red Battlefield",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "red-battlefield",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "The Attack Bar of all allies will be increased by the proportion to the damage dealt, and the damage you deal on enemies will be increased by 50% at the most whenever all enemies and allies on the battlefield receive damage. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Red_Battlefield.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Red_Battlefield.png",
            "/assets/images/skills/attack-bar-up.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Red_Battlefield.png",
        "image2": "/assets/images/skills/attack-bar-up.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:26:10.708Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Demon",
        "thumbImage1": "/assets/images/skills/skill3/Red_Battlefield.png",
        "thumbImage2": "/assets/images/skills/attack-bar-up.png"
    },
    {
        "_id": {
            "$oid": "628c920d49ba4c6799a61731"
        },
        "name": "Purgatory",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "purgatory",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "If you kill an enemy with your attack, you will revive one of dead allies with HP that's the same amount of the damage you dealt on the enemy target. If other ally dies when you are dead, you will be revived with little HP and 100% Attack Bar. [Automatic Effect] (Reusable in 5 turns)",
        "images": [
            "/assets/images/skills/skill3/Purgatory.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Purgatory.png",
            "/assets/images/skills/attack-bar-up.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Purgatory.png",
        "image2": "/assets/images/skills/attack-bar-up.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:25:19.145Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Demon",
        "thumbImage1": "/assets/images/skills/skill3/Purgatory.png",
        "thumbImage2": "/assets/images/skills/attack-bar-up.png"
    },
    {
        "_id": {
            "$oid": "628c924249ba4c6799a61737"
        },
        "name": "Unleashed Fury",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "unleashed-fury",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Gains increased Attack Power and Immunity against harmful effects for 3 turns. Instantly recovers a turn when used. (Reusable in 5 turns)",
        "images": [
            "/assets/images/skills/Chimera",
            "/assets/images/skills/Increase-ATK.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Unleashed_Fury_Fire.png",
            "/assets/images/skills/Increase-ATK.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/Chimera",
        "image2": "/assets/images/skills/Increase-ATK.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:06:18.275Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Chimera",
        "thumbImage1": "/assets/images/skills/skill2/Unleashed_Fury_Fire.png",
        "thumbImage2": "/assets/images/skills/Increase-ATK.png"
    },
    {
        "_id": {
            "$oid": "628c925149ba4c6799a6173a"
        },
        "name": "Squall",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "squall",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "The faster your Attack Speed, the greater the damage becomes. Attack Speed is increased for 2 turns if you get a Critical Hit. The attack will always land as a Critical Hit if the target is under inability effects. (Reusable in 3 turns). Multiplier: (SPD+70)/0.3)%",
        "images": [
            "/assets/images/skills/skill2/Squall_Water.png",
            "/assets/images/skills/Increase-Speed.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Squall_Water.png",
            "/assets/images/skills/Increase-Speed.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Squall_Water.png",
        "image2": "/assets/images/skills/Increase-Speed.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:08:22.972Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Chimera",
        "thumbImage1": "/assets/images/skills/skill2/Squall_Water.png",
        "thumbImage2": "/assets/images/skills/Increase-Speed.png"
    },
    {
        "_id": {
            "$oid": "628c926349ba4c6799a6173d"
        },
        "name": "Forbidden Power",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "forbidden-power",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Inflicts up to 2 extra attacks with 50% of the damage if you get a Critical Hit. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Forbidden_Power_Passive.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Forbidden_Power_Passive.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Forbidden_Power_Passive.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:16:10.265Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Chimera",
        "thumbImage1": "/assets/images/skills/skill3/Forbidden_Power_Passive.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628c926f49ba4c6799a61740"
        },
        "name": "Holy Calling",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "holy-calling",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Stuns all enemies with an 80% chance, increases the Attack Speed of all allies for 2 turns. In addition, increases the Attack Bar of all allies by 25% and decreases the Attack Bar of all enemies by 25%. (Reusable in 5 turns). Level-up Progress",
        "images": [
            "/assets/images/skills/skill3/Holy_Calling.png",
            "/assets/images/skills/Increase-Speed.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/skills/attack-bar-down.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Holy_Calling.png",
            "/assets/images/skills/Increase-Speed.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Holy_Calling.png",
        "image2": "/assets/images/skills/Increase-Speed.png",
        "image3": "/assets/images/skills/attack-bar-up.png",
        "image4": "/assets/images/skills/attack-bar-down.png",
        "modified": {
            "$date": "2022-08-07T06:15:28.227Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Chimera",
        "thumbImage1": "/assets/images/skills/skill3/Holy_Calling.png",
        "thumbImage2": "/assets/images/skills/Increase-Speed.png"
    },
    {
        "_id": {
            "$oid": "628c927e49ba4c6799a61743"
        },
        "name": "Lightning Strike",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "lightning-strike",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies to inflict damage proportionate to your Attack Speed. Weakens their Attack Power for 2 turns and stuns them for 1 turn with a 75% chance. (Reusable in 5 turns) Multiplier: ((SPD+185)/0.7)%",
        "images": [
            "/assets/images/skills/skill3/Lightning_Strike.png",
            "/assets/images/skills/Reduce-ATK.png",
            "/assets/images/skills/Stun.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Lightning_Strike.png",
            "/assets/images/skills/Reduce-ATK.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Lightning_Strike.png",
        "image2": "/assets/images/skills/Reduce-ATK.png",
        "image3": "/assets/images/skills/Stun.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:13:46.567Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Chimera",
        "thumbImage1": "/assets/images/skills/skill3/Lightning_Strike.png",
        "thumbImage2": "/assets/images/skills/Reduce-ATK.png"
    },
    {
        "_id": {
            "$oid": "628c928b49ba4c6799a61746"
        },
        "name": "Crush",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "crush",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy and guarantees to freeze the target for 1 turn. Afterwards, attacks other enemies dealing half the damage of the initial attack, decreasing their Attack Speed for 3 turns and reduces their Attack Bar by 100%. (Reusable in 5 turns). Multiplier: 7.8*{ATK}",
        "images": [
            "/assets/images/skills/skill3/Crush.png",
            "/assets/images/skills/Status_Freeze.png",
            "/assets/images/skills/Reduce-Speed.png",
            "/assets/images/skills/attack-bar-down.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Crush.png",
            "/assets/images/skills/Status_Freeze.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Crush.png",
        "image2": "/assets/images/skills/Status_Freeze.png",
        "image3": "/assets/images/skills/Reduce-Speed.png",
        "image4": "/assets/images/skills/attack-bar-down.png",
        "modified": {
            "$date": "2022-08-07T06:12:15.551Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Chimera",
        "thumbImage1": "/assets/images/skills/skill3/Crush.png",
        "thumbImage2": "/assets/images/skills/Status_Freeze.png"
    },
    {
        "_id": {
            "$oid": "628c929749ba4c6799a61749"
        },
        "name": "Collapse",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "collapse",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Inflicts damage that increases accordingly to your MAX HP, removes 1 beneficial effect and provokes the enemy for 2 turns. If this skill is on cooldown, you have a 30% chance to counterattack the attacker with the [Collapse] Skill when attacked. Deals 75% of the damage when counterattacking. (Reusable in 5 turns). Multiplier: 440%+40%",
        "images": [
            "/assets/images/skills/skill3/Collapse.png",
            "/assets/images/skills/Provoke.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Collapse.png",
            "/assets/images/skills/Provoke.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Collapse.png",
        "image2": "/assets/images/skills/Provoke.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T06:10:18.549Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Chimera",
        "thumbImage1": "/assets/images/skills/skill3/Collapse.png",
        "thumbImage2": "/assets/images/skills/Provoke.png"
    },
    {
        "_id": {
            "$oid": "628c975549ba4c6799a61752"
        },
        "name": "Focused 5 Shots",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Focused-5-Shots",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy 5 times. Each attack has a 50% chance to remove 1 beneficial effect and inflict Continuous Damage for 1 turn. (Reusable in 4 turns). Multiplier: 120% x5",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c976849ba4c6799a61755"
        },
        "name": "Wild Shot!",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Wild-Shot!",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks random enemies 8 times. Each attack has a 50% chance to weaken their Defense for 2 turns. (Reusable in 4 turns) Multiplier: 100% x8",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c977749ba4c6799a61758"
        },
        "name": "Fatal Armor Bullet",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Fatal-Armor-Bullet",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy with a cannon gun and absorbs Attack Bar by 100%. Afterwards, inflicts damage on all enemies and stuns them for 1 turn with a 30% chance. (Reusable in 5 turns). Multiplier: 400%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c978e49ba4c6799a6175b"
        },
        "name": "One More Time!",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "One-More-Time!",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "After attacking an enemy during your turn, attacks the enemy once again with [Fire!] skill. If the enemy is defeated with the first attack, you will attack another enemy with the same skill. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c979949ba4c6799a6175e"
        },
        "name": "Burst Cannon",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Burst-Cannon",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy with a cannon gun and destroys the target's MAX HP by 100% of the inflicted damage. (Reusable in 5 turns) Multiplier: 800%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c97c049ba4c6799a61762"
        },
        "name": "Coy Revenge",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Coy-Revenge",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases the damage to be dealt to an enemy on the next turn by 15% each time an ally is attacked. This effect accumulates up to 5 times and resets after you attack on your turn. [Automatic Effect]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c97d149ba4c6799a61765"
        },
        "name": "Rolling Cannon",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Rolling-Cannon",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with a cannon gun, inflicting damage proportional to the no. of allies alive. This attack won't land as a Glancing Hit. (Reusable in 5 turns). Multiplier: 5.4*{Alive Allies %}*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c97e449ba4c6799a61768"
        },
        "name": "Fatal Extinctive Bullet",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Fatal-Extinctive-Bullet",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy with a cannon gun, removes all beneficial effects granted on the target and blocks the target from receiving beneficial effects for 2 turns. Afterwards, inflicts damage on all enemies and decreases their Attack Bar by 70%. (Reusable in 5 turns). Multiplier: 400%",
        "images": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c97f349ba4c6799a6176b"
        },
        "name": "Fatal Mortar Bullet",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Fatal-Mortar-Bullet",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy with a cannon gun and weakens the Defense and leaves a Branding effect for 2 turns with a 90% chance each. Afterwards, inflicts damage on all enemies and destroys their MAX HP by 50% of the inflicted damage. (Reusable in 5 turns). Multiplier: 3.5*{ATK}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c983e49ba4c6799a61771"
        },
        "name": "Fast Link",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "fast-link",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "The faster your Attack Speed, the greater the damage becomes. Attacks the enemy with the beast 2 times. The beast's attack weakens the enemy's Defense for 1 turn, and the rider's attack absorbs the enemy's Attack Bar by 25% for each harmful effect granted on the target, up to 100%. (Reusable in 5 turns). Multiplier: 100%* ((SPD + 150)/100)",
        "images": [
            "/assets/images/skills/skill2/Fast_Link_Fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Fast_Link_Fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Fast_Link_Fire.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T01:52:08.811Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Beast Rider",
        "thumbImage1": "/assets/images/skills/skill2/Fast_Link_Fire.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628c987249ba4c6799a61777"
        },
        "name": "Critical Link",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "critical-link",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "The faster your Attack Speed, the greater the damage becomes. Attacks the enemy with the beast 2 times. The beast's attack changes all beneficial effects granted on the target to Continuous Damage for 1 turn, and the rider's attack inflicts damage that increases by 15% for each harmful effect granted on the target. (Reusable in 5 turns). Multiplier: 100%* ((SPD + 120)/100)",
        "images": [
            "/assets/images/skills/skill2/Critical_Link_Fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Critical_Link_Fire.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T02:01:49.416Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Beast Rider",
        "thumbImage1": "/assets/images/skills/skill2/Critical_Link_Fire.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628c988f49ba4c6799a6177a"
        },
        "name": "Rider",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "rider",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Dismounts the beast to battle when you're inflicted with damage that may cause you to die. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill4/Rider_Fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill4/Rider_Fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill4/Rider_Fire.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T02:00:15.245Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Beast Rider",
        "thumbImage1": "/assets/images/skills/skill4/Rider_Fire.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628c989a49ba4c6799a6177d"
        },
        "name": "Wild Steps",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "wild-steps",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "The Attack Bar increasing skill effect granted on yourself increases by 50%, and the Attack Bar decreasing skill effect granted on yourself decreases by 50%. Also, your Attack Speed increases by 15% whenever your Attack Bar increases due to skills, up to 5 times. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Wild_Steps.png",
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/skills/attack-bar-down.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Wild_Steps.png",
            "/assets/images/skills/attack-bar-down.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Wild_Steps.png",
        "image2": "/assets/images/skills/attack-bar-down.png",
        "image3": "/assets/images/skills/attack-bar-up.png",
        "image4": "/assets/images/skills/attack-bar-down.png",
        "modified": {
            "$date": "2022-08-07T02:10:08.895Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Beast Rider",
        "thumbImage1": "/assets/images/skills/skill3/Wild_Steps.png",
        "thumbImage2": "/assets/images/skills/attack-bar-down.png"
    },
    {
        "_id": {
            "$oid": "628c98a949ba4c6799a61780"
        },
        "name": "Start of Attacking",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "start-of-attacking",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy with the beast 2 times. The beast's attack removes all beneficial effects granted on the enemy, and the rider's attack ignores the enemy's Defense by 25% for each beneficial effect the beast removed. Afterwards, the Attack Bar of other allies will be increased, up to 50%, in proportion to the enemy's lost HP from this attack. (Reusable in 6 turns). Multiplier: 380%",
        "images": [
            "/assets/images/skills/skill3/Start_of_Attacking.png",
            "/assets/images/skills/attack-bar-up",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Start_of_Attacking.png",
            "/assets/images/skills/attack-bar-up"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Start_of_Attacking.png",
        "image2": "/assets/images/skills/attack-bar-up",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T02:05:43.668Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Beast Rider",
        "thumbImage1": "/assets/images/skills/skill3/Start_of_Attacking.png",
        "thumbImage2": "/assets/images/skills/attack-bar-up"
    },
    {
        "_id": {
            "$oid": "628c98b949ba4c6799a61783"
        },
        "name": "Gigantic Roar",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "gigantic-roar",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "The rider increases the Attack Speed of all allies for 2 turns, and the beast attacks all enemies. Weakens the enemy's Defense for 2 turns if the enemy's Defense is lower than your Attack Power, and decreases the enemy's Attack Bar by 75% if the enemy's Attack Speed is slower than yours. (Reusable in 6 turns). Multiplier: 450%",
        "images": [
            "/assets/images/skills/skill3/Gigantic_Roar.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Gigantic_Roar.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Gigantic_Roar.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T02:03:43.027Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Beast Rider",
        "thumbImage1": "/assets/images/skills/skill3/Gigantic_Roar.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628c98cd49ba4c6799a61787"
        },
        "name": "Wild Chase",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "wild-chase",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "He Attack Speed increases by 20% for each time an enemy gains a turn, up to 5 times. The increased Attack Speed resets when your turn ends. In addition, increases your Attack Speed for 1 turn and decreases the enemy's Defense for 1 turn with each attack. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Wild_Chase.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Wild_Chase.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Wild_Chase.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T02:02:32.135Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Beast Rider",
        "thumbImage1": "/assets/images/skills/skill3/Wild_Chase.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628c98df49ba4c6799a6178a"
        },
        "name": "Late Night Ambush",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "late-night-ambush",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with the beast 2 times. The beast's attack sets the enemies' Attack Bar to 0, and the rider's attack inflicts damage that increases up to 100% in proportion to the Attack Bar that the beast decreased. (Reusable in 6 turns). Multiplier: 220%",
        "images": [
            "/assets/images/skills/skill3/Late_Night_Ambush.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Late_Night_Ambush.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Late_Night_Ambush.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-08-07T01:58:36.998Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Beast Rider",
        "thumbImage1": "/assets/images/skills/skill3/Late_Night_Ambush.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "628c993449ba4c6799a6178f"
        },
        "name": "Crushing Blow (Strengthened)",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Crushing-Blow-(Strengthened)",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Smashes the enemy and removes a beneficial effect granted on the target with a 100% chance. The damage of this skill is proportionate to your MAX HP and this attack will increase your Attack Speed for 2 turns if it lands as a Critical Hit. Multiplier: 110%+18%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c998549ba4c6799a61792"
        },
        "name": "Defend",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Defend",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Escorts the ally target for 3 turns and instantly recovers your turn. Receives half of the damage inflicted on the escorted target while making the damage dealt to the escorted target to 0 and counterattacks the enemy target. (Reusable in 5 turns)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c999349ba4c6799a61795"
        },
        "name": "Trick of Darkness",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Trick-of-Darkness",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with a spell that summons the power of darkness. This attack has a 75% chance to remove beneficial effects and a 75% chance to block beneficial effects granted on the target for 2 turns. The damage of this skill is proportionate to your MAX HP. (Reusable in 5 turns) Multiplier: 29%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c99a149ba4c6799a61798"
        },
        "name": "Meditate",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Meditate",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Removes harmful effects granted on yourself and recovers the ally target's HP by 40% of your MAX HP through meditation. (Reusable in 5 turns). Multiplier: 40%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c99af49ba4c6799a6179b"
        },
        "name": "Trick of Light",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Trick-of-Light",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with a spell that summons the power of light to increase their chances of landing a Glancing Hit for 2 turns with a 75% chance and all allies counterattack for 2 turns. The damage of this skill is proportionate to your MAX HP. (Reusable in 5 turns). Multiplier: 30%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c9d1a49ba4c6799a6179e"
        },
        "name": "Trick of Wind",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Trick-of-Wind",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with a spell that summons the power of wind to decrease their Defense for 2 turns with a 75% chance and increases the Defense of all allies for 2 turns. The damage is proportionate to your MAX HP. (Reusable in 5 turns). Multiplier: 30%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c9d5249ba4c6799a617a1"
        },
        "name": "Trick of Water",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Trick-of-Water",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with a spell that summons the power of water to decreases their Attack Speed for 2 turns with an 80% chance and increases the Attack Bar of all allies by 25%. The damage is proportionate to your MAX HP. (Reusable in 5 turns). Multiplier: 28%",
        "images": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c9d6149ba4c6799a617a4"
        },
        "name": "Trick of Fire",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Trick-of-Fire",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with a spell that summons the power of fire to Silence them for 2 turns with a 75% chance and removes the harmful effects granted on all allies. The damage is proportionate to your MAX HP. (Reusable in 5 turns). Multiplier: 29%",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c9dd749ba4c6799a617aa"
        },
        "name": "Moon Drawn by Clouds",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Moon-Drawn-by-Clouds",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies to remove all beneficial effects granted on them and to increase the chance of landing a Glancing Hit for 2 turns with a 50% chance each. (Reusable in 4 turns). Multiplier: 320%",
        "images": [
            "/assets/images/skills/skill2/moon-dawn-of-clouds-5.png",
            "/assets/images/skills/Reduce-ACC.png",
            "/assets/images/skills/Reduce-DEF.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/moon-dawn-of-clouds-5.png",
            "/assets/images/skills/Reduce-ACC.png",
            "/assets/images/skills/Reduce-DEF.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c9dea49ba4c6799a617ad"
        },
        "name": "Scroll Trap",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Scroll-Trap",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Seals the enemy in the scroll, leaving the enemy out of the battle for a designated period of time. The duration of the seal increases according to your Attack Speed. If all enemies are sealed, the target with the least duration time left will be released. Gains a turn instantly after using the skill. (Reusable in 6 turns). Multiplier: 10*(17*{SPD} + 2900)/({SPD} + 100)",
        "images": [
            "/assets/images/skills/skill2/scroll-trap-1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/scroll-trap-1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c9dfb49ba4c6799a617b0"
        },
        "name": "Mask of Devil",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Mask-of-Devil",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Grants Immunity on all allies for 2 turns and the selected target will go under Threat state while the enemies attack 2 times. You will gain a turn afterwards. (Reusable in 6 turns)",
        "images": [
            "/assets/images/skills/skill3/mask-of-devil-5.png",
            "/assets/images/skills/Status_Threat.png",
            "/assets/images/skills/Immunity.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/mask-of-devil-5.png",
            "/assets/images/skills/Status_Threat.png",
            "/assets/images/skills/Immunity.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c9e0a49ba4c6799a617b3"
        },
        "name": "Final Touch",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Final-Touch",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Draws a giant dragon to attack all enemies. This attack cannot be counterattacked and all passive skills of the enemies are not activated. (Reusable in 5 turns). Multiplier: 380%",
        "images": [
            "/assets/images/skills/skill3/final-touch-4.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/final-touch-4.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c9e1f49ba4c6799a617b6"
        },
        "name": "Serious Matter",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Serious-Matter",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies 3 times to decrease their Attack Bar by 75% with each attack. Increases the skill cooldown time by 1 turn if the target's Attack Bar is 0. (Reusable in 5 turns). Multiplier: 170% x3",
        "images": [
            "/assets/images/skills/skill3/serious-matter-3.png",
            "/assets/images/skills/attack-bar-down.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/serious-matter-3.png",
            "/assets/images/skills/attack-bar-down.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c9e2e49ba4c6799a617b9"
        },
        "name": "Art of Blank Space",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Art-of-Blank-Space",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "When enemies remove harmful effects, the Attack Bar of all allies will be increased by 25%. When enemies remove beneficial effects of allies, all harmful effects on the ally with removed beneficial effects will be removed and the Attack Bar will be increased by 15%. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/art-of-blank-space-passive-2.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/art-of-blank-space-passive-2.png",
            "/assets/images/skills/attack-bar-up.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628c9e3d49ba4c6799a617bc"
        },
        "name": "Blossom Painting",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Blossom-Painting",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies to remove all of their beneficial effects. Increases the Attack Power and Attack Speed of all allies for 2 turns afterwards. (Reusable in 5 turns). Multiplier: 430%",
        "images": [
            "/assets/images/skills/skill3/blossom-painting-1.png",
            "/assets/images/skills/Increase-ATK.png",
            "/assets/images/skills/Increase-Speed.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/blossom-painting-1.png",
            "/assets/images/skills/Increase-ATK.png",
            "/assets/images/skills/Increase-Speed.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "628ca54449ba4c6799a617d1"
        },
        "name": "Increase the Attack Power of ally monsters with Water attribute by 50%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-attack-power-of-ally-monsters-with-water-attribute-by-50percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increase the Attack Power of ally monsters with Water attribute by 50%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Low_Water_Icon-2.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Low_Water_Icon-2.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Low_Water_Icon-2.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:56:32.405Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "SW",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Attack_Power_Low_Water_Icon-2.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62a01d2b7f96ed1164c04346"
        },
        "name": "Thỏ và Rùa",
        "category": "fairytale",
        "subCategory": "vietnam",
        "slug": "thỏ-và-rùa",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Ngày xửa ngày xưa, có một con Rùa và một con Thỏ sống trong một khu rừng xinh đẹp và yên tĩnh. Ngày ngày chúng vui chơi với nhau như hai người bạn thân. Một hôm, Thỏ và Rùa cãi nhau xem ai nhanh hơn. Rồi chúng quyết định giải quyết việc tranh luận bằng một cuộc thi chạy đua. Thỏ và Rùa đồng ý lộ trình và bắt đầu cuộc đua. Thỏ xuất phát nhanh như tên bắn và chạy thục mạng rất nhanh, khi thấy rằng mình đã khá xa Rùa. Thỏ nghĩ nên nghỉ cho đỡ mệt dưới một bóng cây xum xuê lá bên vệ đường. Vì quá tự tin vào khả năng giành chiến thắng của mình, Thỏ ngồi dưới bóng cây và nhanh chóng ngủ thiếp đi. Rùa chạy mãi rồi cũng đến nơi, thấy Thỏ đang ngủ ngon giấc Rùa từ từ vượt qua Thỏ và về đích trước Thỏ. Khi Thỏ thức dậy thì rùa đã đến đích và trở thành người chiến thắng. Lúc này Thỏ biết mình đã thua cuộc vì quá tự tin vào khả năng của mình, còn Rùa chiến thắng vì kiên trì bám đuổi mục tiêu và làm việc hết sức trong khả năng của mình, cộng với một chút may mắn và giành chiến thắng.",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a01d7a7f96ed1164c0434c"
        },
        "name": "Thỏ và Rùa 2",
        "category": "fairytale",
        "subCategory": "vietnam",
        "slug": "thỏ-và-rùa-2",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Thỏ vô cùng thất vọng vì để thua Rùa, thỏ nhận ra rằng mình thua chính vì quá tự tin, bất cẩn và thiếu kỷ luật. Nếu thỏ không xem mọi thứ quá dễ dàng và chắc thắng thì rùa không thể có cơ hội hạ được.  Vì thế, Thỏ quyết định thách thức Rùa bằng một cuộc đua mới. Rùa đồng ý. Lần này, Thỏ chạy với tất cả sức lực của mình và chạy một mạch về đích. thỏ bỏ xa Rùa đến mấy dặm đường.",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a020f07f96ed1164c0436b"
        },
        "name": "Cây táo thần",
        "category": "fairytale",
        "subCategory": "vietnam",
        "slug": "cây-táo-thần",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Ngày xửa, ngày xưa đã lâu lắm rồi, có một cây táo thần mọc ở ngoại ô thành phố. Hàng ngày bọn trẻ thường đến chơi ở đó, nô đùa xung quanh cây táo và bứt những quả táo ngon trên cành để chia nhau ăn.  Một hôm có một cậu bé không biết từ đâu đến, cậu bé cau mày nói với bọn trẻ:  – Này chúng mày, vườn này là của tao, tao đã mua từ trước. Cây táo này là của tao, chúng mày đi chỗ khác chơi, cấm không được đến đây nữa.  Nghe vậy, bọn trẻ rất buồn, tất cả cúi đầu lặng lẽ ra về, chỉ còn cậu bé hống hách ở lại.  Cây táo biết tất cả mọi chuyện, bằng phép lạ nó làm cho cậu bé ngủ thiếp đi dưới gốc cây và cũng bằng phép lạ nó làm cho cậu bé nằm mơ. Cậu bé mơ thấy trên thân cây táo có một cái hốc rất lớn.  Cậu cảm thấy bụng đói cồn cào. Cậu bé trèo lên cây và định bứt táo để ăn. Nhưng mỗi khi tay cậu bé chạm vào một quả táo thì cành táo laị quay đi chỗ khác và quả táo lại rơi vào cái hốc to tướng ở thân cây. Cứ như vậy cho đến khi tất cả trên cành rơi vào hết cái hốc, chỉ còn trơ lại một quả trên cành.  Cậu bé ngồi dưới gốc cây và khóc. Đến lúc đó cây táo mới cất tiếng hỏi:  – Tại sao cháu khóc?  Cậu bé mếu máo trả lời:  – Ông ích kỉ quá. Ông ăn hết cả táo, ông không cho cháu một quả nào. Cháu đói lắm rồi ông ạ.  Cây táo cười và nói:  – Cháu có nhớ là cháu đã đuổi hết tất cả các bạn không? Các bạn cũng muốn ăn táo của ông nhưng cháu không cho các bạn một quả nào, như vậy cháu có ích kỉ không?  Cậu bé nhớ lại lúc các bạn buồn rầu ra về, cậu bé thấy ân hận vô cùng, cậu bé ngước nhìn cây táo và nói:  – Vâng cháu biết lỗi rồi!  Cây táo cất tiếng cười vang, rung cả cây, làm cho quả táo còn lại cũng rơi trúng đầu cậu bé, cậu bé giật mình tỉnh giấc.  Cậu bé ngơ ngác nhìn xung quanh, cậu bé thấy mình đang nằm dưới gốc cây. Cái hố to tướng trên cây táo biến mất.  Cây táo vẫn đứng yên lặng và trên cây vẫn sai trĩu quả.  Cậu bé chồm dậy, nhớ đến giấc mơ, cậu vội chạy đi gọi các bạn:  – Này các bạn ơi! Quay lại đây chơi đi. Mình xin lỗi các bạn vì đã đuổi các bạn đi.  Thế là tất cả cùng nhau chạy ra vườn. Cậu tự mình trèo lên bứt những quả chín ném xuống cho các bạn. Các bạn lại cười đùa vui vẻ. Cậu bé chợt hiểu rằng điều hạnh phúc nhất trên trái đất này là cùng chia sẻ niềm vui với mọi người.",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a021e37f96ed1164c04376"
        },
        "name": "Con cú khôn ngoan",
        "category": "fairytale",
        "subCategory": "vietnam",
        "slug": "con-cú-khôn-ngoan",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Ngày xửa ngày xưa, có một con cú già sống trên một cây sồi to. Mỗi ngày, nó đều phóng tầm mắt ra thật xa để quan sát những điều xảy ra xung quanh mình. Có khi nó nhìn thấy một cậu bé đang giúp ông lão xách một cái túi to, có khi nó nhìn thấy một cô con gái đang cằn nhằn mẹ mình. Ngày qua ngày, con cú nhìn thấy được rất nhiều thứ nhưng nó vẫn giữ im lặng về những điều mà mình thấy. Từ từ, con cú già bắt đầu nói ít hơn và thính giác của nó dần trở nên tốt hơn. Bây giờ nó có thể nghe rõ những cuộc nói chuyện của mọi người. Một ngày, con cú già nghe thấy một người phụ nữ nói với ai đó rằng có một con voi nhảy qua hàng rào. Một ngày khác, con cú lại nghe thấy một người đàn ông nói với ai đó rằng mình là con người hoàn hảo và chưa bao giờ mắc phải sai lầm gì. Mỗi ngày trôi qua, con cú già lại nói ít hơn và nghe nhiều hơn. Nhờ vậy, nó biết được tất cả mọi thứ xảy ra xung quanh, dù không có ở đó. Dần dần, con cú già trở nên khôn ngoan hơn và nổi tiếng vì sự khôn ngoan ấy.",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a0244c7f96ed1164c0437b"
        },
        "name": "Con cừu đen kêu be be",
        "category": "fairytale",
        "subCategory": "vietnam",
        "slug": "con-cừu-đen-kêu-be-be",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Ngày xửa ngày xưa, có một con cừu đen sống trong một ngôi nhà nhỏ. Cứ đến mùa xuân, con cừu đen lại tự cạo sạch lông của mình và đem ra chợ bán cho những người muốn làm quần áo ấm.  Một năm nọ, con cừu đen nhận thấy rằng dường như không ai còn chuộng lông cừu đen nữa. Do đó, số lông cừu mà nó còn lại khá nhiều. Dù vậy, nó không muốn lãng phí số lông này nên đã quyết tâm bán tiếp. Hôm đó, chẳng có ai muốn mua lông của nó cả nên con cừu đen mang số lông ấy về nhà. Ngày hôm sau, nó lại mang ra bán tiếp nhưng mọi chuyện cứ diễn ra y như hôm trước. Và hôm sau, hôm sau nữa cũng y như vậy.  Một ngày nọ, khi con cừu đen đang ngồi buồn rầu với số lông của mình, có một cậu bé chạy lại và hỏi nó có bán số lông này không. Nghe hỏi, con cừu đen vô cùng mừng rỡ và nói có. Cậu bé chạy đến chỗ bố mẹ mình thông báo có chỗ bán lông cừu. Họ cùng nhau đến chỗ con cừu và ngỏ ý muốn mua hết toàn bộ số lông. Họ cho biết mình đến từ ngôi làng kế bên và đã tìm kiếm rất nhiều nơi để tìm mua lông cừu đen nhưng không có chỗ nào bán cả.  Ngày hôm ấy, con cừu trở về nhà và cảm thấy vô cùng hạnh phúc khi những cố gắng của nó đã được đền đáp xứng đáng.",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a024617f96ed1164c0437e"
        },
        "name": "Khỉ và cá sấu",
        "category": "fairytale",
        "subCategory": "vietnam",
        "slug": "khỉ-và-cá-sấu",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Ngày xưa, có một con khỉ sống trên một cây cao lớn và làm bạn với một con cá sấu sống ở dòng sông gần đó. Mỗi ngày, con khỉ sẽ hái những quả táo ngon ở trên cây và đem tặng bạn cá sấu. Nhận được quà từ khỉ, cá sấu đem về và ăn chung với vợ mình. Vợ của cá sấu là một người rất tham ăn và muốn ăn cả trái tim của chú khỉ. Nghe mong muốn đó của vợ, cá sấu rất băn khoăn nhưng vẫn làm theo ý vợ.  Cá sấu đã mời khỉ ngồi trên lưng mình để đưa đi tham quan dòng sông nhưng thật ra nó có ý định giết khỉ và lấy quả tim khi bơi đến giữa dòng. Khi khỉ biết được mưu đồ xấu xa của cá sấu, nó đã nhanh trí nói với cá sấu rằng mình để quả tim ở trên cây. Nếu muốn lấy thì hãy chở nó quay lại. Cá sấu tin lời, chở khỉ quay trở lại để lấy quả tim. Thế nhưng, khi đến nơi, khỉ đã thoăn thoắt trèo lên cây và chẳng mấy chốc biến mất. Và thế là, kế hoạch của cá sấu đã hoàn toàn thất bại.  Ý nghĩa của câu chuyện: Khi gặp tình huống khó khăn, con hãy bình tĩnh và sử dụng trí thông minh của mình để vượt qua điều đó. 777",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a6ec096edce01e4335f230"
        },
        "name": "Omni Knight",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "omni-knight",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/dota/Omniknight.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/dota/Omniknight.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Human",
        "type": "Strength",
        "grade": "5",
        "__v": 0,
        "leaderSkill": "",
        "skill1": "Purification",
        "skill2": "Repel",
        "skill3": "Degen Aura",
        "skill4": "Guardian Angel"
    },
    {
        "_id": {
            "$oid": "62a6ec2d6edce01e4335f233"
        },
        "name": "Night Stalker",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "night-stalker",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/dota/Balanar_square.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/dota/Balanar_square.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Undead",
        "type": "Strength",
        "grade": "5",
        "__v": 0,
        "leaderSkill": "",
        "skill1": "Void",
        "skill2": "Crippling Fear",
        "skill3": "Hunter in the Night",
        "skill4": "Darkness"
    },
    {
        "_id": {
            "$oid": "62a6ec516edce01e4335f236"
        },
        "name": "Axe",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "axe",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/dota/Axe.jpg",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/dota/Axe.jpg",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Strength",
        "grade": "5",
        "__v": 0,
        "skill1": "Berserker's Call",
        "skill2": "Battle Hunger",
        "skill3": "Counter Helix",
        "skill4": "Culling Blade"
    },
    {
        "_id": {
            "$oid": "62a6ecb46edce01e4335f23c"
        },
        "name": "Invoker",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "invoker",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a6eff56edce01e4335f255"
        },
        "name": "Monkey D. Luffy",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "monkey-d.-luffy",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "https://mylife-image-api.herokuapp.com/public/assets/images/Monkey_D._Luffy.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://mylife-image-api.herokuapp.com/public/assets/images/Monkey_D._Luffy.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a6fa386edce01e4335f28f"
        },
        "name": "Roronoa Zoro",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "roronoa-zoro",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://mylife-image-api.herokuapp.com/public/assets/images/Roronoa_Zoro.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a6fbd76edce01e4335f2a4"
        },
        "name": "Nami",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "nami",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a6fc2c6edce01e4335f2b0"
        },
        "name": "Sanji",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "sanji",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a6fc5b6edce01e4335f2b6"
        },
        "name": "Usopp",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "usopp",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a6fe9a6edce01e4335f2d7"
        },
        "name": "Portgas D. Ace",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "portgas-d.-ace",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a851e371554ba4edbeb03c"
        },
        "name": "Abaddon",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "abaddon",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Undead",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8520471554ba4edbeb03f"
        },
        "name": "Alchemist",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "alchemist",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8523271554ba4edbeb042"
        },
        "name": "Ancient Apparition",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "ancient-apparition",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Undead",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8524c71554ba4edbeb045"
        },
        "name": "Anti Mage",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "anti-mage",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8526671554ba4edbeb048"
        },
        "name": "Arc Warden",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "arc-warden",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Undead",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8527e71554ba4edbeb04b"
        },
        "name": "Bane",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "bane",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Undead",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8528971554ba4edbeb04e"
        },
        "name": "Batrider",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "batrider",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8529971554ba4edbeb051"
        },
        "name": "Beastmaster",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "beastmaster",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a852a471554ba4edbeb054"
        },
        "name": "Bloodseeker",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "bloodseeker",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Agility",
        "species": "Orc",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a852c371554ba4edbeb057"
        },
        "name": "Bone",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "bone",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a852d271554ba4edbeb05a"
        },
        "name": "Bounty Hunter",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "bounty-hunter",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a852e071554ba4edbeb05d"
        },
        "name": "Bristleback",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "bristleback",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a852ed71554ba4edbeb060"
        },
        "name": "Broodmother",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "broodmother",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Undead",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a852f871554ba4edbeb063"
        },
        "name": "Centaur Warchief",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "centaur-warchief",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8530971554ba4edbeb066"
        },
        "name": "Chaos Knight",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "chaos-knight",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Undead",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8531771554ba4edbeb069"
        },
        "name": "Chen",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "chen",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8532b71554ba4edbeb06c"
        },
        "name": "Clock",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "clock",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8534271554ba4edbeb06f"
        },
        "name": "Crystal Maiden",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "crystal-maiden",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8534c71554ba4edbeb072"
        },
        "name": "Darkseer",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "darkseer",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Night elf/elves",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8535671554ba4edbeb075"
        },
        "name": "Dazzle",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "dazzle",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8536671554ba4edbeb078"
        },
        "name": "Death Prophet",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "death-prophet",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Undead",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8537771554ba4edbeb07b"
        },
        "name": "Doom",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "doom",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8538971554ba4edbeb07e"
        },
        "name": "Dragon Knight",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "dragon-knight",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Human",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8539871554ba4edbeb081"
        },
        "name": "Drow Ranger",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "drow-ranger",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Human",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a853a971554ba4edbeb084"
        },
        "name": "Earthshaker",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "earthshaker",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a853b271554ba4edbeb087"
        },
        "name": "Ember",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "ember",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a853bc71554ba4edbeb08a"
        },
        "name": "Enchantress",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "enchantress",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a853d371554ba4edbeb08d"
        },
        "name": "Enigma",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "enigma",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Undead",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a853db71554ba4edbeb090"
        },
        "name": "Ezalor",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "ezalor",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Undead",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a853e971554ba4edbeb093"
        },
        "name": "Faceless Void",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "faceless-void",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a853f571554ba4edbeb096"
        },
        "name": "Furion",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "furion",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8540171554ba4edbeb099"
        },
        "name": "Geomancer",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "geomancer",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8544071554ba4edbeb09d"
        },
        "name": "Goblin Shredder",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "goblin-shredder",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Night elf/elves",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8544c71554ba4edbeb0a0"
        },
        "name": "Gyrocopter",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "gyrocopter",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62a8545971554ba4edbeb0a3"
        },
        "name": "Huskar",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "huskar",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa937c5a6d9acb860225fa"
        },
        "name": "Jakiro",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "jakiro",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa93f05a6d9acb860225fd"
        },
        "name": "Kunkka",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "kunkka",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Human",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa93fa5a6d9acb86022600"
        },
        "name": "Legion Commander",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "legion-commander",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Human",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa943c5a6d9acb86022604"
        },
        "name": "Leshrac",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "leshrac",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa948a5a6d9acb8602260a"
        },
        "name": "Lich",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "lich",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Undead",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa94945a6d9acb8602260d"
        },
        "name": "Lifestealer",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "lifestealer",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Undead",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa94a45a6d9acb86022610"
        },
        "name": "Lina",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "lina",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa94a95a6d9acb86022613"
        },
        "name": "Lion",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "lion",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa94bc5a6d9acb86022616"
        },
        "name": "Lone Druid",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "lone-druid",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee/Ranged",
        "species": "Night elf/elves",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa94c85a6d9acb86022619"
        },
        "name": "Lycan",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "lycan",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Night elf/elves",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa94d15a6d9acb8602261c"
        },
        "name": "Magnus",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "magnus",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Night elf/elves",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa94e75a6d9acb8602261f"
        },
        "name": "Medusa",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "medusa",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa94ec5a6d9acb86022622"
        },
        "name": "Mirana",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "mirana",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa94f05a6d9acb86022625"
        },
        "name": "Morphling",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "morphling",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa94f75a6d9acb86022628"
        },
        "name": "Naga Siren",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "naga-siren",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Night elf/elves",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa95045a6d9acb8602262b"
        },
        "name": "Necro",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "necro",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa95105a6d9acb8602262e"
        },
        "name": "Nerubian Assassin",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "nerubian-assassin",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Night elf/elves",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa95315a6d9acb86022632"
        },
        "name": "Obsidian Destroyer",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "obsidian-destroyer",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Undead",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa95d05a6d9acb86022635"
        },
        "name": "Ogre Magi",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "ogre-magi",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Night elf/elves",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa95df5a6d9acb86022638"
        },
        "name": "Pandaren Brewmaster",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "pandaren-brewmaster",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Night elf/elves",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa95fd5a6d9acb8602263b"
        },
        "name": "Phantom Assassin",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "phantom-assassin",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Night elf/elves",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa960d5a6d9acb8602263e"
        },
        "name": "Phantom Lancer",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "phantom-lancer",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Night elf/elves",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa961e5a6d9acb86022641"
        },
        "name": "Phoenix",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "phoenix",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa962d5a6d9acb86022644"
        },
        "name": "Pitlord",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "pitlord",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Night elf/elves",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa96c05a6d9acb86022647"
        },
        "name": "Puck",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "puck",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Ranged",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa96e05a6d9acb8602264a"
        },
        "name": "Pudge",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "pudge",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Undead",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa96f55a6d9acb8602264d"
        },
        "name": "Pugna",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "pugna",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Undead",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa96fd5a6d9acb86022650"
        },
        "name": "Queen of Pain",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "queen-of-pain",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Undead",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa97045a6d9acb86022653"
        },
        "name": "Razor",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "razor",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Undead",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa97115a6d9acb86022656"
        },
        "name": "Rhasta",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "rhasta",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa971a5a6d9acb86022659"
        },
        "name": "Riki",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "riki",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa97215a6d9acb8602265c"
        },
        "name": "Rubick",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "rubick",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa972d5a6d9acb8602265f"
        },
        "name": "Sandking",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "sandking",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa97345a6d9acb86022662"
        },
        "name": "Shadow Demon",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "shadow-demon",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa973f5a6d9acb86022665"
        },
        "name": "Shadow Fiend",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "shadow-fiend",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Undead",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa974f5a6d9acb86022668"
        },
        "name": "Silencer",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "silencer",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa975c5a6d9acb8602266b"
        },
        "name": "Skeleton King",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "skeleton-king",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Undead",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa976c5a6d9acb8602266e"
        },
        "name": "Skywrath Mage",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "skywrath-mage",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa97785a6d9acb86022671"
        },
        "name": "Slardar",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "slardar",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Night elf/elves",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa977f5a6d9acb86022674"
        },
        "name": "Slark",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "slark",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Night elf/elves",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa97895a6d9acb86022677"
        },
        "name": "Sniper",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "sniper",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Human",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa97925a6d9acb8602267a"
        },
        "name": "Spectre",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "spectre",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Undead",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa979b5a6d9acb8602267d"
        },
        "name": "Bara",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "bara",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa97a85a6d9acb86022680"
        },
        "name": "Storm Spirit",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "storm-spirit",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa97b75a6d9acb86022683"
        },
        "name": "Sven",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "sven",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa97bf5a6d9acb86022686"
        },
        "name": "Tauren Chieftaint",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "tauren-chieftaint",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa97cb5a6d9acb86022689"
        },
        "name": "Techies",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "techies",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa97d25a6d9acb8602268c"
        },
        "name": "Templar Assassin",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "templar-assassin",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa97da5a6d9acb8602268f"
        },
        "name": "Terrorblade",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "terrorblade",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa97e15a6d9acb86022692"
        },
        "name": "Thrall",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "thrall",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa97e85a6d9acb86022695"
        },
        "name": "Tidehunter",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "tidehunter",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa97f15a6d9acb86022698"
        },
        "name": "Tinker",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "tinker",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa98045a6d9acb8602269b"
        },
        "name": "Tiny",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "tiny",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Human",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa980b5a6d9acb8602269e"
        },
        "name": "Treant Protector",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "treant-protector",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Night elf/elves",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa981d5a6d9acb860226a1"
        },
        "name": "Troll Warlord",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "troll-warlord",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa98265a6d9acb860226a4"
        },
        "name": "Tuskarr",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "tuskarr",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa982e5a6d9acb860226a7"
        },
        "name": "Undying",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "undying",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Undead",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa98385a6d9acb860226aa"
        },
        "name": "Ursa Warrior",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "ursa-warrior",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Night elf/elves",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa98435a6d9acb860226ad"
        },
        "name": "Vengeful Spirit",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "vengeful-spirit",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Undead",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa98535a6d9acb860226b0"
        },
        "name": "Venomancer",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "venomancer",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa985c5a6d9acb860226b3"
        },
        "name": "Viper",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "viper",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa98675a6d9acb860226b6"
        },
        "name": "Visage",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "visage",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa98725a6d9acb860226b9"
        },
        "name": "Warlock",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "warlock",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa987b5a6d9acb860226bc"
        },
        "name": "Weaver",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "weaver",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Undead",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa988b5a6d9acb860226bf"
        },
        "name": "Windrunner",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "windrunner",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa98955a6d9acb860226c2"
        },
        "name": "Winter Wyvern",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "winter-wyvern",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Undead",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa98a25a6d9acb860226c5"
        },
        "name": "Wisp",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "wisp",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Night elf/elves",
        "type": "Strength",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa98af5a6d9acb860226c8"
        },
        "name": "Witch Doctor",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "witch-doctor",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Orc",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa98b75a6d9acb860226cb"
        },
        "name": "Yurnero",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "yurnero",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Melee",
        "species": "Orc",
        "type": "Agility",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa98bf5a6d9acb860226ce"
        },
        "name": "Zeus",
        "category": "warcraft",
        "subCategory": "monsters",
        "slug": "zeus",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Ranged",
        "species": "Human",
        "type": "Intelligence",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa99645a6d9acb860226d5"
        },
        "name": "Kaido",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "kaido",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa99705a6d9acb860226d8"
        },
        "name": "Shanks",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "shanks",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa997b5a6d9acb860226db"
        },
        "name": "Nico Robin",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "nico-robin",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa99835a6d9acb860226de"
        },
        "name": "Buggy",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "buggy",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa998c5a6d9acb860226e1"
        },
        "name": "Charlotte Linlin",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "charlotte-linlin",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa99965a6d9acb860226e4"
        },
        "name": "Marshall D. Teach",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "marshall-d.-teach",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa999d5a6d9acb860226e7"
        },
        "name": "Boa Hancock",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "boa-hancock",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa99a45a6d9acb860226ea"
        },
        "name": "Edward Newgate",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "edward-newgate",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa99a95a6d9acb860226ed"
        },
        "name": "Koby",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "koby",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa99ae5a6d9acb860226f0"
        },
        "name": "Trafalgar D. Water Law",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "trafalgar-d.-water-law",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa99b35a6d9acb860226f3"
        },
        "name": "Gol D. Roger",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "gol-d.-roger",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa99b85a6d9acb860226f6"
        },
        "name": "Brook",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "brook",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa99bd5a6d9acb860226f9"
        },
        "name": "Jinbe",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "jinbe",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa99c25a6d9acb860226fc"
        },
        "name": "Tony Tony Chopper",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "tony-tony-chopper",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa99c65a6d9acb860226ff"
        },
        "name": "Franky",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "franky",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa99cc5a6d9acb86022702"
        },
        "name": "Monkey D. Garp",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "monkey-d.-garp",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa99d15a6d9acb86022705"
        },
        "name": "Borsalino",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "borsalino",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa99d65a6d9acb86022708"
        },
        "name": "Smoker",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "smoker",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa99dc5a6d9acb8602270b"
        },
        "name": "Arlong",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "arlong",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa99e25a6d9acb8602270e"
        },
        "name": "Nefertari Vivi",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "nefertari-vivi",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9a075a6d9acb86022711"
        },
        "name": "Fujitora",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "fujitora",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Issho, commonly known by his alias Fujitora, is a Marine admiral. He was conscripted into the Marines through a World Military Draft during the two-year timeskip along with fellow newcomer Ryokugyu, both filling the two vacancies in the admiral positions caused by Kuzan's resignation and Sakazuki's promotion.",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9a185a6d9acb86022714"
        },
        "name": "Monkey D. Dragon",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "monkey-d.-dragon",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Monkey D. Dragon is the father of Monkey D. Luffy, and the son of Monkey D. Garp. He is the leader of the Revolution army and aims to take down the World Government. Very little is known about Dragon other then his family ties.",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9a235a6d9acb86022717"
        },
        "name": "Rob Lucci",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "rob-lucci",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Rob Lucci is a member of CP-0, having originally been the strongest member of CP9. Operating undercover to obtain the Pluton blueprints from Iceburg, he worked as a sawyer, treenail, and bolt specialist for Galley-La Company's Dock One.",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9a345a6d9acb8602271a"
        },
        "name": "Galdino",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "galdino",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Galdino (ギャルディーノ, Gyarudīno), alias Mr. 3 (ミスター・スリー, Misutā Surī), is a former officer agent of Baroque Works, alongside his partner Ms. April Fools Day. He was the main antagonist of the Little Garden Arc. He is now a member of the Buggy Pirates and its Pirate alliance.",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9a435a6d9acb8602271d"
        },
        "name": "Fisher Tiger",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "fisher-tiger",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Fisher Tiger, known as the Adventurer, was a sea bream Fish-Man and the founder and original captain of the Sun Pirates.",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9a695a6d9acb86022720"
        },
        "name": "Edward Weevil",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "edward-weevil",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Edward Weevil, or Whitebeard Jr., is the self-proclaimed son of Whitebeard Edward Newgate and one of the Shichibukai. His mother is Miss Bakkin, the self-proclaimed lover of Newgate.",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9a855a6d9acb86022723"
        },
        "name": "Caesar Clown",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "caesar-clown",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Caesar Clown, who was referred to as Master by his subordinates, is a scientist, a former colleague of Vegapunk; both on the research team MADS and with the World Government. [5] the primary antagonist of the Punk Hazard Arc, and the first main antagonist the Straw Hats face in the New World.",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9a9b5a6d9acb86022726"
        },
        "name": "Chinjao",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "chinjao",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Chinjao, formerly known as Don Chinjao and Chinjao the Drill, is a former pirate, the leader of the Chinjao Family, and the former 12th leader of the Happo Navy. He also joined as a gladiator at the Corrida Colosseum to compete for the Mera Mera no Mi.",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9aaf5a6d9acb86022729"
        },
        "name": "Rebecca",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "rebecca",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9abe5a6d9acb8602272c"
        },
        "name": "Zeff",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "zeff",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9c015a6d9acb86022731"
        },
        "name": "Sakazuki",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "sakazuki",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9c0e5a6d9acb86022734"
        },
        "name": "Kizaru",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "kizaru",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9c215a6d9acb86022738"
        },
        "name": "Ryokugyu",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "ryokugyu",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9c435a6d9acb8602273d"
        },
        "name": "Tsuru",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "tsuru",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9c535a6d9acb86022740"
        },
        "name": "John Giant",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "john-giant",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9c5a5a6d9acb86022743"
        },
        "name": "Stainless",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "stainless",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9c5e5a6d9acb86022746"
        },
        "name": "Cancer",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "cancer",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9c635a6d9acb86022749"
        },
        "name": "Mozambia",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "mozambia",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9c665a6d9acb8602274c"
        },
        "name": "Comil",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "comil",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9c6d5a6d9acb8602274f"
        },
        "name": "Momonga",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "momonga",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9c705a6d9acb86022752"
        },
        "name": "Onigumo",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "onigumo",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9c7a5a6d9acb86022755"
        },
        "name": "Doberman",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "doberman",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9c7e5a6d9acb86022758"
        },
        "name": "Strawberry",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "strawberry",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9c8d5a6d9acb8602275b"
        },
        "name": "Yamakaji",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "yamakaji",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9ca95a6d9acb8602275f"
        },
        "name": "Lacroix",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "lacroix",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Vice Admirals",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9cb05a6d9acb86022762"
        },
        "name": "Lonz",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "lonz",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Vice Admirals",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9cb35a6d9acb86022765"
        },
        "name": "Dalmatian",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "dalmatian",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Vice Admirals",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9cb85a6d9acb86022768"
        },
        "name": "Bastille",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "bastille",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Vice Admirals",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9cc45a6d9acb8602276c"
        },
        "name": "Vergo",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "vergo",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Vice Admirals",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9cca5a6d9acb8602276f"
        },
        "name": "Maynard",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "maynard",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Vice Admirals",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9cd55a6d9acb86022772"
        },
        "name": "Momousagi",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "momousagi",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Vice Admirals",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9cda5a6d9acb86022775"
        },
        "name": "Chaton",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "chaton",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Vice Admirals",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9ce15a6d9acb86022778"
        },
        "name": "Nazu Ketagari",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "nazu-ketagari",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Vice Admirals",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9ce85a6d9acb8602277b"
        },
        "name": "Draw",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "draw",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Vice Admirals",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9cf35a6d9acb8602277e"
        },
        "name": "Sicily",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "sicily",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Rear Admirals",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9d2e5a6d9acb86022781"
        },
        "name": "Akehende",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "akehende",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Rear Admirals",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9d405a6d9acb86022784"
        },
        "name": "Catacombo",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "catacombo",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Rear Admirals",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9d435a6d9acb86022787"
        },
        "name": "Hina",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "hina",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Rear Admirals",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9d485a6d9acb8602278a"
        },
        "name": "T Bone",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "t-bone",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Rear Admirals",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9d515a6d9acb8602278d"
        },
        "name": "Kadar",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "kadar",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Rear Admirals",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9d935a6d9acb86022790"
        },
        "name": "Pudding",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "pudding",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Commodores",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9d965a6d9acb86022793"
        },
        "name": "Daigin",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "daigin",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Commodores",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9d9a5a6d9acb86022796"
        },
        "name": "Yarisugi",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "yarisugi",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Commodores",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9d9d5a6d9acb86022799"
        },
        "name": "Brannew",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "brannew",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Commodores",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9da55a6d9acb8602279c"
        },
        "name": "Kibin",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "kibin",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Commodores",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9db55a6d9acb8602279f"
        },
        "name": "Very Good",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "very-good",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Commodores",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9dee5a6d9acb860227a4"
        },
        "name": "Shu",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "shu",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Commodores",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9df35a6d9acb860227a7"
        },
        "name": "Sharinguru",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "sharinguru",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Commodores",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9df75a6d9acb860227aa"
        },
        "name": "Gorilla",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "gorilla",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Commodores",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9dfb5a6d9acb860227ad"
        },
        "name": "Tashigi",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "tashigi",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Commodores",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9e045a6d9acb860227b1"
        },
        "name": "Nezumi",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "nezumi",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Commodores",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9e195a6d9acb860227b4"
        },
        "name": "Ripper",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "ripper",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Commanders, Lieutenant Commanders",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9e225a6d9acb860227b7"
        },
        "name": "Donquixote Rosinante",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "donquixote-rosinante",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Commanders, Lieutenant Commanders",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9e365a6d9acb860227ba"
        },
        "name": "Glove",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "glove",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Commanders, Lieutenant Commanders",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9e435a6d9acb860227bd"
        },
        "name": "Helmeppo",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "helmeppo",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Commanders, Lieutenant Commanders",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9e495a6d9acb860227c0"
        },
        "name": "Fullbody",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "fullbody",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Commanders, Lieutenant Commanders",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9e4f5a6d9acb860227c3"
        },
        "name": "Jango",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "jango",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Commanders, Lieutenant Commanders",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9e655a6d9acb860227c6"
        },
        "name": "Zotto",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "zotto",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Lieutenants, Lieutenant Junior Grades, Ensigns",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9e715a6d9acb860227c9"
        },
        "name": "Stalker",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "stalker",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Lieutenants, Lieutenant Junior Grades, Ensigns",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9e775a6d9acb860227cc"
        },
        "name": "Rokkaku",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "rokkaku",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Lieutenants, Lieutenant Junior Grades, Ensigns",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9e7f5a6d9acb860227cf"
        },
        "name": "Makko",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "makko",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Lieutenants, Lieutenant Junior Grades, Ensigns",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9e845a6d9acb860227d2"
        },
        "name": "Isuka",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "isuka",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Lieutenants, Lieutenant Junior Grades, Ensigns",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9ea05a6d9acb860227d5"
        },
        "name": "Inspector General Sengoku",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "inspector-general-sengoku",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Other High Ranking Marines",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62aa9ead5a6d9acb860227d8"
        },
        "name": "Science Captain Sentomaru",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "science-captain-sentomaru",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Sentomaru[4] is the bodyguard of Vegapunk and is in command of the Marines' Science Unit (科学部隊 Kagaku Butai?) as its captain (隊長 Taichō). After the timeskip, he has become a full-fledged Marine officer. Due to his actions, he can be considered a supporting antagonist in the Sabaody Archipelago Arc and the secondary antagonist of the Return to Sabaody Arc. ",
        "images": [
            "/assets/images/heroes/onepiece/Sentomaru_Anime_Post_Timeskip.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/heroes/onepiece/Sentomaru_Anime_Post_Timeskip.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Other High Ranking Marines",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/heroes/onepiece/Sentomaru_Anime_Post_Timeskip.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-14T06:55:56.722Z"
        },
        "modifiedBy": "Hung Nguyen",
        "thumbImage1": "/assets/images/heroes/onepiece/Sentomaru_Anime_Post_Timeskip.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62aa9eba5a6d9acb860227db"
        },
        "name": "SWORD Captain X Drake",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "sword-captain-x-drake",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "\"Red Flag\" X Drake (read as \"Diez Drake\") is the captain of the Marine Secret Special Unit SWORD. In order to go undercover as a pirate, he publicly defected from his position as rear admiral and founded the Drake Pirates. He is one of twelve pirates referred to as the \"Worst Generation\", and prior to the two-year timeskip had a bounty of Beli.png222,000,000",
        "images": [
            "/assets/images/heroes/onepiece/X_Drake_Pirate_Warriors.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/heroes/onepiece/X_Drake_Pirate_Warriors.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Other High Ranking Marines",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/heroes/onepiece/X_Drake_Pirate_Warriors.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-14T06:55:10.787Z"
        },
        "modifiedBy": "Hung Nguyen",
        "thumbImage1": "/assets/images/heroes/onepiece/X_Drake_Pirate_Warriors.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62aa9ec15a6d9acb860227de"
        },
        "name": "Bogard",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "bogard",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Bogard is a Marine Headquarters Marine and the right hand man of Vice Admiral Monkey D. Garp.[1] His actual rank is currently unknown.",
        "images": [
            "/assets/images/heroes/onepiece/Bogard_Anime.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/heroes/onepiece/Bogard_Anime.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Other High Ranking Marines",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/heroes/onepiece/Bogard_Anime.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-14T06:53:43.15Z"
        },
        "modifiedBy": "Hung Nguyen",
        "thumbImage1": "/assets/images/heroes/onepiece/Bogard_Anime.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62aa9ec45a6d9acb860227e1"
        },
        "name": "Candre",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "candre",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "He is a tall man with a long squared face and a black afro. Like his twin brother, he also has thick lips. He wears a white shirt, a dark-color tie and jacket. Over them, he also wears a Marine high-ranking officer coat.",
        "images": [
            "/assets/images/heroes/onepiece/Candre_Anime.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/heroes/onepiece/Candre_Anime.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Other High Ranking Marines",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/heroes/onepiece/Candre_Anime.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-14T06:52:46.373Z"
        },
        "modifiedBy": "Hung Nguyen",
        "thumbImage1": "/assets/images/heroes/onepiece/Candre_Anime.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62aa9ecd5a6d9acb860227e4"
        },
        "name": "Giant Squad",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "giant-squad",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "The Giant Squad is the name given to a group of giants in the Marine ranks assembled to guard the execution platform to be used for Portgas D. Ace's execution. They consist of at least eight giants.",
        "images": [
            "/assets/images/heroes/onepiece/Giant_Squad_1.png",
            "/assets/images/heroes/onepiece/Giant_Squad_2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/heroes/onepiece/Giant_Squad_1.png",
            "/assets/images/heroes/onepiece/Giant_Squad_2.png"
        ],
        "element": "Other High Ranking Marines",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/heroes/onepiece/Giant_Squad_1.png",
        "image2": "/assets/images/heroes/onepiece/Giant_Squad_2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-14T06:51:41.164Z"
        },
        "modifiedBy": "Hung Nguyen",
        "thumbImage1": "/assets/images/heroes/onepiece/Giant_Squad_1.png",
        "thumbImage2": "/assets/images/heroes/onepiece/Giant_Squad_2.png"
    },
    {
        "_id": {
            "$oid": "62aa9edb5a6d9acb860227e7"
        },
        "name": "Head Scientist Dr. Vegapunk",
        "category": "onepiece",
        "subCategory": "heroes",
        "slug": "head-scientist-dr.-vegapunk",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/heroes/onepiece/Head_Scientist_Dr_Vegapunk.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/heroes/onepiece/Head_Scientist_Dr_Vegapunk.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Other High Ranking Marines",
        "species": "Marines",
        "type": "Attack",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/heroes/onepiece/Head_Scientist_Dr_Vegapunk.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-14T06:48:54.194Z"
        },
        "modifiedBy": "Hung Nguyen",
        "thumbImage1": "/assets/images/heroes/onepiece/Head_Scientist_Dr_Vegapunk.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62b2779aeccb9676b9ccb8b0"
        },
        "name": "Purification",
        "category": "warcraft",
        "subCategory": "skills",
        "slug": "purification",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "The Omniknight heals a target ally instantly. Enemies near the healed target take magic damage.",
        "images": [
            "/assets/images/skills/dota/Purification.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/dota/Purification.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/dota/Purification.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-14T06:44:55.054Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Omniknight ",
        "thumbImage1": "/assets/images/skills/dota/Purification.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62b27843eccb9676b9ccb8b4"
        },
        "name": "Guardian Angel",
        "category": "warcraft",
        "subCategory": "skills",
        "slug": "guardian-angel",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Purist calls down the light of a Guardian Angel to defend his allies. Nearby Allied units gain almost total physical invulnerability (+1000 armor) and increased health regeneration for a short time.",
        "images": [
            "/assets/images/skills/dota/Guardianangel.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/dota/Guardianangel.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Ultimate",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/dota/Guardianangel.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-14T06:39:51.411Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Omniknight ",
        "thumbImage1": "/assets/images/skills/dota/Guardianangel.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62b2785ceccb9676b9ccb8b7"
        },
        "name": "Degen Aura",
        "category": "warcraft",
        "subCategory": "skills",
        "slug": "degen-aura",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Enemies near the Omniknight are slowed and have reduced attack speed.",
        "images": [
            "/assets/images/skills/dota/Degen_aura.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/dota/Degen_aura.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/dota/Degen_aura.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-14T06:40:19.931Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Omniknight ",
        "thumbImage1": "/assets/images/skills/dota/Degen_aura.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62b2786beccb9676b9ccb8ba"
        },
        "name": "Repel",
        "category": "warcraft",
        "subCategory": "skills",
        "slug": "repel",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "The Omniknight creates a divine ward, making his target immune to most targetted magic spells.",
        "images": [
            "/assets/images/skills/dota/Repel.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/dota/Repel.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/dota/Repel.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-14T06:35:04.063Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Omniknight",
        "thumbImage1": "/assets/images/skills/dota/Repel.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62b27c0deccb9676b9ccb8da"
        },
        "name": "Void",
        "category": "warcraft",
        "subCategory": "skills",
        "slug": "void",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Creates a damaging void. If cast at night, slows the target for 4 seconds. If cast at day, slows the target for 2 seconds.",
        "images": [
            "/assets/images/skills/dota/NS_Void.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/dota/NS_Void.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/dota/NS_Void.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-08T04:45:19.239Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Night Stalker",
        "thumbImage1": "/assets/images/skills/dota/NS_Void.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62b27c3ceccb9676b9ccb8dd"
        },
        "name": "Crippling Fear",
        "category": "warcraft",
        "subCategory": "skills",
        "slug": "crippling-fear",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "In the night, the Night Stalker can cause intense fear in enemy units, causing them to miss attacks and be unable to cast spells. This has reduced effect during the day.",
        "images": [
            "/assets/images/skills/dota/NS_CripplingFear.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/dota/NS_CripplingFear.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/dota/NS_CripplingFear.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-08T04:44:48.438Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Night Stalker",
        "thumbImage1": "/assets/images/skills/dota/NS_CripplingFear.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62b27c75eccb9676b9ccb8e0"
        },
        "name": "Hunter in the Night",
        "category": "warcraft",
        "subCategory": "skills",
        "slug": "hunter-in-the-night",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "The Night Stalker is named so for a reason. His attack speed and move speed improve dramatically in the night.",
        "images": [
            "/assets/images/skills/dota/NS_HunterintheNight.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/dota/NS_HunterintheNight.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/dota/NS_HunterintheNight.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/skills/dota/NS_HunterintheNight.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62b27c95eccb9676b9ccb8e3"
        },
        "name": "Darkness",
        "category": "warcraft",
        "subCategory": "skills",
        "slug": "darkness",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Creates a period of artificial night for the Night Stalker to thrive in.",
        "images": [
            "/assets/images/skills/dota/NS_Darkness.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/dota/NS_Darkness.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Ultimate",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/dota/NS_Darkness.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-08T04:42:44.779Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "Night Stalker",
        "thumbImage1": "/assets/images/skills/dota/NS_Darkness.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62c529e450585da924a4b171"
        },
        "name": "Berseker Call",
        "category": "warcraft",
        "subCategory": "skills",
        "slug": "berseker-call",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Mogul Kahn focuses all of his enemies' hatred on him, causing them to attack him at all costs.",
        "images": [
            "/assets/images/skills/dota/BersekerCall.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/dota/BersekerCall.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Axe",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62c52a0850585da924a4b174"
        },
        "name": "Battlehunger",
        "category": "warcraft",
        "subCategory": "skills",
        "slug": "battlehunger",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Afflicts a target with a terrible killing hunger. The target will take damage per second until it kills a unit.",
        "images": [
            "/assets/images/skills/dota/Battlehunger.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/dota/Battlehunger.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Axe",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62c52a3450585da924a4b177"
        },
        "name": "Counter Helix",
        "category": "warcraft",
        "subCategory": "skills",
        "slug": "counter-helix",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Mogul Kahn counters some blows made to him dealing damage to all nearby enemy units.",
        "images": [
            "/assets/images/skills/dota/CounterHelix.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/dota/CounterHelix.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Axe",
        "type": "Passive",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62c52a5e50585da924a4b17a"
        },
        "name": "Culling Blade",
        "category": "warcraft",
        "subCategory": "skills",
        "slug": "culling-blade",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Purges the weak from Mogul Kahn's sight. Deals moderate damage, but will kill a target that is low on life.",
        "images": [
            "/assets/images/skills/dota/CullingBlade.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/dota/CullingBlade.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Axe",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62e34a365a71d05879d661f7"
        },
        "name": "Manx",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "manx",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/hypnomeow/hypnomeow_fire.png",
            "/assets/images/monsters/hypnomeow/hypnomeow_fire2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/hypnomeow/hypnomeow_fire.png",
            "/assets/images/monsters/hypnomeow/hypnomeow_fire2.png"
        ],
        "element": "Fire",
        "species": "Hypnomeow",
        "type": "Attack",
        "grade": "5",
        "leaderSkill": "Increases Accuracy by 25%",
        "skill1": "Bubbly Bubble",
        "skill2": "Sleep Talk",
        "skill3": "Night Night, Everyone",
        "skill4": "",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62e34c735a71d05879d661fc"
        },
        "name": "Increases Accuracy by 25%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-accuracy-by-25percent",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases Accuracy by 25%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Accuracy_Mid_Icon-4.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Accuracy_Mid_Icon-4.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Accuracy_Mid_Icon-4.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:51:38.444Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "SW",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Accuracy_Mid_Icon-4.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62e34d235a71d05879d66201"
        },
        "name": "Bubbly Bubble",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "bubbly-bubble",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy, dealing more damage according to your MAX HP and puts the target to sleep for 1 turn with a 30% chance. You will also fall asleep after attacking. Multiplier: 1.8*{ATK} + 0.12*{MAX HP}",
        "images": [
            "/assets/images/skills/skill1/Bubbly_Bubble_Fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Bubbly_Bubble_Fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62e34d665a71d05879d66204"
        },
        "name": "Sleep Talk",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "sleep-talk",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "You can use skills while sleeping. The damage is increased by 100% when attacking enemies on your turn while sleeping, and the damage is increased by 200% on the next turn when you wake up from sleep from taking damage. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill2/Sleep_Talk_Fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Sleep_Talk_Fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62e34dc55a71d05879d66207"
        },
        "name": "Night Night, Everyone",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "night-night,-everyone",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies to deal damage in proportion to your MAX HP and puts them to sleep for 2 turns. Puts yourself to sleep for 1 turn after attacking. (Reusable in 5 turns). Multiplier: 0.28*{MAX HP}",
        "images": [
            "/assets/images/skills/skill3/Night_Night_Fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Night_Night_Fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62e34f555a71d05879d6620b"
        },
        "name": "Birman",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "birman",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "images": [
            "/assets/images/monsters/hypnomeow/hypnomeow_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/hypnomeow/hypnomeow_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Water",
        "species": "Hypnomeow",
        "type": "Attack",
        "grade": "5",
        "leaderSkill": "Increases SPD by 15",
        "skill1": "Bubbly Bubble",
        "skill2": "Sleep Talk",
        "skill3": "Half Asleep",
        "skill4": "",
        "__v": 0,
        "image1": "/assets/images/monsters/hypnomeow/hypnomeow_water.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/monsters/hypnomeow/hypnomeow_water.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62e3504a5a71d05879d6620e"
        },
        "name": "Half Asleep",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "half-asleep",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "When you wake up from sleep from taking damage, recovers Attack Bar by 50% and recovers HP by 30% of the damage you deal to the enemy on the next turn. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Half_Asleep_Water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Half_Asleep_Water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "Passive",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62e3506e5a71d05879d66211"
        },
        "name": "Increases SPD by 15",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increases-spd-by-15",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Increases SPD by 15",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Speed_Low_Icon-4.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Attack_Speed_Low_Icon-4.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "type": "LeaderSkill",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/leaderskill/Leader_Skill_Attack_Speed_Low_Icon-4.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-07T09:50:42.801Z"
        },
        "modifiedBy": "Hung Nguyen",
        "species": "SW",
        "thumbImage1": "/assets/images/skills/leaderskill/Leader_Skill_Attack_Speed_Low_Icon-4.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62eb86e21d08cbc483ee84dc"
        },
        "name": "Nebelung",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "nebelung",
        "rate": 5,
        "price": 100,
        "quantity": 1,
        "description": "More Details",
        "images": [
            "/assets/images/monsters/hypnomeow/hypnomeow_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/hypnomeow/hypnomeow_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Wind",
        "species": "Hypnomeow",
        "type": "HP",
        "grade": "5",
        "leaderSkill": "Increase the HP of ally monsters by 25%",
        "skill1": "Bubbly Bubble",
        "skill2": "Foresight Dream",
        "skill3": "Dream Fairy",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62eb87521d08cbc483ee84e3"
        },
        "name": "Siamese",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "siamese",
        "rate": 5,
        "price": 100,
        "quantity": 1,
        "description": "More Details",
        "images": [
            "/assets/images/monsters/hypnomeow/hypnomeow_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/hypnomeow/hypnomeow_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Light",
        "species": "Hypnomeow",
        "type": "HP",
        "grade": "5",
        "leaderSkill": "Increase the HP of ally monsters by 25%",
        "skill1": "Bubbly Bubble",
        "skill2": "Foresight Dream",
        "skill3": "Eating Dream",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62eb87921d08cbc483ee84e7"
        },
        "name": "Bombay",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "bombay",
        "rate": 5,
        "price": 100,
        "quantity": 1,
        "description": "More Details",
        "images": [
            "/assets/images/monsters/hypnomeow/hypnomeow_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/hypnomeow/hypnomeow_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "species": "Hypnomeow",
        "type": "HP",
        "grade": "5",
        "leaderSkill": "Increase the HP of ally monsters in Guild Content by 44% ",
        "skill1": "Swift Slash",
        "skill2": "Guard Crush",
        "skill3": "Burst Shot",
        "__v": 0,
        "image1": "/assets/images/monsters/hypnomeow/hypnomeow_dark.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-08T04:40:14.717Z"
        },
        "modifiedBy": "Hung Nguyen",
        "thumbImage1": "/assets/images/monsters/hypnomeow/hypnomeow_dark.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62eb88071d08cbc483ee84ea"
        },
        "name": "Destiny",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "destiny",
        "rate": 5,
        "price": 100,
        "quantity": 1,
        "description": "More Details",
        "images": [
            "/assets/images/monsters/battleangel/battleangel_dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/battleangel/battleangel_dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Dark",
        "species": "Battle Angel",
        "type": "Attack",
        "grade": "5",
        "leaderSkill": "Increase the HP of ally monsters by 25%",
        "skill1": "Bubbly Bubble",
        "skill2": "Sleep Talk",
        "skill3": "Dream Invader",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62eb88811d08cbc483ee84ed"
        },
        "name": "Veronica",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "veronica",
        "rate": 5,
        "price": 100,
        "quantity": 1,
        "description": "More Details",
        "images": [
            "/assets/images/monsters/battleangel/battleangel_light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/battleangel/battleangel_light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Light",
        "species": "Battle Angel",
        "type": "Attack",
        "grade": "5",
        "leaderSkill": "Increase the Accuracy of ally monsters in Guild Content by 55%",
        "skill1": "Swift Slash",
        "skill2": "Ray Spears",
        "skill3": "EMP Shock",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62eb88b81d08cbc483ee84f0"
        },
        "name": "Sonia",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "sonia",
        "rate": 5,
        "price": 100,
        "quantity": 1,
        "description": "More Details",
        "images": [
            "/assets/images/monsters/battleangel/battleangel_wind.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/battleangel/battleangel_wind.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Wind",
        "species": "Battle Angel",
        "type": "Attack",
        "grade": "5",
        "leaderSkill": "Increase the Resistance of ally monsters in Guild Content by 55%",
        "skill1": "Swift Slash",
        "skill2": "Guard Crush",
        "skill3": "Evasion",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62eb88e01d08cbc483ee84f3"
        },
        "name": "Amber",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "amber",
        "rate": 5,
        "price": 100,
        "quantity": 1,
        "description": "More Details",
        "images": [
            "/assets/images/monsters/battleangel/battleangel_water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/battleangel/battleangel_water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Water",
        "species": "Battle Angel",
        "type": "Attack",
        "grade": "5",
        "leaderSkill": "Increase the Critical Rate of ally monsters in Guild Content by 33%",
        "skill1": "Swift Slash",
        "skill2": "Ray Spears",
        "skill3": "Nano Vision",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62eb890a1d08cbc483ee84f6"
        },
        "name": "Claire",
        "category": "summonerswar",
        "subCategory": "monsters",
        "slug": "claire",
        "rate": 5,
        "price": 100,
        "quantity": 1,
        "description": "More Details",
        "images": [
            "/assets/images/monsters/battleangel/battleangel_fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/monsters/battleangel/battleangel_fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Fire",
        "species": "Battle Angel",
        "type": "Attack",
        "grade": "5",
        "leaderSkill": "Increase the Attack Power of ally monsters in Guild Content by 44%",
        "skill1": "Swift Slash",
        "skill2": "Guard Crush",
        "skill3": "Jet Attack",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62eb8a201d08cbc483ee84fe"
        },
        "name": "Swift Slash",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "swift-slash",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy 2 times to decrease Attack Speed for 2 turns with a 30% chance each.\nMultiplier: 1",
        "images": [
            "/assets/images/skills/skill1/Swift_Slash_Fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Swift_Slash_Fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Battle Angel",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62eb8aa91d08cbc483ee8501"
        },
        "name": "Guard Crush",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "guard-crush",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy quickly and strongly. Ignores the enemy's Defense if the target's Defense is half or less than your Attack Power. (Reusable in 5 turns).\nMultiplier: 3.5*{ATK}",
        "images": [
            "/assets/images/skills/skill2/Guard_Crush_Fire.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Guard_Crush_Fire.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Battle Angel",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Guard_Crush_Fire.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-09-08T04:26:06.829Z"
        },
        "modifiedBy": "Hung Nguyen",
        "thumbImage1": "/assets/images/skills/skill2/Guard_Crush_Fire.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62eb8c541d08cbc483ee8523"
        },
        "name": "Ray Spears",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "ray-spears",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies 3 to 4 times. Each attack has a 50% chance to increase the chance of landing a Glancing Hit for 2 turns and to inflict Continuous Damage for 2 turns. The damage of this attack is proportionate to your Attack Speed. (Reusable in 5 turns).\nMultiplier: {ATK}*({SPD} + 150)/280",
        "images": [
            "/assets/images/skills/skill2/Ray_Spears_Water.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Ray_Spears_Water.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Battle Angel",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62eb8cc01d08cbc483ee8526"
        },
        "name": "Burst Shot",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "burst-shot",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy 5 times to decrease Defense for 3 turns and to grant Oblivion for 3 turns each. (Reusable in 5 turns).\nMultiplier: 1.7*{ATK}",
        "images": [
            "/assets/images/skills/skill3/Burst_Shot.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Burst_Shot.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Battle Angel",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Burst_Shot.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/skills/skill3/Burst_Shot.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62eb8ce41d08cbc483ee8529"
        },
        "name": "EMP Shock",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "emp-shock",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies to remove all beneficial effects and increases their cooldown by 2 turns each. (Reusable in 6 turns).\nMultiplier: 4.7*{ATK}",
        "images": [
            "/assets/images/skills/skill3/EMP_Shock.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/EMP_Shock.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Battle Angel",
        "type": "Active",
        "grade": "5",
        "__v": 0,
        "image1": "/assets/images/skills/skill3/EMP_Shock.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/skills/skill3/EMP_Shock.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62eb8d1e1d08cbc483ee852c"
        },
        "name": "Jet Attack",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "jet-attack",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy to decrease Defense for 3 turns. Increases your Attack Bar by 50% afterwards. (Reusable in 5 turns).\nMultiplier: 8.1*{ATK}",
        "images": [
            "/assets/images/skills/skill3/Jet_Attack.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Jet_Attack.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Battle Angel",
        "type": "Active",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62eb8d461d08cbc483ee852f"
        },
        "name": "Nano Vision",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "nano-vision",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "When attacked by an enemy, decreases damage taken by 5% per harmful effect on the enemy target. When attacking an enemy (boss excluded), deals additional damage by 2% of the target's MAX HP per harmful effect on the enemy target (up to 10%). [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Nano_Vision.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Nano_Vision.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Battle Angel",
        "type": "Passive",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62eb8d601d08cbc483ee8532"
        },
        "name": "Evasion",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "evasion",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "The faster you are than the enemy, the chance of receiving a Glancing Hit from the enemy increases by up to 50%. In addition, if the enemy's attack you receive lands as a Glancing Hit, you recover your Attack Bar by 30%. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Evasion.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Evasion.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Battle Angel",
        "type": "Passive",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62eb8dce1d08cbc483ee8539"
        },
        "name": "Dream Invader",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "dream-invader",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "When you attack the enemy on your turn, the enemy's Defense is ignored if both you and the enemy target are sleeping. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Dream_Invader.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Dream_Invader.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Hypnomeow",
        "type": "Passive",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62eb8e111d08cbc483ee853d"
        },
        "name": "Foresight Dream",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "foresight-dream",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "You can use skills while sleeping. Recovers HP of all allies by 20% each when you use a skill while sleeping. In addition, decreases HP of the enemy that wakes up from sleep due to taking damage or getting a turn by 10%. [Automatic Effect]\nMultiplier: 0.2*{MAX HP}",
        "images": [
            "/assets/images/skills/skill2/Foresight_Dream_Light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Foresight_Dream_Light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Hypnomeow",
        "type": "Passive",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62eb8e3f1d08cbc483ee8541"
        },
        "name": "Eating Dream",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "eating-dream",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Removes sleep from all allies, except yourself, if you get a turn while sleeping. In addition, recovers HP of the allies with sleep removed by 30% each. [Automatic Effect]\nMultiplier: 0.3*{Target MAX HP}",
        "images": [
            "/assets/images/skills/skill2/Eating_Dream_Light.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Eating_Dream_Light.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Hypnomeow",
        "type": "Passive",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62eb8f4f1d08cbc483ee8547"
        },
        "name": "Dream Fairy",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "dream-fairy",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy, dealing more damage according to your MAX HP and puts the target to sleep for 1 turn with a 30% chance. You will also fall asleep after attacking.\nMultiplier: 1.8*{ATK} + 0.12*{MAX HP}",
        "images": [
            "/assets/images/skills/skill3/Dream_Fairy.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Dream_Fairy.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Hypnomeow",
        "type": "Passive",
        "grade": "5",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62eb92f51d08cbc483ee8566"
        },
        "name": "Increase the HP of ally monsters by 25%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-hp-of-ally-monsters-by-25percent",
        "rate": 2,
        "price": 1,
        "quantity": 1,
        "description": "Increase the HP of ally monsters by 25%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Low_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Low_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Hypnomeow",
        "type": "LeaderSkill",
        "grade": "2",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62eb94de1d08cbc483ee8581"
        },
        "name": "Increase the HP of ally monsters in Guild Content by 44%",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "increase-the-hp-of-ally-monsters-in-guild-content-by-44percent",
        "rate": 4,
        "price": 1,
        "quantity": 1,
        "description": "Increase the HP of ally monsters in Guild Content by 44%",
        "images": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Mid_Guild_Battles_Icon.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/leaderskill/Leader_Skill_Health_Point_Mid_Guild_Battles_Icon.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Battle Angel",
        "type": "LeaderSkill",
        "grade": "3",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62eb98561d08cbc483ee85a7"
        },
        "name": "Overpower",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "overpower",
        "rate": 4,
        "price": 1,
        "quantity": 1,
        "description": "Deals damage to an enemy and with a 50% chance, decreases its Attack Bar by 30%.\nMultiplier: 380%",
        "images": [
            "/assets/images/skills/skill1/Overpower_Dark.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Overpower_Dark.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Horus",
        "type": "Active",
        "grade": "4",
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f0b6d2a31b4c3afd2206ad"
        },
        "name": "Absolute Zero",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "absolute-zero",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with a gust of freezing wind, dealing damage proportionate to your Defense and setting the Attack Bar to 0. Additionally, the enemies are frozen for 1 turn. (Reusable in 5 turns)\nMultiplier: 500%",
        "images": [
            "/assets/images/skills/skill3/Absolute_Zero.png",
            "/assets/images/skills/skill1/attack-bar-down.png",
            "/assets/images/skills/skill1/Status_Freeze.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Absolute_Zero.png",
            "/assets/images/skills/skill1/attack-bar-down.png"
        ],
        "element": "Skill",
        "species": "Dragon",
        "type": "Active",
        "grade": "4",
        "created": {
            "$date": "2022-08-08T07:10:10.817Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-08T07:10:10.823Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f0b8d9a31b4c3afd2206b1"
        },
        "name": "Fiery Breath",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "fiery-breath",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attack all enemies with a fiery breath and puts their skills on cool down. (Reusable in 6 turns)\nMultiplier: 490%",
        "images": [
            "/assets/images/skills/skill3/Fiery_Breath.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Fiery_Breath.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Skill",
        "species": "Dragon",
        "type": "Active",
        "grade": "5",
        "created": {
            "$date": "2022-08-08T07:18:49.486Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-08T07:18:49.488Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f0b940a31b4c3afd2206b5"
        },
        "name": "Rain of Fire",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "rain-of-fire",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Burns enemies with a fire shower 3 to 5 times, inflicting Continuous Damage for 3 turns with a 35% chance and increases the enemy's skill cooldown time by 1 turn with a 10% chance each. (Reusable in 4 turns).\nMultiplier: 80% x2~6",
        "images": [
            "/assets/images/skills/skill2/Rain_of_Fire.png",
            "/assets/images/skills/Continuous-Damage.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Rain_of_Fire.png",
            "/assets/images/skills/Continuous-Damage.png"
        ],
        "element": "Skill",
        "species": "Dragon",
        "type": "Active",
        "grade": "5",
        "created": {
            "$date": "2022-08-08T07:20:32.704Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-07T09:46:36.276Z"
        },
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Rain_of_Fire.png",
        "image2": "/assets/images/skills/Continuous-Damage.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/skills/skill2/Rain_of_Fire.png",
        "thumbImage2": "/assets/images/skills/Continuous-Damage.png"
    },
    {
        "_id": {
            "$oid": "62f0b982a31b4c3afd2206b8"
        },
        "name": "Snowstorm",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "snowstorm",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies with a storm of ice, dealing damage proportionate to your Defense and freezing them for 1 turn with a 60% chance. Increases the freezing effect up to 2 turns with a 60% chance if you attack the frozen enemy. (Reusable in 4 turns).\nMultiplier: 360%",
        "images": [
            "/assets/images/skills/skill2/Snowstorm.png",
            "/assets/images/skills/Status_Freeze.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Snowstorm.png",
            "/assets/images/skills/Status_Freeze.png"
        ],
        "element": "Skill",
        "species": "Dragon",
        "type": "Active",
        "grade": "5",
        "created": {
            "$date": "2022-08-08T07:21:38.648Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-07T09:45:59.005Z"
        },
        "__v": 0,
        "image1": "/assets/images/skills/skill2/Snowstorm.png",
        "image2": "/assets/images/skills/Status_Freeze.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/skills/skill2/Snowstorm.png",
        "thumbImage2": "/assets/images/skills/Status_Freeze.png"
    },
    {
        "_id": {
            "$oid": "62f1c9ad0934092b67c01e6e"
        },
        "name": "Phần của đường bộ đươc sử dụng cho các phương tiện giao thông qua lại là gì?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "phần-của-đường-bộ-đươc-sử-dụng-cho-các-phương-tiện-giao-thông-qua-lại-là-gì?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "{\"id\":\"Ev3iiMv5GABM\",\"type\":\"WarningOutlined\"}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Phần đường xe chạy",
        "skill1": "Phần mặt đường và lề đường",
        "skill2": "Phần đường xe chạy",
        "skill3": "Phần đường xe cơ giới",
        "created": {
            "$date": "2022-08-09T02:42:53.279Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T02:42:53.283Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1ca640934092b67c01e74"
        },
        "name": "“Làn đường” là gì?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "“làn-đường”-là-gì?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "“Làn đường” là gì?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Là một phần của phần đường xe chạy được chia theo chiều dọc của đường, có bề rộng đủ cho xe chạy an toàn",
        "skill1": "Là một phần của phần đường xe chạy được chai theo chiều dọc của đường, sử dụng cho xe chạy",
        "skill2": "Là một phần của phần đường xe chạy được chia theo chiều dọc của đường, có bề rộng đủ cho xe chạy an toàn",
        "skill3": "Là một phần của phần đường xe chạy được chia theo chiều dọc của đường, có đủ bề rộng cho xe ô tô chạy an toàn",
        "created": {
            "$date": "2022-08-09T02:45:56.713Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T02:45:56.714Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1cb330934092b67c01e7a"
        },
        "name": "Khái niệm “khổ giới hạn đường bộ” được hiểu như thế nào là đúng?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "khái-niệm-“khổ-giới-hạn-đường-bộ”-được-hiểu-như-thế-nào-là-đúng?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Khái niệm “khổ giới hạn đường bộ” được hiểu như thế nào là đúng?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Là khoảng trống có kích thước giới hạn về chiều cao, chiều rộng của đường, cầu, bến phà, hầm đường bộ để các xe kể cả hàng hóa xếp trên xe đi qua được an toàn",
        "skill1": "Là khoảng trống có kích thước giới hạn về chiều cao, chiều rộng của đường, cầu, bến phà, hầm đường bộ để các xe kể cả hàng hóa xếp trên xe đi qua được an toàn",
        "skill2": "Là khoảng trống có kích thước giới hạn về chiều rộng của đường, cầu, bến phà, hầm trên đường bộ để các xe kể cả hàng hóa xếp trên xe được đi qua an toàn",
        "skill3": "Là khoảng trống có kích thước giới hạn về chiều cao của đường, cầu, bến phà, hầm trên đường bộ để các xe được đi qua an toàn",
        "created": {
            "$date": "2022-08-09T02:49:23.581Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T02:49:23.585Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1cb9d0934092b67c01e84"
        },
        "name": "Trong các khái niệm dưới đây, “dải phân cách” được hiểu như thế nào là đúng?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "trong-các-khái-niệm-dưới-đây,-“dải-phân-cách”-được-hiểu-như-thế-nào-là-đúng?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Trong các khái niệm dưới đây, “dải phân cách” được hiểu như thế nào là đúng?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Là bộ phận của đường để phân chia mặt đường thành hai chiều xe chạy riêng biệt hoặc để phân chia phần đường của xe cơ giới và xe thô sơ.",
        "skill1": "Là bộ phận của đường để ngăn cách không cho các loại xe vào những nơi không được phép",
        "skill2": "Là bộ phận đươcng để phân tách phần đường xe chạy và hành lang an toàn giao thông.",
        "skill3": "Là bộ phận của đường để phân chia mặt đường thành hai chiều xe chạy riêng biệt hoặc để phân chia phần đường của xe cơ giới và xe thô sơ.",
        "created": {
            "$date": "2022-08-09T02:51:09.436Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T02:51:09.437Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1cbe40934092b67c01e8a"
        },
        "name": "“Dải phân cách” trên đường bộ gồm những loại nào?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "“dải-phân-cách”-trên-đường-bộ-gồm-những-loại-nào?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "“Dải phân cách” trên đường bộ gồm những loại nào?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Dải phân cách gồm loại cố định và loại di động",
        "skill1": "Dải phân cách gồm loại cố định và loại di động",
        "skill2": "Dải phân cách gồm tường chống ồn, hộ lan cứng và hộ lan mềm",
        "skill3": "Dải phân cách gồm giá long môn và biển báo hiệu đường bộ",
        "created": {
            "$date": "2022-08-09T02:52:20.433Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T02:52:20.437Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1cc0e0934092b67c01e8d"
        },
        "name": "Người lái xe được hiểu như thế nào trong các khái niệm dưới đây",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-lái-xe-được-hiểu-như-thế-nào-trong-các-khái-niệm-dưới-đây",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Người lái xe được hiểu như thế nào trong các khái niệm dưới đây",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Là người điều khiển xe cơ giới",
        "skill1": "Là người điều khiển xe cơ giới",
        "skill2": "Là người điều khiển xe thô sơ",
        "skill3": "Là người điều khiển xe có súc vật kéo",
        "created": {
            "$date": "2022-08-09T02:53:02.572Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T02:53:02.572Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1cc5a0934092b67c01e90"
        },
        "name": "Đường mà trên đó phương tiện tham gia giao thông được các phương tiện giao thông được các phương tiện giao thông đến từ hướng khác nhường đường khi qua nơi đường giao nhau, được cắm biển báo hiệu đường ưu tiên là loại đường gì?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "đường-mà-trên-đó-phương-tiện-tham-gia-giao-thông-được-các-phương-tiện-giao-thông-được-các-phương-tiện-giao-thông-đến-từ-hướng-khác-nhường-đường-khi-qua-nơi-đường-giao-nhau,-được-cắm-biển-báo-hiệu-đường-ưu-tiên-là-loại-đường-gì?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Đường mà trên đó phương tiện tham gia giao thông được các phương tiện giao thông được các phương tiện giao thông đến từ hướng khác nhường đường khi qua nơi đường giao nhau, được cắm biển báo hiệu đường ưu tiên là loại đường gì?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Đường ưu tiên",
        "skill1": "Đường không ưu tiên",
        "skill2": "Đường tỉnh lộ",
        "skill3": "Đường quốc lộ",
        "skill4": "Đường ưu tiên",
        "created": {
            "$date": "2022-08-09T02:54:18.613Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T02:54:18.614Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1cd710934092b67c01e96"
        },
        "name": "Khai niệm “phương tiện giao thông cơ giới đường bộ” được hiểu thế nào là đúng?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "khai-niệm-“phương-tiện-giao-thông-cơ-giới-đường-bộ”-được-hiểu-thế-nào-là-đúng?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Khai niệm “phương tiện giao thông cơ giới đường bộ” được hiểu thế nào là đúng?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Gồm xe ô tô; máy kéo; rơ moóc hoặc sơ mi rơ moóc được kéo bởi xe ô tô, máy kéo; xe mô tô hai bánh; xe mô tô ba bánh, xe gắn máy(kể cả xe máy điện) và các loại xe tương tự",
        "skill1": "Gồm ô tô, máy kéo, xe mô tô hai bánh, xe mô to ba bánh, xe gắn máy, xe cơ giới dùng cho người khuyết tật và xe máy chuyên dùng",
        "skill2": "Gồm xe ô tô; máy kéo; rơ moóc hoặc sơ mi rơ moóc được kéo bởi xe ô tô, máy kéo; xe mô tô hai bánh; xe mô tô ba bánh, xe gắn máy(kể cả xe máy điện) và các loại xe tương tự",
        "skill3": "",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T02:58:57.74Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T02:58:57.741Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1cd960934092b67c01e9a"
        },
        "name": "Khái niệm “phương tiện giao thông thô sơ đường bộ” được hiểu thế nào là đúng?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "khái-niệm-“phương-tiện-giao-thông-thô-sơ-đường-bộ”-được-hiểu-thế-nào-là-đúng?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Khái niệm “phương tiện giao thông thô sơ đường bộ” được hiểu thế nào là đúng?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Gồm xe đạp (kể cả xe đạp máy, xe đạp điện), xe xích lô, xe lăn dùng cho người khuyết tật, xe súc vật kéo và các loại xe tương tự",
        "skill1": "Gồm xe đạp (kể cả xe đạp máy, xe đạp điện), xe xích lô, xe lăn dùng cho người khuyết tật, xe súc vật kéo và các loại xe tương tự",
        "skill2": "Gồm xe đạp(kể cả xe đạp máy, xe đạp điện), xe gắn máy, xe cơ giới dùng cho người khuyết tật và xe máy chuyên dùng",
        "skill3": "Gồm xe ô tô, máy kéo, rơ moóc hoặc sơ mi rơ mo óc được kéo bơi xe ô tô, máy kéo",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T02:59:34.543Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T02:59:34.545Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1cdc90934092b67c01e9e"
        },
        "name": "“ Phương tiện tham gia giao thông đường bộ” gồm những loại nào?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "“-phương-tiện-tham-gia-giao-thông-đường-bộ”-gồm-những-loại-nào?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "“ Phương tiện tham gia giao thông đường bộ” gồm những loại nào?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "B2",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Cả ý 1 và 2",
        "skill1": "Phương tiện giao thông cơ giới đường bộ",
        "skill2": "Phương tiện giao thông thô sơ đường bộ và xe máy chuyên dùng",
        "skill3": "Cả ý 1 và 2",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T03:00:25.018Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-19T04:15:26.973Z"
        },
        "__v": 0,
        "image1": "/assets/images/products/clothes/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png"
    },
    {
        "_id": {
            "$oid": "62f1cdef0934092b67c01ea1"
        },
        "name": "“Người tham gia giao thông đường bộ” Gồm những đối tượng nào?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "“người-tham-gia-giao-thông-đường-bộ”-gồm-những-đối-tượng-nào?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "“Người tham gia giao thông đường bộ” Gồm những đối tượng nào?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Cả ý 1 và 2",
        "skill1": "Người điều khiển, người sử dụng phương tiện tham giao giao thông đường bộ",
        "skill2": "Người điều khiển, dẫn dắt súc vật, người đi bộ trên đường",
        "skill3": "Cả ý 1 và 2",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T03:01:03.107Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T03:01:03.107Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1ce0f0934092b67c01ea4"
        },
        "name": "“Người điều khiển phương tiện tham gia giao thông đường bộ” gồm những đối tượng nào dưới đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "“người-điều-khiển-phương-tiện-tham-gia-giao-thông-đường-bộ”-gồm-những-đối-tượng-nào-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "“Người điều khiển phương tiện tham gia giao thông đường bộ” gồm những đối tượng nào dưới đây?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Cả ý 1 và 2",
        "skill1": "Người điều khiển xe cơ giới, người điều khiển xe thô sơ",
        "skill2": "Người điều khiển xe máy chuyên dùng thao gia giao thông đường bộ",
        "skill3": "Cả ý 1 và 2",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T03:01:35.296Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T03:01:35.297Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1ce2e0934092b67c01ea7"
        },
        "name": "Khai niệm “người điều khiển giao thông” được hiểu như thế nào đúng?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "khai-niệm-“người-điều-khiển-giao-thông”-được-hiểu-như-thế-nào-đúng?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Khai niệm “người điều khiển giao thông” được hiểu như thế nào đúng?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Là cảnh sát giao thông, người được giao nhiệm vụ hướng dẫn giao thông tại nơi thi công, nơi ùn tắc giao thông, ở bến phà, tại cầu đường bộ đi chung với đường sắt",
        "skill1": "Là người điều khiển phương tiện tham gia giao thông tại nơi thi công, nơi ùn tắc giao thông, ở bến phà, tại cầu đường bộ đi chung với đường sắt",
        "skill2": "Là cảnh sát giao thông, người được giao nhiệm vụ hướng dẫn giao thông tại nơi thi công, nơi ùn tắc giao thông, ở bến phà, tại cầu đường bộ đi chung với đường sắt",
        "skill3": "Là người tham gia giao thông tại nơi thi công, nơi ùn tắt giao thông, ở bến phà, tại cầu đường bộ đi chung với đường sắt",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T03:02:06.202Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T03:02:06.203Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1ce7e0934092b67c01eaa"
        },
        "name": "Trong các khái niệm dưới đây khái niệm “dừng xe” được hiểu như thế nào là đúng?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "trong-các-khái-niệm-dưới-đây-khái-niệm-“dừng-xe”-được-hiểu-như-thế-nào-là-đúng?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Trong các khái niệm dưới đây khái niệm “dừng xe” được hiểu như thế nào là đúng?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Là trạng thai đứng yên tạm thời của phương tiện giao thông trong một khoảng thời gian cần đủ để cho người lên, xuống phương tiện, xếp dỡ hàng hóa hoặc thực hiện công việc",
        "skill1": "Là trạng thái đừng yên của phương tiện giao thông không giới hạn thời gian để cho người lên xuống phương tiện, xếp dỡ hàng hóa hoặc thực hiện công việc khác",
        "skill2": "Là trạng thai đứng yên tạm thời của phương tiện giao thông trong một khoảng thời gian cần đủ để cho người lên, xuống phương tiện, xếp dỡ hàng hóa hoặc thực hiện công việc",
        "skill3": "Là trạng thái đứng yên của phương tiện giao thông không giới hạn thời gian giữa 02 lần vận chuyển hàng hóa hoặc hành khách",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T03:03:26.622Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T03:03:26.623Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1ce9c0934092b67c01ead"
        },
        "name": "Khái niệm “đỗ xe” được hiểu như thế nào là đúng quy tắc giao thông?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "khái-niệm-“đỗ-xe”-được-hiểu-như-thế-nào-là-đúng-quy-tắc-giao-thông?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Khái niệm “đỗ xe” được hiểu như thế nào là đúng quy tắc giao thông?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Là trạng thái đứng yên của phương tiện giao thông không giới hạn thời gian",
        "skill1": "Là trạng thái đứng yên của phương tiện giao thông có giới hạn trong một khoảng thời gian cần thiết đủ để cho người lên, xuống phương tiện đó, xếp dỡ hàng hóa hoặc thực hiện công việc khác",
        "skill2": "Là trạng thái đứng yên của phương tiện giao thông không giới hạn thời gian",
        "skill3": "",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T03:03:56.719Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T03:03:56.72Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1d33c0934092b67c01eb1"
        },
        "name": "Khái niệm “đường cao tốc” được hiểu như thế nào là đúng?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "khái-niệm-“đường-cao-tốc”-được-hiểu-như-thế-nào-là-đúng?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Khái niệm “đường cao tốc” được hiểu như thế nào là đúng?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Tất cả các ý trên",
        "skill1": "Đường dành riêng cho xe ô tô và một số loại xe chuyên dùng được phép đi vào theo quy đinh của luật giao thông đường bộ",
        "skill2": "Có dải phân cách phân chia đường cho xe chạy hai chiều riêng biệt mà dải phân cách này xe không được đi lên trên; không giao nhau cùng mức với một hoặc một số đường khác",
        "skill3": "Đường bố trí đầy đủ trang thiết bị phục vụ, bảo đảo giao thông liên tục, an toàn, rút ngắn thời gian hành trình và chỉ cho xe ra, vào ở những điểm nhất định",
        "skill4": "Tất cả các ý trên",
        "created": {
            "$date": "2022-08-09T03:23:40.715Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T03:23:40.715Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1d3940934092b67c01eb5"
        },
        "name": "Hành vi nào dưới đây bị nghiêm cấm?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "hành-vi-nào-dưới-đây-bị-nghiêm-cấm?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Hành vi nào dưới đây bị nghiêm cấm?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Làm hỏng (cố ý) cọc tiêu, giương cầu, dải phân cách",
        "skill1": "Đỗ xe trên đường phố",
        "skill2": "Sử dụng xe đạp đi trên các tuyến quốc lộ có tốc độ cao",
        "skill3": "Làm hỏng (cố ý) cọc tiêu, giương cầu, dải phân cách",
        "skill4": "Sử dụng còi và quay đầu xe trong khu dân cư",
        "created": {
            "$date": "2022-08-09T03:25:08.522Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T03:25:08.523Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1d42f0934092b67c01eba"
        },
        "name": "Cuộc đua xe chỉ được thực hiện khi nào?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "cuộc-đua-xe-chỉ-được-thực-hiện-khi-nào?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Cuộc đua xe chỉ được thực hiện khi nào?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Được cơ quan có thẩm quyền cấp phép",
        "skill1": "Diễn ra trên đường phố không có người qua lại",
        "skill2": "Được người dân ủng hộ",
        "skill3": "Được cơ quan có thẩm quyền cấp phép",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T03:27:43.869Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T03:27:43.87Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1d4890934092b67c01ec4"
        },
        "name": "Hành vi đưa xe cơ giới, xe máy chuyên dùng không bảo đảm tiêu chuẩn an toàn kỹ thuật và bảo vệ môi trường vào tham gia giao thông đường bộ có bị nghiêm cấm hay không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "hành-vi-đưa-xe-cơ-giới,-xe-máy-chuyên-dùng-không-bảo-đảm-tiêu-chuẩn-an-toàn-kỹ-thuật-và-bảo-vệ-môi-trường-vào-tham-gia-giao-thông-đường-bộ-có-bị-nghiêm-cấm-hay-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Hành vi đưa xe cơ giới, xe máy chuyên dùng không bảo đảm tiêu chuẩn an toàn kỹ thuật và bảo vệ môi trường vào tham gia giao thông đường bộ có bị nghiêm cấm hay không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Bị nghiêm cấm",
        "skill1": "Không bị nghiêm cấm",
        "skill2": "Bị nghiêm cấm",
        "skill3": "Bị nghiêm cấm tùy theo các tuyến đường",
        "skill4": "Bị nghiêm cấm tùy theo loại xe",
        "created": {
            "$date": "2022-08-09T03:29:13.547Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T03:29:13.548Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1db660934092b67c01ec7"
        },
        "name": "Người điều khiển phương tiện giao thông đường bộ mà trong cơ thể có chất ma túy có bị nghiêm cấm hay không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-điều-khiển-phương-tiện-giao-thông-đường-bộ-mà-trong-cơ-thể-có-chất-ma-túy-có-bị-nghiêm-cấm-hay-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Người điều khiển phương tiện giao thông đường bộ mà trong cơ thể có chất ma túy có bị nghiêm cấm hay không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Bị nghiêm cấm",
        "skill1": "Bị nghiêm cấm",
        "skill2": "Không bị nghiêm cấm",
        "skill3": "Không bị nghiêm cấm, nếu có chất ma túy ở mức nhẹ, có thể điều khiển phương tiện tham gia giao thông",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T03:58:30.168Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T03:58:30.168Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1e4774f03181831c0ea29"
        },
        "name": "Việc lái xe mô tô, ô tô, máy kéo ngay sai khi uống rượu, bia có được phép không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "việc-lái-xe-mô-tô,-ô-tô,-máy-kéo-ngay-sai-khi-uống-rượu,-bia-có-được-phép-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Việc lái xe mô tô, ô tô, máy kéo ngay sai khi uống rượu, bia có được phép không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Không được phép",
        "skill1": "Không được phép",
        "skill2": "Chỉ được lái ở tốc độ chậm và quãng đường ngắn",
        "skill3": "Chỉ được lái nếu trong cơ thể có nồng độ cồn thấp",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T04:37:11.377Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T04:37:11.383Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1e4ae4f03181831c0ea2c"
        },
        "name": "Người điều khiển ô tô, mô tô, máy kéo trên đường mà trong máu hoặc hơi thở có nồng độ cồn có bị nghiêm cấm không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-điều-khiển-ô-tô,-mô-tô,-máy-kéo-trên-đường-mà-trong-máu-hoặc-hơi-thở-có-nồng-độ-cồn-có-bị-nghiêm-cấm-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Người điều khiển ô tô, mô tô, máy kéo trên đường mà trong máu hoặc hơi thở có nồng độ cồn có bị nghiêm cấm không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Bị nghiêm cấm",
        "skill1": "Bị nghiêm cấm",
        "skill2": "Không bị nghiêm cấm",
        "skill3": "Không bị nghiêm cấm nếu nồng độ cồn trong máu ở mức nhẹ có thể điều khiển được phương tiện giao thông",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T04:38:06.872Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T04:38:06.874Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1f9d21703873d770b0d16"
        },
        "name": "Sử dụng rượu, bia khi lái xe, nếu bị phát hiện thì bị xử lý như thế nào",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "sử-dụng-rượu,-bia-khi-lái-xe,-nếu-bị-phát-hiện-thì-bị-xử-lý-như-thế-nào",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Sử dụng rượu, bia khi lái xe, nếu bị phát hiện thì bị xử lý như thế nào",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Bị xử phạt hành chính hoặc có thể bị xử lý hình sự tùy theo mức độ vi phạm",
        "skill1": "Chỉ bị nhắc nhở",
        "skill2": "Bị xử phạt hành chính hoặc có thể bị xử lý hình sự tùy theo mức độ vi phạm",
        "skill3": "Không bị xử lý hình sự",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T06:08:18.681Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T06:08:18.684Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1fa061703873d770b0d19"
        },
        "name": "Theo luật phòng chống tác hại của rượu, bia, đối tượng nào dưới đây bị cấm sử dụng rượu bia khi tham gia giao thông?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "theo-luật-phòng-chống-tác-hại-của-rượu,-bia,-đối-tượng-nào-dưới-đây-bị-cấm-sử-dụng-rượu-bia-khi-tham-gia-giao-thông?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Theo luật phòng chống tác hại của rượu, bia, đối tượng nào dưới đây bị cấm sử dụng rượu bia khi tham gia giao thông?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Người điều khiển: Xe ô tô, Xe mô tô, xe đạp, xe gắn máy",
        "skill1": "Người điều khiển: Xe ô tô, Xe mô tô, xe đạp, xe gắn máy",
        "skill2": "Người ngồi phía sau người điều khiển xe cơ giới",
        "skill3": "Người đi bộ",
        "skill4": "Cả ý 1 và ý 2",
        "created": {
            "$date": "2022-08-09T06:09:10.206Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T06:09:10.208Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1fc1d1703873d770b0d1c"
        },
        "name": "Hành vi xe cơ giới, xe máy chuyên dùng cho người không đủ điều kiện để điều khiển xe tham gia giao thông có được phép hay không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "hành-vi-xe-cơ-giới,-xe-máy-chuyên-dùng-cho-người-không-đủ-điều-kiện-để-điều-khiển-xe-tham-gia-giao-thông-có-được-phép-hay-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Hành vi xe cơ giới, xe máy chuyên dùng cho người không đủ điều kiện để điều khiển xe tham gia giao thông có được phép hay không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Không được phép",
        "skill1": "Chỉ được thực hiện nếu đã hướng dẫn đầy đủ",
        "skill2": "Không được phép",
        "skill3": "Được phép tùy từng trường hợp",
        "skill4": "Chỉ được phép thực hiện với thành viên trong gia đình",
        "created": {
            "$date": "2022-08-09T06:18:05.704Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T06:18:05.705Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1fc5c1703873d770b0d1f"
        },
        "name": "Hành vi điều khiển xe cơ giới chạy quá tốc độ quy định, giành đường, vượt ẩu có nghiêm cấm hay không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "hành-vi-điều-khiển-xe-cơ-giới-chạy-quá-tốc-độ-quy-định,-giành-đường,-vượt-ẩu-có-nghiêm-cấm-hay-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Hành vi điều khiển xe cơ giới chạy quá tốc độ quy định, giành đường, vượt ẩu có nghiêm cấm hay không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Bị nghiêm cấm",
        "skill1": "Bị nghiêm cấm tùy từng trường hợp",
        "skill2": "Không bị nghiêm cấm",
        "skill3": "Bị nghiêm cấm",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T06:19:08.393Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T06:19:08.393Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f1fc851703873d770b0d22"
        },
        "name": "Khi lái xe trên đường, người lái xe cần quan sát và bảo đảm tốc độ phương tiện như thé nào?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "khi-lái-xe-trên-đường,-người-lái-xe-cần-quan-sát-và-bảo-đảm-tốc-độ-phương-tiện-như-thé-nào?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Khi lái xe trên đường, người lái xe cần quan sát và bảo đảm tốc độ phương tiện như thé nào?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Không vượt quá tốc độ cho phép",
        "skill1": "Chỉ lớn hơn tốc độ tối đa cho phép khi đường vắng",
        "skill2": "Chỉ lớn hơn tốc độ tối đa cho phép vào ban đâm",
        "skill3": "Không vượt quá tốc độ cho phép",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T06:19:49.274Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T06:19:49.274Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f2149762e47ca4da10a50d"
        },
        "name": "Phương tiện giao thông đường bộ di chuyển với tốc độ thấp hơn phải đi như thế nào?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "phương-tiện-giao-thông-đường-bộ-di-chuyển-với-tốc-độ-thấp-hơn-phải-đi-như-thế-nào?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Phương tiện giao thông đường bộ di chuyển với tốc độ thấp hơn phải đi như thế nào?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Đi về phía bên phải",
        "skill1": "Đi về phía bên trái",
        "skill2": "Đi về phía bên phải",
        "skill3": "Đi ở giữa",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T08:02:31.274Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T08:02:31.278Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f214c562e47ca4da10a510"
        },
        "name": "Trên đường có nhiều làn đường, khi điều khiển phương tiện ở tốc độ chậm bạn phải đi ở làn đường nào?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "trên-đường-có-nhiều-làn-đường,-khi-điều-khiển-phương-tiện-ở-tốc-độ-chậm-bạn-phải-đi-ở-làn-đường-nào?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Trên đường có nhiều làn đường, khi điều khiển phương tiện ở tốc độ chậm bạn phải đi ở làn đường nào?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Đi ở làn đường phải trong cùng",
        "skill1": "Đi ở làn đường phải trong cùng",
        "skill2": "Đi ở làn phái bên trái",
        "skill3": "Đi ở làn giữa",
        "skill4": "Đi ở bất cứ làn nào nhưng phải bấm đèn cảnh báo nguy hiểm để báo hiệu cho các phương tiện khác",
        "created": {
            "$date": "2022-08-09T08:03:17.484Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T08:03:17.486Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f214e862e47ca4da10a513"
        },
        "name": "Hành vi vượt xe tại các vị trí có tầm nhìn hạn chế, đường vòng, đầu dóc có bị nghiêm cấm hay không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "hành-vi-vượt-xe-tại-các-vị-trí-có-tầm-nhìn-hạn-chế,-đường-vòng,-đầu-dóc-có-bị-nghiêm-cấm-hay-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Hành vi vượt xe tại các vị trí có tầm nhìn hạn chế, đường vòng, đầu dóc có bị nghiêm cấm hay không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Bị nghiêm cấm",
        "skill1": "Không bị nghiêm cấm",
        "skill2": "Không bị nghiêm cấm khi rất vội",
        "skill3": "Bị nghiêm cấm",
        "skill4": "Không bị nghiêm cấm khi khẩn cẩn",
        "created": {
            "$date": "2022-08-09T08:03:52.855Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T08:03:52.856Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f215aa62e47ca4da10a516"
        },
        "name": "Khi lái xe trong khu đô thị và đông dân cư trừ các khu vực có biển cấm sử dụng còi, người lái xe được sử dụng còi như thế nào trong các trường hợp dưới đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "khi-lái-xe-trong-khu-đô-thị-và-đông-dân-cư-trừ-các-khu-vực-có-biển-cấm-sử-dụng-còi,-người-lái-xe-được-sử-dụng-còi-như-thế-nào-trong-các-trường-hợp-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Khi lái xe trong khu đô thị và đông dân cư trừ các khu vực có biển cấm sử dụng còi, người lái xe được sử dụng còi như thế nào trong các trường hợp dưới đây?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Từ 5 giờ sáng đến 22 giờ",
        "skill1": "Từ 22 giờ đén 5 giờ sáng",
        "skill2": "Từ 5 giờ sáng đến 22 giờ",
        "skill3": "Từ 23 giờ đêm đến 5 giờ sáng hôm sau",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T08:07:06.844Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T08:07:06.845Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f215d262e47ca4da10a519"
        },
        "name": "Người lái xe sử dụng đèn như thế nào khi lái xe trong khu đô thị và đông dân cư vào ban đêm?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-lái-xe-sử-dụng-đèn-như-thế-nào-khi-lái-xe-trong-khu-đô-thị-và-đông-dân-cư-vào-ban-đêm?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Người lái xe sử dụng đèn như thế nào khi lái xe trong khu đô thị và đông dân cư vào ban đêm?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Đèn chiếu gần (đèn cốt)",
        "skill1": "Bất cứ đèn nào miễn là mắt nhìn rõ phía trước",
        "skill2": "Chỉ bật đèn chiếu xa (đèn pha) khi không nhìn rõ đường",
        "skill3": "Đèn chiếu xa (đèn pha) khi đường vắng, đèn chiếu pha gần (đèn cốt) khi có xe đi ngược chiều",
        "skill4": "Đèn chiếu gần (đèn cốt)",
        "created": {
            "$date": "2022-08-09T08:07:46.187Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T08:07:46.188Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f2161c62e47ca4da10a51c"
        },
        "name": "Hành vi lắp đặt, sử dụng còi, đèn không đúng thiết kế của nhà sản xuất đối với từng loại xe cơ giới có được phép hay không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "hành-vi-lắp-đặt,-sử-dụng-còi,-đèn-không-đúng-thiết-kế-của-nhà-sản-xuất-đối-với-từng-loại-xe-cơ-giới-có-được-phép-hay-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Hành vi lắp đặt, sử dụng còi, đèn không đúng thiết kế của nhà sản xuất đối với từng loại xe cơ giới có được phép hay không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Không được phép",
        "skill1": "Được phép",
        "skill2": "Không được phép",
        "skill3": "Được phép tùy theo trường hợp",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T08:09:00.582Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T08:09:00.582Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f2163d62e47ca4da10a51f"
        },
        "name": "Trong trường hợp đặc biết, để được lắp đặt, sử dụng còi, đèn khác thiết kế của nhà sản xuất đối với từng loại xe cơ giới bạn phải đảm bảo yêu cầu nào dưới đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "trong-trường-hợp-đặc-biết,-để-được-lắp-đặt,-sử-dụng-còi,-đèn-khác-thiết-kế-của-nhà-sản-xuất-đối-với-từng-loại-xe-cơ-giới-bạn-phải-đảm-bảo-yêu-cầu-nào-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Trong trường hợp đặc biết, để được lắp đặt, sử dụng còi, đèn khác thiết kế của nhà sản xuất đối với từng loại xe cơ giới bạn phải đảm bảo yêu cầu nào dưới đây?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Phải được chấp thuận của cơ quan có thẩm quyền",
        "skill1": "Phải đảm bảo phụ tùng do đúng nhà sản xuất đó cung cấp",
        "skill2": "Phải được chấp thuận của cơ quan có thẩm quyền",
        "skill3": "Phải là xe đăng ký và hoạt động tại các khu vực có địa hình phức tạp",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T08:09:33.178Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T08:09:33.178Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f21e7d62e47ca4da10a523"
        },
        "name": "Việc sản xuất, mau bán, sử dụng biển số xe cơ giới, xe máy chuyên dùng được quy định như thế nào trong Luật Giao thông đường bộ?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "việc-sản-xuất,-mau-bán,-sử-dụng-biển-số-xe-cơ-giới,-xe-máy-chuyên-dùng-được-quy-định-như-thế-nào-trong-luật-giao-thông-đường-bộ?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Việc sản xuất, mau bán, sử dụng biển số xe cơ giới, xe máy chuyên dùng được quy định như thế nào trong Luật Giao thông đường bộ?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Nghiêm cấm sản xuất, mua bán sử dụng trái phép",
        "skill1": "Được phép sản xuất, sử dụng khi bị mất biển số",
        "skill2": "Được phép mua bán, sử dụng khi bị mất biển số",
        "skill3": "Nghiêm cấm sản xuất, mua bán sử dụng trái phép",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T08:44:45.784Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T08:44:45.784Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f228a862e47ca4da10a527"
        },
        "name": "Người lái xe không được vượt xe khác khi gặp trường hợp nào ghi ở dưới đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-lái-xe-không-được-vượt-xe-khác-khi-gặp-trường-hợp-nào-ghi-ở-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Người lái xe không được vượt xe khác khi gặp trường hợp nào ghi ở dưới đây?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Trên cầu hẹp có một làn xe. Nơi đường giao nhau, đường bộ giao nhau cùng mức với đường sắt; xe được quyền ưu tiên đang phát tín hiệu ưu tiên đi làm nhiệm vụ",
        "skill1": "Trên cầu hẹp có một làn xe. Nơi đường giao nhau, đường bộ giao nhau cùng mức với đường sắt; xe được quyền ưu tiên đang phát tín hiệu ưu tiên đi làm nhiệm vụ",
        "skill2": "Trên cầu có từ 02 làn xe trở lên; nơi đường bộ giao nhau không cùng mức với đường sắt; xe được quyền ưu tiên đang đi phía trước nhưng không phát tín hiệu ưu tiên",
        "skill3": "Trên đường có 2 làn đường được phân chia làn bằng vạch kẻ nét đứt",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T09:28:08.754Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T09:28:08.755Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f228be62e47ca4da10a52a"
        },
        "name": "Ở phần đường dành cho người đi bộ qua đường, trên cầu, đầu cầu, đường cao tốc, đường hẹp, đường dốc, tại nơi đường bộ giao nhau cùng mức với đường sắt có được quay đầu xe hay không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "ở-phần-đường-dành-cho-người-đi-bộ-qua-đường,-trên-cầu,-đầu-cầu,-đường-cao-tốc,-đường-hẹp,-đường-dốc,-tại-nơi-đường-bộ-giao-nhau-cùng-mức-với-đường-sắt-có-được-quay-đầu-xe-hay-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Ở phần đường dành cho người đi bộ qua đường, trên cầu, đầu cầu, đường cao tốc, đường hẹp, đường dốc, tại nơi đường bộ giao nhau cùng mức với đường sắt có được quay đầu xe hay không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Không được phép",
        "skill1": "Được phép",
        "skill2": "Không được phép",
        "skill3": "Tùy từng trường hợp",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T09:28:30.604Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T09:28:30.605Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f228dc62e47ca4da10a52d"
        },
        "name": "Bạn đang lái xe phía trước có một xe cảnh sát giao thông không phát tín hiệu ưu tiên bạn có được phép vượt hay không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "bạn-đang-lái-xe-phía-trước-có-một-xe-cảnh-sát-giao-thông-không-phát-tín-hiệu-ưu-tiên-bạn-có-được-phép-vượt-hay-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Bạn đang lái xe phía trước có một xe cảnh sát giao thông không phát tín hiệu ưu tiên bạn có được phép vượt hay không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Được vượt khi đảm bảo an toàn",
        "skill1": "Không được phép",
        "skill2": "Được vượt khi đang trên cầu",
        "skill3": "Được phép vượt khi qua nơi giao nhau có ít phương tiện cùng tham gia giao thông",
        "skill4": "Được vượt khi đảm bảo an toàn",
        "created": {
            "$date": "2022-08-09T09:29:00.709Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T09:29:00.71Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f2290362e47ca4da10a530"
        },
        "name": "Bạn đang lái xe phía trước có một xe cứu thương đang phát tín hiệu ưu tiên có được phép vượt hay không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "bạn-đang-lái-xe-phía-trước-có-một-xe-cứu-thương-đang-phát-tín-hiệu-ưu-tiên-có-được-phép-vượt-hay-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Bạn đang lái xe phía trước có một xe cứu thương đang phát tín hiệu ưu tiên có được phép vượt hay không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Không được vượt",
        "skill1": "Không được vượt",
        "skill2": "Được vượt khi đang trên cầu",
        "skill3": "Được phép vượt khi qua nơi giao nhau có ít phương tiện cùng tham gia giao thông",
        "skill4": "Được vượt khi đảm bảo an toàn",
        "created": {
            "$date": "2022-08-09T09:29:39.945Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T09:29:39.946Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f2292162e47ca4da10a533"
        },
        "name": "Người lái xe không được quay đầu xe trong các trường hợp nào dưới đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-lái-xe-không-được-quay-đầu-xe-trong-các-trường-hợp-nào-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Người lái xe không được quay đầu xe trong các trường hợp nào dưới đây?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Ở phần đường dành cho người đi bọ qua đường, trên cầu, đầu cầu, đường cao tốc, đường hẹp, đường dốc, tại nơi đường bộ giao nhau cùng mức với đường sắt",
        "skill1": "Ở phần đường dành cho người đi bọ qua đường, trên cầu, đầu cầu, đường cao tốc, đường hẹp, đường dốc, tại nơi đường bộ giao nhau cùng mức với đường sắt",
        "skill2": "Ở phía trước hoặc phía sau của phần đường dành cho người đi bộ qua đường, trên đường quốc lộ, tại nơi đường bộ giao giao nhau không cùng mức với đường sắt",
        "skill3": "Cả ý 1 và ý 2",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T09:30:09.32Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T09:30:09.32Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f2294062e47ca4da10a536"
        },
        "name": "Bạn đang lái xe trong khu dân cư, có đông xe qua lại, nếu muốn quay đầu xe bạn cần làm gì để tránh lại, nếu muốn quay đầu xe bạn cần làm gì để tránh ùn tắc và đảm bảo an toàn giao thông?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "bạn-đang-lái-xe-trong-khu-dân-cư,-có-đông-xe-qua-lại,-nếu-muốn-quay-đầu-xe-bạn-cần-làm-gì-để-tránh-lại,-nếu-muốn-quay-đầu-xe-bạn-cần-làm-gì-để-tránh-ùn-tắc-và-đảm-bảo-an-toàn-giao-thông?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Bạn đang lái xe trong khu dân cư, có đông xe qua lại, nếu muốn quay đầu xe bạn cần làm gì để tránh lại, nếu muốn quay đầu xe bạn cần làm gì để tránh ùn tắc và đảm bảo an toàn giao thông?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Đi tiếp đến điểm giao cắt gần nhất hoặc nơi có biển báo cho phép quay đầu xe",
        "skill1": "Đi tiếp đến điểm giao cắt gần nhất hoặc nơi có biển báo cho phép quay đầu xe",
        "skill2": "Bấm đèn khẩn cấp và quay đầu xe từ từ bảo đảm an toàn",
        "skill3": "Bấm còi liên tục khi quay đầu xe để cảnh báo các xe khác",
        "skill4": "Nhờ một người ra hiệu giao thông trên đường Chậm lại trước khi quay đầu xe",
        "created": {
            "$date": "2022-08-09T09:30:40.16Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T09:30:40.161Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f2295e62e47ca4da10a539"
        },
        "name": "Người lái xe không được lùi xe ở những khu vực nào dưới đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-lái-xe-không-được-lùi-xe-ở-những-khu-vực-nào-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Người lái xe không được lùi xe ở những khu vực nào dưới đây?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Cả ý 2 và ý 3",
        "skill1": "Ở khu vực cho phép đỗ xe",
        "skill2": "Ở khu vực cấm dừng và trên phần đường dành cho người đi bộ qua đường",
        "skill3": "Nơi đường bộ giao nhau, đường bộ giao nhau cùng mức với đường sắt, nơi tầm nhìn bị che khuất, trong hầm đường bộ, đường cao tốc",
        "skill4": "Cả ý 2 và ý 3",
        "created": {
            "$date": "2022-08-09T09:31:10.668Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T09:31:10.669Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f2297862e47ca4da10a53c"
        },
        "name": "Người điều khiển phương tiện giao thông trên đường phố có được dừng xe, đỗ xe trên miệng cống thoát nước, miệng hầm của đường điện thoại, điện cao thế, chỗ dành riêng cho xe chữa cháy lấy nước hay không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-điều-khiển-phương-tiện-giao-thông-trên-đường-phố-có-được-dừng-xe,-đỗ-xe-trên-miệng-cống-thoát-nước,-miệng-hầm-của-đường-điện-thoại,-điện-cao-thế,-chỗ-dành-riêng-cho-xe-chữa-cháy-lấy-nước-hay-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Người điều khiển phương tiện giao thông trên đường phố có được dừng xe, đỗ xe trên miệng cống thoát nước, miệng hầm của đường điện thoại, điện cao thế, chỗ dành riêng cho xe chữa cháy lấy nước hay không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Không được dừng xe, đỗ xe",
        "skill1": "Đường dừng xe, đỗ xe trong trường hợp cần thiết",
        "skill2": "Không được dừng xe, đỗ xe",
        "skill3": "Được dừng xe, không được đỗ xe",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T09:31:36.328Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T09:31:36.329Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f2299862e47ca4da10a53f"
        },
        "name": "Khi xe đã kéo 1 xe hoặc xe đã kéo 1 rơ moóc, bạn có được phép kéo thêm xe (kể cả xe thô sơ) hoặc rơ moóc thứ hai hay không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "khi-xe-đã-kéo-1-xe-hoặc-xe-đã-kéo-1-rơ-moóc,-bạn-có-được-phép-kéo-thêm-xe-(kể-cả-xe-thô-sơ)-hoặc-rơ-moóc-thứ-hai-hay-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Khi xe đã kéo 1 xe hoặc xe đã kéo 1 rơ moóc, bạn có được phép kéo thêm xe (kể cả xe thô sơ) hoặc rơ moóc thứ hai hay không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Không được phép",
        "skill1": "Chỉ được thực hiện trên đường quốc lộ có hai làn xe một chiều",
        "skill2": "Chỉ được thực hiện trên đường cao tốc",
        "skill3": " Không được thực hiện ban ngày",
        "skill4": "Không được phép",
        "created": {
            "$date": "2022-08-09T09:32:08.067Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T09:32:08.067Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f229b462e47ca4da10a542"
        },
        "name": "Người điều khiển xe mô tô hai bánh, ba bánh, xe gắn máy có được phép sử dụng xe để kéo hoặc đẩy các phương tiện khác khi tham gia giao thông không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-điều-khiển-xe-mô-tô-hai-bánh,-ba-bánh,-xe-gắn-máy-có-được-phép-sử-dụng-xe-để-kéo-hoặc-đẩy-các-phương-tiện-khác-khi-tham-gia-giao-thông-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Người điều khiển xe mô tô hai bánh, ba bánh, xe gắn máy có được phép sử dụng xe để kéo hoặc đẩy các phương tiện khác khi tham gia giao thông không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Không được phép",
        "skill1": "Được phép",
        "skill2": "Nếu phương tiện được kéo, đẩy có khối lượng nhỏ hơn phương tiện của mình",
        "skill3": "Tùy trường hợp",
        "skill4": "Không được phép",
        "created": {
            "$date": "2022-08-09T09:32:36.109Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T09:32:36.11Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f229ca62e47ca4da10a545"
        },
        "name": "Khi điều khiển xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy, những hành vi buông cả hai tay; sử dụng xe để kéo, đẩy xe khác, vật khác; sử dụng chân chống của xe quệt xuống đường khi xe đang chạy có được phép không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "khi-điều-khiển-xe-mô-tô-hai-bánh,-xe-mô-tô-ba-bánh,-xe-gắn-máy,-những-hành-vi-buông-cả-hai-tay;-sử-dụng-xe-để-kéo,-đẩy-xe-khác,-vật-khác;-sử-dụng-chân-chống-của-xe-quệt-xuống-đường-khi-xe-đang-chạy-có-được-phép-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Khi điều khiển xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy, những hành vi buông cả hai tay; sử dụng xe để kéo, đẩy xe khác, vật khác; sử dụng chân chống của xe quệt xuống đường khi xe đang chạy có được phép không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Không được phép",
        "skill1": "Được phép",
        "skill2": "Tùy trường hợp",
        "skill3": "Không được phép",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T09:32:58.077Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T09:32:58.077Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f229e762e47ca4da10a548"
        },
        "name": "Khi điều khiển xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy, những hành vi nào không được phép?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "khi-điều-khiển-xe-mô-tô-hai-bánh,-xe-mô-tô-ba-bánh,-xe-gắn-máy,-những-hành-vi-nào-không-được-phép?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Khi điều khiển xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy, những hành vi nào không được phép?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "  Câu 47/ Khi điều khiển xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy, những hành vi nào không được phép?  1 – Buông cả hai tay; sử dụng xe để kéo, đẩy xe khác, vật khác; sử dụng chân chống của xe quệt xuống đường khi xe đang chạy  2 – Buông một ta; sử dụng xe để chở người hoặc hàng hóa; để chân chạm xuống đất khi khởi hành  3 – Đội mũ bảo hiểm; chạy xe đúng tốc độ quy định và chấp hành đúng quy tắc giao thoogn đường bộ  4 – Chở người ngôi sau dưới 16 tuổi",
        "skill1": "  Câu 47/ Khi điều khiển xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy, những hành vi nào không được phép?  1 – Buông cả hai tay; sử dụng xe để kéo, đẩy xe khác, vật khác; sử dụng chân chống của xe quệt xuống đường khi xe đang chạy  2 – Buông một ta; sử dụng xe để chở người hoặc hàng hóa; để chân chạm xuống đất khi khởi hành  3 – Đội mũ bảo hiểm; chạy xe đúng tốc độ quy định và chấp hành đúng quy tắc giao thoogn đường bộ  4 – Chở người ngôi sau dưới 16 tuổi",
        "skill2": "Buông một ta; sử dụng xe để chở người hoặc hàng hóa; để chân chạm xuống đất khi khởi hành",
        "skill3": "Đội mũ bảo hiểm; chạy xe đúng tốc độ quy định và chấp hành đúng quy tắc giao thoogn đường bộ",
        "skill4": "Chở người ngôi sau dưới 16 tuổi",
        "created": {
            "$date": "2022-08-09T09:33:27.993Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T09:33:27.993Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f22a1662e47ca4da10a54b"
        },
        "name": "Người ngồi trên xe mô tô hai bánh, ba bánh, xe gắn máy khi tham gia giao thông có được mang, vác vật cồng kềnh hay không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-ngồi-trên-xe-mô-tô-hai-bánh,-ba-bánh,-xe-gắn-máy-khi-tham-gia-giao-thông-có-được-mang,-vác-vật-cồng-kềnh-hay-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Người ngồi trên xe mô tô hai bánh, ba bánh, xe gắn máy khi tham gia giao thông có được mang, vác vật cồng kềnh hay không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Không được mang vác",
        "skill1": "Được mang vác, tùy trường hợp cụ thể",
        "skill2": "Không được mang vác",
        "skill3": "Được mang, vác nhưng phải đảm bảo an toàn",
        "skill4": "Được mang vác tùy theo sức khỏe của bạn",
        "created": {
            "$date": "2022-08-09T09:34:14.756Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T09:34:14.756Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f22a3a62e47ca4da10a54e"
        },
        "name": "Người ngồi trên xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy khi tham gia giao thông có được bám, kéo hoặc đẩy các phương thiện khác không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-ngồi-trên-xe-mô-tô-hai-bánh,-xe-mô-tô-ba-bánh,-xe-gắn-máy-khi-tham-gia-giao-thông-có-được-bám,-kéo-hoặc-đẩy-các-phương-thiện-khác-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Người ngồi trên xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy khi tham gia giao thông có được bám, kéo hoặc đẩy các phương thiện khác không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Không được phép",
        "skill1": "Được phép",
        "skill2": "Được bám trong trường hợp phương tiện của mìn bị hỏng",
        "skill3": "Không được phép",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T09:34:50.56Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T09:34:50.561Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f22abb62e47ca4da10a552"
        },
        "name": "Người ngôi trên xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy khi tham gia giao thông có được sử dụng ô khi trười mưa hay không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-ngôi-trên-xe-mô-tô-hai-bánh,-xe-mô-tô-ba-bánh,-xe-gắn-máy-khi-tham-gia-giao-thông-có-được-sử-dụng-ô-khi-trười-mưa-hay-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Người ngôi trên xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy khi tham gia giao thông có được sử dụng ô khi trười mưa hay không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Không được sử dụng",
        "skill1": "Được sử dụng",
        "skill2": "Chỉ người ngôi sau được sử dụng",
        "skill3": "Không được sử dụng",
        "skill4": "Được sử dụng nếu không có áo mưa",
        "created": {
            "$date": "2022-08-09T09:36:59.516Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T09:36:59.517Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f22ad462e47ca4da10a555"
        },
        "name": "Khi đang lên dốc người ngồi trên xe mô tô có được phép kéo theo người đang điều khiển xe đạp hay không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "khi-đang-lên-dốc-người-ngồi-trên-xe-mô-tô-có-được-phép-kéo-theo-người-đang-điều-khiển-xe-đạp-hay-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Khi đang lên dốc người ngồi trên xe mô tô có được phép kéo theo người đang điều khiển xe đạp hay không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Không được phép",
        "skill1": "Chỉ được phép nếu cả hai đội mũ bảo hiểm",
        "skill2": "Không được phép",
        "skill3": "Chỉ được phép thực hiện trên đường thật vắng",
        "skill4": "Chỉ được phép khi người đi xe đạp đã quá mệt",
        "created": {
            "$date": "2022-08-09T09:37:24.741Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T09:37:24.742Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f22af762e47ca4da10a558"
        },
        "name": "Hành vi sử dụng xe mô tô để kéo, đẩy xe mô tô khác bị hết xăng đến trạm mua xăng có được phép hay không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "hành-vi-sử-dụng-xe-mô-tô-để-kéo,-đẩy-xe-mô-tô-khác-bị-hết-xăng-đến-trạm-mua-xăng-có-được-phép-hay-không?",
        "rate": 3,
        "price": 1,
        "quantity": 3,
        "description": "Hành vi sử dụng xe mô tô để kéo, đẩy xe mô tô khác bị hết xăng đến trạm mua xăng có được phép hay không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Không được phép",
        "skill1": "Chỉ được kéo nếu đã nhìn thấy trạ xăng",
        "skill2": "Chỉ được thực hiện trên đường vứng phương tiện cùng tham gia giao thông",
        "skill3": "Không được phép",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T09:37:59.833Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T09:37:59.834Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f2787f27e94a83109eae46"
        },
        "name": "Hành vi vận chuyển đồ vật cồng kềnh bằng xe mô tô, xe gắn máy khi tham gia giao thông có được phép hay không?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "hành-vi-vận-chuyển-đồ-vật-cồng-kềnh-bằng-xe-mô-tô,-xe-gắn-máy-khi-tham-gia-giao-thông-có-được-phép-hay-không?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Hành vi vận chuyển đồ vật cồng kềnh bằng xe mô tô, xe gắn máy khi tham gia giao thông có được phép hay không?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Không được vận chuyển",
        "skill1": "Không được vận chuyển",
        "skill2": "Chỉ được vận chuyển khi đã chằng buộc cẩn thận",
        "skill3": "Chỉ được vận chuyển vật cồng kềnh trên xe máy nếu khoảng cách về nhà ngắn hơn 2 km",
        "created": {
            "$date": "2022-08-09T15:08:47.989Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T15:08:47.993Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f278cc27e94a83109eae4a"
        },
        "name": "Người đủ bao nhiêu tuổi trở lên thì được điều khiển xe ô tô tải, máy kéo có trọng tải từ 3.500kg trở lên; xe hạng B2 kéo rơ moóc(FB2)",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-đủ-bao-nhiêu-tuổi-trở-lên-thì-được-điều-khiển-xe-ô-tô-tải,-máy-kéo-có-trọng-tải-từ-3.500kg-trở-lên;-xe-hạng-b2-kéo-rơ-moóc(fb2)",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Người đủ bao nhiêu tuổi trở lên thì được điều khiển xe ô tô tải, máy kéo có trọng tải từ 3.500kg trở lên; xe hạng B2 kéo rơ moóc(FB2)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "21 Tuổi",
        "skill1": "19 tuổi",
        "skill2": "21 Tuổi",
        "skill3": "20 Tuổi",
        "created": {
            "$date": "2022-08-09T15:10:04.189Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T15:10:04.191Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f278e027e94a83109eae4d"
        },
        "name": "Người đủ bao nhiêu tuổi trở lên thì được điều khiern xe mô tô hai bánh, xe mô tô ba bánh có dung tích xi lanh từ 50 cm3 trở lên và các loại xe có kết cấu tương tự; xe ô tô tải, máy kéo có trọng tải dưới 3500kg; xe ô tô chở người đến 9 chỗ ngồi?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-đủ-bao-nhiêu-tuổi-trở-lên-thì-được-điều-khiern-xe-mô-tô-hai-bánh,-xe-mô-tô-ba-bánh-có-dung-tích-xi-lanh-từ-50-cm3-trở-lên-và-các-loại-xe-có-kết-cấu-tương-tự;-xe-ô-tô-tải,-máy-kéo-có-trọng-tải-dưới-3500kg;-xe-ô-tô-chở-người-đến-9-chỗ-ngồi?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Người đủ bao nhiêu tuổi trở lên thì được điều khiern xe mô tô hai bánh, xe mô tô ba bánh có dung tích xi lanh từ 50 cm3 trở lên và các loại xe có kết cấu tương tự; xe ô tô tải, máy kéo có trọng tải dưới 3500kg; xe ô tô chở người đến 9 chỗ ngồi?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "18 Tuổi",
        "skill1": "16 tuổi",
        "skill2": "18 Tuổi",
        "skill3": "17 Tuổi",
        "created": {
            "$date": "2022-08-09T15:10:24.878Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T15:10:24.879Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f278fa27e94a83109eae50"
        },
        "name": "Người lái xe ô tô chở người trên 30 chỗ ngồi (hạng E), lái xe hạng D kéo rơ Moóc (FD) phải đủ bao nhiêu tuổi trở lên?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-lái-xe-ô-tô-chở-người-trên-30-chỗ-ngồi-(hạng-e),-lái-xe-hạng-d-kéo-rơ-moóc-(fd)-phải-đủ-bao-nhiêu-tuổi-trở-lên?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Người lái xe ô tô chở người trên 30 chỗ ngồi (hạng E), lái xe hạng D kéo rơ Moóc (FD) phải đủ bao nhiêu tuổi trở lên?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "27 Tuổi",
        "skill1": "23 tuổi",
        "skill2": "2 4 Tuổi",
        "skill3": "27 Tuổi",
        "skill4": "30 Tuổi",
        "created": {
            "$date": "2022-08-09T15:10:50.534Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T15:10:50.535Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f2791e27e94a83109eae53"
        },
        "name": "Tuổi tối đa cửa người lái xe ô tô chở người trên 30 chỗ ngồi (hạng E) là bao nhiêu tuổi?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "tuổi-tối-đa-cửa-người-lái-xe-ô-tô-chở-người-trên-30-chỗ-ngồi-(hạng-e)-là-bao-nhiêu-tuổi?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Tuổi tối đa cửa người lái xe ô tô chở người trên 30 chỗ ngồi (hạng E) là bao nhiêu tuổi?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "55 tuổi đối với nam và 50 tuổi đối với nữ",
        "skill1": "55 tuổi đối với nam và 50 tuổi đối với nữ",
        "skill2": "55 tuổi đối vơi nam và nữ",
        "skill3": "60 tuổi đối với nam và 55 tuổi đối với nữ",
        "skill4": "45 tuổi với nam và 40 tuổi đối với nữ",
        "created": {
            "$date": "2022-08-09T15:11:26.62Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T15:11:26.621Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f2793b27e94a83109eae56"
        },
        "name": "Người lái xe chở từ 10 đến 30 chỗ ngồi (hạng D), lái xe hạng C kéo rơ Moóc(FC) phải đủ bao nhiêu tuổi trở lên?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-lái-xe-chở-từ-10-đến-30-chỗ-ngồi-(hạng-d),-lái-xe-hạng-c-kéo-rơ-moóc(fc)-phải-đủ-bao-nhiêu-tuổi-trở-lên?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Người lái xe chở từ 10 đến 30 chỗ ngồi (hạng D), lái xe hạng C kéo rơ Moóc(FC) phải đủ bao nhiêu tuổi trở lên?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "2 4 Tuổi",
        "skill1": "23 tuổi",
        "skill2": "2 4 Tuổi",
        "skill3": "27 Tuổi",
        "skill4": "18 Tuổi",
        "created": {
            "$date": "2022-08-09T15:11:55.869Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T15:11:55.869Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f2796127e94a83109eae59"
        },
        "name": "Người đủ 16 tuổi được điều khiển các loại xe nào dưới Đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-đủ-16-tuổi-được-điều-khiển-các-loại-xe-nào-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Người đủ 16 tuổi được điều khiển các loại xe nào dưới Đây?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Xe gắn máy có dung tích xi-lanh dưới 50cm3",
        "skill1": "Xe mô tô 2 bánh có dung tích xi-lanh từ 50 cm3 trở lên",
        "skill2": "Xe gắn máy có dung tích xi-lanh dưới 50cm3",
        "skill3": "Xe ô tô tải dưới 3.500kg; xe chở người đến 9 chỗ ngồi",
        "skill4": "Tất cả các ý nêu trên",
        "created": {
            "$date": "2022-08-09T15:12:33.448Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T15:12:33.449Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f2798727e94a83109eae5c"
        },
        "name": "Người có giấy phép lái xe mô tô hạng A1 được phép điều khiển các loại xe nào dưới đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-có-giấy-phép-lái-xe-mô-tô-hạng-a1-được-phép-điều-khiển-các-loại-xe-nào-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Người có giấy phép lái xe mô tô hạng A1 được phép điều khiển các loại xe nào dưới đây?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Cả ý 1 và ý 2",
        "skill1": "Xe mô tô có dung tích xi-lanh từ 50 Cm3 đến dưới 175 cm3",
        "skill2": "Xe mô tô ba bánh dành cho người khuyết tật",
        "skill3": "Cả ý 1 và ý 2",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T15:13:11.323Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T15:13:11.324Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f279a527e94a83109eae5f"
        },
        "name": "Người có giấy phép lái xe mô tô hạng A2 được phép điều khiển loại xe nào dưới đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-có-giấy-phép-lái-xe-mô-tô-hạng-a2-được-phép-điều-khiển-loại-xe-nào-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Người có giấy phép lái xe mô tô hạng A2 được phép điều khiển loại xe nào dưới đây?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Xe mô tô hai bánh có dung tích xi-lanh từ 175 cm3 trở lên và các loại xe quy định cho giấy phép lái xe hạng A1",
        "skill1": "Xe mô tô ba bánh",
        "skill2": "Xe mô tô hai bánh có dung tích xi-lanh từ 175 cm3 trở lên và các loại xe quy định cho giấy phép lái xe hạng A1",
        "skill3": "Các lọi máy kéo nhỏ có trọng tải đến 1000",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T15:13:41.09Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T15:13:41.091Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f279b527e94a83109eae62"
        },
        "name": "Người có giấy phép lái xe mô tô hạng A3 được phép điều khiển loại xe nào dưới đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-có-giấy-phép-lái-xe-mô-tô-hạng-a3-được-phép-điều-khiển-loại-xe-nào-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Người có giấy phép lái xe mô tô hạng A3 được phép điều khiển loại xe nào dưới đây?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Xe mô tô ba bánh",
        "skill1": "Xe mô tô ba bánh",
        "skill2": "Xe mô tô hai bánh có dung tích xi-lanh từ 175 cm3 trở lên và các loại xe quy định cho giấy phép lái xe hạng A1",
        "skill3": "Các lọi máy kéo nhỏ có trọng tải đến 1000",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T15:13:57.368Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T15:13:57.368Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f279e827e94a83109eae65"
        },
        "name": "Người có giấy phép lái xe hạng B1 số tự động được điều khiển loại xe nào?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-có-giấy-phép-lái-xe-hạng-b1-số-tự-động-được-điều-khiển-loại-xe-nào?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Người có giấy phép lái xe hạng B1 số tự động được điều khiển loại xe nào?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Ô tô số tự động chở người đến 9 chỗ ngồi, kể cả chỗ ngồi cho người lái xe; ô tô tải, kể cả ô tô tải chuyên dùng số tự độngcó trọng tải thiết kế dưới 35000 kg; ô tô dung cho người khuyết tật. Không được hành nghề lái xe",
        "skill1": "Ô tô số tự động chở người đến 9 chỗ ngồi, kể cả chỗ ngồi cho người lái xe; ô tô tải, kể cả ô tô tải chuyên dùng số tự độngcó trọng tải thiết kế dưới 35000 kg; ô tô dung cho người khuyết tật. Không được hành nghề lái xe",
        "skill2": "Ô tô số tự động chở người đến 9 chỗ ngồi, kể cả chỗ ngồi cho người lái xe; ô tô tải, kể cả ô tô tải chuyên dùng số tự động có trọng tải thiết kế dưới 3.500 kg; ô tô dùng cho người khuyết tật. Được hành nghề lái xe kinh doanh vận tải",
        "skill3": "Ô tô chở người đến 9 chỗ ngồi, kể cả chỗ ngồi cho người lái xe; ô tô tải, kể cả ô tô tải chuyên dùng có trọng tải thiết kế dưới 3.500 kg; ô tô dùng cho người khuyết tật",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T15:14:48.455Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T15:14:48.456Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f27a0427e94a83109eae68"
        },
        "name": "Người có giấy phép lái xe hạng B1 được điều khiển loại xe nào",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-có-giấy-phép-lái-xe-hạng-b1-được-điều-khiển-loại-xe-nào",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Người có giấy phép lái xe hạng B1 được điều khiển loại xe nào",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Ô tô chở người đến 9 chỗ ngồi, kể cả chỗ ngồi cho người lái xe; ô tô tải, kể cả ô tô tải chuyên dùng có trọng tải thiết kế dưới 3.500kg; máy kéo kéo một rơ moóc có trọng tải thiết kế dưới 3.500 kg. Khong hành nghề lái xe",
        "skill1": "Ô tô chỏ người đến 9 chỗ ngồi, kể cả chỗ ngồi cho người lái xe; ô tô tải, kể cả ô tô tải chuyên dùng có trọng tải thiết kế dưới 3.500kg; máy kéo kéo một rơ moóc có trọng tải thiết kế dưới 3.500 kg. Được hành nghề lái xe",
        "skill2": "Ô tô chở người đến 9 chỗ ngồi, kể cả chỗ ngồi cho người lái xe; ô tô tải, kể cả ô tô tải chuyên dùng có trọng tải thiết kế dưới 3.500kg; máy kéo kéo một rơ moóc có trọng tải thiết kế dưới 3.500 kg. Khong hành nghề lái xe",
        "skill3": "Ô tô số tự đọng chở người đến 9 chỗ ngồi, kể cả chỗ ngồi cho người lái xe; ô tô tả, kể cả ô tô tải chuyên dùng số tự động có trọng tải thiết kế trên 3.500 kg; ô tô dùng cho người khuyết tật",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T15:15:16.68Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T15:15:16.68Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f27a2027e94a83109eae6b"
        },
        "name": "Người có giấy phép lái xe hạng B2 được điều khiển loại xe nào?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-có-giấy-phép-lái-xe-hạng-b2-được-điều-khiển-loại-xe-nào?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Người có giấy phép lái xe hạng B2 được điều khiển loại xe nào?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Xe ô tô chở người đến 9 chỗ ngồi; xe ô tô tải; máy kéo có trọng tải dưới 3.500kg",
        "skill1": "Xe ô tô chở người trên 9 chỗ ngồi; xe ô tô tải; xe kéo có trọng tải trên 3.500kg",
        "skill2": "Xe ô tô chở người đến 9 chỗ ngồi; xe ô tô tải; máy kéo có trọng tải dưới 3.500kg",
        "skill3": "Xe ô tô chở người từ 10 đến 30 chỗ ngồi; xe ô tô tải; máy kéo có trọng tải trên 3.500kg",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T15:15:44.691Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T15:15:44.691Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f27a4627e94a83109eae6e"
        },
        "name": "Người có giấy phép lái xe hạng C được điều khiển loại xe nào?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-có-giấy-phép-lái-xe-hạng-c-được-điều-khiển-loại-xe-nào?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Người có giấy phép lái xe hạng C được điều khiển loại xe nào?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Xe ô tô chở người đến 9 chỗ ngồi; xe ô tô tải; máy kéo có trọng tải trên 3.500kg",
        "skill1": "Xe ô tô chở người trên 9 chỗ ngồi; xe ô tô tải; máy kéo có trọng tải trên 3.500kg",
        "skill2": "Xe ô tô chở người từ 10 đến 30 chỗ ngồi; xe ô tô tải; máy kéo có trọng tải trên 3.500kg",
        "skill3": "Xe ô tô chở người đến 9 chỗ ngồi; xe ô tô tải; máy kéo có trọng tải trên 3.500kg",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T15:16:22.563Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T15:16:22.564Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f27a6f27e94a83109eae71"
        },
        "name": "Người có giấy phép lái xe hạng D được điều khiển loại xe nào dưới đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-có-giấy-phép-lái-xe-hạng-d-được-điều-khiển-loại-xe-nào-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Người có giấy phép lái xe hạng D được điều khiển loại xe nào dưới đây?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Xe ô tô chở người đến 30 chỗ ngồi, kể cả chỗ ngồi cho người lái xe; xe ô tô tải, máy kéo có trọng tải 3.500kg",
        "skill1": "Xe ô tô chở người đến 30 chỗ ngồi, kể cả chỗ ngồi cho người lái xe; xe ô tô tải, máy kéo có trọng tải 3.500kg",
        "skill2": "Xe ô tô chở người trên 30 chỗ ngồi; xe ô tô tải, máy kéo có trọng tải trên 3.500kg",
        "skill3": "Xe kéo rơ mo óc, ô tô đầu kéo kéo sơ mi rơ mo óc và điều khiển các loại xe quy định cho giấy phép lái xe hạng B1, B2, C và FB2",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T15:17:03.136Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T15:17:03.136Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f27a8827e94a83109eae74"
        },
        "name": "Người có giấy pháp lái xe hạng E được điều khiển loại xe nào dưới đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-có-giấy-pháp-lái-xe-hạng-e-được-điều-khiển-loại-xe-nào-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Người có giấy pháp lái xe hạng E được điều khiển loại xe nào dưới đây?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Xe ô tô chở người trên 20 chỗ ngồi; xe ô tô tải, máy kéo có trọng tải trên 3.500 kg",
        "skill1": "Xe kéo rơ Moóc, ô tô đầu kéo kéo sơ mi và rơ moóc và được điều khiển các loại xe theo quy định cho giấy phép lái xe hạng B1, B2, C và FB2",
        "skill2": "Xe ô tô chở người trên 20 chỗ ngồi; xe ô tô tải, máy kéo có trọng tải trên 3.500 kg",
        "skill3": "Xe kéo rơ mo óc và được điều kheiern các loại xe; ô tô chở khách nối toa và các loại xe quy định cho giấy phép lái xe hạng B1, B2, C, D, FB2, FD",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T15:17:28.918Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T15:17:28.918Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f27a9c27e94a83109eae77"
        },
        "name": "Người có giấy phép lái xe hạng FC được điều khiển loại xe nào dưới đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-có-giấy-phép-lái-xe-hạng-fc-được-điều-khiển-loại-xe-nào-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Người có giấy phép lái xe hạng FC được điều khiển loại xe nào dưới đây?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Các loại xe được quy định tại giấy phép lái xe hạng C có kéo rơ mooc, ô tô đầu kéo kéo sơ mi, rơ moóc và được điều khiển các loại xe quy định cho giấy phép hạng B1, B2 và FB2",
        "skill1": "Các loại xe được quy định tại giấy phép lái xe hạng C có kéo rơ moóc, ô tô đầu kéo sơ mi rơ moóc, ô tô chở khách nối toa và được điều khiển các loại xe quy định cho giấy phép láu xe hạng B1, B2 và FB2",
        "skill2": "Các loại xe được quy định tại giấy phép lái xe hạng C có kéo rơ mooc, ô tô đầu kéo kéo sơ mi, rơ moóc và được điều khiển các loại xe quy định cho giấy phép hạng B1, B2 và FB2",
        "skill3": "Mô tô hai bánh, các loại xe được quy định tại giấy phép lái xe hạng C có kéo rơ moóc, ô tô đầu kéo kéo sơ mi rơ moóc và được điều khiển các loại xe quy định cho giấy phép lái xe hạng B1, B2 và FB2",
        "skill4": "",
        "created": {
            "$date": "2022-08-09T15:17:48.792Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-09T15:17:48.793Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f37b5f7a36a9d2363b9adc"
        },
        "name": "Người có giấy phép lái xe hang FE được điều khiển loại xe nào dưới đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-có-giấy-phép-lái-xe-hang-fe-được-điều-khiển-loại-xe-nào-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Người có giấy phép lái xe hang FE được điều khiển loại xe nào dưới đây?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Các loại xe được quy định tại giấy phép lái xe hạng E có kéo rơ moóc và đưuọc điều khiển các loại xe: Ô tô chở khách nối toa và các loại xe quy định cho giấy phép lái xe hạng B1, B2, C, D, FB2, FD",
        "skill1": "Các loại xe được quy định tại giấy phép lái xe hạng E có kéo rơ moóc và đưuọc điều khiển các loại xe: Ô tô chở khách nối toa và các loại xe quy định cho giấy phép lái xe hạng B1, B2, C, D, FB2, FD",
        "skill2": "Các loại xe được quy định tại giấy phép lái xe hạng E có kéo rơ mo óc, ô tô đầu kéo kéo sơ mi rơ mo óc và được điều khiển các loại xe: Ô tô chở khách nối toa và các loại xe quy định cho giấy phép lái xe hạng B1, B2, C, D, FB2, FD",
        "skill3": "Tất cả các loại xe nêu trên",
        "created": {
            "$date": "2022-08-10T09:33:19.398Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-10T09:33:19.402Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f37d457a36a9d2363b9adf"
        },
        "name": "Biển báo hiệu có dạng hình tròn, viền đỏ, nền trắng, trên nền có hình vẽ dược chữ số, chữ viết màu đen là loại biển gì dưới đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "biển-báo-hiệu-có-dạng-hình-tròn,-viền-đỏ,-nền-trắng,-trên-nền-có-hình-vẽ-dược-chữ-số,-chữ-viết-màu-đen-là-loại-biển-gì-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Biển báo hiệu có dạng hình tròn, viền đỏ, nền trắng, trên nền có hình vẽ dược chữ số, chữ viết màu đen là loại biển gì dưới đây?",
        "images": [
            "/assets/images/luatgiaothong/bien_bao_cam_oto.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/luatgiaothong/bien_bao_cam_oto.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "Hình Ảnh",
        "grade": "3",
        "leaderSkill": "Biển báo cấm",
        "skill1": "Biển báo nguy hiểm",
        "skill2": "Biển báo cấm",
        "skill3": "Biển báo hiệu lệnh",
        "skill4": "Biển báo chỉ dẫn",
        "created": {
            "$date": "2022-08-10T09:41:25.728Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-10T09:41:25.729Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f37dc07a36a9d2363b9ae2"
        },
        "name": "Biển báo hiện hình tròn có nền xanh lam có hình vẽ màu trắng là loại gì dưới đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "biển-báo-hiện-hình-tròn-có-nền-xanh-lam-có-hình-vẽ-màu-trắng-là-loại-gì-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Biển báo hiện hình tròn có nền xanh lam có hình vẽ màu trắng là loại gì dưới đây?",
        "images": [
            "/assets/images/luatgiaothong/bien_bao_hieu_lenh_thi_hanh_duong1chieu.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/luatgiaothong/bien_bao_hieu_lenh_thi_hanh_duong1chieu.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "Hình Ảnh",
        "grade": "3",
        "leaderSkill": "Biển báo hiệu lệnh phải thi hành",
        "skill1": "Biển báo nguy hiểm",
        "skill2": "Biển báo cấm",
        "skill3": "Biển báo hiệu lệnh phải thi hành",
        "skill4": "Biển báo chỉ dẫn",
        "created": {
            "$date": "2022-08-10T09:43:28.859Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-10T09:43:28.861Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f37e147a36a9d2363b9ae5"
        },
        "name": "Biển báo hiệu hình chữ nhật hoặc hình vuông hoặc hình mũi tên nền xanh lam là loại biển gì dưới đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "biển-báo-hiệu-hình-chữ-nhật-hoặc-hình-vuông-hoặc-hình-mũi-tên-nền-xanh-lam-là-loại-biển-gì-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Biển báo hiệu hình chữ nhật hoặc hình vuông hoặc hình mũi tên nền xanh lam là loại biển gì dưới đây?",
        "images": [
            "/assets/images/luatgiaothong/bien_bao_hieu_lenh_thi_hanh_duocquaytrai.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/luatgiaothong/bien_bao_hieu_lenh_thi_hanh_duocquaytrai.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "Hình Ảnh",
        "grade": "3",
        "leaderSkill": "Biển báo chỉ dẫn",
        "skill1": "Biển báo nguy hiểm",
        "skill2": "Biển báo cấm",
        "skill3": "Biển báo hiệu lệnh phải thi hành",
        "skill4": "Biển báo chỉ dẫn",
        "created": {
            "$date": "2022-08-10T09:44:52.309Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-10T09:44:52.309Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f37e487a36a9d2363b9ae8"
        },
        "name": "Khi tập lái xe ô tô, người tập lái xe phỉa thực hiện các điều kiện gì dưới đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "khi-tập-lái-xe-ô-tô,-người-tập-lái-xe-phỉa-thực-hiện-các-điều-kiện-gì-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Khi tập lái xe ô tô, người tập lái xe phỉa thực hiện các điều kiện gì dưới đây?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Cả ý 1 và ý 2",
        "skill1": "Phải thực hành lái xe trên xe tập lái và có giáo viên bảo trợ tay lái",
        "skill2": "Phải mang theo phù hiện “học viên tập lái xe”",
        "skill3": "Phải mang theo giấy chứng nhận kiểm định an toàn kỹ thuật và bảo vệ môi trường còn hiệu lực, giấy phép vận chuyển (nếu các loại xe đó cần phải có)",
        "skill4": "Cả ý 1 và ý 2",
        "created": {
            "$date": "2022-08-10T09:45:44.429Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-10T09:45:44.43Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f37e6d7a36a9d2363b9aeb"
        },
        "name": "Khi dạy thực hành lái xe, giáo viên phải mang theo các loại giấy tờ gì dưới đây?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "khi-dạy-thực-hành-lái-xe,-giáo-viên-phải-mang-theo-các-loại-giấy-tờ-gì-dưới-đây?",
        "rate": 3,
        "price": 1,
        "quantity": 1,
        "description": "Khi dạy thực hành lái xe, giáo viên phải mang theo các loại giấy tờ gì dưới đây?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "All",
        "type": "All",
        "grade": "3",
        "leaderSkill": "Phải mang theo phù hiệu “giáo viên dạy lái xe”, giấy chứng nhận kiểm định an toàn kỹ thuật và bảo vệ môi trường còn hiệu lực, giấy phép xe tập lái do cơ quan có thẩm quyền cấp còn hiệu lực",
        "skill1": "Phải mang theo phù hiệu “giáo viên dạy lái xe”, giấy chứng nhận kiểm định an toàn kỹ thuật và bảo vệ môi trường còn hiệu lực, giấy phép xe tập lái do cơ quan có thẩm quyền cấp còn hiệu lực",
        "skill2": "Phải mang theo phù hiệu “học viên tập lái xe” và kế hoạch học tập của khóa học",
        "skill3": "Phải mang theo giấy chứng nhận giáo viên dạy thực hành lái xe, biên lai thu phí bảo trì đường bộ",
        "skill4": "",
        "created": {
            "$date": "2022-08-10T09:46:21.879Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-10T09:46:21.879Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f45a7985f4b864917dc00f"
        },
        "name": "Người lái xe không được quay đầu xe tại các khu vực nào nêu dưới đây? ",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-lái-xe-không-được-quay-đầu-xe-tại-các-khu-vực-nào-nêu-dưới-đây?-",
        "rate": 5,
        "price": 1,
        "quantity": 4,
        "description": "Người lái xe không được quay đầu xe tại các khu vực nào nêu dưới đây? ",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "B2",
        "type": "DiemLiet",
        "grade": "5",
        "leaderSkill": "Trên cầu",
        "skill1": "Nơi đường giao nhau",
        "skill2": "Trên cầu",
        "skill3": "",
        "skill4": "",
        "created": {
            "$date": "2022-08-11T01:25:13.704Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-11T01:25:13.706Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f45aa385f4b864917dc012"
        },
        "name": "Người lái xe không được quay đầu xe tại các khu vực nào nêu dưới đây? trên cầu, gầm cầu vượt, đường ngầm hay khu vực đường bộ giao nhau cùng mức với đường sắt?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "người-lái-xe-không-được-quay-đầu-xe-tại-các-khu-vực-nào-nêu-dưới-đây?-trên-cầu,-gầm-cầu-vượt,-đường-ngầm-hay-khu-vực-đường-bộ-giao-nhau-cùng-mức-với-đường-sắt?",
        "rate": 5,
        "price": 1,
        "quantity": 4,
        "description": "Người lái xe không được quay đầu xe tại các khu vực nào nêu dưới đây? trên cầu, gầm cầu vượt, đường ngầm hay khu vực đường bộ giao nhau cùng mức với đường sắt?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "B2",
        "type": "DiemLiet",
        "grade": "5",
        "leaderSkill": "Gầm cầu vượt",
        "skill1": "Gầm cầu vượt",
        "skill2": "Nơi đường giao nhau",
        "skill3": "Nơi có biển báo cho phép quay đầu xe",
        "skill4": "",
        "created": {
            "$date": "2022-08-11T01:25:55.384Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-11T01:25:55.385Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f4783b7182babb3abe4e14"
        },
        "name": "Khi điều khiển xe mô tô tay ga xuống đường dốc dài, độ dốc cao, người lái xe cần thực hiện các thao tác nào dưới đây để đảm bảo an toàn?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "khi-điều-khiển-xe-mô-tô-tay-ga-xuống-đường-dốc-dài,-độ-dốc-cao,-người-lái-xe-cần-thực-hiện-các-thao-tác-nào-dưới-đây-để-đảm-bảo-an-toàn?",
        "rate": 4,
        "price": 1,
        "quantity": 4,
        "description": "Khi điều khiển xe mô tô tay ga xuống đường dốc dài, độ dốc cao, người lái xe cần thực hiện các thao tác nào dưới đây để đảm bảo an toàn?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            null,
            null
        ],
        "element": "LyThuyet",
        "species": "B2",
        "type": "All",
        "grade": "4",
        "leaderSkill": "Giữ tay ga ở mức độ phù hợp, sử dụng phanh trước và phanh sau để giảm tốc độ",
        "skill1": "Giữ tay ga ở mức độ phù hợp, sử dụng phanh trước và phanh sau để giảm tốc độ",
        "skill2": "Nhả hết tay ga, tắt động cơ, sử dụng phanh trước và phanh sau để giảm tốc độ",
        "skill3": "Sử dụng phanh trước để giảm tốc độ kết hợp với tắt chìa khóa điện của xe",
        "created": {
            "$date": "2022-08-11T03:32:11.665Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-11T03:32:11.673Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f478a27182babb3abe4e17"
        },
        "name": "Biển này có ý nghĩa gì?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "biển-này-có-ý-nghĩa-gì?",
        "rate": 4,
        "price": 1,
        "quantity": 4,
        "description": "Biển này có ý nghĩa gì?",
        "images": [
            "/assets/images/luatgiaothong/bien_bao_hieu_cam_oto_khach.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/luatgiaothong/bien_bao_hieu_cam_oto_khach.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "B2",
        "type": "All",
        "grade": "4",
        "leaderSkill": "Cấm ô tô chở khách",
        "skill1": "Cấm ô tô buýt",
        "skill2": "Cấm ô tô chở khách",
        "skill3": "Cấm ô tô con",
        "created": {
            "$date": "2022-08-11T03:33:54.53Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-11T03:33:54.531Z"
        },
        "__v": 0
    }
]